// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;charset=UTF-8,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%23333%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3e%3cpolyline points=%276,9 12,15 18,9%27%3e%3c/polyline%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%278%27 height=%278%27 viewBox=%270 0 8 8%27%3E%3Cpath fill=%27%23374151%27 d=%27M0 2l4 4 4-4z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0px;
  padding: 0px;
}

/* Success Message Toast Styles */
.success-message {
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 9999;
  background-color: #4caf50;
  color: white;
  padding: 12px 24px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 500;
  max-width: 90vw;
  text-align: center;
  animation: slideInFromRight 0.3s ease-out;
}

@keyframes slideInFromRight {
  from {
    transform: translateX(400px);
    opacity: 0;
  }

  to {
    transform: translateX(0);
    opacity: 1;
  }
}

@media (max-width: 768px) {
  .success-message {
    font-size: 11px;
    padding: 8px 12px;
    gap: 5px;
    top: 8px;
    right: 8px;
    max-width: 80vw;
  }

  @keyframes slideInFromRight {
    from {
      transform: translateX(300px);
      opacity: 0;
    }

    to {
      transform: translateX(0);
      opacity: 1;
    }
  }
}

@media (max-width: 480px) {
  .success-message {
    font-size: 10px;
    padding: 6px 10px;
    gap: 4px;
    top: 6px;
    right: 6px;
    max-width: 75vw;
    flex-direction: column;
    line-height: 1.2;
  }

  @keyframes slideInFromRight {
    from {
      transform: translateX(250px);
      opacity: 0;
    }

    to {
      transform: translateX(0);
      opacity: 1;
    }
  }
}

@media (max-width: 360px) {
  .success-message {
    font-size: 9px;
    padding: 5px 8px;
    gap: 3px;
    top: 5px;
    right: 5px;
    max-width: 70vw;
    flex-direction: column;
    line-height: 1.1;
  }

  @keyframes slideInFromRight {
    from {
      transform: translateX(200px);
      opacity: 0;
    }

    to {
      transform: translateX(0);
      opacity: 1;
    }
  }
}

.success-message-dashboard {
  position: fixed;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 9999;
  background-color: #4caf50;
  color: white;
  padding: 12px 24px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 500;
  max-width: 90vw;
  text-align: center;
  animation: slideInFromTop 0.3s ease-out;
}

@keyframes slideInFromTop {
  from {
    transform: translateX(-50%) translateY(-100px);
    opacity: 0;
  }

  to {
    transform: translateX(-50%) translateY(0);
    opacity: 1;
  }
}

@media (max-width: 768px) {
  .success-message-dashboard {
    font-size: 12px;
    padding: 10px 16px;
    gap: 6px;
    top: 10px;
    max-width: 90vw;
    border-radius: 6px;
  }

  .success-message-dashboard .close-icon {
    font-size: 12px;
    margin-left: 8px;
  }
}

@media (max-width: 480px) {
  .success-message-dashboard {
    font-size: 11px;
    padding: 8px 12px;
    gap: 5px;
    top: 8px;
    max-width: 90vw;
    flex-direction: row;
    line-height: 1.3;
    border-radius: 5px;
  }

  .success-message-dashboard .close-icon {
    font-size: 11px;
    margin-left: 6px;
  }
}

/* @media (max-width: 360px) {
  .success-message-dashboard {
    font-size: 10px;
    padding: 6px 10px;
    gap: 4px;
    top: 6px;
    max-width: 75vw;
    flex-direction: row;
    line-height: 1.2;
    border-radius: 4px;
  }

  .success-message-dashboard .close-icon {
    font-size: 10px;
    margin-left: 4px;
  } 
}*/

.spinner {
  width: 40px;
  height: 40px;
  border: 4px solid var(--gray-200);
  border-top: 4px solid var(--primary);
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

/* ==========================================================================
   Hire Person Banner Styles
   ========================================================================== */

.hire-person-banner {
  background: linear-gradient(135deg, #f0f7ff 0%, #e0effe 100%);
  border: 1px solid rgba(59, 130, 246, 0.2);
  border-radius: 12px;
  padding: 12px 16px;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  box-shadow: 0 4px 15px rgba(59, 130, 246, 0.06);
  transition: all 0.2s ease;
  color: #1d4ed8;
  width: fit-content;
  gap: 16px;
}

.hire-person-banner:hover {
  background: linear-gradient(135deg, #e0effe 0%, #dbeafe 100%);
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(59, 130, 246, 0.12);
  border-color: rgba(59, 130, 246, 0.35);
}

.hire-person-content {
  display: flex;
  flex-direction: column;
  gap: 4px;
  text-align: left;
}

.hire-person-heading {
  margin: 0;
  font-size: 0.9rem;
  font-weight: 700;
  color: #1e3a8a;
  line-height: 1.3;
}

.hire-person-subheading {
  margin: 0;
  font-size: 0.75rem;
  color: #3b82f6;
  font-weight: 500;
  line-height: 1.4;
}

.hire-person-icon {
  width: 32px;
  height: 32px;
  background: #ffffff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.85rem;
  color: #3b82f6;
  box-shadow: 0 2px 6px rgba(59, 130, 246, 0.15);
  transition: all 0.2s ease;
  flex-shrink: 0;
}

.hire-person-banner:hover .hire-person-icon {
  transform: translateX(4px);
  background: #3b82f6;
  color: #ffffff;
  box-shadow: 0 4px 10px rgba(59, 130, 246, 0.3);
}

/* ==========================================================================
   Hire Person Modal / Popup Styles
   ========================================================================== */

.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  backdrop-filter: blur(3px);
  -webkit-backdrop-filter: blur(3px);
  padding: 16px;
}

.modal-content {
  background: #ffffff;
  border-radius: 16px;
  box-shadow:
    0 4px 6px rgba(0, 0, 0, 0.05),
    0 20px 50px rgba(0, 0, 0, 0.15);
  width: 100%;
  max-width: 460px;
  max-height: 90vh;
  overflow-y: auto;
  animation: modalSlideIn 0.28s cubic-bezier(0.34, 1.3, 0.64, 1);
}

.hire-modal-content {
  max-width: 460px;
}

/* --- Header --- */
.modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px 18px;
  border-bottom: 1px solid #f1f5f9;
}

.modal-header h2 {
  font-size: 1rem;
  font-weight: 700;
  color: #0f172a;
  margin: 0;
  letter-spacing: -0.01em;
}

.close-button {
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: #f1f5f9;
  color: #64748b;
  border-radius: 8px;
  cursor: pointer;
  font-size: 13px;
  transition: background 0.18s, color 0.18s;
  flex-shrink: 0;
}

.close-button:hover {
  background: #e2e8f0;
  color: #0f172a;
}

/* --- Body --- */
.modal-body {
  padding: 20px 24px;
}

.hire-modal-body {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 20px 24px;
}

/* --- Info Sections --- */
.hire-info-section {
  border-radius: 12px;
  padding: 18px 20px;
}

/* Pricing section — soft amber tint */
.hire-info-section:first-child {
  background: #fffbeb;
  border: 1px solid #fde68a;
}

/* Contact section — soft blue tint */
.hire-info-section:last-child {
  background: #f0f9ff;
  border: 1px solid #bae6fd;
}

.hire-info-section h3 {
  margin: 0 0 10px 0;
  font-size: 0.8rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  display: flex;
  align-items: center;
  gap: 7px;
}

/* Heading color per section */
.hire-info-section:first-child h3 {
  color: #b45309;
}

.hire-info-section:last-child h3 {
  color: #0369a1;
}

.hire-info-section p {
  margin: 0 0 4px 0;
  font-size: 0.875rem;
  color: #475569;
  line-height: 1.65;
}

.hire-info-section strong {
  color: #0f172a;
  font-weight: 650;
}

/* --- Contact Card --- */
.contact-details-card {
  margin-top: 14px;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 8px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03);
}

.contact-link {
  text-decoration: none;
  display: block;
  border-radius: 8px;
  transition: all 0.2s ease;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
}

.contact-link:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.contact-link.call-link:hover {
  background: #f0f9ff;
  border-color: #bae6fd;
}

.contact-link.whatsapp-link:hover {
  background: #f0fdf4;
  border-color: #bbf7d0;
}

.contact-row {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 12px 16px;
}

.contact-icon-wrapper {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  flex-shrink: 0;
}

.call-link .contact-icon-wrapper {
  background: #e0f2fe;
  color: #0284c7;
}

.call-link:hover .contact-icon-wrapper {
  background: #0284c7;
  color: #ffffff;
}

.whatsapp-link .contact-icon-wrapper {
  background: #dcfce7;
  color: #22c55e;
}

.whatsapp-link:hover .contact-icon-wrapper {
  background: #22c55e;
  color: #ffffff;
}

.contact-text-group {
  display: flex;
  flex-direction: column;
  gap: 2px;
  text-align: left;
}

.contact-label {
  font-size: 0.72rem;
  font-weight: 600;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.contact-number {
  font-size: 0.95rem;
  font-weight: 600;
  color: #0f172a;
}

/* --- Footer --- */
.modal-footer {
  display: flex;
  justify-content: flex-end;
  padding: 14px 24px 20px;
  border-top: 1px solid #f1f5f9;
}

.btn-secondary {
  padding: 9px 24px;
  background: #f1f5f9;
  color: #475569;
  border: none;
  border-radius: 9px;
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.18s, color 0.18s;
}

.btn-secondary:hover {
  background: #e2e8f0;
  color: #0f172a;
}

/* --- Animation --- */
@keyframes modalSlideIn {
  from {
    opacity: 0;
    transform: translateY(20px) scale(0.96);
  }

  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

/* ==========================================================================
   Responsive
   ========================================================================== */

@media (max-width: 768px) {
  .hire-person-banner {
    margin: 0;
    padding: 6px 10px !important;
    width: 100%;
    box-sizing: border-box;
    gap: 8px !important;
    border-radius: 8px !important;
  }

  .hire-person-heading {
    font-size: 0.75rem !important;
    white-space: normal;
    font-weight: 700 !important;
  }

  .hire-person-subheading {
    font-size: 0.62rem !important;
    white-space: normal;
    font-weight: 500 !important;
  }

  .hire-person-icon {
    width: 24px !important;
    height: 24px !important;
    font-size: 0.7rem !important;
  }

  .modal-content,
  .hire-modal-content {
    border-radius: 14px;
    max-width: 90% !important;
    max-height: 85vh !important;
    display: flex !important;
    flex-direction: column !important;
    overflow: hidden !important;
    margin: auto !important;
  }

  .modal-header {
    padding: 12px 16px !important;
  }

  .modal-header h2 {
    font-size: 0.92rem !important;
  }

  .close-button {
    width: 28px !important;
    height: 28px !important;
    font-size: 11px !important;
  }

  .hire-modal-body {
    padding: 12px 16px !important;
    overflow-y: auto !important;
    display: flex !important;
    flex-direction: column !important;
    gap: 12px !important;
  }

  .modal-footer {
    padding-left: 16px;
    padding-right: 16px;
  }

  .hire-info-section {
    padding: 12px 14px !important;
  }

  .hire-info-section h3 {
    font-size: 0.72rem !important;
    margin-bottom: 6px !important;
  }

  .hire-info-section p {
    font-size: 0.8rem !important;
    line-height: 1.5 !important;
  }

  .contact-details-card {
    margin-top: 8px !important;
    gap: 6px !important;
    padding: 6px !important;
  }

  .contact-row {
    padding: 8px 12px !important;
    gap: 10px !important;
  }

  .contact-icon-wrapper {
    width: 30px !important;
    height: 30px !important;
  }

  .contact-icon-wrapper svg {
    width: 14px !important;
    height: 14px !important;
  }

  .contact-number {
    font-size: 13.5px !important;
  }

  .wallet-action-right {
    align-items: stretch !important;
    width: 100%;
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.dashboard-container {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background: var(--gray-50);
  margin: 0;
  padding: 0;
}

/* Modern color scheme and variables */
:root {
  --primary: #3b82f6;
  --primary-light: #93c5fd;
  --primary-dark: #1e40af;
  --secondary: #8b5cf6;
  --accent: #ec4899;
  --gray-50: #f9fafb;
  --gray-100: #f3f4f6;
  --gray-200: #e5e7eb;
  --gray-300: #d1d5db;
  --gray-700: #374151;
  --gray-800: #1f2937;
  --gray-900: #0f172a;
  --success: #10b981;
  --warning: #f59e0b;
  --danger: #ef4444;
}

.dashboard-header {
  background: linear-gradient(135deg, #0047AB 0%, #003680 100%) !important;
}

/* Minimal Dashboard Styles */
.premium-dashboard-header {
  background: white;
  border-radius: 12px;
  padding: 1.5rem;
  margin-bottom: 1.5rem;
  color: var(--gray-800);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  border: 1px solid var(--gray-200);
}

.premium-stats-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  flex-wrap: nowrap;
  position: relative;
  z-index: 1;
}

.premium-stat-card {
  background: var(--gray-50);
  border-radius: 8px;
  padding: 0.75rem;
  border: 1px solid var(--gray-200);
  display: flex;
  align-items: center;
  gap: 0.5rem;
  transition: all 0.2s ease;
  flex: 1 1;
  min-width: 200px;
}

.premium-stat-card:hover {
  background: white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.stat-icon-wrapper {
  width: 32px;
  height: 32px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.9rem;
  flex-shrink: 0;
  background: var(--gray-200);
  color: var(--gray-600);
}

.stat-content {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.5rem;
}

.stat-content h4 {
  font-size: 0.75rem;
  font-weight: 500;
  color: var(--gray-600);
  margin: 0;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.stat-content p {
  font-size: 1.2rem;
  font-weight: 600;
  margin: 0;
  color: var(--gray-900);
  white-space: nowrap;
}

.wallet-amount {
  color: var(--primary);
}

.premium-add-money-btn {
  background: var(--primary);
  color: white;
  border: none;
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  font-size: 0.7rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  margin-top: 0.5rem;
}

.premium-add-money-btn:hover {
  background: var(--primary-dark);
}

/* Premium Rate Management */
.premium-rate-management {
  margin-bottom: 2.5rem;
}

.rate-management-header {
  margin-bottom: 1.5rem;
  display: flex;
  justify-content: start;
  gap: 10px;
}

.rate-management-header h3 {
  font-size: 2.5rem;
  font-weight: 700;
  color: var(--gray-800);
  margin: 0 0 0.5rem 0;
}

.rate-management-header p {
  color: var(--gray-600);
  font-size: 1.2rem;
  margin-top: 10px;

  text-align: center;
}

.premium-rate-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 0.75rem;
}

.premium-rate-card {
  background: white;
  border-radius: 10px;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.05);
  border: 1px solid var(--gray-200);
  overflow: hidden;
  transition: all 0.3s ease;
  min-height: auto;
}

.premium-rate-card:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.06);
}

.rate-card-header {
  padding: 0.4rem 0.5rem;
  background: var(--gray-50);
  border-bottom: 1px solid var(--gray-200);
  display: flex;
  align-items: center;
  gap: 0.4rem;
  width: 100%;
}

.rate-card-icon {
  width: 20px;
  height: 20px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.6rem;
  color: white;
  flex-shrink: 0;
  background: var(--primary);
}

.bulk-icon {
  background: #10b981;
}

.type-icon {
  background: var(--gray-600);
}


.rate-card-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex: 1 1;
  width: 100%;
}

.heading-card-dashboard {
  flex: 1 1;
  font-size: 2rem;
  font-weight: 600;
  color: var(--gray-800);
  margin: 0;
}

.rate-card-title button {
  flex-shrink: 0;
  margin-left: auto;
}

.rate-card-title p {
  font-size: 0.8rem;
  color: var(--gray-600);
  margin: 0;
}

.rate-card-content {
  padding: 0.5rem;
  display: flex;
  flex-direction: column;
  /* Changed to column */
  gap: 0.5rem;
  flex-grow: 1;
  /* Allow content to grow */
}

.rate-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  color: var(--gray-600);
  font-size: 0.9rem;
  padding: 1rem;
}

.rate-edit-form {
  display: flex;
  flex-direction: row;
  gap: 5px;
  width: 100%;
  height: 100%;
  /* border: solid 2px green; */
  align-items: center;
}

.rate-input-group {
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: 0.5rem;
  flex-wrap: nowrap;
}

.rate-input-group label {
  font-weight: 600;
  color: black;
  font-size: 0.9rem;
  min-width: 30px;
  white-space: nowrap;
}

.premium-rate-input {
  /* flex: 1; */
  padding: 0.6rem 1rem;
  border: 2px solid var(--gray-300);
  border-radius: 8px;
  font-size: 1rem;
  transition: all 0.3s ease;
  min-width: 0;
  /* height: 50px; */
  /* border: solid 2px red; */
}

.premium-rate-input:focus {
  outline: none;
  border-color: var(--primary);
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.rate-edit-actions {
  display: flex;
  gap: 0.5rem;
  justify-content: center;
  /* align-items: center; */
  /* border: solid 2px green; */
  height: 40px;
  width: 40%;
  /* margin-top: 1.5rem; */
}

.premium-btn {
  padding: 0.3rem 0.6rem;
  border-radius: 4px;
  font-weight: 500;
  font-size: 0.75rem;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  gap: 0.2rem;
  text-decoration: none;
  min-width: auto;
  width: auto;
}

.premium-btn-primary {
  background: var(--primary);
  color: white;
}

.premium-btn-primary:hover {
  background: var(--primary-dark);
}

.premium-btn-success {
  background: var(--success);
  color: white;
}

.premium-btn-success:hover {
  background: #059669;
}

.premium-btn-secondary {
  background: #2563eb;
  color: white;
}

.premium-btn-secondary:hover {
  background: #1d4ed8;
}

.premium-btn-accent {
  background: var(--secondary);
  color: white;
}

.premium-btn-accent:hover {
  background: #7c3aed;
}

.premium-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.rate-display-form {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 1rem;
  width: 100%;
  height: 100%;
  /* border: solid 2px red; */
}

.rate-display-form-dashboard {
  display: flex;
  align-items: center;
  justify-content: space-between;
  /* font-size: 50px; */
  gap: 1rem;
  width: 100%;
  height: 100%;
  padding: 0.75rem;
  background: linear-gradient(135deg, #f8f9ff 0%, #ffffff 100%);
  border-radius: 8px;
  border: 1px solid var(--gray-200);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
}

.rate-display-form-dashboard:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  transform: translateY(-1px);
}

.current-milk-rate-display-dashboard {
  text-align: center;
  padding: 0.75rem 1rem;
  background: var(--gray-50);
  border-radius: 6px;
  border: 1px solid var(--gray-200);
  flex: 1 1;
  min-width: 120px;
  height: 50px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  transition: all 0.3s ease;
}

.rate-value {
  display: block;
  font-size: 1.2rem;
  font-weight: 600;
  color: var(--primary);
  margin-bottom: 0.1rem;
}

.rate-label {
  font-size: 0.8rem;
  color: var(--gray-600);
  font-weight: 500;
}

.bulk-rate-features,
.rate-settings-features {
  margin-bottom: 0.75rem;
  flex-grow: 1;
  /* Allow features to take up space */
}

.feature-item {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  margin-bottom: 0.3rem;
  font-size: 0.8rem;
  color: var(--gray-700);
}

/* New user highlight styles */
.new-user-highlight {
  color: #dc3545 !important;
  font-weight: 600 !important;
}

.new-user-message {
  color: #dc3545 !important;
  font-weight: 600 !important;
  font-style: italic;
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0.7;
  }

  100% {
    opacity: 1;
  }
}

.feature-check {
  color: var(--success);
  font-size: 0.5rem;
  flex-shrink: 0;
}

.feature-warning {
  color: #dc3545 !important;
  font-size: 0.5rem;
  flex-shrink: 0;
  animation: pulse 2s infinite;
}

.bulk-action-btn-rate,
.bulk-action-btn-milk-rate {
  width: auto;
  /* max-width: 150px; */
  justify-content: center;
  padding: 0.4rem 0.7rem;
  /* background-color: #047857; */
  font-size: 1rem;
  font-weight: 500;
  margin: 10px auto;
  display: flex;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s ease;
  align-items: center;
  gap: 0.3rem;
  height: fit-content;
}

.bulk-action-btn-rate {
  background-color: #0056b3;
}

.bulk-action-btn-milk-rate {
  background-color: #28a745;
}

/* Base styles for content buttons - 70% width and centered */
.rate-card-content .bulk-action-btn-rate,
.rate-card-content .bulk-action-btn-milk-rate {
  width: 70%;
  margin: 0 auto;
  justify-content: center;
  display: flex;
}

/* Hide content buttons on screens above 768px */
@media (min-width: 769px) {

  .rate-card-content .bulk-action-btn-rate,
  .rate-card-content .bulk-action-btn-milk-rate {
    display: none;
  }
}

/* Header button styling */
.rate-card-title .bulk-action-btn-rate,
.rate-card-title .bulk-action-btn-milk-rate {
  padding: 0.3rem 0.6rem;
  font-size: 0.7rem;
  border-radius: 4px;
  border: none;
  color: white;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 0.2rem;
  white-space: nowrap;
}

.rate-card-title .bulk-action-btn-rate:hover,
.rate-card-title .bulk-action-btn-milk-rate:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

.bulk-action-btn-rate svg {
  font-size: 0.9em;
  margin-right: 0.2rem;
}

.bulk-action-btn-rate:hover {
  background: #059669;
  transform: translateY(-1px);
}

/* Rate Content Wrapper - 50-50 Layout */
.rate-content-wrapper {
  display: flex;
  gap: 1rem;
  align-items: stretch;
}

.rate-display-section {
  flex: 1 1;
  display: flex;
  flex-direction: column;
}

.rate-type-section {
  flex: 1 1;
  display: flex;
  flex-direction: column;
}

.current-balance-section {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  flex-wrap: wrap;
  padding: 0.75rem 1rem;
  background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%);
  border-radius: 10px;
  border: 1px solid #bae6fd;
}

.wallet-balance-display {
  padding: 1rem 1.5rem;
  background: #ffffff;
}

.balance-label-payment {
  font-size: 15px;
  font-weight: 600;
  color: #0369a1;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.balance-amount {
  font-size: 1.5rem;
  font-weight: 700;
  color: #0284c7;
  min-width: 100px;
  text-align: center;
}

.refresh-balance-btn-payment {
  background: linear-gradient(135deg, #0284c7 0%, #0369a1 100%);
  border: none;
  border-radius: 8px;
  padding: 0.6rem;
  color: white;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  box-shadow: 0 2px 8px rgba(2, 132, 199, 0.25);
}

.refresh-balance-btn-payment:hover:not(:disabled) {
  background: linear-gradient(135deg, #0369a1 0%, #075985 100%);
  transform: scale(1.05);
  box-shadow: 0 4px 12px rgba(2, 132, 199, 0.35);
}

.refresh-balance-btn-payment:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.new-balance-section {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  margin-top: 0.75rem;
  padding-top: 0.75rem;
  border-top: 2px dashed #86efac;
  animation: slideDown 0.3s ease-out;
}

.new-balance-label-payment {
  font-size: 15px;
  font-weight: 600;
  color: #15803d;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.new-balance-amount {
  font-size: 1.5rem;
  font-weight: 700;
  color: #16a34a;
  min-width: 100px;
  text-align: center;
}

/* Mobile responsive for wallet balance display */
@media (max-width: 768px) {
  .wallet-balance-display {
    padding: 0.875rem 1rem;
  }

  .current-balance-section {
    padding: 0.6rem 0.8rem;
    gap: 0.5rem;
    flex-wrap: nowrap;
  }

  .balance-amount,
  .new-balance-amount {
    font-size: 1.1rem;
    min-width: auto;
  }

  .balance-label-payment,
  .new-balance-label-payment {
    font-size: 12px !important;
  }

  .refresh-balance-btn-payment {
    padding: 0.4rem;
    font-size: 0.8rem;
  }

  .new-balance-section {
    margin-top: 0.5rem;
    padding-top: 0.5rem;
    flex-wrap: nowrap;
  }
}

/* rate settings modal - exact match to image */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1001;
  padding: 16px;
}

.modal-container {
  background: white;
  width: 100%;
  max-width: 350px;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}

/* Increase modal width on desktop screens */
@media (min-width: 769px) {
  .modal-container {
    max-width: 500px;
  }
}

/* Header */
.rate-settings-modal-header {
  padding: 16px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #f0f0f0;
}

.rate-settings-modal-header h2 {
  font-size: 18px;
  font-weight: 600;
  color: #1a1a1a;
  margin: 0;
}

.rate-settings-modal-close-btn {
  background: none;
  border: none;
  font-size: 20px;
  color: #666;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
}

.rate-settings-modal-close-btn:hover {
  background: #f5f5f5;
}

/* Body */
.rate-settings-modal-body {
  padding: 16px 20px;
}

.rate-settings-modal-section {
  margin-bottom: 16px;
}

.rate-settings-modal-section:last-child {
  margin-bottom: 0;
}

.rate-settings-modal-heading {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin-bottom: 8px;
}

/* Milk Rate Card - Blue container */
.rate-settings-modal-input-group-dashboard {
  background: #f8f9fa;
  border: none;
  border-radius: 12px;
  padding: 16px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.rate-settings-modal-label {
  font-size: 14px;
  color: #666;
  font-weight: 500;
}

.rate-settings-modal-input {
  border: solid 1px #003680;
  border-radius: 5px;
  background: transparent;
  font-size: 23px;
  font-weight: 700;
  color: #0047AB;
  width: 90px;
  text-align: center;

  /* outline: none; */
}

.rate-settings-modal-input:disabled {
  color: #0047AB;
  opacity: 1;
}

/* Dropdown */
.rate-settings-modal-dropdown {
  width: 100%;
  padding: 14px 16px;
  border: 1px solid #e0e0e0;
  border-radius: 12px;
  font-size: 16px;
  appearance: none;
  background-color: white;
  color: #333;
  font-weight: 500;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 12px center;
  background-size: 16px;
  padding-right: 40px;
}

/* Option Buttons - Grid layout */
.rate-settings-modal-row {
  display: flex;
  gap: 16px;
  margin-bottom: 16px;
}

.rate-settings-modal-col {
  flex: 1 1;
}

.rate-settings-modal-options {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

.rate-settings-modal-option-btn {
  padding: 12px 16px;
  border: 1px solid #e0e0e0;
  background: white;
  border-radius: 8px;
  font-weight: 600;
  color: #666;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 14px;
}

.rate-settings-modal-option-btn.active {
  background-color: #0047AB;
  border-color: #0047AB;
  color: white;
}

.rate-settings-modal-option-btn:hover:not(.active) {
  background: #f8f9fa;
  border-color: #adb5bd;
}

/* Footer Buttons */
.rate-settings-modal-footer {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  padding: 16px 20px;
  border-top: 1px solid #f0f0f0;
}

.rate-settings-modal-cancel-btn {
  padding: 14px 20px;
  background: white;
  border: 1px solid #0047AB;
  border-radius: 12px;
  font-weight: 600;
  color: #0047AB;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.rate-settings-modal-cancel-btn:hover {
  background: #f8f9fa;
}

.rate-settings-modal-save-btn {
  padding: 14px 20px;
  background-color: #0047AB;
  border: none;
  border-radius: 12px;
  color: white;
  font-weight: 600;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.rate-settings-modal-save-btn:hover:not(:disabled) {
  background: #003680;
}

.rate-settings-modal-save-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Edit/Save buttons for milk rate */
.balance-label-payment {
  font-size: 15px;
  font-weight: 500;
  color: #0c4a6e;
}

.balance-amount {
  font-size: 1.25rem;
  font-weight: 700;
  color: #0284c7;
}

.refresh-balance-btn-payment {
  background: #0284c7;
  border: none;
  border-radius: 6px;
  padding: 0.5rem;
  color: white;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  margin-left: 0.5rem;
}

.refresh-balance-btn-payment:hover:not(:disabled) {
  background: #0369a1;
  transform: scale(1.05);
}

.refresh-balance-btn-payment:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.new-balance-label-payment {
  font-size: 15px;
  font-weight: 500;
  color: #15803d;
}

.rate-settings-modal-btn {
  background-color: #0047AB;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 10px 16px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 8px;
}

.rate-settings-modal-btn:hover:not(:disabled) {
  background-color: #003680;
}

.rate-settings-modal-btn-secondary {
  background-color: #6c757d;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 8px 10px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 8px;
}

.rate-settings-modal-btn-secondary:hover {
  background-color: #5a6268;
}

.rate-settings-modal-flex-gap {
  display: flex;
  gap: 8px;
}

.rate-settings-modal-icon-margin {
  margin-right: 2px;
}

.edit-field {
  /* border: solid 2px red; */
  margin-bottom: 10px;
}

/* Confirmation Modal Styles */
.confirmation-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  padding: 16px;
}

.confirmation-modal-container {
  background: white;
  width: 100%;
  max-width: 350px;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}

.confirmation-modal-header {
  padding: 16px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #f0f0f0;
}

.confirmation-modal-header h3 {
  font-size: 16px;
  font-weight: 600;
  color: #1a1a1a;
  margin: 0;
}

.confirmation-modal-close-btn {
  background: none;
  border: none;
  font-size: 18px;
  color: #666;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
}

.confirmation-modal-close-btn:hover {
  background: #f5f5f5;
}

.confirmation-modal-body {
  padding: 16px 20px;
  text-align: center;
}

.confirmation-modal-message {
  font-size: 14px;
  color: #333;
  margin-bottom: 12px;
  font-weight: 500;
}

.confirmation-modal-value-display {
  background: #0047AB;
  color: white;
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 600;
  display: inline-block;
  margin-bottom: 12px;
}

.confirmation-modal-description {
  font-size: 12px;
  color: #666;
  margin: 0;
}

.confirmation-modal-footer {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  padding: 16px 20px;
  border-top: 1px solid #f0f0f0;
}

.confirmation-modal-cancel-btn {
  padding: 10px 16px;
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  font-weight: 500;
  color: #666;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.confirmation-modal-cancel-btn:hover {
  background: #f8f9fa;
}

.confirmation-modal-confirm-btn {
  padding: 10px 16px;
  background-color: #0047AB;
  border: none;
  border-radius: 8px;
  color: white;
  font-weight: 500;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.confirmation-modal-confirm-btn:hover {
  background-color: #003680;
}


/* Mobile Responsive Styles for Rate Content */
@media (max-width: 768px) {
  .rate-content-wrapper {
    flex-direction: column;
    gap: 1rem;
  }

  .rate-display-section,
  .rate-type-section {
    flex: none;
    width: 100%;
  }

  .modal-container {
    width: 95%;
    max-width: 320px;
    border-radius: 12px;
  }

  .rate-settings-modal-header {
    padding: 16px 20px;
  }

  .rate-settings-modal-header h2 {
    font-size: 16px;
  }

  .rate-settings-modal-close-btn {
    font-size: 18px;
  }

  .rate-settings-modal-body {
    padding: 16px 20px;
  }

  .rate-settings-modal-section {
    margin-bottom: 20px;
  }

  .rate-settings-modal-heading {
    font-size: 14px;
    margin-bottom: 10px;
  }

  .rate-settings-modal-input-group {
    padding: 12px;
  }

  .rate-settings-modal-label {
    font-size: 12px;
  }

  .rate-settings-modal-input {
    font-size: 20px;
    width: 70px;
  }

  .rate-settings-modal-dropdown {
    padding: 10px 12px;
    font-size: 14px;
    padding-right: 35px;
  }

  .rate-settings-modal-row {
    gap: 12px;
    margin-bottom: 20px;
  }

  .rate-settings-modal-options {
    gap: 8px;
  }

  .rate-settings-modal-option-btn {
    padding: 10px 12px;
    font-size: 12px;
  }

  .rate-settings-modal-footer {
    padding: 16px 20px;
    gap: 12px;
  }

  .rate-settings-modal-cancel-btn,
  .rate-settings-modal-save-btn {
    padding: 12px 16px;
    font-size: 14px;
  }

  .rate-settings-modal-btn,
  .rate-settings-modal-btn-secondary {
    padding: 6px 10px;
    font-size: 12px;
  }

  .rate-settings-modal-flex-gap {
    gap: 6px;
  }

  .rate-settings-modal-icon-margin {
    margin-right: 2px;
  }

  /* Mobile styles for rate display form dashboard */
  .rate-display-form-dashboard {
    flex-direction: column;
    align-items: stretch;
    gap: 0.5rem;
    padding: 0.5rem;
    height: auto;
    min-height: auto;
  }

  .current-milk-rate-display-dashboard {
    width: 100%;
    height: 45px;
    min-width: auto;
    padding: 0.5rem;
  }

  .rate-value {
    font-size: 1rem;
    font-weight: 600;
  }

  .edit-rate-button-dashboard {
    width: auto;
    max-width: 250px;
    justify-content: center;
    padding: 0.5rem 0.75rem;
    font-size: 0.75rem;
    height: auto;
    min-height: 40px;
    white-space: nowrap;
    margin: auto;
  }
}

/* Rate Type Control - Updated for 50-50 layout */
.preview-table-bulk {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
  border: 1px solid #e0e0e0;
}

.preview-table-bulk th,
.preview-table-bulk td {
  border: 1px solid #e0e0e0;
  padding: 8px 12px;
  text-align: center;
}

.preview-table-bulk th {
  background-color: #f5f5f5;
  font-weight: 600;
}

.rate-type-control-compact {
  display: flex;
  flex-direction: column;
  gap: 0rem;
  /* padding: 1revm; */
  /* background: linear-gradient(135deg, #f8f9ff 0%, #ffffff 100%); */
  border-radius: 8px;
  /* box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05); */
  border: none;
  height: 100%;
}

.rate-type-row {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex-wrap: wrap;
  justify-content: flex-start;
}

.rate-type-label {
  font-size: 1.2rem;
  font-weight: 600;
  color: var(--gray-700);
  margin: auto;
  white-space: nowrap;
  background: linear-gradient(135deg, var(--primary-light) 0%, var(--primary) 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.premium-select-rate-type {
  border: 1px solid var(--gray-300);
  padding: 0.5rem 0.75rem;
  border-radius: 6px;
  font-size: 0.7rem;
  background: white;
  cursor: pointer;
  transition: all 0.2s ease;
  outline: none;
  min-width: 120px;
  width: 50%;
  height: auto;
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-repeat: no-repeat;
  background-position: right 0.5rem center;
  padding-right: 2rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.premium-select-rate-type:hover {
  border-color: var(--primary);
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.1);
  transform: translateY(-1px);
}

.premium-select-rate-type:focus {
  border-color: var(--primary);
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.15);
}

.premium-select-rate-type:disabled {
  background-color: var(--gray-100);
  color: var(--gray-500);
  cursor: not-allowed;
  opacity: 0.6;
}

/* Mobile responsive styling for rate type dropdown */
@media (max-width: 768px) {
  .premium-select-rate-type {
    padding: 0.4rem 0.6rem;
    font-size: 12px;
    min-width: 100px;
    width: 60%;
    border-radius: 4px;
    background-position: right 0.4rem center;
    padding-right: 1.5rem;
  }

  .premium-select-rate-type:hover {
    box-shadow: 0 0 0 1px rgba(59, 130, 246, 0.1);
    transform: translateY(-0.5px);
  }

  .premium-select-rate-type:focus {
    box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.15);
  }

  .premium-select-rate-type option {
    font-size: 0.6rem;
  }
}

@media (max-width: 480px) {
  .premium-select-rate-type {
    padding: 0.3rem 0.5rem;
    font-size: 12px;
    min-width: 80px;
    margin: auto;
    width: 70%;
    border-radius: 3px;
    background-position: right 0.3rem center;
    padding-right: 1.2rem;
  }

  .premium-select-rate-type:hover {
    transform: none;
  }

  .premium-select-rate-type:focus {
    box-shadow: 0 0 0 1px rgba(59, 130, 246, 0.15);
  }

  .premium-select-rate-type option {
    font-size: 1rem;
  }

  /* Mobile styling for Current Milk Rate card */
  .premium-rate-card {
    padding: 0.5rem;
  }

  .rate-card-header {
    flex-direction: row;
    padding: 0.4rem;
    gap: 0.4rem;
  }

  .rate-card-icon {
    width: 20px;
    height: 20px;
    font-size: 0.6rem;
  }

  .heading-card-dashboard {
    font-size: 2rem;
    margin-bottom: 0.05rem;
    font-weight: 600;
    text-align: left;
  }

  .rate-card-title p {
    font-size: 0.5rem;
  }

  .rate-card-content {
    padding: 0.5rem;
    gap: 0rem;
  }

  .current-rate-display {
    padding: 0.4rem;
    min-width: 70px;
  }

  .rate-value {
    font-size: 0.9rem;
    font-weight: 600;
  }

  .rate-label {
    font-size: 0.6rem;
  }

  .edit-rate-button {
    padding: 0.2rem 0.4rem;
    font-size: 0.55rem;
    gap: 0.15rem;
  }


  .rate-type-row {
    gap: 0.4rem;
  }

  .rate-type-label {
    font-size: 1rem;
  }

  .save-rate-button {
    padding: 0.2rem 0.4rem;
    font-size: 0.55rem;
    max-width: 60px;
    border-radius: 3px;
  }
}

.premium-select-rate-type option {
  padding: 0.25rem 0.5rem;
  font-size: 0.65rem;
  background: white;
  color: var(--gray-700);
}

.premium-select-rate-type.compact {
  padding: 0.2rem 0.4rem;
  font-size: 0.6rem;
  min-width: 80px;
  height: 24px;
  background-position: right 0.2rem center;
  padding-right: 1rem;
}

.premium-select-rate-type.compact:hover {
  box-shadow: 0 0 0 1px rgba(59, 130, 246, 0.1);
}

.premium-select-rate-type.compact:focus {
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.15);
}

.premium-select-rate-type.compact option {
  font-size: 0.6rem;
}

.premium-select.compact {
  padding: 0.4rem 0.6rem;
  font-size: 0.875rem;
  border-radius: 4px;
  flex: 1 1;
  min-width: 120px;
}

.rate-type-saving-indicator {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #10b981;
  font-size: 0.75rem;
  margin-left: 8px;
  padding: 3px 6px;
  background-color: rgba(16, 185, 129, 0.1);
  border-radius: 4px;
  animation: pulse 1.5s ease-in-out infinite;
}

@keyframes pulse {

  0%,
  100% {
    opacity: 1;
  }

  50% {
    opacity: 0.6;
  }
}

.save-rate-button {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  border: none;
  color: white;
  padding: 0.35rem 0.75rem;
  border-radius: 6px;
  font-size: 0.75rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  white-space: nowrap;
  min-width: auto;
  width: auto;
  max-width: 120px;
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.25);
}

.save-rate-button:hover:not(:disabled) {
  background: linear-gradient(135deg, #059669 0%, #047857 100%);
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(16, 185, 129, 0.35);
}

.save-rate-button:disabled {
  background: linear-gradient(135deg, #e5e7eb 0%, #d1d5db 100%);
  color: #9ca3af;
  cursor: not-allowed;
  transform: none;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.premium-select.compact {
  padding: 0.25rem 0.5rem;
  font-size: 0.65rem;
  min-width: 90px;
  border-radius: 4px;
  border: 1px solid var(--gray-300);
  background: white;
  cursor: pointer;
  transition: all 0.2s ease;
  outline: none;
  height: 28px;
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-repeat: no-repeat;
  background-position: right 0.4rem center;
  padding-right: 1.2rem;
}

.premium-select.compact:hover {
  border-color: var(--primary);
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.1);
}

.premium-select.compact:focus {
  border-color: var(--primary);
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.15);
}

.premium-select.compact option {
  padding: 0.25rem 0.5rem;
  font-size: 0.65rem;
  background: white;
  color: var(--gray-700);
}

/* Mobile responsive dropdown */
@media (max-width: 768px) {
  .premium-select.compact {
    padding: 0.15rem 0.3rem;
    font-size: 0.55rem;
    min-width: 70px;
    height: 24px;
    background-position: right 0.2rem center;
    padding-right: 1rem;
  }

  .premium-select.compact:hover {
    box-shadow: 0 0 0 1px rgba(59, 130, 246, 0.1);
  }

  .premium-select.compact:focus {
    box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.15);
  }

  .premium-select.compact option {
    font-size: 0.55rem;
  }

  /* Mobile styling for Bulk Rate Update card */
  .premium-rate-card {
    padding: 0.5rem;
  }

  .rate-card-header {
    padding: 0.4rem;
    gap: 0.4rem;
    flex-direction: row;
  }

  .rate-card-icon {
    width: 20px;
    height: 20px;
    font-size: 0.6rem;
  }

  .heading-card-dashboard {
    font-size: 1rem;
    margin-bottom: 0.05rem;
  }

  .rate-card-title p {
    font-size: 0.5rem;
  }

  .rate-card-content {
    padding: 0.5rem;
    gap: 0rem;
    /* border: solid 2px red; */
  }

  .bulk-rate-features {
    margin-bottom: 0.5rem;
  }

  .feature-item {
    font-size: 0.6rem;
    margin-bottom: 0.3rem;
    gap: 0.3rem;
  }

  .feature-check {
    font-size: 0.5rem;
  }

  .bulk-action-btn-rate {
    /* padding: 0.3rem 0.6rem; */
    font-size: 0.6rem;
    min-height: 28px;
    border-radius: 3px;
    width: 90%;
    /* border: solid 2px red; */
  }

  .bulk-action-btn-rate svg {
    font-size: 0.8em;
  }
}

.premium-btn.compact {
  padding: 0.4rem 0.8rem;
  font-size: 0.75rem;
  min-height: auto;
  height: auto;
}

.premium-select {
  padding: 0.6rem 1rem;
  border: 2px solid var(--gray-300);
  border-radius: 8px;
  font-size: 0.9rem;
  background: white;
  cursor: pointer;
  transition: all 0.3s ease;
}

.premium-select:focus {
  outline: none;
  border-color: var(--primary);
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

/* Premium Action Sections */
.premium-action-sections {
  margin-bottom: 2rem;
}

.premium-action-sections .section-header {
  margin-bottom: 1.5rem;
}

.premium-action-sections .section-header h3 {
  font-size: 2.5rem;
  font-weight: 700;
  color: var(--gray-800);
  margin: 0 0 0.5rem 0;
}

.premium-action-sections .section-header p {
  color: var(--gray-600);
  font-size: 1.2rem;
  margin: 0;
}

.premium-action-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 1rem;
}

.premium-action-card {
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.06);
  border: 1px solid var(--gray-200);
  overflow: hidden;
  transition: all 0.3s ease;
}

.premium-action-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.08);
}

.premium-action-card.disabled-card {
  opacity: 0.6;
  pointer-events: none;
}

.action-card-header {
  padding: 1rem;
  background: var(--gray-50);
  border-bottom: 1px solid var(--gray-200);
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.action-card-icon {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
  color: white;
  flex-shrink: 0;
}

.standard-icon {
  background: var(--primary);
}

.prorata-icon {
  background: var(--primary);
}

.reports-icon {
  background: red;
}

.action-card-title h4 {
  font-size: 1.2rem;
  font-weight: 600;
  color: var(--gray-800);
  margin: 0 0 0.2rem 0;
}

.action-card-title p {
  font-size: 0.9rem;
  color: var(--gray-600);
  margin: 0;
}

.action-card-content {
  padding: 1rem;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  /* border: solid 2px red; */
  gap: 0.75rem;
}

.premium-action-btn {
  padding: 1rem 0.8rem;
  border-radius: 8px;
  font-weight: 500;
  font-size: 0.9rem;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  text-decoration: none;
  justify-content: center;
  /* border: solid 2px green; */
}

.premi.bulk-action-btn {
  padding: 0.6rem 1rem;
  border-radius: 8px;
  font-weight: 500;
  font-size: 0.85rem;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  text-decoration: none;
  justify-content: center;
}

.primary-btn {
  background: #28a745;
  color: white;
}

.primary-btn:hover {
  background: #218838;
}

.secondary-btn {
  background: linear-gradient(135deg, #0047AB 0%, #003680 100%);
  color: white;
  border: 1px solid #003680;
}

.secondary-btn:hover {
  background: linear-gradient(135deg, #003680 0%, #002850 100%);
}

.premium-action-btn.disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.disabled-badge {
  font-size: 0.75rem;
  color: var(--warning);
  font-weight: 600;
  background-color: rgba(245, 158, 11, 0.1);
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  border: 1px solid rgba(245, 158, 11, 0.3);
  display: inline-block;
  margin-top: 0.5rem;
}

/* Responsive Design for Premium Dashboard */
@media (max-width: 1024px) {
  .premium-dashboard-header {
    padding: 2rem;
  }

  .premium-header-title h2 {
    font-size: 1.8rem;
  }

  .premium-stats-row {
    grid-template-columns: 1fr;
    gap: 1rem;
  }

  .premium-rate-cards {
    grid-template-columns: 1fr;
  }

  .premium-action-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 768px) {
  .premium-dashboard-header {
    padding: 1.5rem;
    margin-bottom: 1.5rem;
  }

  .premium-header-title h2 {
    font-size: 1.5rem;
  }

  .premium-header-title p {
    font-size: 1rem;
  }

  .premium-stat-card {
    padding: 1rem;
  }

  .stat-icon-wrapper {
    width: 40px;
    height: 40px;
    font-size: 1.1rem;
  }

  .stat-content p {
    font-size: 1.1rem;
  }

  .rate-management-header h3 {
    font-size: 1.5rem;
  }

  .premium-action-sections .section-header h3 {
    font-size: 1.5rem;
  }

  .rate-card-header,
  .action-card-header {
    padding: 1rem;
  }

  .rate-card-content,
  .action-card-content {
    padding: 1rem;
  }

  .rate-card-icon,
  .action-card-icon {
    width: 40px;
    height: 40px;
    font-size: 1rem;
  }

  .heading-card-dashboard,
  .action-card-title h4 {
    font-size: 1rem;
  }

  .rate-value {
    font-size: 1.5rem;
  }

  .premium-btn {
    padding: 0.5rem 1rem;
    font-size: 0.8rem;
  }

  .premium-action-btn {
    padding: 0.6rem 1rem;
    font-size: 0.8rem;
  }

  .action-card-content {
    flex-direction: column;
    gap: 0.5rem;
  }

  /* Responsive rate cards for tablets */
  .premium-rate-cards {
    grid-template-columns: 1fr;
    gap: 1rem;
  }

  .rate-card-header {
    padding: 0.6rem 0.8rem;
    gap: 0.6rem;
  }

  .rate-card-icon {
    width: 22px;
    height: 22px;
    font-size: 0.65rem;
  }

  .heading-card-dashboard {
    font-size: 1rem;
  }

  .rate-card-content {
    padding: 0.8rem;
    gap: 0.6rem;
  }

  .feature-item {
    font-size: 0.85rem;
    gap: 0.5rem;
    margin-bottom: 0.4rem;
  }

  .feature-check {
    font-size: 0.55rem;
  }

  .rate-card-title .bulk-action-btn-rate,
  .rate-card-title .bulk-action-btn-milk-rate {
    padding: 0.4rem 0.7rem;
    font-size: 0.75rem;
    gap: 0.25rem;
  }

  /* Hide content buttons on tablet */
  .rate-card-content .bulk-action-btn-rate,
  .rate-card-content .bulk-action-btn-milk-rate {
    display: none;
  }
}

@media (max-width: 480px) {
  .premium-dashboard-header {
    padding: 0.75rem;
    margin-bottom: 1rem;
  }

  .premium-header-title h2 {
    font-size: 1.3rem;
  }

  .premium-stats-row {
    flex-direction: column;
    gap: 0.75rem;
  }

  .owner-wallet-row {
    flex-direction: column;
    align-items: flex-start;
    /* gap: 0.5rem; */
  }

  .owner-info {
    width: 100%;
  }

  .wallet-info {
    width: 100%;
    /* justify-content: space-between; */
  }

  .stat-icon-wrapper {
    width: 40px;
    height: 40px;
    border-radius: 8px;
    font-size: 1rem;
    background: var(--primary);
    color: white;
  }

  .dairy-icon {
    background: #0056b3;
  }

  .wallet-icon {
    background: #10b981;
  }

  .stat-content {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.25rem;
    text-align: left;
    flex: 1 1;
  }

  .stat-content h4 {
    font-size: 0.65rem;
    font-weight: 600;
    color: var(--gray-600);
    margin-bottom: 0.1rem;
  }

  .stat-content p {
    font-size: 0.85rem;
    font-weight: 700;
    color: var(--gray-900);
    margin: 0;
  }

  .wallet-amount {
    color: #10b981;
    font-size: 0.9rem;
    font-weight: 700;
  }

  .premium-add-money-btn {
    margin-top: 0.25rem;
    padding: 0.2rem 0.5rem;
    font-size: 0.6rem;
    border-radius: 4px;
    background: #10b981;
    color: white;
    border: none;
    font-weight: 600;
    box-shadow: 0 2px 4px rgba(16, 185, 129, 0.2);
  }

  .premium-add-money-btn:hover {
    background: #059669;
    transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(64, 73, 70, 0.3);
  }

  .rate-edit-actions {
    flex-direction: column;
  }

  .rate-input-group {
    flex-direction: row;
    align-items: center;
    gap: 0.5rem;
    /* border: solid 2px red; */
  }

  .action-card-content {
    flex-direction: column;
    gap: 0.5rem;
  }

  .premium-action-btn {
    padding: 0.8rem 0.6rem;
    font-size: 0.8rem;
  }

  /* Responsive rate cards for mobile */
  .premium-rate-cards {
    grid-template-columns: 1fr !important;
    gap: 0.6rem !important;
  }

  .premium-rate-card {
    border-radius: 8px !important;
    border: 1px solid rgba(0, 0, 0, 0.08) !important;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.02) !important;
  }

  .rate-card-header {
    padding: 6px 10px !important;
    gap: 6px !important;
    background: #fafafa !important;
    border-bottom: 1px solid #f0f0f0 !important;
  }

  .rate-card-icon {
    width: 20px !important;
    height: 20px !important;
    font-size: 0.65rem !important;
    border-radius: 4px !important;
  }

  .heading-card-dashboard {
    font-size: 0.8rem !important;
    font-weight: 700 !important;
    color: #1f2937 !important;
  }

  .current-rate-box-dashboard {
    padding: 2px 6px !important;
    margin-top: 0px !important;
    border-radius: 6px !important;
    margin-right: 0px !important;
  }

  .current-rate-box-dashboard .rate-symbol,
  .current-rate-box-dashboard .rate-amount {
    font-size: 11px !important;
  }

  .rate-card-content {
    padding: 8px 10px !important;
    display: flex !important;
    flex-direction: column !important;
    gap: 8px !important;
  }

  .feature-item {
    font-size: 0.72rem !important;
    gap: 6px !important;
    margin-bottom: 4px !important;
    color: #4b5563 !important;
    display: flex !important;
    align-items: center !important;
  }

  .feature-check {
    font-size: 0.6rem !important;
    color: #10b981 !important;
  }

  /* Hide buttons in header on mobile */
  .rate-card-title .bulk-action-btn-rate,
  .rate-card-title .bulk-action-btn-milk-rate {
    display: none !important;
  }

  /* Show buttons at bottom of content on mobile as full-width */
  .rate-card-content .bulk-action-btn-rate,
  .rate-card-content .bulk-action-btn-milk-rate {
    display: flex !important;
    padding: 7px 12px !important;
    font-size: 0.78rem !important;
    font-weight: 600 !important;
    gap: 6px !important;
    width: 100% !important;
    margin: 2px 0 0 0 !important;
    border-radius: 6px !important;
    justify-content: center !important;
    box-sizing: border-box !important;
  }

  /* 
  .bulk-action-btn {
    padding: 0.6rem 1rem;
    font-size: 0.9rem;
  } */

  /* Mobile styling for Current Milk Rate card */
  .premium-rate-card {
    padding: 0.75rem;
  }

  .rate-card-header {
    padding: 0.5rem;
    gap: 0.5rem;
    flex-direction: row;
  }

  .rate-card-icon {
    width: 24px;
    height: 24px;
    font-size: 0.7rem;
  }

  .heading-card-dashboard {
    font-size: 1.5rem;
    margin-bottom: 0.1rem;
    font-weight: 600;
  }

  .rate-card-title p {
    font-size: 0.6rem;
  }

  .rate-card-content {
    padding: 0.75rem;
    gap: 0.5rem;
    /* border: solid 2px red; */
  }

  .current-rate-display {
    padding: 0.4rem;
    min-width: 70px;
  }

  .rate-value {
    font-size: 0.9rem;
    font-weight: 600;
  }

  .rate-label {
    font-size: 0.6rem;
  }

  .edit-rate-button {
    padding: 0.3rem 0.6rem;
    font-size: 0.65rem;
    gap: 0.2rem;
  }

  .rate-type-row {
    gap: 0.4rem;
  }

  .premium-select.compact {
    padding: 0.3rem 0.5rem;
    font-size: 0.7rem;
    min-width: 100px;
  }

  .save-rate-button {
    padding: 0.3rem 0.6rem;
    font-size: 0.65rem;
    max-width: 80px;
  }

  .premium-rate-input {
    padding: 0.25rem 0.4rem;
    font-size: 0.7rem;
    border-radius: 4px;
  }

  .rate-edit-actions {
    gap: 0.3rem;
    margin-top: 0.3rem;
  }

  .premium-btn {
    padding: 0.2rem 0.4rem;
    font-size: 0.55rem;
    border-radius: 3px;
  }

  .edit-rate-button {
    padding: 0.2rem 0.4rem;
    font-size: 0.55rem;
    gap: 0.15rem;
  }

  .premium-select-rate.compact {
    padding: 0.2rem 0.4rem;
    font-size: 0.6rem;
    min-width: 80px;
    border-radius: 3px;
  }

  .save-rate-button {
    padding: 0.2rem 0.4rem;
    font-size: 0.55rem;
    max-width: 60px;
    border-radius: 3px;
  }
}

/* Header */
.dashboard-header {
  background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);

  padding: 0;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: none;
  box-shadow: 0 8px 32px rgba(37, 99, 235, 0.2);
  gap: 1rem;
  height: 70px;
  position: relative;
  /* Establishes a stacking context */
  z-index: 999;
  width: 100vw;
  left: 50%;
  transform: translateX(-50%);
}

/* Desktop Header Layout */
.desktop-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 100%;
}

/* Mobile Header Layout */
.mobile-header {
  display: none;
  flex-direction: column;
  width: 100%;
  height: auto;


}

.mobile-header-top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 0.5rem 1rem 0.5rem;
  min-height: 55px;
  position: relative;
  gap: 0.5rem;
  margin-top: 0;
}

.mobile-header-title {
  position: absolute;
  /* left: 50%; */
  /* transform: translateX(-50%); */
  font-size: 1.2rem;
  font-weight: 600;
  color: white;
  margin: 0;
  white-space: nowrap;
  text-align: left;
  z-index: 1;
}

.mobile-header-bottom {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.5rem;
  min-height: 40px;

}

.header-center {
  flex: 1 1;
  text-align: center;
  padding: 0;
  margin: 0;
}

.dashboard-header h1 {
  font-size: 2rem;
  color: white;
  margin: 0;
  padding: 0;
  font-weight: 700;
}

.logo-container {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.2);
  width: 50px;
  height: 50px;
  border-radius: 10px;
  flex-shrink: 0;
  box-shadow: none;
  transition: all 0.3s ease;
  margin: 0;
  padding: 0;
  margin-left: 1.5rem;
}

.logo-container-mobile {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.2);
  width: 44px;
  height: 44px;
  border-radius: 10px;
  flex-shrink: 0;
  box-shadow: none;
  transition: all 0.3s ease;
  margin: 0;
  padding: 0;
}

.logo-container:hover {
  transform: scale(1.08);
  background: rgba(255, 255, 255, 0.3);
}

.logo {
  position: relative;
  top: 0;
  width: 40px;
  object-fit: contain;
  background: transparent;
  margin: 0;
  padding: 0;
}

.user-info {
  display: flex;
  align-items: center;
  gap: 1rem;
  flex-shrink: 0;
  margin: 0;
  padding: 0;
  margin-right: 1rem;
  overflow: visible;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin: 0;
  padding: 0;
  overflow: visible;
}

.home-btn {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: white;
  text-decoration: none;
  padding: 0.5rem 1rem;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  transition: all 0.3s ease;
  font-size: 0.9rem;
  font-weight: 500;
}

.home-btn:hover {
  background: rgba(255, 255, 255, 0.2);
  transform: translateY(-2px);
}

.home-btn-mobile {
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  text-decoration: none;
  padding: 0.5rem;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  transition: all 0.3s ease;
  font-size: 1rem;
}

.home-btn-mobile:hover {
  background: rgba(255, 255, 255, 0.2);
}

.user-details {
  display: flex;
  flex-direction: row;
  gap: 0.8rem;
  align-items: center;
  background: rgba(255, 255, 255, 0.15);
  padding: 0.5rem 1rem;
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  margin: 0;
  backdrop-filter: blur(10px);
}

.user-name-phone {
  display: flex;
  align-items: center;
  gap: 0.6rem;
}

.user-icon,
.phone-icon {
  color: white;
  font-size: 0.9rem;
}

.user-name {
  color: white;
  font-weight: 600;
  font-size: 0.95rem;
}

.user-phone {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  font-size: 0.8rem;
  color: rgba(255, 255, 255, 0.9);
  font-weight: 400;
}

.logout-button {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 6px;
  background-color: rgba(255, 255, 255, 0.15);
  color: white;
  transition: all 0.3s ease;
  cursor: pointer;
  font-weight: 500;
  font-size: 0.85rem;
  box-shadow: none;
  margin: 0;
  backdrop-filter: blur(10px);
}


.logout-button:active {
  transform: translateY(0);
  box-shadow: 0 2px 6px rgba(239, 68, 68, 0.15);
}

/* Profile Dropdown Styles */
.profile-dropdown {
  position: relative;
  width: fit-content;
  /* padding: 10px; */
  z-index: 99999;
  /* border: green solid 2px; */
}

.profile-button-dashboard {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 6px;
  background-color: rgba(255, 255, 255, 0.15);
  color: white;
  transition: all 0.3s ease;
  cursor: pointer;
  font-weight: 500;
  font-size: 0.85rem;
  box-shadow: none;
  margin: 0;
  backdrop-filter: blur(10px);
}

.profile-button-dashboard:hover {
  background-color: rgba(255, 255, 255, 0.25);
  border-color: rgba(255, 255, 255, 0.4);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.profile-icon-dashboard {
  font-size: 1.2rem;
  color: white;
  /* border: solid 2px red; */
}

.profile-chevron {
  font-size: 0.7rem;
  color: rgba(255, 255, 255, 0.9);
  transition: transform 0.3s ease;
}

.profile-chevron.open {
  transform: rotate(180deg);
}

.profile-menu {
  position: absolute;
  top: calc(100% + 0.5rem);
  right: 0;
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
  min-width: 250px;
  max-width: 300px;
  z-index: 99999;
  overflow: visible;
  transform: translateX(0);
  opacity: 1;
  visibility: visible;
}

/* Prevent dropdown from going off-screen on smaller viewports */
@media (max-width: 768px) {
  .profile-menu {
    right: -1rem;
    min-width: 200px;
    max-width: 250px;
  }
}

@media (max-width: 480px) {
  .profile-menu {
    right: -2rem;
    min-width: 180px;
    max-width: 220px;
  }
}

.profile-info {
  padding: 1rem;
  border-bottom: 1px solid #f0f0f0;
}

.profile-header-dashborad {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 0.75rem;
}

.profile-avatar {
  font-size: 2rem;
  color: var(--primary);
  flex-shrink: 0;
}

.profile-details {
  flex: 1 1;
}

.profile-name {
  font-size: 0.95rem;
  font-weight: 600;
  color: #333;
  margin-bottom: 0.2rem;
}

.profile-role {
  font-size: 0.8rem;
  color: #666;
}

.profile-contact,
.profile-dairy {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.85rem;
  color: #555;
  margin-bottom: 0.5rem;
}

/* Dairy logo edit button inside the profile dropdown */
.profile-logo-edit-btn {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: #f1f5f9;
  border: 1px solid #e2e8f0;
  color: #0d47a1;
  padding: 3px 10px;
  border-radius: 50px;
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  margin-left: auto;
  flex-shrink: 0;
}

.profile-logo-edit-btn:hover {
  background: #e2e8f0;
  border-color: #cbd5e1;
}

.profile-logo-thumb {
  width: 18px;
  height: 18px;
  object-fit: contain;
  border-radius: 3px;
  background: #ffffff;
}

/* Logo preview row in the profile dropdown */
.profile-logo-preview-row {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 0.5rem;
}

.profile-logo-preview-img {
  max-width: 120px;
  max-height: 60px;
  object-fit: contain;
  border-radius: 8px;
  background: #f8fafc;
  padding: 4px;
  border: 1px solid #e2e8f0;
}

.contact-icon,
.dairy-icon {
  font-size: 0.8rem;
  color: #888;
  width: 16px;
}

.profile-actions {
  padding: 0.5rem;
}

.profile-logout-btn {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  width: 100%;
  padding: 0.6rem 0.8rem;
  border: none;
  border-radius: 6px;
  background: #f5f5f5;
  color: #d32f2f;
  cursor: pointer;
  font-weight: 500;
  font-size: 0.85rem;
  /* transition: all 0.3s ease; */
}

.profile-logout-btn:hover {
  background: #ffebee;
  color: #c62828;
}

.logout-icon {
  font-size: 0.9rem;
}

/* Mobile Menu Toggle */
.mobile-menu-toggle {
  display: none;
  background: none;
  border: none;
  color: white;
  font-size: 1.5rem;
  cursor: pointer;
  padding: 0.5rem;
  border-radius: 6px;
  transition: all 0.3s ease;
}

.mobile-menu-toggle:hover {
  background: rgba(255, 255, 255, 0.1);
}

.mobile-menu-overlay {
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1051;
  /* Must be higher than header (1050) */
  opacity: 0;
  transition: opacity 0.3s ease;
}

.mobile-menu-overlay.active {
  display: block;
  opacity: 1;
}

.mobile-menu {
  position: fixed;
  top: 0;
  right: -100%;
  width: 280px;
  height: 100%;
  background: white;
  box-shadow: -4px 0 12px rgba(0, 0, 0, 0.1);
  z-index: 1052;
  /* Must be higher than overlay and header */
  transition: right 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  overflow-y: auto;
}

.mobile-menu.active {
  right: 0;
}

.mobile-menu-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.5rem;
  border-bottom: 1px solid #e5e7eb;
}

.mobile-menu-close {
  background: none;
  border: none;
  color: #374151;
  font-size: 1.5rem;
  cursor: pointer;
  padding: 0.5rem;
  border-radius: 6px;
  transition: all 0.3s ease;
}

.mobile-menu-close:hover {
  background: #f3f4f6;
}

.mobile-menu-content {
  padding: 1.5rem;
}

.mobile-user-info {
  background: #f9fafb;
  padding: 1rem;
  border-radius: 8px;
  margin-bottom: 1.5rem;
  border: 1px solid #e5e7eb;
}

.mobile-user-name {
  color: #374151;
  font-weight: 600;
  font-size: 1rem;
  margin-bottom: 0.5rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.mobile-user-name .user-icon {
  color: #374151;
  font-size: 0.9rem;
}

.mobile-user-phone {
  color: #6b7280;
  font-size: 0.9rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.mobile-user-phone .phone-icon {
  color: #6b7280;
  font-size: 0.9rem;
}

.mobile-m.premium-stats-row {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

/* Desktop layout - wallet in top right corner */
@media (min-width: 769px) {
  .premium-stats-row {
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
  }

  .owner-info-vertical {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    width: 100%;
  }

  .owner-wallet-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }

  .owner-info {
    flex-shrink: 0;
  }

  .wallet-info {
    flex-shrink: 0;
    margin-left: auto;
  }

  .phone-info {
    width: 100%;
    margin-top: 0.5rem;
  }
}

.mobile-language-switcher {
  margin-bottom: 1rem;
}

/* Mobile language switcher specific styling */
.mobile-language-switcher .language-switcher {
  width: 100%;
}

.mobile-language-switcher .lang-btn {
  width: 100%;
  justify-content: center;
  padding: 0.75rem 1rem;
  background: #f9fafb;
  color: #374151;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 0.9rem;
  font-weight: 500;
}

.mobile-language-switcher .lang-btn .lang-icon {
  color: #6b7280;
  font-size: 0.9rem;
}

.mobile-language-switcher .lang-btn .lang-text {
  color: #374151;
  font-size: 0.9rem;
}

.mobile-language-switcher .lang-btn .lang-chevron {
  color: #6b7280;
  font-size: 0.8rem;
}

.mobile-language-switcher .lang-btn:hover {
  background: #f3f4f6;
  border-color: #d1d5db;
}

.mobile-language-switcher .language-dropdown {
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  right: auto;
  margin-top: 0.5rem;
  width: 200px;
  max-width: 90vw;
}

.mobile-logout-btn {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1rem;
  border: none;
  border-radius: 6px;
  background-color: #ef4444;
  color: white;
  transition: all 0.3s ease;
  cursor: pointer;
  font-weight: 500;
  font-size: 0.9rem;
  text-decoration: none;
  justify-content: center;
}

.mobile-logout-btn:hover {
  background-color: #dc2626;
  transform: translateY(-1px);
}

.mobile-home-link {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1rem;
  border-radius: 6px;
  background-color: #3b82f6;
  color: white;
  transition: all 0.3s ease;
  cursor: pointer;
  font-weight: 500;
  font-size: 0.9rem;
  text-decoration: none;
  justify-content: center;
  margin-bottom: 0.5rem;
}

.mobile-home-link:hover {
  background-color: #2563eb;
  transform: translateY(-1px);
}

/* Tablet Responsive Styles */
@media (max-width: 1024px) {
  .dashboard-header {
    padding: 0;
    height: 60px;
  }

  .logo-container {
    width: 40px;
    height: 40px;
    margin-left: 1rem;
  }

  .logo {
    width: 32px;
  }

  .dashboard-header h1 {
    font-size: 1.3rem;
  }

  .user-details {
    padding: 0.4rem 0.8rem;
    gap: 0.6rem;
  }

  .user-name {
    font-size: 0.85rem;
  }

  .user-phone {
    font-size: 0.75rem;
  }

  .logout-button {
    padding: 0.4rem 0.8rem;
    font-size: 0.8rem;
  }
}

/* Mobile Responsive Styles */
@media (max-width: 768px) {
  .dashboard-header {
    height: auto;
    padding: 0;
    position: relative;
    flex-direction: column;
  }

  .desktop-header {
    display: none;
  }

  .mobile-header {
    display: flex;
  }

  .mobile-header-top {
    padding: 0.5rem 1rem;
    height: 50px;
    display: flex;
    justify-content: none;
    align-items: center;
    margin-top: 0;
  }

  .mobile-header-title {
    font-size: 1rem;
    font-weight: 600;
    color: white;
    margin-left: 0;
    white-space: nowrap;
    text-align: left;
    align-items: flex-start;
    /* position: absolute; */
    left: 50%;
    transform: translateX(-50%);
  }

  .mobile-header-actions {
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }

  .mobile-header-actions .profile-button-dashboard {
    padding: 0.4rem 0.8rem;
    font-size: 0.8rem;
  }

  .mobile-header-actions .profile-icon-dashboard {
    font-size: 1rem;
  }

  .mobile-header-bottom {
    padding: 0.5rem;
    min-height: 40px;
  }

  .mobile-header-bottom h1 {
    font-size: 1.1rem;
    font-weight: 600;
    color: white;
    margin: 0;
    text-align: center;
  }

  .logo-container-mobile {
    width: 36px;
    height: 36px;
    margin: 0;
  }

  .logo {
    width: 28px;
  }

  .mobile-menu-toggle {
    display: block;
    font-size: 1.2rem;
    padding: 0.5rem;
    background: none;
    border: none;
    color: white;
    cursor: pointer;
    border-radius: 6px;
    transition: all 0.3s ease;
  }

  .mobile-menu-toggle:hover {
    background: rgba(255, 255, 255, 0.1);
  }

  .user-info {
    display: none;
  }

  .header-actions {
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }
}

/* Small Mobile Responsive Styles */
@media (max-width: 480px) {
  .mobile-header-top {

    padding: 0.4rem 0.75rem;
    height: 45px;
    margin-top: 0;
  }

  .mobile-header-title {
    font-size: 0.95rem;
    font-weight: 600;
    color: white;
    margin: 0;
    white-space: nowrap;
    text-align: center;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
  }

  .mobile-header-bottom {
    padding: 0.4rem;
    min-height: 35px;
  }

  .mobile-header-bottom h1 {
    font-size: 0.95rem;
    font-weight: 600;
  }

  .logo-container-mobile {
    width: 32px;
    height: 32px;
  }

  .logo {
    width: 20px;
  }

  .mobile-menu-toggle {
    font-size: 1.1rem;
    padding: 0.4rem;
  }
}

/* Extra Small Mobile Responsive Styles */
@media (max-width: 360px) {
  .mobile-header-top {
    padding: 0.3rem 0.5rem;
    height: 40px;
    margin-top: 0;
  }

  .mobile-header-bottom {
    padding: 0.3rem;
    min-height: 30px;
  }

  .mobile-header-bottom h1 {
    font-size: 0.85rem;
    font-weight: 600;
  }

  .logo-container-mobile {
    width: 28px;
    height: 28px;
  }

  .logo {
    width: 25px;
  }

  .mobile-menu-toggle {
    font-size: 1rem;
    padding: 0.3rem;
  }

  .mobile-menu {
    width: 240px;
  }
}

/* Main Content */
.dashboard-content {
  flex: 1 1;
  max-width: 1280px;
  margin: 0 auto;
  padding: 2rem;
  width: 100%;
}

/* Responsive adjustments for dashboard content */
@media (max-width: 768px) {
  .dashboard-content {
    padding: 1rem;
  }
}

@media (max-width: 480px) {
  .dashboard-content {
    padding: 0.75rem;
  }
}

@media (max-width: 360px) {
  .dashboard-content {
    padding: 0.5rem;
  }
}

/* Welcome Section */
.welcome-section {
  background-color: white;
  border-radius: 8px;
  padding: 1.5rem;
  margin-bottom: 2rem;
  border: 1px solid var(--gray-200);
}

.welcome-section h2 {
  color: var(--gray-800);
  margin-bottom: 0.5rem;
}

/* Dashboard Sections */
.dashboard-sections {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 2rem;
}

.dashboard-section {
  background: white;
  border-radius: 16px;
  padding: 2rem;
  border: 1px solid var(--gray-200);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.06);
  transition: all 0.3s ease;
}

.dashboard-section:hover {
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
}

.section-header {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 2rem;
  padding-bottom: 1rem;
  border-bottom: 2px solid var(--gray-100);
}

.section-icon {
  color: var(--primary);
  font-size: 1.75rem;
  background: linear-gradient(135deg, var(--primary-light) 0%, var(--primary) 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.section-header h3 {
  color: var(--gray-800);
  font-size: 1.35rem;
  font-weight: 700;
  letter-spacing: -0.01em;
}

/* Action Cards */
.actions-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1.5rem;
}

.action-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem 1.5rem;
  border-radius: 12px;
  background: linear-gradient(135deg, var(--gray-50) 0%, white 100%);
  border: 1px solid var(--gray-200);
  text-decoration: none;
  color: var(--gray-800);
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  cursor: pointer;
}

.action-card:hover {
  background: linear-gradient(135deg, white 0%, var(--gray-50) 100%);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  transform: translateY(-4px);
  border-color: var(--primary-light);
}

.action-card.primary {
  background: linear-gradient(135deg, var(--primary) 0%, var(--primary-dark) 100%);
  color: white;
  border: none;
  box-shadow: 0 4px 16px rgba(59, 130, 246, 0.3);
}

.action-card.primary:hover {
  background: linear-gradient(135deg, var(--primary-dark) 0%, #1e3a8a 100%);
  box-shadow: 0 8px 24px rgba(59, 130, 246, 0.4);
  transform: translateY(-4px);
}

.action-card.raw {
  background: linear-gradient(135deg, var(--secondary) 0%, #7c3aed 100%);
  color: white;
  border: none;
  box-shadow: 0 4px 16px rgba(139, 92, 246, 0.3);
}

.action-card.raw:hover {
  background: linear-gradient(135deg, #7c3aed 0%, #6d28d9 100%);
  box-shadow: 0 8px 24px rgba(139, 92, 246, 0.4);
  transform: translateY(-4px);
}

/* View Collections button - More visible subtle style */
.action-card.view-collections-button {
  background-color: var(--gray-100);
  border: 2px solid #7cbef4fa;
  color: #495057;
  transition: all 0.2s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.action-card.view-collections-button:hover {
  background-color: #e9ecef;
  border-color: #7cbef4fa;
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

/* ProRata View Collections button - More visible subtle style */
.action-card.prorata-view-collections-button {
  background-color: var(--gray-100);
  border: 2px solid #7cbef4fa;
  color: #495057;
  transition: all 0.2s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.action-card.prorata-view-collections-button:hover {
  background-color: #e9ecef;
  border-color: #7cbef4fa;
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

/* Disabled state for KG/Liters rate types */
.dashboard-section.disabled-section {
  opacity: 0.6;
  position: relative;
}

.action-card.disabled {
  opacity: 0.5;
  cursor: not-allowed !important;
  pointer-events: none;
}

.action-card.disabled:hover {
  background-color: var(--gray-50);
  transform: none;
}

.disabled-badge {
  font-size: 0.75rem;
  color: var(--warning);
  font-weight: 600;
  margin-left: auto;
  background-color: rgba(245, 158, 11, 0.1);
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  border: 1px solid rgba(245, 158, 11, 0.3);
}

.action-icon {
  font-size: 1.5rem;
  margin-bottom: 0.75rem;
}

/* Messages */
.success-message {
  background-color: var(--success);
  color: white;
  padding: 0.75rem 1rem;
  border-radius: 6px;
  margin-bottom: 1rem;
}

.low-balance-alert {
  background-color: var(--danger);
  color: white;
  padding: 0.75rem 1rem;
  border-radius: 6px;
  margin-bottom: 1rem;
}

/* Responsive Design */
@media (max-width: 1024px) {
  .dashboard-content {
    padding: 1.5rem;
  }
}

@media (max-width: 768px) {
  .dashboard-content {
    padding: 1rem;
  }

  .dashboard-sections {
    grid-template-columns: 1fr;
    gap: 1rem;
  }

  .dashboard-section {
    padding: 1rem;
  }

  .section-header {
    margin-bottom: 1rem;
  }

  .section-header h3 {
    font-size: 1rem;
  }

  .section-icon {
    font-size: 1.1rem;
  }

  .actions-grid {
    grid-template-columns: 1fr;
    gap: 0.5rem;
  }

  .action-card {
    padding: 0.75rem 1rem;
    width: 100%;
    min-height: auto;
  }

  .action-card span {
    font-size: 0.9rem;
  }

  .action-icon {
    font-size: 1.1rem;
    margin-bottom: 0.35rem;
  }

  .dashboard-header {
    padding: 0;
    flex-direction: column;
    gap: 1rem;
    text-align: center;
    height: auto;
    min-height: 80px;
  }

  .header-center {
    order: 2;
  }

  .dashboard-header h1 {
    font-size: 1.15rem;
  }

  .logo-container {
    width: 50px;
    height: 50px;
    order: 1;
  }

  .logo {
    width: 42px;
  }

  .user-info {
    flex-direction: column;
    gap: 0.75rem;
    order: 3;
    width: 100%;
  }

  .user-details {
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
    width: 100%;
    gap: 0.5rem;
    padding: 0.6rem 0.75rem;
  }

  .user-name-phone {
    font-size: 0.85rem;
    gap: 0.4rem;
  }

  .user-phone {
    font-size: 0.85rem;
    gap: 0.4rem;
  }

  .user-icon,
  .phone-icon {
    font-size: 0.85rem;
  }

  .user-name {
    font-size: 0.9rem;
  }

  .header-actions {
    flex-direction: row;
    gap: 0.5rem;
    align-items: center;
    flex-shrink: 0;
    justify-content: center;
    width: 100%;
  }

  .logout-button {
    padding: 0.5rem 0.8rem;
    font-size: 0.8rem;
    width: auto;
    justify-content: center;
    flex-shrink: 0;
  }

  .welcome-section {
    padding: 1rem;
    margin-bottom: 1rem;
  }

  .welcome-section h2 {
    font-size: 1.1rem;
  }

  .welcome-section p {
    font-size: 0.9rem;
  }

  /* Responsive Combined Info Container */
  .combined-info-container-dashboard {
    grid-template-columns: 1fr;
    gap: 1rem;
    margin-bottom: 1.5rem;
  }

  .dairy-info-container-dashboard,
  .rate-info-container {
    padding: 1rem;
    border-radius: 8px;
  }

  .dairy-info-content {
    gap: 0.75rem;
  }

  .info-item {
    /* padding: 0.6rem; */
    flex-wrap: wrap;
  }

  .info-icon {
    font-size: 1rem;
  }

  .info-label {
    font-size: 0.85rem;
  }

  .info-value {
    font-size: 0.9rem;
  }

  .add-money-btn {
    font-size: 0.8rem;
    padding: 0.4rem 0.8rem;
    margin-left: 0;
    margin-top: 8px;
    width: 90%;
    max-width: none;
  }

  .rate-info-container {
    padding: 1rem;
    margin-bottom: 1rem;
  }

  .rate-info-content {
    flex-direction: column;
    gap: 0.75rem;
  }

  .rate-section,
  .rate-type-section {
    padding: 0.6rem;
    min-height: auto;
  }

  .rate-display p,
  .rate-type-display p {
    font-size: 0.85rem;
  }

  .rate-edit-container {
    flex-direction: column;
    align-items: stretch;
  }

  .rate-edit,
  .rate-type-control {
    flex-direction: column;
    align-items: stretch;
    min-width: 100%;
  }

  .rate-input {
    width: 100%;
    padding: 0.4rem;
    font-size: 0.9rem;
  }

  .rate-edit-container .bulk-rate-button {
    /* width: 100%; */
    justify-content: center;
    padding: 0.4rem 0.6rem;
    font-size: 0.8rem;
  }
}

/* Combined Info Cards Container */
.combined-info-container-dashboard {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.5rem;
  margin-bottom: 1rem;
}

/* Tablet devices - medium screens */
@media (min-width: 769px) and (max-width: 1024px) {
  .combined-info-container-dashboard {
    grid-template-columns: 1fr 1fr;
    gap: 0.8rem;
  }

  .dairy-info-container-dashboard,
  .rate-info-container {
    padding: 0.8rem;
  }

  .dairy-info-content {
    gap: 0.2rem;
    justify-content: space-between;
    align-items: center;
    flex-direction: row;
  }

  .info-item {
    padding: 0.25rem 0.35rem;
    gap: 0.15rem;
    /* flex: 1; */
    min-width: 45%;
    justify-content: flex-start;
    align-items: center;
  }

  .info-icon {
    font-size: 0.7rem;
  }

  .info-label {
    font-size: 0.65rem;
  }

  .info-value {
    font-size: 0.7rem;
    text-align: left;
  }

  .add-money-btn {
    padding: 0.08rem 0.18rem;
    font-size: 0.48rem;
    margin-left: 0.09rem;
  }

  .rate-buttons {
    gap: 0.28rem;
    justify-content: center;
    align-items: center;
  }

  .edit-rate-button-dashboard,
  .bulk-rate-button {
    padding: 0.32rem 0.55rem;
    font-size: 0.66rem;
    min-height: 30px;
    display: inline-flex;
    align-items: center;
    gap: 0.2rem;
    white-space: nowrap;
  }

  .bulk-rate-button {
    padding: 0.42rem 0.65rem;
    font-size: 0.71rem;
  }
}

@media (width: 768px) {
  .combined-info-container-dashboard {
    display: flex;
    flex-direction: row;
    gap: 0.8rem;
  }

  .dairy-info-container-dashboard,
  .rate-info-container {
    padding: 0.8rem;
    width: 50%;
  }

  .dairy-info-content {
    display: flex;
    flex-direction: row;
    gap: 0.8rem;
  }

  .info-item {
    padding: 0.25rem 0.35rem;
    gap: 0.15rem;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 20px;
  }

  .info-icon {
    font-size: 0.7rem;
  }

  .info-label {
    font-size: 0.65rem;
  }

  .info-value {
    font-size: 0.7rem;
    text-align: left;
  }

  .add-money-btn {
    padding: 0.08rem 0.18rem;
    font-size: 0.48rem;
    margin-left: 0.09rem;
  }


  .rate-buttons {
    gap: 0.28rem;
    justify-content: center;
    align-items: center;
  }

  .edit-rate-button-dashboard,
  .bulk-rate-button {
    padding: 0.32rem 0.55rem;
    font-size: 0.66rem;
    min-height: 30px;
    display: inline-flex;
    align-items: center;
    gap: 0.2rem;
    white-space: nowrap;
  }

  .bulk-rate-button {
    padding: 0.42rem 0.65rem;
    font-size: 0.71rem;
  }

  .combined-info-container-dashboard {
    grid-template-columns: 1fr 1fr;
    gap: 0.6rem;
  }

  .dairy-info-container-dashboard,
  .rate-info-container {
    padding: 0.7rem;
  }

  .dairy-info-content {
    gap: 0.15rem;
  }

  .info-item {
    padding: 0.2rem 0.3rem;
    gap: 0.12rem;
  }

  .info-icon {
    font-size: 0.68rem;
  }

  .info-label {
    font-size: 0.63rem;
  }

  .info-value {
    font-size: 0.68rem;
  }

  .add-money-btn {
    padding: 0.07rem 0.14rem;
    font-size: 0.47rem;
    margin-left: 0.085rem;
  }

  .dashboard-sections {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1rem;
  }

  .actions-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 0.75rem;
  }

  .action-card {
    padding: 1rem 0.75rem;
    min-height: 80px;
  }

  /* Show owner info in dairy card at 768px */
  .owner-info-768 {
    display: flex !important;
  }

  /* Show owner info in header at 768px */
  .user-details {
    display: flex !important;
  }

  .user-info {
    gap: 0.5rem;
  }
}

/* Large tablets and small desktops */
@media (min-width: 1025px) and (max-width: 1366px) {
  .combined-info-container-dashboard {
    grid-template-columns: 1fr 1fr;
    gap: 0.6rem;
  }

  .dairy-info-container-dashboard,
  .rate-info-container {
    padding: 0.7rem;
  }

  .dairy-info-content {
    gap: 0.15rem;
  }

  .info-item {
    padding: 0.2rem 0.3rem;
    gap: 0.12rem;
  }

  .info-icon {
    font-size: 0.68rem;
  }

  .info-label {
    font-size: 0.63rem;
  }

  .info-value {
    font-size: 0.68rem;
  }

  .add-money-btn {
    padding: 0.07rem 0.14rem;
    font-size: 0.47rem;
    margin-left: 0.085rem;
  }
}

/* Mobile responsive - stack cards vertically */
@media (max-width: 768px) {
  .combined-info-container-dashboard {
    grid-template-columns: 1fr;
    gap: 1rem;
  }

  .dairy-info-container-dashboard,
  .rate-info-container {
    max-width: 100%;
    padding: 0.5rem;
  }

  .dairy-info-content {
    gap: 0rem !important;
    flex-direction: row !important;
    justify-content: center !important;
    align-items: center !important;
    flex-wrap: wrap !important;
  }

  .info-item {
    padding: 0.15rem 0.2rem !important;
    gap: 0.1rem !important;
    flex: none !important;
    min-width: auto !important;
    justify-content: center !important;
    align-items: center !important;
  }

  .info-icon {
    font-size: 0.8rem;
    flex-shrink: 0;
    width: 18px;
  }

  .info-label {
    font-size: 0.75rem;
    font-weight: 600;
    flex-shrink: 0;
    white-space: nowrap;
    margin-right: 0.3rem;
  }

  .info-value {
    font-size: 0.75rem !important;
    font-weight: 500 !important;
    flex: 1 1 !important;
    text-align: left !important;
    white-space: nowrap !important;
  }

  .add-money-btn {
    padding: 0.06rem 0.12rem;
    font-size: 0.45rem;
    font-weight: 600;
    flex-shrink: 0;
    margin-left: 0.08rem;
    min-width: auto;
    width: auto;
  }

  .rate-info-content {
    gap: 0.5rem;
  }

  .rate-section,
  .rate-type-section {
    padding: 0.6rem;
  }

  .rate-display p {
    font-size: 0.85rem;
    font-weight: 500;
  }

  .rate-buttons {
    flex-direction: row;
    gap: 0.25rem;
    width: 100%;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
  }

  .edit-rate-button-dashboard,
  .bulk-rate-button {
    flex: none;
    justify-content: center;
    padding: 0.3rem 0.5rem;
    font-size: 0.65rem;
    font-weight: 600;
    min-height: 28px;
    border-radius: 5px;
    transition: all 0.2s ease;
    min-width: auto;
    width: auto;
    display: inline-flex;
    align-items: center;
    gap: 0.2rem;
    white-space: nowrap;
  }

  .edit-rate-button-dashboard {
    background-color: white;
    border: 1px solid var(--primary);
    color: var(--primary);
    padding: 0.25rem 0.45rem;
    font-size: 0.62rem;
  }

  .edit-rate-button-dashboard:hover {
    background-color: var(--primary);
    color: black;
    transform: translateY(-1px);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }

  .bulk-rate-button {
    padding: 0.35rem 0.6rem;
    font-size: 0.68rem;
    background: linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%);
    color: white;
    border: none;
    border-radius: 5px;
    box-shadow: 0 2px 6px rgba(79, 70, 229, 0.2);
    animation: bulkButtonPulse 2s infinite;
  }

  .bulk-rate-button:hover {
    background: linear-gradient(135deg, #4338ca 0%, #6d28d9 100%);
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(79, 70, 229, 0.3);
  }

  @keyframes bulkButtonPulse {
    0% {
      box-shadow: 0 2px 6px rgba(79, 70, 229, 0.2);
    }

    50% {
      box-shadow: 0 2px 10px rgba(79, 70, 229, 0.4);
    }

    100% {
      box-shadow: 0 2px 6px rgba(79, 70, 229, 0.2);
    }
  }

  /* Very small screens responsive design */
  @media (max-width: 380px) {
    .rate-buttons {
      flex-direction: column;
      gap: 0.4rem;
      align-items: center;
    }

    .edit-rate-button-dashboard,
    .bulk-rate-button {
      width: auto;
      padding: 0.35rem 0.6rem;
      font-size: 0.68rem;
      min-height: 32px;
      max-width: 180px;
      display: inline-flex;
      align-items: center;
      gap: 0.2rem;
      white-space: nowrap;
    }

    .bulk-rate-button {
      font-size: 0.73rem;
      padding: 0.45rem 0.75rem;
      max-width: 200px;
    }
  }

  .rate-type-control {
    flex-direction: column;
    gap: 0.6rem;
    align-items: stretch;
  }

  .rate-type-left {
    width: 100%;
    justify-content: space-between;
  }

  /* 
  .rate-type-label {
    font-size: 0.85rem;
    font-weight: 600;
  } */

  .rate-type-select {
    flex: 1 1;
    min-width: auto;
    max-width: 150px;
    padding: 0.4rem 0.6rem;
    font-size: 0.85rem;
  }

  .rate-type-controls {
    width: 100%;
    justify-content: center;
  }

  .submit-rate-type-button {
    width: auto;
    max-width: 150px;
    justify-content: center;
    padding: 0.5rem 0.8rem;
    font-size: 0.8rem;
    font-weight: 600;
  }

  .rate-edit-container {
    gap: 0.6rem;
  }

  .rate-edit {
    gap: 0.5rem;
  }

  .rate-edit label {
    font-size: 0.85rem;
    font-weight: 600;
  }

  .rate-input {
    padding: 0.4rem 0.6rem;
    font-size: 0.85rem;
    min-width: 80px;
  }
}

/* Dairy Info Container */
.dairy-info-container-dashboard {
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
  border-radius: 12px;
  padding: 1.5rem;
  border: 1px solid var(--gray-200);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.06);
  transition: all 0.3s ease;
  display: flex;
  justify-content: center;
  align-items: center;
}

.dairy-info-container-dashboard:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
}

.dairy-info-content {
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  width: 100%;
  justify-content: center;
  align-items: center;
}

.info-item {
  display: flex;
  align-items: center;
  gap: 0.8rem;
  padding: 1rem 1.2rem;
  background: linear-gradient(135deg, var(--gray-50) 0%, white 100%);
  border-radius: 8px;
  border: 1px solid var(--gray-200);
  transition: all 0.3s ease;
  justify-content: center;
  width: 100%;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.info-item:hover {
  background: linear-gradient(135deg, white 0%, var(--gray-50) 100%);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  transform: translateY(-1px);
}

.info-icon {
  color: var(--primary);
  font-size: 1.2rem;
  flex-shrink: 0;
}

.info-label {
  font-weight: 600;
  color: var(--gray-700);
  font-size: 0.75rem;
  flex-shrink: 0;
  text-align: left;
}

.info-value {
  color: var(--gray-800);
  font-weight: 500;
  font-size: 0.8rem;
  flex: 1 1;
  text-align: left;
}

.add-money-btn {
  background-color: var(--success);
  color: white;
  border: none;
  padding: 0.2rem 0.6rem;
  border-radius: 3px;
  font-size: 0.7rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s ease;
  white-space: nowrap;
  flex-shrink: 0;
}

.add-money-btn:hover {
  background-color: #16a34a;
}

/* Hide owner info by default, show only at 768px */
.owner-info-768 {
  display: none;
}

.rate-info-container {
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
  border-radius: 12px;
  padding: 1.5rem;
  border: 1px solid var(--gray-200);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.06);
  transition: all 0.3s ease;
}

.rate-info-container:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
}

.rate-info-content {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: stretch;
}

.rate-section {
  flex: 1 1;
  background: linear-gradient(135deg, var(--gray-50) 0%, white 100%);
  border: 1px solid var(--gray-200);
  border-radius: 8px;
  padding: 1rem;
  min-height: auto;
  display: flex;
  align-items: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  transition: all 0.3s ease;
}

.rate-section:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.rate-display,
.rate-type-display {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.5rem;
  width: 100%;
}

.rate-buttons {
  display: flex;
  gap: 0.3rem;
  align-items: center;
}

.rate-display p,
.rate-type-display p {
  font-size: 0.75rem;
  margin: 0;
}

.rate-edit-container {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
  width: 100%;
}

.rate-edit {
  display: flex;
  align-items: center;
  gap: 0.3rem;
  flex-wrap: wrap;
}

.rate-edit label {
  font-size: 0.75rem;
  font-weight: 500;
  color: var(--gray-700);
  white-space: nowrap;
}

.rate-input {
  padding: 0.2rem 0.4rem;
  font-size: 0.75rem;
  border: 1px solid var(--gray-300);
  border-radius: 3px;
  min-width: 70px;
}

.rate-type-control {
  display: flex;
  align-items: center;
  gap: 0.3rem;
  width: 100%;
  flex-wrap: wrap;
  justify-content: space-between;
}

.rate-type-label {
  font-size: 1rem;
  font-weight: 600;
  color: var(--gray-700);
  display: flex;
  align-items: center;
  gap: 0.5rem;
  white-space: nowrap;
}

.rate-type-icon {
  font-size: 0.8rem;
  color: var(--primary);
  opacity: 0.8;
}

.rate-type-left {
  display: flex;
  align-items: center;
  gap: 0.3rem;
}

.rate-type-select {
  padding: 0.2rem 0.4rem;
  font-size: 0.75rem;
  border: 1px solid var(--gray-300);
  border-radius: 3px;
  min-width: 90px;
}

.rate-type-controls {
  display: flex;
  align-items: center;
  gap: 0.3rem;
}

.edit-rate-button-dashboard,
.bulk-rate-button,
.save-rate-button,
.submit-rate-type-button {
  padding: 0.35rem 0.75rem;
  font-size: 0.75rem;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  text-decoration: none;
  min-width: auto;
  width: auto;
}

.edit-rate-button-dashboard {
  background-color: var(--primary);
  border: 2px solid var(--primary);
  color: white;
  padding: 0.5rem 1rem;
  font-size: 0.75rem;
  font-weight: 600;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  white-space: nowrap;
  box-shadow: 0 2px 8px rgba(59, 130, 246, 0.1);
  height: fit-content;
  min-width: auto;
}

.edit-rate-button-dashboard:hover {
  background-color: var(--primary-dark);
  color: white;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.2);
}

.edit-rate-button-dashboard:active {
  transform: translateY(0);
  box-shadow: 0 2px 4px rgba(59, 130, 246, 0.1);
}

.save-rate-button-dashboard {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  border: none;
  color: white;
  padding: 0.15rem 0.4rem;
  border-radius: 4px;
  font-size: 0.90rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  gap: 0.2rem;
  white-space: nowrap;
  min-width: auto;
  width: 50%;
  box-shadow: 0 1px 4px rgba(16, 185, 129, 0.2);
}

.save-rate-button-dashboard:hover:not(:disabled) {
  background: linear-gradient(135deg, #059669 0%, #047857 100%);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);
}

.save-rate-button-dashboard:disabled {
  background: linear-gradient(135deg, #e5e7eb 0%, #d1d5db 100%);
  color: #9ca3af;
  cursor: not-allowed;
  transform: none;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.cancel-rate-button-dashboard {
  padding: 0.15rem 0.4rem;
  background: linear-gradient(135deg, #ffffff 0%, #f8f9ff 100%);
  border: 1px solid #e5e7eb;
  color: #6b7280;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-weight: 600;
  font-size: 0.90rem;
  display: inline-flex;
  align-items: center;
  gap: 0.2rem;
  white-space: nowrap;
  width: 50%;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
}

.cancel-rate-button-dashboard:hover:not(:disabled) {
  background: linear-gradient(135deg, #f3f4f6 0%, #e5e7eb 100%);
  border-color: #d1d5db;
  color: #374151;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.cancel-rate-button-dashboard:disabled {
  background: #f9fafb;
  border-color: #e5e7eb;
  color: #9ca3af;
  cursor: not-allowed;
  transform: none;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.bulk-rate-button {
  background: linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%);
  color: white;
  border: none;
  padding: 0.6rem 1.2rem;
  font-size: 0.85rem;
  font-weight: 700;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(79, 70, 229, 0.3);
  animation: bulkButtonPulse 2s infinite;
}

.bulk-rate-button:hover {
  background: linear-gradient(135deg, #4338ca 0%, #6d28d9 100%);
  transform: translateY(-3px);
  box-shadow: 0 6px 16px rgba(79, 70, 229, 0.4);
}

@keyframes bulkButtonPulse {
  0% {
    box-shadow: 0 2px 6px rgba(79, 70, 229, 0.2);
  }

  50% {
    box-shadow: 0 2px 10px rgba(79, 70, 229, 0.4);
  }

  100% {
    box-shadow: 0 2px 6px rgba(79, 70, 229, 0.2);
  }
}

.save-rate-button,
.submit-rate-type-button {
  background: linear-gradient(135deg, var(--success) 0%, #059669 100%);
  border: none;
  color: white;
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);
}

.save-rate-button:hover,
.submit-rate-type-button:hover {
  background: linear-gradient(135deg, #059669 0%, #047857 100%);
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(16, 185, 129, 0.4);
}

.save-rate-button:disabled,
.submit-rate-type-button:disabled {
  background: var(--gray-200);
  color: var(--gray-500);
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.add-money-btn {
  background: linear-gradient(135deg, var(--success) 0%, #059669 100%);
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 6px;
  font-size: 0.8rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);
}

.add-money-btn:hover {
  background: linear-gradient(135deg, #059669 0%, #047857 100%);
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(16, 185, 129, 0.4);
}

.submit-rate-type-button:not(:disabled) {
  background-color: var(--success);
  border: 1px solid var(--success);
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(34, 197, 94, 0.4);
  }

  70% {
    box-shadow: 0 0 0 6px rgba(34, 197, 94, 0);
  }

  100% {
    box-shadow: 0 0 0 0 rgba(34, 197, 94, 0);
  }
}

.rate-info-container {
  padding: 2rem;
  margin-bottom: 1rem;
  /* border: solid 2px red; */
}

@media (max-width: 768px) {
  .rate-info-container {
    padding: 1rem;
    margin-bottom: 1rem;
    /* border: solid 2px red; */
  }

  .rate-info-content {
    flex-direction: column;
    gap: 0.75rem;
  }

  .rate-section,
  .rate-type-section {
    padding: 0.6rem;
    min-height: auto;
  }

  .rate-display p,
  .rate-type-display p {
    font-size: 0.85rem;
  }

  .rate-edit-container {
    flex-direction: column;
    align-items: stretch;
  }

  .rate-edit,
  .rate-type-control {
    flex-direction: column;
    align-items: stretch;
    min-width: 100%;
  }

  .rate-input {
    width: 100%;
    padding: 0.4rem;
    font-size: 0.9rem;
  }

  .rate-edit-container .bulk-rate-button {
    width: 100%;
    justify-content: center;
    padding: 0.4rem 0.6rem;
    font-size: 0.8rem;
  }

  .rate-type-select {
    width: 100%;
    padding: 0.35rem 0.6rem;
    font-size: 0.85rem;
  }

  .submit-rate-type-button {
    width: auto;
    max-width: 150px;
    justify-content: center;
    padding: 0.35rem 0.6rem;
    font-size: 0.8rem;
  }

  .rate-display,
  .rate-type-display {
    flex-direction: column;
    text-align: center;
    gap: 0.5rem;
  }

  .rate-buttons-group {
    flex-direction: column;
    width: 100%;
    gap: 0.5rem;
  }

  .edit-rate-button-dashboard,
  .bulk-rate-button,
  .save-rate-button {
    width: auto;
    max-width: 150px;
    justify-content: center;
    padding: 0.4rem 0.6rem;
    font-size: 0.8rem;
    white-space: nowrap;
  }

  .save-rate-button-dashboard,
  .cancel-rate-button-dashboard {
    width: auto;
    font-size: 0.8rem;
  }
}

/* Footer */
.dashboard-footer {
  text-align: center;
  padding: 2rem;
  margin-top: auto;
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
  border-top: 1px solid var(--gray-200);
  box-shadow: 0 -4px 16px rgba(0, 0, 0, 0.04);
}

.dashboard-footer p {
  margin: 0;
  color: var(--gray-700);
  font-size: 0.9rem;
  font-weight: 500;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .dashboard-footer {
    padding: 1rem;
  }

  /* Make preview table more compact on tablets/phones */
  .preview-table {
    min-width: 800px;
    font-size: 12px;
  }

  .preview-table th,
  .preview-table td {
    padding: 6px 8px;
  }
}

.razorpay-section {
  background: white;
  border-radius: 8px;
  padding: 1.5rem 2rem 1.25rem 2rem;
  border: 1px solid var(--gray-200);
  margin-top: 2rem;
  margin-bottom: 2rem;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 0.7rem;
}

.dashboard-centered-card {
  margin: 0 auto 2.5rem auto;
  max-width: 540px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 14px 0 rgba(41, 67, 161, 0.08);
  border: 1px solid var(--gray-200);
  padding: 2rem 2.2rem 1.7rem 2.2rem;
  display: flex;
  flex-direction: column;
  gap: 1.1rem;
  z-index: 1;
}

.razorpay-section-label {
  display: flex;
  align-items: center;
  gap: 0.95rem;
  font-size: 1.22rem;
  font-weight: 700;
  color: var(--gray-800);
  margin-bottom: 4px;
  letter-spacing: 0.01em;
}

.razorpay-icon-bg {
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--primary);
  color: #fff;
  border-radius: 50%;
  font-size: 1.31rem;
  width: 2.4rem;
  height: 2.4rem;
}

.add-funds-desc {
  color: var(--gray-700);
  margin-bottom: 0.2rem;
  font-size: 1rem;
  opacity: 0.8;
}

.add-funds-form-row {
  display: flex;
  gap: 1.33rem;
  align-items: flex-end;
  margin-top: 4px;
}

.add-funds-input {
  width: 180px;
  padding: 0.9rem 1.1rem;
  font-size: 1.17rem;
  border-radius: 7px;
  background: var(--gray-100);
  border: 1.5px solid var(--gray-200);
  box-shadow: 0 1px 2px 0 rgba(0, 0, 10, 0.05);
  outline: none;
  transition: border 0.19s, box-shadow 0.19s;
}

.add-funds-input.input-error {
  border-color: var(--danger);
}

.add-funds-input:focus {
  border-color: var(--primary);
  background: #fff;
  box-shadow: 0 0 0 2px var(--primary-light);
}

.add-funds-button {
  padding: 0.9rem 2.2rem;
  font-size: 1.17rem;
  border-radius: 7px;
  font-weight: 600;
  box-shadow: 0 1.5px 4.5px 0 rgba(41, 67, 161, 0.10);
}

.add-funds-feedback-error {
  color: var(--danger);
  font-size: 14.5px;
  margin-top: 5px;
  animation: fadeIn 0.2s ease-in;
}

.add-funds-feedback-success {
  color: var(--success);
  font-size: 15px;
  margin-top: 7px;
  animation: fadeIn 0.2s ease-in;
}

@keyframes fadeIn {
  0% {
    opacity: 0;
    transform: translateY(5px);
  }

  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (max-width: 768px) {
  .dashboard-centered-card {
    padding: 1rem;
    margin-bottom: 1.5rem;
  }

  .razorpay-section {
    padding: 1rem;
    margin-top: 1rem;
    margin-bottom: 1rem;
    gap: 0.6rem;
  }

  .razorpay-section-label {
    font-size: 1rem;
    gap: 0.7rem;
    margin-bottom: 2px;
  }

  .razorpay-icon-bg {
    width: 2rem;
    height: 2rem;
    font-size: 1.1rem;
  }

  .add-funds-desc {
    font-size: 0.85rem;
    margin-bottom: 0.15rem;
  }

  .add-funds-form-row {
    flex-direction: column;
    align-items: stretch;
    gap: 0.75rem;
    margin-top: 3px;
  }

  .add-funds-input,
  .add-funds-button {
    width: 100%;
    font-size: 0.95rem;
    min-width: 0;
    padding: 0.75rem 0.9rem;
  }

  .add-funds-feedback-error,
  .add-funds-feedback-success {
    font-size: 0.8rem;
    margin-top: 4px;
  }
}

/* Action button styling for Change Milk Rate */
.action-button {
  cursor: pointer;
  border: none;
  font-family: inherit;
  font-size: inherit;
  border: 1px solid var(--gray-200);
}

/* Modal Styles - REMOVED CONFLICTING OVERLAY */

.modal-content {
  background-color: white;
  border-radius: 8px;
  padding: 0;
  max-width: 90vw;
  max-height: 95vh;
  overflow-y: auto;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);

  display: flex;
  flex-direction: column;
}

.date-filter-modal {
  width: 500px;
}

.preview-modal {
  width: 95%;
  max-width: 1400px;
  max-height: 95vh;
  display: flex;
  flex-direction: column;
}

.preview-modal .modal-body {
  flex: 1 1;
  overflow-y: auto;
  padding: 1rem;
  min-height: 0;
}

.preview-modal .modal-header {
  flex-shrink: 0;
}

.preview-modal .modal-footer {
  flex-shrink: 0;
  border-top: 1px solid var(--gray-200);
  background-color: white;
  position: sticky;
  bottom: 0;
}


.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem;
  border-bottom: 1px solid var(--gray-200);
}

.modal-header h2 {
  margin: 0;
  color: var(--gray-800);
  font-size: 1.25rem;
}

.modal-close-button,
.close-modal-button {
  background: none;
  border: none;
  font-size: 1.25rem;
  color: var(--gray-700);
  cursor: pointer;
  padding: 0.5rem;
  border-radius: 4px;
  transition: background-color 0.2s;
}

.modal-close-button:hover,
.close-modal-button:hover {
  background-color: var(--gray-100);
}

.date-filter-container {
  padding: 1.5rem;
}

.date-input-group {
  margin-bottom: 1rem;
}

.date-input-group label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
  color: var(--gray-700);
}

.date-input {
  width: 100%;
  padding: 0.75rem;
  border: 1px solid var(--gray-200);
  border-radius: 4px;
  font-size: 1rem;
}

.date-filter-actions {
  display: flex;
  gap: 1rem;
  justify-content: flex-end;
  margin-top: 1.5rem;
}

.date-filter-button {
  padding: 0.75rem 1.5rem;
  border-radius: 4px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.date-filter-button.secondary {
  background-color: white;
  border: 1px solid var(--gray-200);
  color: var(--gray-700);
}

.date-filter-button.secondary:hover {
  background-color: var(--gray-50);
}

.date-filter-button.primary {
  background-color: var(--primary);
  border: none;
  color: white;
}

.date-filter-button.primary:hover {
  background-color: var(--primary-dark);
}

.modal-body {
  padding: 1.5rem;
  flex: 1 1;
  overflow-y: auto;
  min-height: 0;
}

.modal-footer {
  display: flex;
  gap: 1rem;
  justify-content: flex-end;
  padding: 1.5rem;
  border-top: 1px solid var(--gray-200);
}

.cancel-button {
  padding: 0.35rem 0.75rem;
  background: linear-gradient(135deg, #ffffff 0%, #f8f9ff 100%);
  border: 2px solid #e5e7eb;
  color: #6b7280;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-weight: 600;
  font-size: 0.75rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.cancel-button:hover {
  background: linear-gradient(135deg, #f3f4f6 0%, #e5e7eb 100%);
  border-color: #d1d5db;
  color: #374151;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.confirm-button {
  padding: 0.75rem 1.5rem;
  background-color: var(--primary);
  border: none;
  color: white;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.confirm-button:hover {
  background-color: var(--primary-dark);
}

.confirm-button:disabled {
  background-color: var(--gray-200);
  cursor: not-allowed;
}

/* Collections Display Styles */
.collections-display-section {
  background-color: white;
  border-radius: 8px;
  padding: 1.5rem;
  margin-bottom: 2rem;
  border: 1px solid var(--gray-200);
}

.collections-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}

.collections-header h3 {
  margin: 0;
  color: var(--gray-800);
}

.close-collections-button {
  background: none;
  border: none;
  font-size: 1.25rem;
  color: var(--gray-700);
  cursor: pointer;
  padding: 0.5rem;
  border-radius: 4px;
  transition: background-color 0.2s;
}

.close-collections-button:hover {
  background-color: var(--gray-100);
}

.collections-table-container {
  overflow-x: auto;
}

.collections-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.875rem;
}

.collections-table th,
.collections-table td {
  padding: 0.75rem;
  text-align: left;
  border-bottom: 1px solid var(--gray-200);
}

.collections-table th {
  background-color: var(--gray-50);
  font-weight: 600;
  color: var(--gray-700);
}

.collections-table tbody tr:hover {
  background-color: var(--gray-50);
}

.customer-name-cell {
  min-width: 200px;
}

/* Preview table styles */
.preview-table-container {
  overflow-x: auto;
  margin: 1rem 0;
}

.preview-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
  min-width: 1000px;
  /* keep columns readable; allow horizontal scroll when needed */
}

.preview-table th {
  padding: 8px 10px;
  text-align: left;
  background-color: #f5f5f5;
  font-weight: 600;
  color: #444;
  border-bottom: 1px solid #e0e0e0;
}

.preview-table td {
  padding: 8px 10px;
  text-align: left;
  border-bottom: 1px solid #e0e0e0;
  white-space: nowrap;
}

.preview-table tbody tr:hover {
  background-color: #f9f9f9;
}

.error-message {
  color: var(--danger);
  background-color: #fef2f2;
  border: 1px solid #fecaca;
  padding: 0.75rem;
  border-radius: 4px;
  margin: 1rem 0;
}

.edit-form-error {
  color: var(--danger);
  background-color: #fef2f2;
  border: 1px solid #fecaca;
  padding: 0.75rem;
  border-radius: 4px;
  margin-bottom: 15px;
  font-weight: bold;
}

/* Responsive styles for modals */
@media (max-width: 768px) {
  /* Removed conflicting modal-overlay styles */

  .modal-content {
    margin: 0;
    width: 95%;
    max-width: 320px;
    border-radius: 8px;
  }

  /* Mobile modal z-index fixes */
  .modal-overlay {
    z-index: 1001 !important;
  }

  .confirmation-modal-overlay {
    z-index: 9999 !important;
  }
}

/* Extra small mobile screens */
@media (max-width: 480px) {

  /* Extra small mobile modal z-index fixes */
  .modal-overlay {
    z-index: 1001 !important;
  }

  .confirmation-modal-overlay {
    z-index: 9999 !important;
  }
}

/* Universal modal z-index fix for all screen sizes */
@media all {
  .modal-overlay {
    z-index: 1001 !important;
  }

  .confirmation-modal-overlay {
    z-index: 9999 !important;
  }
}

.collections-table {
  font-size: 0.7rem;
  min-width: 800px;
  /* Ensure horizontal scroll for better readability */
}

.collections-table th,
.collections-table td {
  padding: 0.4rem 0.3rem;
  white-space: nowrap;
}

.collections-table th {
  font-size: 0.65rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.025em;
}

.date-filter-form {
  flex-direction: column;
  gap: 1rem;
}

.date-filter-form .form-group {
  flex-direction: column;
  gap: 0.5rem;
}

.date-filter-form .form-group label {
  font-weight: 600;
  font-size: 0.9rem;
  color: var(--gray-700);
}

.date-filter-form input {
  padding: 0.75rem;
  font-size: 1rem;
  border-radius: 6px;
  border: 1px solid var(--gray-300);
}

.modal-footer {
  flex-direction: column;
  gap: 0.75rem;
}

.modal-footer button {
  width: 100%;
  padding: 0.875rem;
  font-size: 1rem;
  font-weight: 600;
}

.milk-rate-input {
  width: 100%;
  max-width: 120px;
  font-size: 1rem;
  padding: 0.75rem;
  text-align: center;
  font-weight: 600;
}

.rate-settings {
  margin: 0.5rem 0;
  padding: 0.75rem;
  background-color: var(--gray-50);
  border-radius: 8px;
  border: 1px solid var(--gray-200);
}

.rate-input-group {
  flex-direction: row;
  align-items: center;
  gap: 0.75rem;
}

.rate-input-group label {
  font-size: 1rem;
  font-weight: 600;
  color: var(--gray-800);
}


/* Collection Summary Styles */
.preview-summary {
  margin-top: 1rem;
  border: 1px solid var(--gray-200);
  border-radius: 6px;
  overflow: hidden;
  flex-shrink: 0;
}

/* Preview table container improvements */
.preview-table-container {
  overflow-x: auto;
  margin: 1rem 0;
  max-height: 80vh;
  /* taller scrollable area so more rows are visible on desktop */
  overflow-y: auto;
  border: 1px solid var(--gray-200);
  border-radius: 4px;
  width: 100%;
}

/* Milk rate input styling */
.milk-rate-input {
  padding: 8px 12px;
  border: 1px solid #ccc;
  border-radius: 4px;
  width: 100px;
  font-size: 1rem;
}

/* Preview header styling */
.preview-header {
  margin-bottom: 1rem;
}

.preview-header h3 {
  margin-bottom: 8px;
  color: var(--gray-800);
}

.collections-count {
  margin-left: 10px;
  font-size: 0.9em;
  color: #666;
}

.rate-settings {
  margin-top: 8px;
  margin-bottom: 8px;
}

/* Compact the Milk Rate card inside the preview header */
.preview-header .rate-settings {
  margin: 6px 0;
  padding: 6px 10px;
}

.preview-header .rate-input-group {
  gap: 8px;
  /* border: solid 2px red; */
}

.milk-rate-input {
  padding: 6px 10px;
  height: 34px;
}

.rate-input-group {
  display: flex;
  align-items: center;
  gap: 10px;
  /* border: solid 2px red; */
}

.rate-input-group label {
  font-weight: bold;
  color: var(--gray-700);
  /* border: solid 2px red; */
}

.summary-card {
  transition: all 0.2s ease;
}

.summary-card:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

/* Responsive styles for summary cards */
@media (max-width: 768px) {
  .preview-summary {
    margin: 1rem 0;
  }

  .preview-summary [style*="grid-template-columns: repeat(4, 1fr)"] {
    grid-template-columns: repeat(2, 1fr) !important;
    gap: 6px !important;
  }

  .summary-card {
    padding: 6px 8px !important;
  }

  .summary-card div:first-child {
    font-size: 10px !important;
  }

  .summary-card div:last-child {
    font-size: 12px !important;
  }

  .rate-input {
    padding: 6px 10px;
    height: 34px;
    margin: auto;
    /* font-size: 25px; */
  }

  #rate-input-milk {
    font-size: 15px;
  }
}

/* Wallet Transaction History Styles */
.transaction-history-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid var(--gray-200);
}

.transaction-history-header h3 {
  margin: 0;
  color: var(--gray-800);
  font-size: 1.25rem;
  display: flex;
  align-items: center;
}

.toggle-transactions-button {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.9rem;
}

.transaction-history-content {
  margin-top: 1rem;
}

.transactions-table-container {
  overflow-x: auto;
  border-radius: 8px;
  border: 1px solid var(--gray-200);
}

.transaction-type {
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  font-size: 0.8rem;
  font-weight: 500;
  text-transform: uppercase;
}

.transaction-type.credit {
  background-color: #dcfce7;
  color: #166534;
}

.transaction-type.debit {
  background-color: #fef2f2;
  color: #991b1b;
}

.transaction-status {
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  font-size: 0.8rem;
  font-weight: 500;
  text-transform: uppercase;
}

.transaction-status.success {
  background-color: #dcfce7;
  color: #166534;
}

.transaction-status.pending {
  background-color: #fef3c7;
  color: #92400e;
}

.transaction-status.failed {
  background-color: #fef2f2;
  color: #991b1b;
}

.credit-amount {
  color: var(--success);
  font-weight: 600;
}

.debit-amount {
  color: var(--danger);
  font-weight: 600;
}

.no-transactions {
  text-align: center;
  padding: 2rem;
  color: var(--gray-700);
}

.no-transactions p {
  margin: 0;
  font-style: italic;
}

/* Payment Link Display Styles */
.payment-link-container {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin-top: 1rem;
  padding: 1rem;
  background-color: #f0f9ff;
  border: 1px solid #0ea5e9;
  border-radius: 8px;
}

.payment-link-header {
  color: #0369a1;
  font-size: 0.9rem;
  margin-bottom: 0.25rem;
  text-align: center;
}

.payment-link-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.75rem 1.5rem;
  background-color: #0ea5e9;
  color: white;
  text-decoration: none;
  border-radius: 6px;
  font-weight: 600;
  font-size: 1rem;
  transition: all 0.2s ease;
  border: none;
  cursor: pointer;
}

.payment-link-button:hover {
  background-color: #0284c7;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(14, 165, 233, 0.3);
  color: white;
  text-decoration: none;
}

.refresh-balance-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.5rem 1rem;
  background-color: var(--success);
  color: white;
  border: none;
  border-radius: 6px;
  font-weight: 500;
  font-size: 0.9rem;
  cursor: pointer;
  transition: all 0.2s ease;
}

.refresh-balance-button:hover {
  background-color: #16a34a;
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(34, 197, 94, 0.3);
}

/* Responsive styles for payment link container */
@media (max-width: 768px) {
  .payment-link-container {
    padding: 0.75rem;
    gap: 0.75rem;
    margin-top: 0.75rem;
    flex-direction: column;
    align-items: stretch;
  }

  .payment-link-button {
    padding: 0.625rem 1rem;
    font-size: 0.9rem;
    width: 100%;
    text-align: center;
  }

  .payment-link-header {
    font-size: 0.85rem;
    text-align: center;
  }
}

@media (max-width: 480px) {
  .payment-link-container {
    padding: 0.5rem;
    gap: 0.5rem;
    margin-top: 0.5rem;
  }

  .payment-link-button {
    padding: 0.5rem 0.75rem;
    font-size: 0.85rem;
  }

  .payment-link-button:hover {
    transform: none;
    /* Disable hover transform on mobile */
  }

  .payment-link-header {
    font-size: 0.8rem;
  }

  /* Additional mobile improvements for milk rate modals - Removed conflicting modal-overlay */

  .modal-content {
    border-radius: 6px;
  }

  .date-filter-modal {
    max-height: 90vh;
  }

  .preview-modal {
    height: 98vh;
    max-height: 98vh;
  }

  /* Further compact table for small phones */
  .preview-table {
    min-width: 680px;
    font-size: 11px;
  }

  .preview-table th,
  .preview-table td {
    padding: 5px 6px;
  }

  .preview-modal .modal-header {
    padding: 0.4rem;
  }

  .preview-modal .modal-header h2 {
    font-size: 0.95rem;
  }

  .preview-modal .modal-body {
    padding: 0.25rem;
  }

  .preview-modal .modal-footer {
    padding: 0.4rem;
  }

  .collections-table {
    font-size: 0.65rem;
    min-width: 700px;
  }

  .collections-table th,
  .collections-table td {
    padding: 0.3rem 0.2rem;
  }

  .collections-table th {
    font-size: 0.6rem;
  }

  .modal-footer button {
    padding: 0.6rem;
    font-size: 0.9rem;
  }

  .milk-rate-input {
    max-width: 100px;
    font-size: 0.9rem;
    padding: 0.625rem;
  }

  .rate-settings {
    margin: 0.5rem 0;
    padding: 0.5rem;
  }

  .rate-input-group {
    gap: 0.5rem;
  }

  .rate-input-group label {
    font-size: 0.9rem;
  }

  .date-filter-form input {
    padding: 0.625rem;
    font-size: 0.9rem;
  }
}

/* Add Money Button in Dairy Info Card */
.add-money-btn {
  margin-left: 12px;
  padding: 6px 14px;
  background-color: #1a73e8;
  color: white;
  border: none;
  border-radius: 5px;
  font-size: 0.8rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(26, 115, 232, 0.2);
  white-space: nowrap;
  flex-shrink: 0;
  text-align: center;
  max-width: 110px;
}

.add-money-btn:hover {
  background-color: #1557b0;
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(26, 115, 232, 0.3);
}

.add-money-btn:active {
  transform: translateY(0);
}

/* Modal Overlay - Perfect Centering */
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 0;
  overflow: hidden;
  min-height: 100vh;
  width: 100vw;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

/* Modal Content */
.modal-content {
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  border: 1px solid #e5e7eb;
  max-width: 500px;
  width: 90%;
  max-height: 90vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  animation: slideUp 0.3s ease-out;
}

/* Ensure wider layout for the milk rate preview modal card */
.modal-content.preview-modal {
  width: 95%;
  max-width: 1400px;
  max-height: 95vh;
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.add-money-modal {
  max-width: 450px;
  background: white;
  border-radius: 16px;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  overflow: hidden;
  width: 95%;
}

/* Offers Modal */
.offers-modal {
  max-width: 400px;
  background: white;
  border-radius: 16px;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  overflow: hidden;
  width: 95%;
}

.offers-modal-header {
  padding: 1.5rem;
  border-bottom: 1px solid #f3f4f6;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: white;
}

.offers-modal-title-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  flex: 1 1;
}

.offers-modal-icon-wrapper {
  width: 48px;
  height: 48px;
  background: linear-gradient(135deg, #ff6b35, #f7931e);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 0.75rem;
}

.offers-modal-icon {
  color: white;
  font-size: 1.5rem;
}

.offers-modal-header h3 {
  margin: 0;
  font-size: 1.25rem;
  color: #111827;
  font-weight: 700;
}

.offers-modal-subtitle {
  margin: 0.25rem 0 0 0;
  font-size: 0.875rem;
  color: #6b7280;
  font-weight: 500;
}

.offers-modal-close-btn {
  background: none;
  border: none;
  font-size: 1.5rem;
  color: #6b7280;
  cursor: pointer;
  padding: 0.25rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: all 0.2s;
}

.offers-modal-close-btn:hover {
  background-color: #f3f4f6;
  color: #1f2937;
}

.offers-modal-body {
  padding: 1.5rem;
  background-color: #ffffff;
}

.offers-list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.offer-item {
  position: relative;
  padding: 1.25rem;
  border: 2px solid #e5e7eb;
  border-radius: 16px;
  transition: all 0.2s;
}

.offer-item.starter-bonus {
  background-color: #f8fafc;
  border-color: #3b82f6;
}

.offer-item.premium-bonus {
  background-color: #fef3c7;
  border-color: #f59e0b;
}

.offer-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.best-value-tag {
  position: absolute;
  top: -8px;
  right: 12px;
  background: linear-gradient(135deg, #dc2626, #ef4444);
  color: white;
  font-size: 0.75rem;
  font-weight: 700;
  padding: 0.25rem 0.75rem;
  border-radius: 12px;
  box-shadow: 0 2px 4px rgba(220, 38, 38, 0.3);
}

.offer-header {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 1rem;
}

.offer-badge {
  background: linear-gradient(135deg, #10b981, #059669);
  color: white;
  font-size: 0.875rem;
  font-weight: 600;
  padding: 0.375rem 0.75rem;
  border-radius: 20px;
  display: flex;
  align-items: center;
  gap: 0.375rem;
  box-shadow: 0 2px 4px rgba(16, 185, 129, 0.3);
}

.offer-header h4 {
  margin: 0;
  font-size: 1.125rem;
  font-weight: 700;
  color: #111827;
}

.offer-details p {
  margin: 0 0 0.5rem 0;
  font-size: 0.875rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.offer-details p:last-child {
  margin-bottom: 0;
}

.offer-range {
  color: #374151;
  font-weight: 600;
}

.offer-bonus {
  color: #059669;
  font-weight: 600;
}

.offer-example {
  color: #6b7280;
  font-size: 0.8rem;
  font-style: italic;
}

/* Modal Header */
.modal-header {
  padding: 1.5rem;
  border-bottom: 1px solid #f3f4f6;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: white;
}

.modal-header h3 {
  margin: 0;
  font-size: 1.25rem;
  color: #111827;
  font-weight: 700;
}

.modal-header-actions {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.offers-btn {
  background: #ff7e00;
  border: 1px solid #ff7e00;
  border-radius: 8px;
  padding: 0.5rem 1rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #ffffff;
  font-size: 0.875rem;
  cursor: pointer;
  transition: all 0.2s;
}

.offers-btn:hover {
  background-color: #e67200;
  border-color: #e67200;
}

.modal-close-btn {
  background: none;
  border: none;
  font-size: 1.5rem;
  color: #6b7280;
  cursor: pointer;
  padding: 0.25rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: all 0.2s;
}

.modal-close-btn:hover {
  background-color: #f3f4f6;
  color: #1f2937;
}

/* Modal Body */
.modal-body {
  padding: 1.5rem;
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  flex: 1 1;
}

.modal-body-money {
  padding: 1rem 1.5rem;
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
}

.add-funds-desc {
  color: #6b7280;
  font-size: 0.95rem;
  margin-bottom: 1.5rem;
}

.add-funds-form {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
}

.info-message {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  padding: 0.75rem 1rem;
  background-color: #f0f9ff;
  border-radius: 8px;
  color: #0c4a6e;
  font-size: 0.875rem;
  font-weight: 500;
  margin-bottom: 0.5rem;
  width: 100%;
  line-height: 1.4;
}

.info-icon {
  color: #0284c7;
  font-size: 1rem;
  flex-shrink: 0;
  margin-top: 2px;
}

.refresh-link {
  color: #0284c7;
  text-decoration: underline;
  cursor: pointer;
  font-weight: 600;
  border: none;
  background: none;
  padding: 0;
}

.refresh-link:hover {
  color: #0369a1;
}

.amount-input-container {
  position: relative;
  display: flex;
  align-items: center;
  margin: 1rem 0;
  width: 100%;
  max-width: 300px;
  margin-left: auto;
  margin-right: auto;
}

.currency-symbol {
  position: absolute;
  left: 1rem;
  font-size: 1.5rem;
  color: #6b7280;
  font-weight: 500;
  z-index: 1;
}

.amount-input {
  padding-left: 3rem !important;
  font-size: 2rem !important;
  font-weight: 600 !important;
  height: 4rem !important;
  border: 2px solid #e5e7eb !important;
  border-radius: 12px !important;
  background: white !important;
}

.amount-input:focus {
  border-color: #667eea !important;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1) !important;
}

.form-label {
  font-weight: 600;
  color: #374151;
  font-size: 0.95rem;
  margin-bottom: 0.5rem;
  display: block;
}

.form-input {
  width: 100%;
  padding: 0.75rem;
  border: 2px solid #e5e7eb;
  border-radius: 8px;
  font-size: 1rem;
  transition: all 0.3s;
  outline: none;
}

.form-input:focus {
  border-color: #1a73e8;
  box-shadow: 0 0 0 3px rgba(26, 115, 232, 0.1);
}

.form-input.input-error {
  border-color: #ef4444;
}

/* Bonus Message */
.bonus-message {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1rem;
  background-color: #d1fae5;
  border: 1px solid #a7f3d0;
  border-radius: 8px;
  color: #065f46;
  font-size: 0.875rem;
  font-weight: 500;
  margin-top: 0.75rem;
  animation: slideDown 0.3s ease-out;
}

.bonus-message-new {
  /* display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  background-color: #dcfce7;
  border: 1px solid #bbf7d0;
  border-radius: 20px;
  color: #166534;
  font-size: 0.875rem;
  font-weight: 500;
  margin: 1rem auto 0;
  animation: slideDown 0.3s ease-out; */
  width: 100%;
  color: #166534;

  /* border: solid 2px red; */
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.bonus-icon {
  font-size: 1.25rem;
}

/* Quick Recharge Section */
.quick-recharge-section {
  padding: 1.5rem;
  background-color: #ffffff;
  border-top: 1px solid #f3f4f6;
}

.quick-recharge-buttons {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 0.75rem;
}

.quick-amount-btn {
  width: 100%;
  padding: 0.875rem 0.5rem;
  background-color: white;
  color: #374151;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;
}

.quick-amount-btn:hover:not(:disabled) {
  background-color: #f9fafb;
  border-color: #d1d5db;
}

.quick-amount-btn:active:not(:disabled) {
  transform: scale(0.98);
}

.quick-amount-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.quick-amount-highlight {
  background-color: #10b981;
  color: white;
  border-color: #10b981;
}

.quick-amount-highlight:hover:not(:disabled) {
  background-color: #059669;
  border-color: #059669;
}

.quick-amount-selected {
  background-color: #10b981;
  color: white;
  border-color: #10b981;
}

.quick-amount-selected:hover:not(:disabled) {
  background-color: #059669;
  border-color: #059669;
}

.feedback-error {
  color: #ef4444;
  font-size: 0.875rem;
  margin-top: 0.5rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.feedback-success {
  color: #22c55e;
  font-size: 0.875rem;
  margin-top: 0.5rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.payment-link-container {
  margin-top: 1rem;
  padding: 1rem;
  background-color: #f0f7ff;
  border-radius: 8px;
  border: 1px solid #bfdbfe;
  display: flex;
  align-items: center;
  gap: 1rem;
}

.payment-link-header {
  color: #1e40af;
  font-size: 0.95rem;
  white-space: nowrap;
  flex-shrink: 0;
}

.payment-link-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.75rem 1.5rem;
  background-color: #1a73e8;
  color: white;
  text-decoration: none;
  border-radius: 8px;
  font-weight: 600;
  transition: all 0.3s;
  flex: 1 1;
}

.payment-link-button:hover {
  background-color: #1557b0;
  transform: translateY(-1px);
}


/* Modal Footer */
.modal-footer {
  padding: 1.5rem;
  border-top: 1px solid #f3f4f6;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  background-color: #ffffff;
}

.modal-btn {
  padding: 1rem;
  border-radius: 12px;
  font-weight: 600;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.3s;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.modal-btn-primary {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  padding: 1rem;
  border-radius: 12px;
  font-weight: 600;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.25);
}

.modal-btn-primary:hover:not(:disabled) {
  background: linear-gradient(135deg, #5a67d8 0%, #6b46c1 100%);
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.35);
}

.modal-btn-primary:disabled {
  background: linear-gradient(135deg, #e5e7eb 0%, #d1d5db 100%);
  color: #9ca3af;
  cursor: not-allowed;
  transform: none;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.coupon-btn {
  background: white !important;
  color: #667eea !important;
  border: 1px solid #667eea !important;
  font-size: 0.875rem !important;
  padding: 0.875rem 1rem !important;
  border-radius: 12px !important;
  box-shadow: none !important;
}

.coupon-btn:hover:not(:disabled) {
  background: #f8faff !important;
  border-color: #5a67d8 !important;
  color: #5a67d8 !important;
  transform: none !important;
  box-shadow: none !important;
}

.modal-btn-secondary {
  background: linear-gradient(135deg, #ffffff 0%, #f8f9ff 100%);
  color: #6b7280;
  border: 2px solid #e5e7eb;
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  font-weight: 600;
  font-size: 0.8rem;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.modal-btn-secondary:hover:not(:disabled) {
  background: linear-gradient(135deg, #f3f4f6 0%, #e5e7eb 100%);
  border-color: #d1d5db;
  color: #374151;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.modal-btn-secondary:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Responsive Modal */
@media (max-width: 768px) {
  .modal-content {
    width: 95%;
    max-height: 95vh;
  }

  .modal-header {
    padding: 1rem;
  }

  .modal-body {
    padding: 1rem;
  }

  .modal-footer {
    padding: 0.75rem 1rem;
    flex-direction: column-reverse;
  }

  .modal-btn {
    width: 100%;
  }

  .add-money-btn {
    font-size: 0.85rem;
    padding: 8px 16px;
    margin-left: 8px;
    margin-top: 0;
    min-width: 110px;
  }

  /* Quick recharge 2x2 grid on mobile */
  .quick-recharge-buttons {
    grid-template-columns: repeat(2, 1fr);
  }

  .quick-amount-btn {
    font-size: 0.95rem;
    padding: 0.625rem 0.75rem;
  }

  .info-message {
    font-size: 10px !important;
  }

  .bonus-message-new {
    font-size: 10px;
  }
}

/* Mobile Responsive Styles for Add Money Modal */
@media (max-width: 768px) {
  .modal-overlay .add-money-modal {
    margin: 10px;
    max-height: 90vh;
    overflow-y: auto;
  }

  .add-money-modal .modal-header {
    padding: 12px 16px;
  }

  .add-money-modal .modal-header h3 {
    font-size: 16px;
  }

  .add-money-modal .modal-header-actions {
    gap: 8px;
  }

  .add-money-modal .offers-btn {
    padding: 6px 10px;
    font-size: 12px;
  }

  .add-money-modal .modal-close-btn {
    width: 28px;
    height: 28px;
    font-size: 12px;
  }

  .wallet-balance-display {
    padding: 8px 16px;
    margin: 8px 0;
  }

  .current-balance-section {
    gap: 8px;
  }

  .balance-label-payment {
    font-size: 12px;
  }

  .balance-amount {
    font-size: 14px;
  }

  .refresh-balance-btn-payment {
    width: 24px;
    height: 24px;
    font-size: 10px;
  }

  .payment-feedback {
    margin: 6px 16px;
    padding: 8px 12px;
    font-size: 12px;
  }

  .feedback-error {
    margin: 6px 16px;
    padding: 8px 12px;
    font-size: 12px;
  }

  .modal-body-money {
    padding: 8px 16px;
  }

  .add-funds-form {
    gap: 12px;
  }

  .info-message {
    padding: 8px 12px;
    font-size: 11px !important;
  }

  .info-icon {
    font-size: 12px;
    margin-right: 6px;
  }

  .refresh-link {
    font-size: 11px;
  }

  .amount-input-container {
    margin: 8px 0;
  }

  .currency-symbol {
    font-size: 16px;
  }

  .amount-input {
    font-size: 16px;
    padding: 8px 12px;
  }

  .bonus-message-new {
    padding: 8px 12px;
    margin: 8px 0;
    font-size: 11px;
  }

  .bonus-icon {
    font-size: 14px;
    margin-right: 6px;
  }

  .quick-recharge-section {
    padding: 8px 16px;
    margin: 8px 0;
  }

  .quick-recharge-buttons {
    gap: 8px;
  }

  .quick-amount-btn {
    padding: 8px 12px;
    font-size: 12px;
    min-height: 36px;
  }

  .modal-footer {
    padding: 12px 16px;
    gap: 8px;
  }

  .modal-btn {
    padding: 10px 16px;
    font-size: 14px;
    min-height: 40px;
  }

  .trouble-section {
    margin-top: 8px;
    padding-top: 8px;
    flex-direction: column;
    gap: 8px;
    text-align: center;
  }

  .trouble-text {
    font-size: 12px;
  }

  .contact-us-btn {
    padding: 8px 16px;
    font-size: 12px;
    min-height: 36px;
  }
}

/* Extra small screens - further optimization */
@media (max-width: 480px) {
  .modal-overlay .add-money-modal {
    margin: 5px;
    max-height: 95vh;
  }

  .add-money-modal .modal-header {
    padding: 10px 12px;
  }

  .add-money-modal .modal-header h3 {
    font-size: 14px;
  }

  .wallet-balance-display {
    padding: 6px 12px;
    margin: 6px 0;
  }

  .modal-body-money {
    padding: 6px 12px;
  }

  .quick-recharge-section {
    padding: 6px 12px;
  }

  .modal-footer {
    padding: 10px 12px;
  }

  .quick-recharge-buttons {
    gap: 6px;
  }

  .quick-amount-btn {
    padding: 6px 8px;
    font-size: 11px;
    min-height: 32px;
  }

  .modal-btn {
    padding: 8px 12px;
    font-size: 13px;
    min-height: 36px;
  }
}

@media (max-width: 480px) {
  .add-money-btn {
    font-size: 0.8rem;
    padding: 7px 14px;
    margin-left: 6px;
    min-width: 100px;
  }
}

/* Extra small screens - optimize layout */
@media (max-width: 480px) {
  .combined-info-container-dashboard {
    gap: 0.75rem;
    margin-bottom: 1rem;
  }

  .dairy-info-container-dashboard,
  .rate-info-container {
    padding: 0.75rem;
  }

  .info-item {
    padding: 0.5rem;
    flex-direction: row;
    align-items: flex-start;
    /* gap: 0.5rem; */
  }

  .info-label {
    font-size: 0.8rem;
  }

  .info-value {
    font-size: 0.85rem;
    width: 100%;
  }

  .add-money-btn {
    width: 100%;
    margin-top: 0.5rem;
    font-size: 0.75rem;
    padding: 0.4rem 0.6rem;
  }

  .rate-info-content {
    gap: 0.5rem;
  }

  .rate-section,
  .rate-type-section {
    padding: 0.5rem;
  }

  .rate-display p,
  .rate-type-display p {
    font-size: 0.8rem;
  }

  .rate-input {
    font-size: 0.85rem;
    padding: 0.35rem;
  }

  .edit-rate-button-dashboard,
  .bulk-rate-button,
  .save-rate-button,
  .submit-rate-type-button {
    font-size: 0.75rem;
    padding: 0.35rem 0.6rem;
  }

  .dashboard-header {
    padding: 0;
    min-height: 70px;
  }

  .logo-container {
    width: 45px;
    height: 45px;
  }

  .logo {
    width: 38px;
  }

  .dashboard-header h1 {
    font-size: 1rem;
  }

  .user-details {
    padding: 0.5rem 0.6rem;
  }

  .user-name-phone,
  .user-phone {
    font-size: 0.8rem;
  }

  .user-name {
    font-size: 0.85rem;
  }
}

/* Very small screens - wrap button to new line */
@media (max-width: 380px) {
  .info-item {
    flex-wrap: wrap;
  }

  .add-money-btn {
    margin-left: 0;
    margin-top: 8px;
    width: 90%;
    max-width: none;
    font-size: 0.875rem;
    font-weight: 600;
  }
}

/* Bulk Rate Selector Modal - Perfect Mobile Centering */
.bulk-rate-selector-modal {
  width: 90vw;
  max-width: 360px;
  margin: auto;
  background: linear-gradient(135deg, #fef3c7 0%, #fde68a 50%, #fef3c7 100%);
  border-radius: 20px;
  backdrop-filter: blur(20px);
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  transform: none;
  left: auto;
  right: auto;
  top: auto;
  bottom: auto;
  max-height: 90vh;
}

.bulk-rate-selector-modal::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: #0056b3;
  opacity: 0.8;
}

.bulk-rate-selector-modal .bulk-modal-header {
  padding: 28px 32px;
  border-bottom: 1px solid rgba(245, 158, 11, 0.08);
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #0056b3;
  border-radius: 18px 18px 0 0;
  position: relative;
  color: white;
}

.bulk-rate-selector-modal .bulk-modal-header::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.15) 0%, rgba(255, 255, 255, 0.05) 100%);
  border-radius: 18px 18px 0 0;
}

.bulk-rate-selector-modal .bulk-modal-header .bulk-header-text {
  margin: 0;
  font-size: 22px;
  font-weight: 800;
  color: white;
  letter-spacing: -0.6px;
  position: relative;
  z-index: 1;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.bulk-rate-selector-modal .close-modal-button {
  background: rgba(255, 255, 255, 0.25);
  border: 2px solid rgba(255, 255, 255, 0.4);
  font-size: 18px;
  cursor: pointer;
  color: white;
  padding: 0;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  border-radius: 50%;
  position: relative;
  z-index: 1;
  backdrop-filter: blur(10px);
}

.bulk-rate-selector-modal .close-modal-button:hover {
  background: rgba(255, 255, 255, 0.35);
  transform: scale(1.1);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.bulk-rate-selector-modal .modal-body {
  padding: 32px;
  background: linear-gradient(135deg, #fffbeb 0%, #ffffff 50%, #fffbeb 100%);
  position: relative;
}

.collection-type-options {
  display: flex;
  flex-direction: row;
  gap: 16px;
  padding: 0 8px;
}

.collection-type-btn {
  flex: 1 1;
  padding: 24px 16px;
  border: 2px solid rgba(102, 126, 234, 0.15);
  border-radius: 16px;
  background: linear-gradient(135deg, #ffffff 0%, #f8f9ff 100%);
  cursor: pointer;
  font-size: 16px;
  font-weight: 700;
  color: #2d3748;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  min-height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  white-space: normal;
  word-wrap: break-word;
  overflow-wrap: break-word;
  overflow: hidden;
  box-shadow: 0 8px 25px rgba(102, 126, 234, 0.08),
    inset 0 1px 0 rgba(255, 255, 255, 0.8);
}

.collection-type-btn::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(102, 126, 234, 0.1), transparent);
  transition: left 0.4s ease;
}

.collection-type-btn:hover {
  border-color: #667eea;
  /* background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); */
  background: #0056b3;
  color: white;
  transform: translateY(-3px);
  box-shadow: 0 12px 24px rgba(102, 126, 234, 0.25);
}

.collection-type-btn:hover::before {
  left: 100%;
}

.collection-type-btn:active {
  transform: translateY(-1px);
  box-shadow: 0 8px 16px rgba(102, 126, 234, 0.3);
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* ========================================
   COMPREHENSIVE RESPONSIVE DESIGN
   ======================================== */

/* Extra Small Devices (320px - 480px) */
@media (max-width: 480px) {
  .dashboard-container {
    padding: 0 0.5rem 0.5rem;
  }

  .dashboard-header {
    flex-direction: column;
    gap: 1rem;
    padding: 0;
  }

  .header-center {
    order: -1;
    text-align: center;
  }

  .user-info {
    flex-direction: column;
    align-items: center;
    gap: 0.5rem;
  }

  .premium-rate-cards {
    grid-template-columns: 1fr;
    gap: 1rem;
  }

  .premium-rate-cards .bulk-rate-card {
    order: -1;
  }

  .premium-rate-card {
    padding: 1.25rem;
    border-radius: 12px;
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
    min-height: 180px;
    display: flex;
    flex-direction: column;
  }

  .rate-card-header {
    flex-direction: row;
    text-align: center;
    gap: 0.75rem;
    padding-bottom: 1rem;
    border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  }

  .rate-card-content {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 1rem;
  }

  .rate-display-form {
    flex-direction: column;
    gap: 1rem;
    align-items: stretch;
  }

  .current-rate-display {
    padding: 1rem;
    background: linear-gradient(135deg, #f8f9ff 0%, #ffffff 100%);
    border-radius: 8px;
    text-align: center;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  }

  .rate-value {
    font-size: 1.4rem;
    font-weight: 700;
    color: var(--primary);
  }

  .rate-label {
    font-size: 0.8rem;
    color: var(--gray-600);
    margin-top: 0.25rem;
  }

  .edit-rate-button-dashboard {
    width: auto;
    max-width: 120px;
    padding: 0.75rem 1rem;
    font-size: 0.85rem;
    border-radius: 8px;
    margin-top: 0.5rem;
    white-space: nowrap;
  }

  .rate-type-row {
    flex-direction: column;
    gap: 0rem;
    align-items: stretch;
  }

  .rate-type-label {
    text-align: center;
    font-weight: 600;
    color: var(--gray-700);
    margin-bottom: 0.5rem;
  }

  .premium-select.compact {
    width: 100%;
    padding: 0.75rem;
    font-size: 0.9rem;
    border-radius: 8px;
    border: 2px solid var(--gray-300);
  }

  .save-rate-button {
    width: 100%;
    max-width: none;
    padding: 0.75rem 1rem;
    font-size: 0.85rem;
    border-radius: 8px;
    margin-top: 0.5rem;
  }

  .bulk-action-btn-rate {
    width: 100%;
    /* padding: 0.75rem 1rem; */
    font-size: 0.9rem;
    border-radius: 8px;
    margin-top: -0.7rem;
  }

  .bulk-rate-features {
    margin-bottom: 1rem;
  }

  .bulk-rate-features li {
    padding: 0.5rem 0;
    font-size: 0.85rem;
  }

  .bulk-rate-selector-modal {
    width: 95%;
    margin: 1rem;
    border-radius: 16px;
  }

  .bulk-rate-selector-modal .modal-header {
    padding: 1.5rem;
    border-radius: 16px 16px 0 0;
  }

  .bulk-rate-selector-modal .modal-header h2 {
    font-size: 1.2rem;
    font-weight: 700;
  }

  .bulk-rate-selector-modal .modal-body {
    padding: 1.5rem;
  }

  .collection-type-options {
    flex-direction: column;
    gap: 1rem;
  }

  .collection-type-btn {
    padding: 1.25rem 0.75rem;
    font-size: 0.9rem;
    border-radius: 12px;
    min-height: 70px;
    line-height: 1.2;
  }

  .modal-btn-primary,
  .modal-btn-secondary,
  .cancel-button {
    width: 100%;
    margin-bottom: 0.5rem;
    padding: 0.75rem 1rem;
    font-size: 0.85rem;
    border-radius: 8px;
  }

  .modal-footer {
    flex-direction: column;
    gap: 0.5rem;
  }
}

/* Small Mobile Devices (480px and below) */
@media (max-width: 480px) {
  .rate-display-form-dashboard {
    padding: 0.4rem;
    gap: 0.4rem;
  }

  .current-milk-rate-display-dashboard {
    height: 40px;
    padding: 0.4rem;
  }

  .rate-value {
    font-size: 0.9rem;
    font-weight: 600;
  }

  .edit-rate-button-dashboard {
    padding: 0.4rem 0.6rem;
    font-size: 0.7rem;
    min-height: 36px;
  }
}

/* Large Devices (769px - 1024px) - Fix card layout and visibility */
@media (min-width: 769px) and (max-width: 1024px) {
  .premium-rate-cards {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }

  .premium-rate-card {
    min-height: 180px;
    padding: 1.5rem;
  }

  .rate-card-content {
    flex-direction: column;
    gap: 1rem;
  }

  .rate-content-wrapper {
    flex-direction: column;
    gap: 1rem;
  }

  .rate-display-section,
  .rate-type-section {
    width: 100%;
  }

  .current-milk-rate-display-dashboard {
    min-width: 200px;
    padding: 1rem;
  }

  .edit-rate-button-dashboard {
    max-width: 200px;
    padding: 0.6rem 1rem;
    font-size: 0.8rem;
  }
}

/* Large Devices (1024px - 1440px) - Fix card layout and visibility */
@media (min-width: 1024px) and (max-width: 1440px) {
  .premium-rate-cards {
    grid-template-columns: repeat(2, 1fr) !important;
    gap: 1.5rem;
    display: grid !important;
  }

  .premium-rate-card {
    min-height: 180px;
    padding: 1.5rem;
  }

  /* Desktop rate card optimizations */
  .rate-card-header {
    padding: 0.5rem 0.8rem;
    gap: 0.5rem;
  }

  .rate-card-icon {
    width: 22px;
    height: 22px;
    font-size: 0.65rem;
  }

  .heading-card-dashboard {
    font-size: 1rem;
  }

  .rate-card-content {
    padding: 0.8rem;
    gap: 0.6rem;
  }

  .feature-item {
    font-size: 0.9rem;
    gap: 0.5rem;
    margin-bottom: 0.4rem;
  }

  .feature-check {
    font-size: 0.6rem;
  }

  .rate-card-title .bulk-action-btn-rate,
  .rate-card-title .bulk-action-btn-milk-rate {
    padding: 0.4rem 0.8rem;
    font-size: 0.75rem;
    gap: 0.25rem;
  }

  /* Hide content buttons on desktop */
  .rate-card-content .bulk-action-btn-rate,
  .rate-card-content .bulk-action-btn-milk-rate {
    display: none;
  }

  .rate-card-content {
    flex-direction: column;
    gap: 1rem;
  }

  .rate-content-wrapper {
    flex-direction: column;
    gap: 1rem;
  }

  .rate-display-section,
  .rate-type-section {
    width: 100%;
  }

  .current-milk-rate-display-dashboard {
    min-width: 200px;
    padding: 1rem;
  }

  .edit-rate-button-dashboard {
    max-width: 200px;
    padding: 0.6rem 1rem;
    font-size: 0.8rem;
  }
}

/* Specific fix for exactly 768px - force single column layout */
@media (max-width: 768px) {
  .premium-rate-cards {
    grid-template-columns: 1fr !important;
    gap: 1rem !important;
    display: grid !important;
  }

  .bulk-action-btn-rate {
    width: auto;
    max-width: 120px;
    font-size: 0.8rem;
    padding: 6px 10px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .bulk-action-btn-milk-rate {
    width: auto;
    max-width: 140px;
    font-size: 0.8rem;
    padding: 6px 10px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .current-rate-display {
    padding: 0.6rem;
    margin-bottom: 0.4rem;
  }

  .current-rate-label {
    font-size: 0.6rem;
    margin-bottom: 0.2rem;
  }

  .current-rate-value {
    font-size: 1rem;
  }
}

/* Medium Small Devices (425px - 768px) - Full Width Layout */
@media (min-width: 425px) and (max-width: 768px) {
  .premium-rate-cards {
    grid-template-columns: 1fr;
    gap: 1rem;
  }

  .premium-rate-card {
    min-height: 160px;
  }

  .rate-card-content {
    flex-direction: column;
    gap: 0.75rem;
  }
}

/* Small Devices (481px - 768px) */
@media (min-width: 481px) and (max-width: 768px) {
  .dashboard-header {
    padding: 0;
  }

  .premium-rate-cards {
    grid-template-columns: 1fr;
    gap: 1.25rem;
  }

  .premium-rate-cards .bulk-rate-card {
    order: -1;
  }

  .rate-type-row {
    flex-wrap: wrap;
    gap: 0.75rem;
  }

  .premium-select.compact {
    flex: 1 1;
    min-width: 150px;
  }

  .bulk-rate-selector-modal {
    width: 90%;
  }

  .collection-type-options {
    gap: 1.25rem;
  }
}

/* Medium Devices (769px - 1024px) - Tablets */
@media (min-width: 769px) and (max-width: 1024px) {
  .dashboard-header {
    padding: 0;
  }

  .premium-rate-cards {
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 1.5rem;
  }

  .rate-management-header {
    flex-direction: column;
    text-align: center;
    gap: 0.5rem;
  }

  .bulk-rate-selector-modal {
    max-width: 600px;
  }

  .collection-type-options {
    gap: 1.5rem;
  }
}

/* Large Devices (1025px - 1440px) - Desktops */
@media (min-width: 1025px) and (max-width: 1440px) {
  .premium-rate-cards {
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
    gap: 1.75rem;
  }

  .bulk-rate-selector-modal {
    max-width: 580px;
  }
}

/* Extra Large Devices (1441px+) - Large Desktops */
@media (min-width: 1441px) {
  .dashboard-container {
    max-width: 1400px;
    margin: 0 auto;
  }

  .premium-rate-cards {
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 2rem;
  }

  /* Extra large screen optimizations */
  .rate-card-header {
    padding: 0.6rem 1rem;
    gap: 0.6rem;
  }

  .rate-card-icon {
    width: 24px;
    height: 24px;
    font-size: 0.7rem;
  }

  .heading-card-dashboard {
    font-size: 1.1rem;
  }

  .rate-card-content {
    padding: 1rem;
    gap: 0.7rem;
  }

  .feature-item {
    font-size: 0.95rem;
    gap: 0.6rem;
    margin-bottom: 0.5rem;
  }

  .feature-check {
    font-size: 0.65rem;
  }

  .rate-card-title .bulk-action-btn-rate,
  .rate-card-title .bulk-action-btn-milk-rate {
    padding: 0.5rem 0.9rem;
    font-size: 0.8rem;
    gap: 0.3rem;
  }

  /* Hide content buttons on extra large screens */
  .rate-card-content .bulk-action-btn-rate,
  .rate-card-content .bulk-action-btn-milk-rate {
    display: none;
  }

  .bulk-rate-selector-modal {
    max-width: 620px;
  }

  .premium-rate-card {
    min-height: 200px;
  }
}

/* High DPI / Retina Displays */
@media (min-resolution: 192dpi) {
  .bulk-rate-selector-modal::before {
    height: 1px;
  }

  .premium-rate-card {
    border-width: 0.5px;
  }
}

/* Landscape Orientation for Mobile */
@media (max-width: 768px) and (orientation: landscape) {
  .dashboard-header {
    flex-direction: row;
    padding: 0;
  }

  .premium-rate-cards {
    grid-template-columns: 1fr;
    gap: 1rem;
  }

  .premium-rate-cards .bulk-rate-card {
    order: -1;
  }

  .bulk-rate-selector-modal .modal-header {
    padding: 1rem 1.5rem;
  }

  .bulk-rate-selector-modal .bulk-modal-header {
    padding: 1rem 1.5rem;
  }

  .bulk-rate-selector-modal .bulk-modal-header .bulk-header-text {
    font-size: 1.2rem;
    font-weight: 700;
  }

  .bulk-rate-selector-modal .modal-body {
    padding: 1.5rem;
  }
}

/* Dark Mode Support (if needed in future) */
@media (prefers-color-scheme: dark) {

  /* Placeholder for dark mode styles */
  .bulk-rate-selector-modal {
    background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 50%, #1a1a1a 100%);
  }
}

/* Language Switcher Styling for Dashboard Header */
.dashboard-header .lang-btn {
  background: rgba(255, 255, 255, 0.15);
  border: 1px solid rgba(255, 255, 255, 0.3);
  color: white;
  padding: 8px 12px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
}

.dashboard-header .lang-btn:hover {
  background: rgba(255, 255, 255, 0.3);
  border-color: rgba(255, 255, 255, 0.4);
}

.dashboard-header .lang-icon {
  color: white;
}

.dashboard-header .lang-text {
  color: white;
}

.dashboard-header .lang-chevron {
  color: rgba(255, 255, 255, 0.9);
}

.dashboard-header .lang-menu {
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  min-width: 150px;
}

.dashboard-header .lang-item {
  color: #333;
  padding: 10px 12px;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 13px;
}

.dashboard-header .lang-item:hover {
  background-color: #f5f5f5;
}

.dashboard-header .lang-item.active {
  background-color: #e3f2fd;
  color: #2563eb;
  font-weight: 600;
}

/* Reduced Motion Support */
@media (prefers-reduced-motion: reduce) {

  .bulk-rate-selector-modal,
  .collection-type-btn,
  .save-rate-button,
  .cancel-button,
  .modal-btn-primary,
  .modal-btn-secondary {
    animation: none;
    transition: none;
  }

  .collection-type-btn:hover,
  .save-rate-button:hover,
  .cancel-button:hover,
  .modal-btn-primary:hover,
  .modal-btn-secondary:hover {
    transform: none;
  }
}

/* ============================================
   COMPREHENSIVE RESPONSIVE DESIGN
   ============================================ */

/* Single Clean Mobile Rule */
@media (max-width: 768px) {
  .bulk-rate-selector-modal {
    max-width: 92vw;
  }

  /* Chrome Mobile Specific Fix */
  .modal-overlay {
    -webkit-overflow-scrolling: touch;
  }

  .bulk-rate-selector-modal {
    transform: none;
  }
}

/* Extra Small Devices (320px - 480px) - Small Phones */
@media (max-width: 480px) {
  .dashboard-container {
    padding: 0 0.5rem 0.5rem;
  }

  .dashboard-header {
    height: auto;
    min-height: 60px;
    padding: 0;
  }

  .desktop-header {
    display: none;
  }

  .mobile-header {
    display: block;
  }

  .mobile-header-top {
    padding: 0.5rem;
    margin-top: 0;
  }

  .mobile-header-bottom h1 {
    font-size: 1.1rem;
    margin: 0.5rem 0;
  }

  .premium-dashboard-header {
    padding: 1rem;
    margin-bottom: 1rem;
  }

  .premium-stats-row {
    flex-direction: column;
    gap: 0.75rem;
  }

  .owner-wallet-row {
    flex-direction: column;
    align-items: flex-start;
    /* gap: 0.5rem; */
  }

  .owner-info {
    width: 100%;
  }

  .wallet-info {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    width: 100%;
    /* justify-content: space-between; */
  }

  .premium-stat-card {
    flex-direction: row;
    padding: 0.75rem;
    min-width: 100%;
    border-radius: 8px;
  }

  .stat-icon-wrapper {
    width: 32px;
    height: 32px;
    font-size: 0.8rem;
  }

  .stat-content {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.25rem;
  }

  .stat-content h4 {
    font-size: 0.6rem;
  }

  .stat-content p {
    font-size: 0.8rem;
  }

  .premium-add-money-btn {
    padding: 0.15rem 0.4rem;
    font-size: 0.55rem;
  }

  .rate-management-header h3 {
    font-size: 1.2rem;
  }

  .premium-rate-cards {
    grid-template-columns: 1fr;
    gap: 0.75rem;
  }

  .premium-rate-card {
    padding: 0.75rem;
  }

  .rate-card-header {
    padding: 0.5rem;
    gap: 0.5rem;
    flex-direction: row;
  }

  .rate-card-icon {
    width: 20px;
    height: 20px;
    font-size: 0.6rem;
  }

  .heading-card-dashboard {
    font-size: 1.5rem;
  }

  .rate-card-title p {
    font-size: 0.5rem;
  }

  .rate-card-content {
    padding: 0.75rem;
    gap: 0.5rem;
    flex-direction: column;
  }

  .rate-content-wrapper {
    flex-direction: column;
    gap: 0.75rem;
  }

  .current-milk-rate-display-dashboard {
    padding: 0.5rem;
    min-width: auto;
    height: 45px;
  }

  .rate-value {
    font-size: 0.9rem;
  }

  .rate-label {
    font-size: 0.6rem;
  }

  .premium-rate-input {
    padding: 0.4rem 0.6rem;
    font-size: 0.8rem;
  }

  .rate-edit-actions {
    flex-direction: column;
    gap: 0.5rem;
    height: auto;
    width: 100%;
  }

  .premium-btn {
    padding: 0.3rem 0.6rem;
    font-size: 0.6rem;
    width: 100%;
  }

  .premium-action-grid {
    grid-template-columns: 1fr;
    gap: 0.75rem;
  }

  .premium-action-card {
    border-radius: 8px;
  }

  .action-card-header {
    padding: 0.75rem;
    gap: 0.5rem;
  }

  .action-card-icon {
    width: 28px;
    height: 28px;
    font-size: 0.8rem;
  }

  .action-card-title h4 {
    font-size: 1rem;
  }

  .action-card-title p {
    font-size: 0.7rem;
  }

  .action-card-content {
    padding: 0.75rem;
    gap: 0.5rem;
  }

  .premium-action-btn {
    padding: 0.8rem 1rem;
    font-size: 0.8rem;
  }

  .bulk-rate-selector-modal {
    width: 95%;
    margin: 0.5rem;
    border-radius: 12px;
  }

  .bulk-rate-selector-modal .bulk-modal-header {
    padding: 1rem;
  }

  .bulk-rate-selector-modal .bulk-modal-header .bulk-header-text {
    font-size: 1.1rem;
    font-weight: 700;
  }

  .bulk-rate-selector-modal .modal-body {
    padding: 1rem;
  }

  .collection-type-options {
    flex-direction: column;
    gap: 0.75rem;
    padding: 0;
  }

  .collection-type-btn {
    padding: 1rem 0.75rem;
    font-size: 0.8rem;
    min-height: 60px;
    border-radius: 8px;
  }

  /* .premium-select-rate-type {
cms
   粗体
   aja
    width: 100 Reich
   obot
    premium-select-rate-typeides
    bs
   elve
    Early
   lain
    sled
    0.6rem;
    font-size: 0.7rem;
  } */

  .save-rate-button {
    padding: 0.3rem 0.6rem;
    font-size: 0.6rem;
    width: 100%;
  }

  .mobile-menu-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    z-index: 999;
  }

  .mobile-menu {
    position: fixed;
    top: 0;
    right: -100%;
    width: 80%;
    max-width: 300px;
    height: 100%;
    background: white;
    box-shadow: -2px 0 10px rgba(0, 0, 0, 0.1);
    transition: right 0.3s ease;
    z-index: 1000;
    overflow-y: auto;
  }

  .mobile-menu.active {
    right: 0;
  }

  .mobile-menu-header {
    padding: 1rem;
    border-bottom: 1px solid #e5e7eb;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .mobile-menu-close {
    background: none;
    border: none;
    font-size: 1.5rem;
    cursor: pointer;
    color: #6b7280;
  }

  .mobile-menu-content {
    padding: 1rem;
  }

  .mobile-menu-section {
    margin-bottom: 2rem;
  }

  .mobile-menu-section h3 {
    font-size: 0.9rem;
    color: #6b7280;
    margin-bottom: 0.5rem;
    text-transform: uppercase;
  }

  .mobile-menu-link {
    display: block;
    padding: 0.75rem;
    color: #374151;
    text-decoration: none;
    border-radius: 6px;
    transition: background 0.2s ease;
  }

  .mobile-menu-link:hover {
    background: #f3f4f6;
  }
}

/* Small Devices (481px - 768px) - Large Phones and Small Tablets */
@media (min-width: 481px) and (max-width: 768px) {
  .dashboard-container {
    padding: 0 1rem 1rem;
  }

  .premium-dashboard-header {
    padding: 1.5rem;
  }

  .premium-stats-row {
    grid-template-columns: repeat(2, 1fr);
    gap: 1rem;
  }

  .premium-stat-card {
    flex-direction: column;
    text-align: center;
    padding: 1rem;
  }

  .stat-icon-wrapper {
    width: 40px;
    height: 40px;
    font-size: 1rem;
  }

  .stat-content {
    flex-direction: column;
    align-items: center;
    gap: 0.5rem;
  }

  .stat-content h4 {
    font-size: 0.7rem;
  }

  .stat-content p {
    font-size: 1rem;
  }

  .premium-rate-cards {
    grid-template-columns: repeat(2, 1fr);
    gap: 1rem;
  }

  .rate-card-content {
    flex-direction: column;
    gap: 1rem;
  }

  .premium-action-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 1rem;
  }

  .bulk-rate-selector-modal {
    width: 90%;
    max-width: 500px;
  }

  .bulk-rate-selector-modal .bulk-modal-header {
    padding: 1.5rem;
  }

  .bulk-rate-selector-modal .bulk-modal-header .bulk-header-text {
    font-size: 1.3rem;
    font-weight: 750;
  }

  .collection-type-options {
    gap: 1rem;
  }

  .collection-type-btn {
    padding: 1.25rem 1rem;
    font-size: 0.9rem;
    min-height: 70px;
  }
}

/* Medium Devices (769px - 1024px) - Tablets */
@media (min-width: 769px) and (max-width: 1024px) {
  .dashboard-container {
    padding: 0 1.5rem 1.5rem;
    max-width: 100%;
  }

  .premium-dashboard-header {
    padding: 2rem;
  }

  .premium-stats-row {
    grid-template-columns: repeat(3, 1fr);
    gap: 1.25rem;
  }

  .premium-stat-card {
    padding: 1.25rem;
  }

  .stat-icon-wrapper {
    width: 44px;
    height: 44px;
    font-size: 1.1rem;
  }

  .stat-content h4 {
    font-size: 0.8rem;
  }

  .stat-content p {
    font-size: 1.1rem;
  }

  .premium-rate-cards {
    grid-template-columns: repeat(2, 1fr);
    gap: 1.25rem;
  }

  .premium-rate-card {
    min-height: 140px;
  }

  .rate-card-header {
    padding: 1rem;
  }

  .rate-card-icon {
    width: 32px;
    height: 32px;
    font-size: 0.9rem;
  }

  .heading-card-dashboard {
    font-size: 1.5rem;
  }

  .rate-card-title p {
    font-size: 0.7rem;
  }

  .rate-card-content {
    padding: 1.25rem;
  }

  .premium-action-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 1.25rem;
  }

  .premium-action-card {
    min-height: 160px;
  }

  .action-card-header {
    padding: 1.25rem;
  }

  .action-card-icon {
    width: 40px;
    height: 40px;
    font-size: 1.1rem;
  }

  .action-card-title h4 {
    font-size: 1.1rem;
  }

  .action-card-title p {
    font-size: 0.7rem;
  }

  .action-card-content {
    padding: 1.25rem;
  }

  .premium-action-btn {
    padding: 1rem 1.25rem;
    font-size: 0.9rem;
  }

  .bulk-rate-selector-modal {
    max-width: 550px;
  }

  .bulk-rate-selector-modal .bulk-modal-header {
    padding: 2rem;
  }

  .bulk-rate-selector-modal .bulk-modal-header .bulk-header-text {
    font-size: 1.5rem;
    font-weight: 800;
  }

  .collection-type-btn {
    padding: 1.5rem 1.25rem;
    font-size: 1rem;
    min-height: 75px;
  }

  .premium-rate-input {
    padding: 0.5rem 0.75rem;
    font-size: 0.9rem;
  }

  .premium-btn {
    padding: 0.4rem 0.8rem;
    font-size: 0.7rem;
  }

  .premium-select-rate-type {
    padding: 0.5rem 0.75rem;
    font-size: 0.8rem;
  }
}

/* Large Devices (1025px - 1440px) - Large Tablets and Small Desktops */
@media (min-width: 1025px) and (max-width: 1440px) {
  .dashboard-container {
    padding: 0 2rem 2rem;
    max-width: 1400px;
    margin: 0 auto;
  }

  .premium-stats-row {
    grid-template-columns: repeat(4, 1fr);
    gap: 1.5rem;
  }

  .premium-rate-cards {
    grid-template-columns: repeat(3, 1fr);
    gap: 1.5rem;
  }

  .premium-action-grid {
    grid-template-columns: repeat(3, 1fr);
    gap: 1.5rem;
  }

  .bulk-rate-selector-modal {
    max-width: 600px;
  }
}

/* Body scroll lock for modal */
body.modal-open {
  overflow: hidden;
  position: fixed;
  width: 100%;
}

/* Removed GPU hacks - they cause layout bugs on Chrome mobile */

/* Landscape Orientation Adjustments */
@media (max-width: 768px) and (orientation: landscape) {
  .mobile-header-bottom h1 {
    font-size: 1rem;
    margin: 0.25rem 0;
  }

  .premium-stats-row {
    grid-template-columns: repeat(2, 1fr);
    gap: 0.5rem;
  }

  .premium-stat-card {
    padding: 0.5rem;
  }

  .stat-icon-wrapper {
    width: 28px;
    height: 28px;
    font-size: 0.7rem;
  }

  .stat-content h4 {
    font-size: 0.55rem;
  }

  .stat-content p {
    font-size: 0.75rem;
  }

  .premium-rate-cards {
    grid-template-columns: repeat(3, 1fr);
    gap: 0.5rem;
  }

  .rate-card-header {
    padding: 0.4rem;
  }

  .rate-card-icon {
    width: 24px;
    height: 24px;
    font-size: 0.6rem;
  }


  .rate-card-title p {
    font-size: 0.45rem;
  }

  .rate-card-content {
    padding: 0.5rem;
  }

  .premium-action-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 0.5rem;
  }

  .action-card-header {
    padding: 0.5rem;
  }

  .action-card-icon {
    width: 32px;
    height: 32px;
    font-size: 0.8rem;
  }

  .action-card-title h4 {
    font-size: 1rem;
  }

  .action-card-title p {
    font-size: 0.7rem;
  }

  .action-card-content {
    padding: 0.5rem;
  }

  .premium-action-btn {
    padding: 0.6rem 0.8rem;
    font-size: 0.75rem;
  }
}

/* High DPI/Retina Display Optimizations */
@media (min-resolution: 192dpi) {

  .stat-icon-wrapper,
  .rate-card-icon,
  .action-card-icon {
    border-width: 0.5px;
  }

  .premium-btn,
  .premium-action-btn {
    border-width: 0.5px;
  }
}


/* Success/Error Notification */
.notification-toast {
  position: fixed;
  top: 20px;
  right: 20px;
  background-color: #10b981;
  color: #fff;
  padding: 1rem 1.5rem;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 9999;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  font-size: 0.95rem;
  font-weight: 500;
  animation: slideIn 0.3s ease-out;
  max-width: 400px;
}

.notification-toast.error {
  background-color: #dc2626;
}

@keyframes slideIn {
  from {
    transform: translateX(100%);
    opacity: 0;
  }

  to {
    transform: translateX(0);
    opacity: 1;
  }
}

/* Footer Logo */
.footer-logo {
  width: 170px;
}

/* Premium Dashboard Header Styles */
.owner-info-vertical {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.owner-wallet-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  /* gap: 1rem; */
  flex-wrap: wrap;
}

/* Mobile reordering: owner name first, then phone, then wallet */
@media (max-width: 480px) {
  .owner-info-vertical {
    display: flex;
    flex-direction: column;
  }

  .owner-wallet-row {
    display: flex !important;
    flex-direction: column !important;
    gap: 12px !important;
  }

  .owner-info-left:not(.long-name) {
    display: flex !important;
    flex-direction: row !important;
    flex-wrap: nowrap !important;
    align-items: center !important;
    gap: 8px !important;
    order: -2 !important;
    width: 100% !important;
  }

  .owner-info-left.long-name {
    display: flex !important;
    flex-direction: column !important;
    align-items: flex-start !important;
    gap: 6px !important;
    order: -2 !important;
    width: 100% !important;
  }

  .wallet-action-right {
    display: flex !important;
    flex-direction: column !important;
    align-items: stretch !important;
    width: 100% !important;
    order: -1 !important;
    gap: 10px !important;
  }

  .owner-info-left:not(.long-name) .owner-info {
    margin-bottom: 0 !important;
    display: flex !important;
    align-items: center !important;
    gap: 0.5rem !important;
    flex: 1 1 !important;
    min-width: 0 !important;
  }

  .owner-info-left:not(.long-name) .phone-info {
    margin-bottom: 0 !important;
    display: flex !important;
    align-items: center !important;
    gap: 0.5rem !important;
    flex: 1 1 !important;
    min-width: 0 !important;
  }

  .owner-info-left.long-name .owner-info,
  .owner-info-left.long-name .phone-info {
    margin-bottom: 0 !important;
    display: flex !important;
    align-items: center !important;
    gap: 0.5rem !important;
    width: 100% !important;
  }

  .owner-info span,
  .phone-info span {
    font-size: 0.9rem !important;
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
  }

  .owner-info-left.long-name span {
    max-width: 100% !important;
  }

  .wallet-info {
    order: 0;
    /* Wallet third */
    width: 100%;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: flex-start;
    gap: 0.4rem;
    padding: 0.5rem 0;
  }

  .hire-person-banner {
    order: 1;
    /* Hire button last */
    width: 100% !important;
    margin: 0 !important;
    box-sizing: border-box;
  }

  .wallet-info .icon-wallet {
    font-size: 1rem;
  }

  .wallet-info .wallet-recharge-link {
    font-size: 0.8rem;
    font-weight: 600;
    color: #3b82f6;
    text-decoration: underline;
    white-space: nowrap;
    margin-left: 0;
    padding-left: 0;
  }

  .wallet-info span:last-child {
    font-size: 0.9rem;
    font-weight: 700;
    color: #1f2937;
  }

  .heading-card-dashboard {
    font-size: 1rem !important;
    font-weight: 600;
    text-align: left;
  }
}

.premium-add-money-btn {
  margin-left: 0;
  margin-top: 0.35rem;
}

.owner-info {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-shrink: 0;
}

.phone-info {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-shrink: 0;
}

.wallet-info {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-shrink: 0;
}

.wallet-recharge-link {
  cursor: pointer;
  transition: text-decoration 0.3s ease;
}

.wallet-recharge-link:hover {
  text-decoration: underline;
  color: #3b82f6;
}

.owner-info span,
.phone-info span,
.wallet-info span {
  font-size: 1.1rem;
  font-weight: 500;
}

/* Icon Color Styles */
.icon-user {
  color: #3b82f6;
}

.icon-phone {
  color: #10b981;
}

.icon-wallet {
  color: #6366f1;
}

/* Button Margin Styles */
.btn-margin-left {
  margin-left: 0.5rem;
}

/* FontAwesome Icon Spacing */
.icon-margin-right-10 {
  margin-right: 10px;
}

.icon-margin-right-6 {
  margin-right: 6px;
}

.icon-margin-right-8 {
  margin-right: 8px;
}

.icon-margin-right-5 {
  margin-right: 5px;
}

.icon-margin-right-0-5rem {
  margin-right: 0.5rem;
}

/* Flex Container Styles */
.flex-gap-0-5rem {
  display: flex;
  gap: 0.5rem;
}

/* Error Message Styles */
.error-message-red {
  color: red;
  margin: 10px 0;
}

.edit-form-error {
  margin-bottom: 15px;
  color: red;
  font-weight: bold;
}

/* Modal Body Styles */
.modal-body-flex {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  overflow: auto;
  padding: 20px;
  padding-bottom: 20px;
}

/* Preview Header Styles */
.preview-header-blue {
  background-color: #e3f2fd;
  padding: 5px 8px;
  border-radius: 3px;
  margin-bottom: 8px;
  border-left: 2px solid #1976d2;
  flex-shrink: 0;
}

/* Close Button Styles */
.close-btn-16px {
  font-size: 16px;
}

/* Rate Chart Modal Styles */
.rate-chart-modal {
  background-color: white;
  border-radius: 8px;
  max-width: 600px;
  width: 90%;
  max-height: 80vh;
  overflow: auto;
  position: relative;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
}

.rate-chart-header {
  padding: 16px 20px;
  border-bottom: 1px solid #e0e0e0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #f8f9fa;
  border-radius: 8px 8px 0 0;
}

.rate-chart-header h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #333;
}

.modal-close-btn-ratechart {
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
  color: #666;
  padding: 4px;
  border-radius: 4px;
  transition: all 0.2s;
}

.modal-close-btn-ratechart:hover {
  background-color: #f0f0f0;
  color: #333;
}

.rate-chart-body {
  padding: 20px;
  max-height: 60vh;
  overflow-y: auto;
}

.rate-chart-section {
  margin-bottom: 24px;
}

.rate-chart-section:last-child {
  margin-bottom: 0;
}

.rate-chart-section h4 {
  margin: 0 0 8px 0;
  font-size: 16px;
  font-weight: 600;
  color: #333;
}

.rate-description {
  margin: 0 0 16px 0;
  font-size: 14px;
  color: #666;
  line-height: 1.4;
}

.rate-row {
  display: flex;
  gap: 12px;
  margin-bottom: 12px;
  align-items: flex-end;
}

.rate-input-group {
  flex: 1 1;
}

.rate-input-group label {
  display: block;
  font-size: 12px;
  color: #666;
  margin-bottom: 4px;
  font-weight: 500;
}

.rate-input {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  transition: border-color 0.2s;
}

.rate-input:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
}

.rate-input-with-icon {
  display: flex;
  align-items: center;
}

.rate-icon {
  margin-right: 8px;
  font-size: 14px;
  color: #666;
  font-weight: 600;
  min-width: 16px;
}

.delete-rate-btn {
  padding: 8px;
  border: 1px solid #dc3545;
  background-color: #dc3545;
  color: white;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
}

.delete-rate-btn:hover {
  background-color: #c82333;
  border-color: #c82333;
}

.add-step-btn {
  padding: 8px 16px;
  border: 1px solid #007bff;
  background-color: #007bff;
  color: white;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.2s;
}

.add-step-btn:hover {
  background-color: #0056b3;
  border-color: #0056b3;
}

.rate-chart-footer {
  padding: 16px 20px;
  border-top: 1px solid #e0e0e0;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  background-color: #f8f9fa;
  border-radius: 0 0 8px 8px;
}

.modal-btn {
  padding: 8px 16px;
  border: 1px solid transparent;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  gap: 6px;
}

.modal-btn-secondary {
  background-color: #6c757d;
  color: white;
  border-color: #6c757d;
}

.modal-btn-secondary:hover {
  background-color: #5a6268;
  border-color: #5a6268;
}

.modal-btn-primary {
  background-color: #007bff;
  color: white;
  border-color: #007bff;
}

.modal-btn-primary:hover {
  background-color: #0056b3;
  border-color: #0056b3;
}

.modal-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Mobile Responsive Styles for Rate Chart Modal */
@media (max-width: 768px) {
  .rate-chart-modal {
    width: 95%;
    max-height: 90vh;
    margin: 10px;
  }

  .rate-chart-header {
    padding: 12px 16px;
  }

  .rate-chart-header h3 {
    font-size: 16px;
  }

  .modal-close-btn-ratechart {
    font-size: 18px;
    padding: 6px;
  }

  .rate-chart-body {
    padding: 16px;
    max-height: 65vh;
  }

  .rate-chart-section {
    margin-bottom: 20px;
  }

  .rate-chart-section h4 {
    font-size: 15px;
    margin-bottom: 6px;
  }

  .rate-description {
    font-size: 13px;
    margin-bottom: 12px;
  }

  .rate-row {
    flex-direction: column;
    gap: 8px;
    align-items: stretch;
  }

  .rate-input-group {
    width: 100%;
  }

  .rate-input {
    padding: 10px 12px;
    font-size: 16px;
    /* Prevents zoom on iOS */
  }

  .rate-input-with-icon {
    align-items: center;
  }

  .rate-icon {
    margin-right: 10px;
    font-size: 16px;
  }

  .delete-rate-btn {
    position: absolute;
    right: 8px;
    top: 8px;
    padding: 6px;
    font-size: 11px;
  }

  .add-step-btn {
    padding: 10px 16px;
    font-size: 15px;
    justify-content: center;
  }

  .rate-chart-footer {
    padding: 12px 16px;
    flex-direction: column;
    gap: 8px;
  }

  .modal-btn {
    width: 100%;
    padding: 12px 16px;
    font-size: 15px;
    justify-content: center;
  }
}

@media (max-width: 480px) {
  .rate-chart-modal {
    width: 98%;
    margin: 5px;
    max-height: 95vh;
  }

  .rate-chart-header {
    padding: 10px 12px;
  }

  .rate-chart-header h3 {
    font-size: 15px;
  }

  .rate-chart-body {
    padding: 12px;
    max-height: 70vh;
  }

  .rate-chart-section {
    margin-bottom: 16px;
  }

  .rate-chart-section h4 {
    font-size: 14px;
  }

  .rate-description {
    font-size: 12px;
    margin-bottom: 10px;
  }

  .rate-input {
    padding: 8px 10px;
    font-size: 16px;
  }

  .rate-icon {
    margin-right: 8px;
    font-size: 14px;
  }

  .add-step-btn {
    padding: 8px 12px;
    font-size: 14px;
  }

  .rate-chart-footer {
    padding: 10px 12px;
  }

  .modal-btn {
    padding: 10px 12px;
    font-size: 14px;
  }
}

/* Bulk Edit Modal Buttons Mobile Responsive */
@media (max-width: 768px) {

  .modal-footer .cancel-button,
  .modal-footer .confirm-button {
    width: 100% !important;
    padding: 12px 16px !important;
    font-size: 15px !important;
    min-height: 48px;
    margin-bottom: 8px;
  }

  .modal-footer {
    flex-direction: column !important;
    gap: 8px !important;
    padding: 16px !important;
    flex-wrap: wrap !important;
  }
}

@media (max-width: 480px) {

  .modal-footer .cancel-button,
  .modal-footer .confirm-button {
    padding: 10px 12px !important;
    font-size: 14px !important;
    min-height: 44px;
    margin-bottom: 6px;
  }

  .modal-footer {
    padding: 12px !important;
    gap: 6px !important;
  }
}

/* Payment Feedback Message Styles */
.payment-feedback {
  padding: 12px 16px;
  margin: 10px 0;
  border-radius: 8px;
  font-weight: 500;
  text-align: center;
  animation: slideInFromTop 0.3s ease-out;
}

.payment-feedback.success {
  background-color: #e8f5e8;
  color: #2e7d32;
  border: 1px solid #4caf50;
}

.payment-feedback.error {
  background-color: #ffebee;
  color: #c62828;
  border: 1px solid #f44336;
}

@keyframes slideInFromTop {
  from {
    transform: translateY(-20px);
    opacity: 0;
  }

  to {
    transform: translateY(0);
    opacity: 1;
  }
}

/* Current Rate Box Styles */
.current-rate-box-dashboard {
  display: inline-flex;
  align-items: center;
  border: 1px solid #000;
  border-radius: 8px;
  padding: 4px 12px;
  margin-top: 0px;
  margin-right: 10px;
  transition: all 0.3s ease;
}

.current-rate-box-dashboard:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(76, 175, 80, 0.3);
}

.rate-symbol {
  font-size: 18px;
  font-weight: bold;
  color: #2e7d32;
  margin-right: 4px;
}

.rate-amount {
  font-size: 18px;
  font-weight: bold;
  color: #2e7d32;
  font-family: 'Courier New', monospace;
}

@media (max-width: 768px) {
  .current-rate-box-dashboard {
    padding: 4px 8px;
    margin-top: 6px;
  }

  .rate-symbol,
  .rate-amount {
    font-size: 16px;
  }
}

/* Mobile Language Switcher Styles */
@media (max-width: 768px) {
  .mobile-header-top {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 8px !important;
  }

  .logo-container-mobile {
    flex-shrink: 0;
  }

  .mobile-header-title {
    text-align: left !important;
    justify-self: flex-start !important;
    flex: 1 1;
    position: static;
    transform: none;
    left: auto;
    margin-left: 0;
    margin-right: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 200px;
  }

  .mobile-header-actions {
    flex-shrink: 0;
  }

  .mobile-header-actions .language-switcher {
    transform: scale(0.75);
    margin-left: 15px;
    margin-right: 3px;
  }

  .mobile-header-actions .language-switcher .language-switcher-button {
    padding: 4px 8px;
    font-size: 11px;
    min-width: 60px;
  }

  .mobile-header-actions .language-switcher .language-dropdown {
    top: 30px;
    right: 0;
  }

  .mobile-header-actions .language-switcher .language-dropdown .language-option {
    padding: 6px 10px;
    font-size: 11px;
  }
}

/* Support Modal Styles */
.trouble-section {
  display: flex;
  /* flex-direction: column; */
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid #eee;
}

.trouble-text {
  color: #000;
  font-size: 14px;
}

.contact-us-btn {
  background: linear-gradient(135deg, #1e3a8a, #1e40af);
  color: white;
  border: none;
  padding: 10px 18px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  box-shadow: 0 2px 8px rgba(30, 58, 138, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.contact-us-btn:hover {
  background: linear-gradient(135deg, #1e40af, #1d4ed8);
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(30, 58, 138, 0.4);
  border-color: rgba(255, 255, 255, 0.2);
}

.contact-us-btn:active {
  transform: translateY(0);
  box-shadow: 0 2px 8px rgba(30, 58, 138, 0.2);
}

.support-modal {
  background: white;
  border-radius: 12px;
  max-width: 450px;
  width: 90%;
  max-height: 80vh;
  overflow-y: auto;
  position: relative;
  animation: modalSlideIn 0.3s ease-out;
}

.support-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px;
  border-bottom: 1px solid #eee;
  background: linear-gradient(135deg, #4a90e2, #357abd);
  border-radius: 12px 12px 0 0;
}

.support-modal-header h3 {
  margin: 0;
  color: white;
  font-size: 18px;
  font-weight: 600;
}

.support-modal-header .modal-close-btn {
  background: rgba(255, 255, 255, 0.2);
  border: none;
  color: white;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.3s ease;
}

.support-modal-header .modal-close-btn:hover {
  background: rgba(255, 255, 255, 0.3);
}

.support-modal-body {
  padding: 16px;
}

.support-options {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 16px;
}

.support-option {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 12px;
  border-radius: 8px;
  text-decoration: none;
  border: 2px solid #f0f0f0;
  transition: all 0.3s ease;
}

.support-option:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.whatsapp-support:hover {
  border-color: #25d366;
  background: rgba(37, 211, 102, 0.05);
}

.call-support:hover {
  border-color: #4a90e2;
  background: rgba(74, 144, 226, 0.05);
}

.support-option-icon {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  color: white;
}

.whatsapp-support .support-option-icon {
  background: #25d366;
}

.call-support .support-option-icon {
  background: #4a90e2;
}

.support-option-content h4 {
  margin: 0 0 4px 0;
  font-size: 16px;
  font-weight: 600;
  color: #333;
}

.support-option-content p {
  margin: 0 0 8px 0;
  font-size: 14px;
  color: #666;
}

.support-number {
  font-size: 14px;
  font-weight: 600;
  color: #333;
}

.support-website {
  text-align: center;
  padding: 16px;
  background: #f8f9fa;
  border-radius: 8px;
}

.support-website p {
  margin: 0 0 8px 0;
  font-size: 14px;
  color: #666;
}

.website-link {
  color: #4a90e2;
  text-decoration: none;
  font-weight: 600;
  font-size: 16px;
  transition: color 0.3s ease;
}

.website-link:hover {
  color: #357abd;
  text-decoration: underline;
}

.refresh-link {
  color: #4a90e2;
  text-decoration: none;
  font-weight: 600;
  font-size: 12px;
  padding: 4px 8px;
  border: 1px solid #4a90e2;
  border-radius: 4px;
  background: rgba(74, 144, 226, 0.05);
  transition: all 0.3s ease;
  cursor: pointer;
  display: inline-block;
}

.refresh-link:hover {
  color: #357abd;
  background: rgba(74, 144, 226, 0.1);
  border-color: #357abd;
  transform: translateY(-1px);
}

@keyframes modalSlideIn {
  from {
    opacity: 0;
    transform: scale(0.9) translateY(-20px);
  }

  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

/* Mobile Responsive Styles for Support Modal */
@media (max-width: 768px) {
  .support-modal {
    width: 95%;
    max-height: 85vh;
  }

  .support-modal-header {
    padding: 16px 20px;
  }

  .support-modal-header h3 {
    font-size: 16px;
  }

  .support-modal-body {
    padding: 20px;
  }

  .support-option {
    padding: 12px;
    gap: 12px;
  }

  .support-option-icon {
    width: 40px;
    height: 40px;
    font-size: 16px;
  }

  .support-option-content h4 {
    font-size: 14px;
  }

  .support-option-content p {
    font-size: 12px;
  }

  .support-number {
    font-size: 12px;
  }

  .trouble-section {
    flex-direction: column;
    gap: 12px;
    text-align: center;
  }

  .contact-us-btn {
    width: 100%;
    max-width: 200px;
  }
}

/* Offers Modal Support Section */
.offers-support-section {
  margin-top: 16px;
  padding: 12px;
  background: #f8f9fa;
  border-radius: 8px;
  text-align: center;
  border-top: 2px solid #4a90e2;
}

.offers-support-text {
  display: block;
  margin-bottom: 12px;
  color: #666;
  font-size: 13px;
  font-size: 14px;
  font-weight: 500;
}

.offers-contact-btn {
  background: linear-gradient(135deg, #4a90e2, #357abd);
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.offers-contact-btn:hover {
  background: linear-gradient(135deg, #357abd, #2968a3);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(74, 144, 226, 0.3);
}

/* Rate Settings Modal Support Section */
.rate-settings-support-section {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 0;
  border-top: 1px solid #eee;
  margin-top: 12px;
}

.rate-settings-support-text {
  color: #666;
  font-size: 14px;
  font-weight: 500;
}

.rate-settings-contact-btn {
  background: linear-gradient(135deg, #4a90e2, #357abd);
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 6px;
}

.rate-settings-contact-btn:hover {
  background: linear-gradient(135deg, #357abd, #2968a3);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(74, 144, 226, 0.3);
}

/* Mobile Responsive Styles for Support Sections */
@media (max-width: 768px) {
  .offers-support-section {
    margin-top: 16px;
    padding: 12px;
  }

  .offers-support-text {
    font-size: 13px;
    margin-bottom: 10px;
  }

  .offers-contact-btn {
    padding: 8px 16px;
    font-size: 13px;
  }

  .rate-settings-support-section {
    flex-direction: column;
    gap: 8px;
    text-align: center;
  }

  .rate-settings-contact-btn {
    width: 100%;
    max-width: 200px;
    justify-content: center;
  }
}

.prorata-report-btn-wrapper {
  position: relative;
  display: inline-block;
}

@media (max-width: 768px) {
  .prorata-report-btn-wrapper {
    width: 100% !important;
    display: flex !important;
    flex-direction: column !important;
  }
  .prorata-report-btn-wrapper .pro-rata-report-generator {
    width: 100% !important;
  }
  .prorata-report-btn-wrapper button {
    width: 100% !important;
  }
}

/* Rate Settings Modal Row styling for Rate Type & Animal Type side-by-side */
.rate-settings-modal-row-dashboard {
  display: flex;
  gap: 16px;
  margin-bottom: 15px;
}

@media (max-width: 480px) {
  .rate-settings-modal-row-dashboard {
    flex-direction: row !important;
    gap: 8px !important;
    margin-bottom: 10px !important;
  }
  .rate-settings-modal-row-dashboard .rate-settings-modal-section-dashboard {
    flex: 1 1 !important;
    min-width: 0 !important;
  }
}

/* Bulk Edit Stats Panel Mobile Alignment */
@media (max-width: 768px) {
  .bulk-edit-stats-panel {
    display: grid !important;
    grid-template-columns: repeat(2, 1fr) !important;
    gap: 12px 0 !important;
    padding: 10px 8px !important;
    width: 100% !important;
    box-sizing: border-box !important;
  }

  .bulk-edit-stats-divider {
    display: none !important;
  }

  .bulk-edit-stats-item {
    width: 100% !important;
    min-width: 0 !important;
    flex: none !important;
    box-sizing: border-box !important;
  }

  .bulk-edit-stats-item:nth-child(4n+1) {
    border-right: 1px solid #dee2e6 !important;
  }

  /* Rate Settings Modal Mobile Buttons styling */
  .rate-settings-modal-option-btn {
    padding: 8px 12px !important;
    font-size: 13px !important;
    border-radius: 6px !important;
  }

  .rate-settings-modal-cancel-btn,
  .rate-settings-modal-save-btn {
    padding: 10px 14px !important;
    font-size: 14px !important;
    border-radius: 8px !important;
  }

  .rate-settings-modal-btn {
    padding: 8px 12px !important;
    font-size: 11px !important;
    border-radius: 6px !important;
  }

  .rate-settings-modal-footer {
    gap: 8px !important;
    padding: 10px 12px !important;
  }

  .rate-settings-modal-body {
    padding: 12px 16px !important;
  }

  .rate-settings-modal-section,
  .rate-settings-modal-col {
    margin-bottom: 12px !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Dashboard.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,iCAAiC;AACjC;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,0CAA0C;EAC1C,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE;IACE,4BAA4B;IAC5B,UAAU;EACZ;;EAEA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE;IACE,eAAe;IACf,iBAAiB;IACjB,QAAQ;IACR,QAAQ;IACR,UAAU;IACV,eAAe;EACjB;;EAEA;IACE;MACE,4BAA4B;MAC5B,UAAU;IACZ;;IAEA;MACE,wBAAwB;MACxB,UAAU;IACZ;EACF;AACF;;AAEA;EACE;IACE,eAAe;IACf,iBAAiB;IACjB,QAAQ;IACR,QAAQ;IACR,UAAU;IACV,eAAe;IACf,sBAAsB;IACtB,gBAAgB;EAClB;;EAEA;IACE;MACE,4BAA4B;MAC5B,UAAU;IACZ;;IAEA;MACE,wBAAwB;MACxB,UAAU;IACZ;EACF;AACF;;AAEA;EACE;IACE,cAAc;IACd,gBAAgB;IAChB,QAAQ;IACR,QAAQ;IACR,UAAU;IACV,eAAe;IACf,sBAAsB;IACtB,gBAAgB;EAClB;;EAEA;IACE;MACE,4BAA4B;MAC5B,UAAU;IACZ;;IAEA;MACE,wBAAwB;MACxB,UAAU;IACZ;EACF;AACF;;AAEA;EACE,eAAe;EACf,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,0CAA0C;EAC1C,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE;IACE,8CAA8C;IAC9C,UAAU;EACZ;;EAEA;IACE,yCAAyC;IACzC,UAAU;EACZ;AACF;;AAEA;EACE;IACE,eAAe;IACf,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,eAAe;IACf,iBAAiB;IACjB,QAAQ;IACR,QAAQ;IACR,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;;;;;;;;;;;;;;;;EAgBE;;AAEF;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,oCAAoC;EACpC,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;;+EAE+E;;AAE/E;EACE,6DAA6D;EAC7D,yCAAyC;EACzC,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,+CAA+C;EAC/C,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,+CAA+C;EAC/C,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;EACd,8CAA8C;EAC9C,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,cAAc;EACd,8CAA8C;AAChD;;AAEA;;+EAE+E;;AAE/E;EACE,eAAe;EACf,QAAQ;EACR,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,0BAA0B;EAC1B,kCAAkC;EAClC,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB;;mCAEiC;EACjC,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,8DAA8D;AAChE;;AAEA;EACE,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;AACpB;;AAEA,0BAA0B;AAC1B;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,sCAAsC;AACtC;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA,qCAAqC;AACrC;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA,8BAA8B;AAC9B;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,yBAAyB;AACzB;EACE,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kFAAkF;AACpF;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,yBAAyB;EACzB,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;;EAEA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;;+EAE+E;;AAE/E;EACE;IACE,SAAS;IACT,4BAA4B;IAC5B,WAAW;IACX,sBAAsB;IACtB,mBAAmB;IACnB,6BAA6B;EAC/B;;EAEA;IACE,6BAA6B;IAC7B,mBAAmB;IACnB,2BAA2B;EAC7B;;EAEA;IACE,6BAA6B;IAC7B,mBAAmB;IACnB,2BAA2B;EAC7B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,4BAA4B;EAC9B;;EAEA;;IAEE,mBAAmB;IACnB,yBAAyB;IACzB,2BAA2B;IAC3B,wBAAwB;IACxB,iCAAiC;IACjC,2BAA2B;IAC3B,uBAAuB;EACzB;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;EAC5B;;EAEA;IACE,6BAA6B;IAC7B,2BAA2B;IAC3B,wBAAwB;IACxB,iCAAiC;IACjC,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,6BAA6B;IAC7B,6BAA6B;EAC/B;;EAEA;IACE,4BAA4B;IAC5B,2BAA2B;EAC7B;;EAEA;IACE,0BAA0B;IAC1B,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,4BAA4B;IAC5B,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,+BAA+B;IAC/B,WAAW;EACb;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,0BAA0B;EAC1B,SAAS;EACT,UAAU;AACZ;;AAEA,sCAAsC;AACtC;EACE,kBAAkB;EAClB,wBAAwB;EACxB,uBAAuB;EACvB,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,wEAAwE;AAC1E;;AAEA,6BAA6B;AAC7B;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,qBAAqB;EACrB,sBAAsB;EACtB,yCAAyC;EACzC,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,yBAAyB;EACzB,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;EACd,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,SAAS;EACT,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;EACT,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;EAC1B,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;AACjC;;AAEA,4BAA4B;AAC5B;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;;EAEhB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;EAC1C,iCAAiC;EACjC,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,wCAAwC;EACxC,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,YAAY;EACZ,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;;AAGA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAO;EACP,WAAW;AACb;;AAEA;EACE,SAAO;EACP,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,sBAAsB;EACtB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,iCAAiC;EACjC,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,4BAA4B;EAC5B,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,WAAW;EACX,uBAAuB;EACvB,yBAAyB;EACzB,6BAA6B;EAC7B,YAAY;EACZ,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,qBAAqB;EACrB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,6DAA6D;EAC7D,kBAAkB;EAClB,iCAAiC;EACjC,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA;EACE,0CAA0C;EAC1C,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,0BAA0B;EAC1B,kBAAkB;EAClB,iCAAiC;EACjC,SAAO;EACP,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;;EAEE,sBAAsB;EACtB,YAAY;EACZ,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA,8BAA8B;AAC9B;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;EACd,4BAA4B;AAC9B;;AAEA;;EAEE,WAAW;EACX,sBAAsB;EACtB,uBAAuB;EACvB,sBAAsB;EACtB,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,6DAA6D;AAC7D;;EAEE,UAAU;EACV,cAAc;EACd,uBAAuB;EACvB,aAAa;AACf;;AAEA,gDAAgD;AAChD;;EAEE;;IAEE,aAAa;EACf;AACF;;AAEA,0BAA0B;AAC1B;;EAEE,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,mBAAmB;AACrB;;AAEA;;EAEE,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA,wCAAwC;AACxC;EACE,aAAa;EACb,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,qBAAqB;EACrB,6DAA6D;EAC7D,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,6CAA6C;AAC/C;;AAEA;EACE,6DAA6D;EAC7D,sBAAsB;EACtB,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,iDAAiD;AACjD;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;IACtB,WAAW;IACX,iBAAiB;EACnB;;EAEA;;IAEE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;EACnB;AACF;;AAEA,+CAA+C;AAC/C;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA,4CAA4C;AAC5C;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,WAAW;EACX,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,SAAS;AACT;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA,oCAAoC;AACpC;EACE,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,WAAW;EACX,kBAAkB;;EAElB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,UAAU;AACZ;;AAEA,aAAa;AACb;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,yDAAqR;EACrR,4BAA4B;EAC5B,sCAAsC;EACtC,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,oCAAoC;AACpC;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA,8BAA8B;AAC9B;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,WAAW;EACX,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;;AAGA,8CAA8C;AAC9C;EACE;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;;IAEE,UAAU;IACV,WAAW;EACb;;EAEA;IACE,UAAU;IACV,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,SAAS;EACX;;EAEA;;IAEE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;;IAEE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,iBAAiB;EACnB;;EAEA,kDAAkD;EAClD;IACE,sBAAsB;IACtB,oBAAoB;IACpB,WAAW;IACX,eAAe;IACf,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,uBAAuB;IACvB,uBAAuB;IACvB,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;EACd;AACF;;AAEA,iDAAiD;AACjD;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,oBAAoB;EACpB,mEAAmE;EACnE,kBAAkB;EAClB,+CAA+C;EAC/C,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;EACnB,iFAAiF;EACjF,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,iCAAiC;EACjC,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,gBAAgB;EAChB,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,yDAAuL;EACvL,4BAA4B;EAC5B,wCAAwC;EACxC,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,4BAA4B;EAC5B,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;EAC5B,8CAA8C;AAChD;;AAEA;EACE,iCAAiC;EACjC,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;AACd;;AAEA,qDAAqD;AACrD;EACE;IACE,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,kBAAkB;IAClB,wCAAwC;IACxC,qBAAqB;EACvB;;EAEA;IACE,6CAA6C;IAC7C,6BAA6B;EAC/B;;EAEA;IACE,8CAA8C;EAChD;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,eAAe;IACf,eAAe;IACf,YAAY;IACZ,UAAU;IACV,kBAAkB;IAClB,wCAAwC;IACxC,qBAAqB;EACvB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,8CAA8C;EAChD;;EAEA;IACE,eAAe;EACjB;;EAEA,8CAA8C;EAC9C;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,eAAe;IACf,WAAW;EACb;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,sBAAsB;IACtB,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,YAAY;EACd;;;EAGA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;EACpB;AACF;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,yCAAyC;EACzC,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;;EAEE;;IAEE,UAAU;EACZ;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,wBAAwB;EACxB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,+CAA+C;AACjD;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,iCAAiC;EACjC,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,yDAAuL;EACvL,4BAA4B;EAC5B,wCAAwC;EACxC,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;EAC5B,6CAA6C;AAC/C;;AAEA;EACE,4BAA4B;EAC5B,8CAA8C;AAChD;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA,+BAA+B;AAC/B;EACE;IACE,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,wCAAwC;IACxC,mBAAmB;EACrB;;EAEA;IACE,6CAA6C;EAC/C;;EAEA;IACE,8CAA8C;EAChD;;EAEA;IACE,kBAAkB;EACpB;;EAEA,6CAA6C;EAC7C;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,sBAAsB;EACxB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,SAAS;IACT,2BAA2B;EAC7B;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,iBAAiB;IACjB,qBAAqB;IACrB,WAAW;EACb;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,4BAA4B;IAC5B,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;IACV,2BAA2B;EAC7B;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,iCAAiC;EACjC,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,4BAA4B;EAC5B,6CAA6C;AAC/C;;AAEA,4BAA4B;AAC5B;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;EAC1C,iCAAiC;EACjC,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,wCAAwC;EACxC,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;EAChB,yCAAyC;EACzC,uBAAuB;EACvB,kBAAkB;EAClB,yCAAyC;EACzC,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA,4CAA4C;AAC5C;EACE;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,eAAe;IACf,qBAAqB;EACvB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;IAEE,aAAa;EACf;;EAEA;;IAEE,aAAa;EACf;;EAEA;;IAEE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,oBAAoB;IACpB,iBAAiB;EACnB;;EAEA;IACE,oBAAoB;IACpB,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA,sCAAsC;EACtC;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;IAEE,sBAAsB;IACtB,kBAAkB;IAClB,YAAY;EACd;;EAEA,mCAAmC;EACnC;;IAEE,aAAa;EACf;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,iBAAiB;EACnB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,oCAAoC;EACtC;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,0BAA0B;IAC1B,YAAY;EACd;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,YAAY;IACZ,gBAAgB;IAChB,SAAO;EACT;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,cAAc;IACd,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,sBAAsB;IACtB,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,6CAA6C;EAC/C;;EAEA;IACE,mBAAmB;IACnB,2BAA2B;IAC3B,2CAA2C;EAC7C;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;IACnB,WAAW;IACX,2BAA2B;EAC7B;;EAEA;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,iBAAiB;EACnB;;EAEA,qCAAqC;EACrC;IACE,qCAAqC;IACrC,sBAAsB;EACxB;;EAEA;IACE,6BAA6B;IAC7B,gDAAgD;IAChD,oDAAoD;EACtD;;EAEA;IACE,4BAA4B;IAC5B,mBAAmB;IACnB,8BAA8B;IAC9B,2CAA2C;EAC7C;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,6BAA6B;IAC7B,6BAA6B;EAC/B;;EAEA;IACE,4BAA4B;IAC5B,2BAA2B;IAC3B,yBAAyB;EAC3B;;EAEA;IACE,2BAA2B;IAC3B,0BAA0B;IAC1B,6BAA6B;IAC7B,4BAA4B;EAC9B;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,4BAA4B;IAC5B,wBAAwB;IACxB,iCAAiC;IACjC,mBAAmB;EACrB;;EAEA;IACE,6BAA6B;IAC7B,mBAAmB;IACnB,6BAA6B;IAC7B,yBAAyB;IACzB,wBAAwB;IACxB,8BAA8B;EAChC;;EAEA;IACE,4BAA4B;IAC5B,yBAAyB;EAC3B;;EAEA,qCAAqC;EACrC;;IAEE,wBAAwB;EAC1B;;EAEA,8DAA8D;EAC9D;;IAEE,wBAAwB;IACxB,4BAA4B;IAC5B,6BAA6B;IAC7B,2BAA2B;IAC3B,mBAAmB;IACnB,sBAAsB;IACtB,4BAA4B;IAC5B,6BAA6B;IAC7B,kCAAkC;IAClC,iCAAiC;EACnC;;EAEA;;;;KAIG;;EAEH,8CAA8C;EAC9C;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,qBAAqB;IACrB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,WAAW;IACX,2BAA2B;EAC7B;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,uBAAuB;IACvB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,sBAAsB;IACtB,iBAAiB;IACjB,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;EACpB;AACF;;AAEA,WAAW;AACX;EACE,6DAA6D;;EAE7D,UAAU;EACV,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,6CAA6C;EAC7C,SAAS;EACT,YAAY;EACZ,kBAAkB;EAClB,mCAAmC;EACnC,YAAY;EACZ,YAAY;EACZ,SAAS;EACT,2BAA2B;AAC7B;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,YAAY;AACd;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY;;;AAGd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,2BAA2B;EAC3B,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,iCAAiC;EACjC,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;;AAElB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oCAAoC;EACpC,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,SAAS;EACT,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oCAAoC;EACpC,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,sBAAsB;EACtB,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,SAAS;EACT,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,oBAAoB;EACpB,kBAAkB;EAClB,oCAAoC;EACpC,0CAA0C;EAC1C,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,oCAAoC;EACpC,0CAA0C;EAC1C,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,qCAAqC;EACrC,oBAAoB;EACpB,kBAAkB;EAClB,0CAA0C;EAC1C,SAAS;EACT,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;;EAEE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,0CAA0C;EAC1C,kBAAkB;EAClB,2CAA2C;EAC3C,YAAY;EACZ,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;EACT,2BAA2B;AAC7B;;;AAGA;EACE,wBAAwB;EACxB,6CAA6C;AAC/C;;AAEA,4BAA4B;AAC5B;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,0CAA0C;EAC1C,kBAAkB;EAClB,2CAA2C;EAC3C,YAAY;EACZ,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;EACT,2BAA2B;AAC7B;;AAEA;EACE,2CAA2C;EAC3C,sCAAsC;EACtC,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,yCAAyC;EACzC,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,wBAAwB;EACxB,UAAU;EACV,mBAAmB;AACrB;;AAEA,gEAAgE;AAChE;EACE;IACE,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;EAClB;AACF;;AAEA;EACE,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,qBAAqB;AACvB;;AAEA,uDAAuD;AACvD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,6CAA6C;AAC7C;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;;EAEE,iBAAiB;EACjB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,sCAAsC;EACtC,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,MAAM;EACN,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,0CAA0C;EAC1C,aAAa;EACb,2CAA2C;EAC3C,2DAA2D;EAC3D,gBAAgB;AAClB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,gDAAgD;AAChD;EACE;IACE,mBAAmB;IACnB,8BAA8B;IAC9B,uBAAuB;EACzB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,WAAW;EACb;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA,8CAA8C;AAC9C;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA,6BAA6B;AAC7B;EACE;IACE,UAAU;IACV,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,iBAAiB;EACnB;AACF;;AAEA,6BAA6B;AAC7B;EACE;IACE,YAAY;IACZ,UAAU;IACV,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,oBAAoB;IACpB,YAAY;IACZ,aAAa;IACb,qBAAqB;IACrB,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,wBAAwB;IACxB,SAAS;IACT,2BAA2B;EAC7B;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;IACZ,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,SAAS;EACX;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,cAAc;IACd,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,yBAAyB;EAC3B;;EAEA;IACE,oCAAoC;EACtC;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,WAAW;EACb;AACF;;AAEA,mCAAmC;AACnC;EACE;;IAEE,uBAAuB;IACvB,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,SAAS;IACT,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,SAAS;IACT,2BAA2B;EAC7B;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;AACF;;AAEA,yCAAyC;AACzC;EACE;IACE,sBAAsB;IACtB,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;AACF;;AAEA,iBAAiB;AACjB;EACE,SAAO;EACP,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,WAAW;AACb;;AAEA,iDAAiD;AACjD;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA,oBAAoB;AACpB;EACE,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,iCAAiC;EACjC,0CAA0C;EAC1C,yBAAyB;AAC3B;;AAEA;EACE,yCAAyC;EACzC,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,oBAAoB;EACpB,wCAAwC;AAC1C;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,iFAAiF;EACjF,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,mBAAmB;EACnB,kEAAkE;EAClE,iCAAiC;EACjC,qBAAqB;EACrB,sBAAsB;EACtB,yBAAyB;EACzB,yCAAyC;EACzC,eAAe;AACjB;;AAEA;EACE,kEAAkE;EAClE,0CAA0C;EAC1C,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;EACE,gFAAgF;EAChF,YAAY;EACZ,YAAY;EACZ,8CAA8C;AAChD;;AAEA;EACE,yEAAyE;EACzE,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA;EACE,sEAAsE;EACtE,YAAY;EACZ,YAAY;EACZ,8CAA8C;AAChD;;AAEA;EACE,6DAA6D;EAC7D,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA,wDAAwD;AACxD;EACE,iCAAiC;EACjC,2BAA2B;EAC3B,cAAc;EACd,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA,gEAAgE;AAChE;EACE,iCAAiC;EACjC,2BAA2B;EAC3B,cAAc;EACd,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA,4CAA4C;AAC5C;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;EACE,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;EACjB,yCAAyC;EACzC,uBAAuB;EACvB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA,aAAa;AACb;EACE,gCAAgC;EAChC,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;IAC1B,WAAW;EACb;;EAEA;IACE,qBAAqB;IACrB,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,sBAAsB;EACxB;;EAEA;IACE,UAAU;IACV,sBAAsB;IACtB,SAAS;IACT,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,QAAQ;EACV;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,YAAY;IACZ,QAAQ;IACR,WAAW;EACb;;EAEA;IACE,mBAAmB;IACnB,8BAA8B;IAC9B,uBAAuB;IACvB,WAAW;IACX,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,WAAW;EACb;;EAEA;;IAEE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;IACnB,WAAW;IACX,mBAAmB;IACnB,cAAc;IACd,uBAAuB;IACvB,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,iBAAiB;IACjB,WAAW;IACX,uBAAuB;IACvB,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA,uCAAuC;EACvC;IACE,0BAA0B;IAC1B,SAAS;IACT,qBAAqB;EACvB;;EAEA;;IAEE,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,qBAAqB;IACrB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,sBAAsB;IACtB,cAAc;IACd,eAAe;IACf,UAAU;IACV,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,YAAY;EACd;;EAEA;;IAEE,eAAe;IACf,gBAAgB;EAClB;;EAEA;;IAEE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;;IAEE,sBAAsB;IACtB,oBAAoB;IACpB,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,uBAAuB;IACvB,sBAAsB;IACtB,iBAAiB;EACnB;AACF;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,mBAAmB;AACrB;;AAEA,oCAAoC;AACpC;EACE;IACE,8BAA8B;IAC9B,WAAW;EACb;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,wBAAwB;IACxB,YAAY;IACZ,aAAa;IACb,cAAc;IACd,2BAA2B;IAC3B,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,wBAAwB;IACxB,kBAAkB;IAClB,oBAAoB;EACtB;;EAEA;IACE,YAAY;IACZ,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;;IAEE,wBAAwB;IACxB,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;IACnB,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,wBAAwB;IACxB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,aAAa;IACb,mBAAmB;IACnB,WAAW;EACb;;EAEA;;IAEE,eAAe;IACf,UAAU;EACZ;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,wBAAwB;IACxB,YAAY;IACZ,2BAA2B;IAC3B,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,wBAAwB;IACxB,kBAAkB;IAClB,oBAAoB;EACtB;;;EAGA;IACE,YAAY;IACZ,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;;IAEE,wBAAwB;IACxB,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;IACnB,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,wBAAwB;IACxB,kBAAkB;EACpB;;EAEA;IACE,8BAA8B;IAC9B,WAAW;EACb;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,wBAAwB;IACxB,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,SAAS;EACX;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,YAAY;EACd;;EAEA;IACE,qBAAqB;IACrB,gBAAgB;EAClB;;EAEA,2CAA2C;EAC3C;IACE,wBAAwB;EAC1B;;EAEA,uCAAuC;EACvC;IACE,wBAAwB;EAC1B;;EAEA;IACE,WAAW;EACb;AACF;;AAEA,qCAAqC;AACrC;EACE;IACE,8BAA8B;IAC9B,WAAW;EACb;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,wBAAwB;IACxB,kBAAkB;IAClB,qBAAqB;EACvB;AACF;;AAEA,+CAA+C;AAC/C;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;;IAEE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,oBAAoB;IACpB,8BAA8B;IAC9B,kCAAkC;IAClC,8BAA8B;IAC9B,0BAA0B;EAC5B;;EAEA;IACE,kCAAkC;IAClC,sBAAsB;IACtB,qBAAqB;IACrB,0BAA0B;IAC1B,kCAAkC;IAClC,8BAA8B;EAChC;;EAEA;IACE,iBAAiB;IACjB,cAAc;IACd,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,6BAA6B;IAC7B,2BAA2B;IAC3B,oBAAkB;IAClB,2BAA2B;IAC3B,8BAA8B;EAChC;;EAEA;IACE,wBAAwB;IACxB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,oBAAoB;IACpB,eAAe;IACf,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;EACjB;;EAEA;;IAEE,UAAU;IACV,uBAAuB;IACvB,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;IACzB,eAAe;IACf,WAAW;IACX,oBAAoB;IACpB,mBAAmB;IACnB,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,uBAAuB;IACvB,gCAAgC;IAChC,qBAAqB;IACrB,wBAAwB;IACxB,kBAAkB;EACpB;;EAEA;IACE,gCAAgC;IAChC,YAAY;IACZ,2BAA2B;IAC3B,wCAAwC;EAC1C;;EAEA;IACE,uBAAuB;IACvB,kBAAkB;IAClB,6DAA6D;IAC7D,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,4CAA4C;IAC5C,sCAAsC;EACxC;;EAEA;IACE,6DAA6D;IAC7D,2BAA2B;IAC3B,6CAA6C;EAC/C;;EAEA;IACE;MACE,4CAA4C;IAC9C;;IAEA;MACE,6CAA6C;IAC/C;;IAEA;MACE,4CAA4C;IAC9C;EACF;;EAEA,yCAAyC;EACzC;IACE;MACE,sBAAsB;MACtB,WAAW;MACX,mBAAmB;IACrB;;IAEA;;MAEE,WAAW;MACX,uBAAuB;MACvB,kBAAkB;MAClB,gBAAgB;MAChB,gBAAgB;MAChB,oBAAoB;MACpB,mBAAmB;MACnB,WAAW;MACX,mBAAmB;IACrB;;IAEA;MACE,kBAAkB;MAClB,wBAAwB;MACxB,gBAAgB;IAClB;EACF;;EAEA;IACE,sBAAsB;IACtB,WAAW;IACX,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,8BAA8B;EAChC;;EAEA;;;;KAIG;;EAEH;IACE,SAAO;IACP,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,uBAAuB;IACvB,sBAAsB;IACtB,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;EACjB;AACF;;AAEA,yBAAyB;AACzB;EACE,6DAA6D;EAC7D,mBAAmB;EACnB,eAAe;EACf,iCAAiC;EACjC,0CAA0C;EAC1C,yBAAyB;EACzB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,WAAW;EACX,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,kEAAkE;EAClE,kBAAkB;EAClB,iCAAiC;EACjC,yBAAyB;EACzB,uBAAuB;EACvB,WAAW;EACX,yCAAyC;AAC3C;;AAEA;EACE,kEAAkE;EAClE,0CAA0C;EAC1C,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;EACjB,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,sCAAsC;EACtC,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,mDAAmD;AACnD;EACE,aAAa;AACf;;AAEA;EACE,6DAA6D;EAC7D,mBAAmB;EACnB,eAAe;EACf,iCAAiC;EACjC,0CAA0C;EAC1C,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,SAAO;EACP,kEAAkE;EAClE,iCAAiC;EACjC,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;;EAEE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,iCAAiC;EACjC,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,iCAAiC;EACjC,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;;;;EAIE,wBAAwB;EACxB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,gCAAgC;EAChC,gCAAgC;EAChC,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,6CAA6C;EAC7C,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,YAAY;EACZ,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,wBAAwB;EACxB,6CAA6C;AAC/C;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,UAAU;EACV,6CAA6C;AAC/C;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,uBAAuB;EACvB,6DAA6D;EAC7D,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,UAAU;EACV,yCAAyC;AAC3C;;AAEA;EACE,6DAA6D;EAC7D,qBAAqB;EACrB,cAAc;EACd,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,6CAA6C;EAC7C,sCAAsC;AACxC;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE;IACE,4CAA4C;EAC9C;;EAEA;IACE,6CAA6C;EAC/C;;EAEA;IACE,4CAA4C;EAC9C;AACF;;AAEA;;EAEE,oEAAoE;EACpE,YAAY;EACZ,YAAY;EACZ,8CAA8C;AAChD;;AAEA;;EAEE,6DAA6D;EAC7D,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;;EAEE,2BAA2B;EAC3B,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oEAAoE;EACpE,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,8CAA8C;AAChD;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,gCAAgC;EAChC,gCAAgC;EAChC,4BAA4B;AAC9B;;AAEA;EACE;IACE,0CAA0C;EAC5C;;EAEA;IACE,0CAA0C;EAC5C;;EAEA;IACE,wCAAwC;EAC1C;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE;IACE,aAAa;IACb,mBAAmB;IACnB,2BAA2B;EAC7B;;EAEA;IACE,sBAAsB;IACtB,YAAY;EACd;;EAEA;;IAEE,eAAe;IACf,gBAAgB;EAClB;;EAEA;;IAEE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;;IAEE,sBAAsB;IACtB,oBAAoB;IACpB,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,uBAAuB;IACvB,sBAAsB;IACtB,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,uBAAuB;IACvB,uBAAuB;IACvB,iBAAiB;EACnB;;EAEA;;IAEE,sBAAsB;IACtB,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,WAAW;IACX,WAAW;EACb;;EAEA;;;IAGE,WAAW;IACX,gBAAgB;IAChB,uBAAuB;IACvB,sBAAsB;IACtB,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;;IAEE,WAAW;IACX,iBAAiB;EACnB;AACF;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,6DAA6D;EAC7D,qCAAqC;EACrC,2CAA2C;AAC7C;;AAEA;EACE,SAAS;EACT,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE;IACE,aAAa;EACf;;EAEA,sDAAsD;EACtD;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;;IAEE,gBAAgB;EAClB;AACF;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,iCAAiC;EACjC,iCAAiC;EACjC,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,gDAAgD;EAChD,iCAAiC;EACjC,kCAAkC;EAClC,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;EAC1B,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,2BAA2B;EAC3B,mCAAmC;EACnC,4CAA4C;EAC5C,aAAa;EACb,0CAA0C;AAC5C;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,mDAAmD;AACrD;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,aAAa;IACb,qBAAqB;EACvB;;EAEA;IACE,aAAa;IACb,gBAAgB;IAChB,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,eAAe;IACf,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,YAAY;IACZ,eAAe;EACjB;;EAEA;;IAEE,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,uBAAuB;EACzB;;EAEA;;IAEE,iBAAiB;IACjB,eAAe;EACjB;AACF;;AAEA,+CAA+C;AAC/C;EACE,eAAe;EACf,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA,+CAA+C;;AAE/C;EACE,uBAAuB;EACvB,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,0CAA0C;;EAE1C,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qCAAqC;EACrC,uBAAuB;EACvB,gBAAgB;EAChB,SAAS;AACX;;;AAGA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,SAAS;EACT,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;;EAEE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;;EAEE,iCAAiC;AACnC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,iCAAiC;EACjC,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;EACvB,iCAAiC;EACjC,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;EAChC,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,SAAO;EACP,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,eAAe;EACf,qCAAqC;AACvC;;AAEA;EACE,wBAAwB;EACxB,6DAA6D;EAC7D,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,6DAA6D;EAC7D,qBAAqB;EACrB,cAAc;EACd,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,uBAAuB;EACvB,gCAAgC;EAChC,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA,+BAA+B;AAC/B;EACE,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;EAChB,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;AAClB;;AAEA,yBAAyB;AACzB;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,iBAAiB;EACjB,+DAA+D;AACjE;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;EACX,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,yBAAyB;EACzB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,yBAAyB;EACzB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,iCAAiC;AACjC;EACE,6CAA6C;;EAE7C;IACE,SAAS;IACT,UAAU;IACV,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA,+BAA+B;EAC/B;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA,+BAA+B;AAC/B;;EAEE,2CAA2C;EAC3C;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA,qDAAqD;AACrD;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,oDAAoD;AACtD;;AAEA;;EAEE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;;AAGA,8BAA8B;AAC9B;EACE,gBAAgB;EAChB,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,yCAAyC;AACzC;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,+DAA+D;EAC/D,gBAAgB;EAChB,iCAAiC;EACjC,kBAAkB;EAClB,WAAW;AACb;;AAEA,4BAA4B;AAC5B;EACE,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;;AAEA,2BAA2B;AAC3B;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA,yDAAyD;AACzD;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,QAAQ;EACR,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA,wCAAwC;AACxC;EACE;IACE,cAAc;EAChB;;EAEA;IACE,gDAAgD;IAChD,mBAAmB;EACrB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;IACjB,YAAY;IACZ,YAAY;IACZ,qBAAqB;EACvB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,sCAAsC;AACtC;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,sBAAsB;EACtB,wCAAwC;AAC1C;;AAEA;EACE,SAAS;EACT,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,kBAAkB;AACpB;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,yBAAyB;EACzB,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,8CAA8C;EAC9C,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,gCAAgC;EAChC,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA,iDAAiD;AACjD;EACE;IACE,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;IACnB,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;IACtB,iBAAiB;IACjB,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,eAAe;IACf,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,sCAAsC;EACxC;;EAEA;IACE,iBAAiB;EACnB;;EAEA,4FAA4F;;EAE5F;IACE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA,2CAA2C;EAC3C;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;;IAEE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;;IAEE,sBAAsB;EACxB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;AACF;;AAEA,wCAAwC;AACxC;EACE,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,6CAA6C;EAC7C,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,sCAAsC;AACtC;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,UAAU;EACV,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA,kBAAkB;AAClB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;EAC1C,yBAAyB;EACzB,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA,6DAA6D;AAC7D;EACE,UAAU;EACV,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,qFAAqF;EACrF,gBAAgB;EAChB,UAAU;AACZ;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,qFAAqF;EACrF,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,SAAO;AACT;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qDAAqD;EACrD,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,qDAAqD;EACrD,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,qDAAqD;EACrD,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,6CAA6C;AAC/C;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,oBAAoB;EACpB,yBAAyB;EACzB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,qBAAqB;EACrB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,6BAA6B;EAC7B,0BAA0B;EAC1B,2BAA2B;EAC3B,uBAAuB;EACvB,oCAAoC;EACpC,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;EAChC,yDAAyD;AAC3D;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,qBAAqB;AACvB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE;;;;;;;;;;;;uCAYqC;EACrC,WAAW;EACX,cAAc;;EAEd,2BAA2B;AAC7B;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA,2BAA2B;AAC3B;EACE,eAAe;EACf,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,YAAY;AACd;;AAEA;EACE,WAAW;EACX,wBAAwB;EACxB,uBAAuB;EACvB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,yBAAyB;EACzB,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,SAAO;AACT;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;;AAGA,iBAAiB;AACjB;EACE,eAAe;EACf,6BAA6B;EAC7B,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,oBAAoB;EACpB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,gDAAgD;AAClD;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,gDAAgD;AAClD;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,4BAA4B;EAC5B,yBAAyB;EACzB,oCAAoC;EACpC,8BAA8B;EAC9B,iCAAiC;EACjC,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,yBAAyB;EACzB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,6DAA6D;EAC7D,qBAAqB;EACrB,cAAc;EACd,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE;IACE,UAAU;IACV,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,qBAAqB;IACrB,8BAA8B;EAChC;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,aAAa;IACb,gBAAgB;EAClB;;EAEA,sCAAsC;EACtC;IACE,qCAAqC;EACvC;;EAEA;IACE,kBAAkB;IAClB,yBAAyB;EAC3B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,iDAAiD;AACjD;EACE;IACE,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,aAAa;EACf;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,iBAAiB;IACjB,0BAA0B;EAC5B;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,aAAa;EACf;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,QAAQ;EACV;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,QAAQ;IACR,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA,+CAA+C;AAC/C;EACE;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;EAClB;AACF;;AAEA,0CAA0C;AAC1C;EACE;IACE,YAAY;IACZ,mBAAmB;EACrB;;EAEA;;IAEE,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;;IAEE,eAAe;EACjB;;EAEA;;IAEE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;;;;IAIE,kBAAkB;IAClB,uBAAuB;EACzB;;EAEA;IACE,UAAU;IACV,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA,iDAAiD;AACjD;EACE;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,UAAU;IACV,eAAe;IACf,mBAAmB;IACnB,gBAAgB;EAClB;AACF;;AAEA,wDAAwD;AACxD;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,0EAA0E;EAC1E,mBAAmB;EACnB,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,UAAU;EACV,WAAW;EACX,SAAS;EACT,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,iDAAiD;EACjD,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,4BAA4B;EAC5B,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,iGAAiG;EACjG,4BAA4B;AAC9B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,UAAU;EACV,yCAAyC;AAC3C;;AAEA;EACE,qCAAqC;EACrC,0CAA0C;EAC1C,eAAe;EACf,eAAe;EACf,YAAY;EACZ,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iDAAiD;EACjD,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,2BAA2B;AAC7B;;AAEA;EACE,qCAAqC;EACrC,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,0EAA0E;EAC1E,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,2CAA2C;EAC3C,mBAAmB;EACnB,6DAA6D;EAC7D,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iDAAiD;EACjD,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;EACrB,yBAAyB;EACzB,gBAAgB;EAChB;0CACwC;AAC1C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ,sFAAsF;EACtF,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,mEAAmE;EACnE,mBAAmB;EACnB,YAAY;EACZ,2BAA2B;EAC3B,iDAAiD;AACnD;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;;6CAE6C;;AAE7C,wCAAwC;AACxC;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,UAAU;EACZ;;EAEA;IACE,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,yCAAyC;IACzC,iBAAiB;IACjB,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,oBAAoB;IACpB,4CAA4C;EAC9C;;EAEA;IACE,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,6DAA6D;IAC7D,kBAAkB;IAClB,kBAAkB;IAClB,yCAAyC;EAC3C;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;EACvB;;EAEA;IACE,iBAAiB;IACjB,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,qBAAqB;IACrB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,qBAAqB;EACvB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,iCAAiC;EACnC;;EAEA;IACE,WAAW;IACX,eAAe;IACf,qBAAqB;IACrB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,2BAA2B;IAC3B,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,UAAU;IACV,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,4BAA4B;EAC9B;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,wBAAwB;IACxB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;;;IAGE,WAAW;IACX,qBAAqB;IACrB,qBAAqB;IACrB,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,WAAW;EACb;AACF;;AAEA,2CAA2C;AAC3C;EACE;IACE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,iBAAiB;IACjB,gBAAgB;EAClB;AACF;;AAEA,oEAAoE;AACpE;EACE;IACE,0BAA0B;IAC1B,WAAW;EACb;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,oBAAoB;IACpB,iBAAiB;EACnB;AACF;;AAEA,qEAAqE;AACrE;EACE;IACE,gDAAgD;IAChD,WAAW;IACX,wBAAwB;EAC1B;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA,oCAAoC;EACpC;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,iBAAiB;IACjB,WAAW;IACX,qBAAqB;EACvB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;IAEE,sBAAsB;IACtB,kBAAkB;IAClB,YAAY;EACd;;EAEA,oCAAoC;EACpC;;IAEE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,oBAAoB;IACpB,iBAAiB;EACnB;AACF;;AAEA,gEAAgE;AAChE;EACE;IACE,qCAAqC;IACrC,oBAAoB;IACpB,wBAAwB;EAC1B;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,qBAAqB;EACvB;;EAEA;IACE,iBAAiB;IACjB,qBAAqB;EACvB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,6DAA6D;AAC7D;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,YAAY;EACd;AACF;;AAEA,kCAAkC;AAClC;EACE;IACE,UAAU;EACZ;;EAEA;IACE,0BAA0B;IAC1B,YAAY;EACd;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,SAAO;IACP,gBAAgB;EAClB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,YAAY;EACd;AACF;;AAEA,8CAA8C;AAC9C;EACE;IACE,UAAU;EACZ;;EAEA;IACE,2DAA2D;IAC3D,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA,+CAA+C;AAC/C;EACE;IACE,2DAA2D;IAC3D,YAAY;EACd;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA,mDAAmD;AACnD;EACE;IACE,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,2DAA2D;IAC3D,SAAS;EACX;;EAEA,qCAAqC;EACrC;IACE,oBAAoB;IACpB,WAAW;EACb;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;IAEE,sBAAsB;IACtB,iBAAiB;IACjB,WAAW;EACb;;EAEA,gDAAgD;EAChD;;IAEE,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,+BAA+B;AAC/B;EAEE;IACE,WAAW;EACb;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA,qCAAqC;AACrC;EACE;IACE,mBAAmB;IACnB,UAAU;EACZ;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,4CAA4C;AAC5C;;EAEE,qCAAqC;EACrC;IACE,0EAA0E;EAC5E;AACF;;AAEA,mDAAmD;AACnD;EACE,qCAAqC;EACrC,0CAA0C;EAC1C,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;;EAEE;;;;;;IAME,eAAe;IACf,gBAAgB;EAClB;;EAEA;;;;;IAKE,eAAe;EACjB;AACF;;AAEA;;iDAEiD;;AAEjD,6BAA6B;AAC7B;EACE;IACE,eAAe;EACjB;;EAEA,+BAA+B;EAC/B;IACE,iCAAiC;EACnC;;EAEA;IAEE,eAAe;EACjB;AACF;;AAEA,uDAAuD;AACvD;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,YAAY;IACZ,gBAAgB;IAChB,UAAU;EACZ;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,iBAAiB;EACnB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,WAAW;IACX,oCAAoC;EACtC;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;IAC1B,YAAY;EACd;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,WAAW;IACX,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,eAAe;IACf,eAAe;IACf,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,iBAAiB;IACjB,WAAW;EACb;;EAEA;IACE,0BAA0B;IAC1B,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,oBAAoB;IACpB,iBAAiB;EACnB;;EAEA;IACE,UAAU;IACV,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,YAAY;IACZ,UAAU;EACZ;;EAEA;IACE,qBAAqB;IACrB,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;;;;;;;;;;;;;;KAcG;;EAEH;IACE,sBAAsB;IACtB,iBAAiB;IACjB,WAAW;EACb;;EAEA;IACE,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,8BAA8B;IAC9B,YAAY;EACd;;EAEA;IACE,eAAe;IACf,MAAM;IACN,YAAY;IACZ,UAAU;IACV,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,0CAA0C;IAC1C,2BAA2B;IAC3B,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,aAAa;IACb,gCAAgC;IAChC,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,cAAc;IACd,qBAAqB;IACrB,yBAAyB;EAC3B;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,cAAc;IACd,qBAAqB;IACrB,kBAAkB;IAClB,gCAAgC;EAClC;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA,mEAAmE;AACnE;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,qCAAqC;IACrC,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,qCAAqC;IACrC,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,qCAAqC;IACrC,SAAS;EACX;;EAEA;IACE,UAAU;IACV,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,qBAAqB;IACrB,iBAAiB;IACjB,gBAAgB;EAClB;AACF;;AAEA,8CAA8C;AAC9C;EACE;IACE,wBAAwB;IACxB,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,qCAAqC;IACrC,YAAY;EACd;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,qCAAqC;IACrC,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,qCAAqC;IACrC,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,qBAAqB;IACrB,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;IACvB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;IACvB,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,iBAAiB;EACnB;;EAEA;IACE,uBAAuB;IACvB,iBAAiB;EACnB;AACF;;AAEA,uEAAuE;AACvE;EACE;IACE,oBAAoB;IACpB,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,qCAAqC;IACrC,WAAW;EACb;;EAEA;IACE,qCAAqC;IACrC,WAAW;EACb;;EAEA;IACE,qCAAqC;IACrC,WAAW;EACb;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA,+BAA+B;AAC/B;EACE,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;;AAEA,gEAAgE;;AAEhE,sCAAsC;AACtC;EACE;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,qCAAqC;IACrC,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,qCAAqC;IACrC,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;;EAGA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,qCAAqC;IACrC,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;EACpB;AACF;;AAEA,0CAA0C;AAC1C;;EAGE;;;IAGE,mBAAmB;EACrB;;EAEA;;IAEE,mBAAmB;EACrB;AACF;;;AAGA,+BAA+B;AAC/B;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,yBAAyB;EACzB,WAAW;EACX,oBAAoB;EACpB,kBAAkB;EAClB,0CAA0C;EAC1C,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;;EAEA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA,gBAAgB;AAChB;EACE,YAAY;AACd;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,eAAe;AACjB;;AAEA,iEAAiE;AACjE;EACE;IACE,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,wBAAwB;IACxB,iCAAiC;IACjC,oBAAoB;EACtB;;EAEA;IACE,wBAAwB;IACxB,8BAA8B;IAC9B,4BAA4B;IAC5B,8BAA8B;IAC9B,mBAAmB;IACnB,oBAAoB;IACpB,sBAAsB;EACxB;;EAEA;IACE,wBAAwB;IACxB,iCAAiC;IACjC,kCAAkC;IAClC,mBAAmB;IACnB,oBAAoB;IACpB,sBAAsB;EACxB;;EAEA;IACE,wBAAwB;IACxB,iCAAiC;IACjC,+BAA+B;IAC/B,sBAAsB;IACtB,oBAAoB;IACpB,oBAAoB;EACtB;;EAEA;IACE,2BAA2B;IAC3B,wBAAwB;IACxB,8BAA8B;IAC9B,sBAAsB;IACtB,oBAAuB;IACvB,uBAAuB;EACzB;;EAEA;IACE,2BAA2B;IAC3B,wBAAwB;IACxB,8BAA8B;IAC9B,sBAAsB;IACtB,oBAAuB;IACvB,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;IAC3B,wBAAwB;IACxB,8BAA8B;IAC9B,sBAAsB;IACtB,sBAAsB;EACxB;;EAEA;;IAEE,4BAA4B;IAC5B,8BAA8B;IAC9B,2BAA2B;IAC3B,kCAAkC;EACpC;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,QAAQ;IACR,iBAAiB;IACjB,WAAW;IACX,iBAAiB;IACjB,mBAAmB;IACnB,2BAA2B;IAC3B,WAAW;IACX,iBAAiB;EACnB;;EAEA;IACE,QAAQ;IACR,qBAAqB;IACrB,sBAAsB;IACtB,oBAAoB;IACpB,sBAAsB;EACxB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,0BAA0B;IAC1B,mBAAmB;IACnB,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,0BAA0B;IAC1B,gBAAgB;IAChB,gBAAgB;EAClB;AACF;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,qCAAqC;AACvC;;AAEA;EACE,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;;;EAGE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,yBAAyB;AACzB;EACE,mBAAmB;AACrB;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;AACtB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,WAAW;AACb;;AAEA,yBAAyB;AACzB;EACE,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,UAAU;EACV,iBAAiB;AACnB;;AAEA,sBAAsB;AACtB;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,aAAa;EACb,oBAAoB;AACtB;;AAEA,0BAA0B;AAC1B;EACE,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,8BAA8B;EAC9B,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE,eAAe;AACjB;;AAEA,4BAA4B;AAC5B;EACE,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,cAAc;EACd,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,kDAAkD;AAClD;EACE;IACE,UAAU;IACV,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,QAAQ;IACR,oBAAoB;EACtB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,yBAAyB;EAC3B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;IAClB,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,UAAU;IACV,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;AACF;;AAEA,8CAA8C;AAC9C;;EAEE;;IAEE,sBAAsB;IACtB,6BAA6B;IAC7B,0BAA0B;IAC1B,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,iCAAiC;IACjC,mBAAmB;IACnB,wBAAwB;IACxB,0BAA0B;EAC5B;AACF;;AAEA;;EAEE;;IAEE,6BAA6B;IAC7B,0BAA0B;IAC1B,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;AACF;;AAEA,oCAAoC;AACpC;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE;IACE,4BAA4B;IAC5B,UAAU;EACZ;;EAEA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA,4BAA4B;AAC5B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;;IAEE,eAAe;EACjB;AACF;;AAEA,oCAAoC;AACpC;EACE;IACE,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,mBAAmB;EACrB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,2BAA2B;IAC3B,mCAAmC;IACnC,SAAO;IACP,gBAAgB;IAChB,eAAe;IACf,UAAU;IACV,cAAc;IACd,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,sBAAsB;IACtB,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,SAAS;IACT,QAAQ;EACV;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;AACF;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,4BAA4B;EAC5B,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,qDAAqD;EACrD,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,4CAA4C;EAC5C,0CAA0C;AAC5C;;AAEA;EACE,qDAAqD;EACrD,2BAA2B;EAC3B,6CAA6C;EAC7C,sCAAsC;AACxC;;AAEA;EACE,wBAAwB;EACxB,4CAA4C;AAC9C;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,6BAA6B;EAC7B,qDAAqD;EACrD,4BAA4B;AAC9B;;AAEA;EACE,SAAS;EACT,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,kBAAkB;EAClB,qBAAqB;EACrB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,oCAAoC;EACpC,yBAAyB;EACzB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,mCAAmC;EACnC,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;;EAEA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA,+CAA+C;AAC/C;EACE;IACE,UAAU;IACV,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;AACF;;AAEA,iCAAiC;AACjC;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qDAAqD;EACrD,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,qDAAqD;EACrD,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA,wCAAwC;AACxC;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qDAAqD;EACrD,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,qDAAqD;EACrD,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA,kDAAkD;AAClD;EACE;IACE,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,QAAQ;IACR,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,uBAAuB;EACzB;AACF;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE;IACE,sBAAsB;IACtB,wBAAwB;IACxB,iCAAiC;EACnC;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;AACF;;AAEA,6EAA6E;AAC7E;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE;IACE,8BAA8B;IAC9B,mBAAmB;IACnB,8BAA8B;EAChC;EACA;IACE,oBAAsB;IACtB,uBAAuB;EACzB;AACF;;AAEA,2CAA2C;AAC3C;EACE;IACE,wBAAwB;IACxB,gDAAgD;IAChD,sBAAsB;IACtB,4BAA4B;IAC5B,sBAAsB;IACtB,iCAAiC;EACnC;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,qBAAqB;IACrB,iCAAiC;EACnC;;EAEA;IACE,0CAA0C;EAC5C;;EAEA,+CAA+C;EAC/C;IACE,4BAA4B;IAC5B,0BAA0B;IAC1B,6BAA6B;EAC/B;;EAEA;;IAEE,6BAA6B;IAC7B,0BAA0B;IAC1B,6BAA6B;EAC/B;;EAEA;IACE,4BAA4B;IAC5B,0BAA0B;IAC1B,6BAA6B;EAC/B;;EAEA;IACE,mBAAmB;IACnB,6BAA6B;EAC/B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;AACF","sourcesContent":["* {\n  margin: 0px;\n  padding: 0px;\n}\n\n/* Success Message Toast Styles */\n.success-message {\n  position: fixed;\n  top: 20px;\n  right: 20px;\n  z-index: 9999;\n  background-color: #4caf50;\n  color: white;\n  padding: 12px 24px;\n  border-radius: 8px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 14px;\n  font-weight: 500;\n  max-width: 90vw;\n  text-align: center;\n  animation: slideInFromRight 0.3s ease-out;\n}\n\n@keyframes slideInFromRight {\n  from {\n    transform: translateX(400px);\n    opacity: 0;\n  }\n\n  to {\n    transform: translateX(0);\n    opacity: 1;\n  }\n}\n\n@media (max-width: 768px) {\n  .success-message {\n    font-size: 11px;\n    padding: 8px 12px;\n    gap: 5px;\n    top: 8px;\n    right: 8px;\n    max-width: 80vw;\n  }\n\n  @keyframes slideInFromRight {\n    from {\n      transform: translateX(300px);\n      opacity: 0;\n    }\n\n    to {\n      transform: translateX(0);\n      opacity: 1;\n    }\n  }\n}\n\n@media (max-width: 480px) {\n  .success-message {\n    font-size: 10px;\n    padding: 6px 10px;\n    gap: 4px;\n    top: 6px;\n    right: 6px;\n    max-width: 75vw;\n    flex-direction: column;\n    line-height: 1.2;\n  }\n\n  @keyframes slideInFromRight {\n    from {\n      transform: translateX(250px);\n      opacity: 0;\n    }\n\n    to {\n      transform: translateX(0);\n      opacity: 1;\n    }\n  }\n}\n\n@media (max-width: 360px) {\n  .success-message {\n    font-size: 9px;\n    padding: 5px 8px;\n    gap: 3px;\n    top: 5px;\n    right: 5px;\n    max-width: 70vw;\n    flex-direction: column;\n    line-height: 1.1;\n  }\n\n  @keyframes slideInFromRight {\n    from {\n      transform: translateX(200px);\n      opacity: 0;\n    }\n\n    to {\n      transform: translateX(0);\n      opacity: 1;\n    }\n  }\n}\n\n.success-message-dashboard {\n  position: fixed;\n  top: 20px;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 9999;\n  background-color: #4caf50;\n  color: white;\n  padding: 12px 24px;\n  border-radius: 8px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 14px;\n  font-weight: 500;\n  max-width: 90vw;\n  text-align: center;\n  animation: slideInFromTop 0.3s ease-out;\n}\n\n@keyframes slideInFromTop {\n  from {\n    transform: translateX(-50%) translateY(-100px);\n    opacity: 0;\n  }\n\n  to {\n    transform: translateX(-50%) translateY(0);\n    opacity: 1;\n  }\n}\n\n@media (max-width: 768px) {\n  .success-message-dashboard {\n    font-size: 12px;\n    padding: 10px 16px;\n    gap: 6px;\n    top: 10px;\n    max-width: 90vw;\n    border-radius: 6px;\n  }\n\n  .success-message-dashboard .close-icon {\n    font-size: 12px;\n    margin-left: 8px;\n  }\n}\n\n@media (max-width: 480px) {\n  .success-message-dashboard {\n    font-size: 11px;\n    padding: 8px 12px;\n    gap: 5px;\n    top: 8px;\n    max-width: 90vw;\n    flex-direction: row;\n    line-height: 1.3;\n    border-radius: 5px;\n  }\n\n  .success-message-dashboard .close-icon {\n    font-size: 11px;\n    margin-left: 6px;\n  }\n}\n\n/* @media (max-width: 360px) {\n  .success-message-dashboard {\n    font-size: 10px;\n    padding: 6px 10px;\n    gap: 4px;\n    top: 6px;\n    max-width: 75vw;\n    flex-direction: row;\n    line-height: 1.2;\n    border-radius: 4px;\n  }\n\n  .success-message-dashboard .close-icon {\n    font-size: 10px;\n    margin-left: 4px;\n  } \n}*/\n\n.spinner {\n  width: 40px;\n  height: 40px;\n  border: 4px solid var(--gray-200);\n  border-top: 4px solid var(--primary);\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n/* ==========================================================================\n   Hire Person Banner Styles\n   ========================================================================== */\n\n.hire-person-banner {\n  background: linear-gradient(135deg, #f0f7ff 0%, #e0effe 100%);\n  border: 1px solid rgba(59, 130, 246, 0.2);\n  border-radius: 12px;\n  padding: 12px 16px;\n  margin: 0;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  cursor: pointer;\n  box-shadow: 0 4px 15px rgba(59, 130, 246, 0.06);\n  transition: all 0.2s ease;\n  color: #1d4ed8;\n  width: fit-content;\n  gap: 16px;\n}\n\n.hire-person-banner:hover {\n  background: linear-gradient(135deg, #e0effe 0%, #dbeafe 100%);\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(59, 130, 246, 0.12);\n  border-color: rgba(59, 130, 246, 0.35);\n}\n\n.hire-person-content {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  text-align: left;\n}\n\n.hire-person-heading {\n  margin: 0;\n  font-size: 0.9rem;\n  font-weight: 700;\n  color: #1e3a8a;\n  line-height: 1.3;\n}\n\n.hire-person-subheading {\n  margin: 0;\n  font-size: 0.75rem;\n  color: #3b82f6;\n  font-weight: 500;\n  line-height: 1.4;\n}\n\n.hire-person-icon {\n  width: 32px;\n  height: 32px;\n  background: #ffffff;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.85rem;\n  color: #3b82f6;\n  box-shadow: 0 2px 6px rgba(59, 130, 246, 0.15);\n  transition: all 0.2s ease;\n  flex-shrink: 0;\n}\n\n.hire-person-banner:hover .hire-person-icon {\n  transform: translateX(4px);\n  background: #3b82f6;\n  color: #ffffff;\n  box-shadow: 0 4px 10px rgba(59, 130, 246, 0.3);\n}\n\n/* ==========================================================================\n   Hire Person Modal / Popup Styles\n   ========================================================================== */\n\n.modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(15, 23, 42, 0.55);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  backdrop-filter: blur(3px);\n  -webkit-backdrop-filter: blur(3px);\n  padding: 16px;\n}\n\n.modal-content {\n  background: #ffffff;\n  border-radius: 16px;\n  box-shadow:\n    0 4px 6px rgba(0, 0, 0, 0.05),\n    0 20px 50px rgba(0, 0, 0, 0.15);\n  width: 100%;\n  max-width: 460px;\n  max-height: 90vh;\n  overflow-y: auto;\n  animation: modalSlideIn 0.28s cubic-bezier(0.34, 1.3, 0.64, 1);\n}\n\n.hire-modal-content {\n  max-width: 460px;\n}\n\n/* --- Header --- */\n.modal-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 20px 24px 18px;\n  border-bottom: 1px solid #f1f5f9;\n}\n\n.modal-header h2 {\n  font-size: 1rem;\n  font-weight: 700;\n  color: #0f172a;\n  margin: 0;\n  letter-spacing: -0.01em;\n}\n\n.close-button {\n  width: 30px;\n  height: 30px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: none;\n  background: #f1f5f9;\n  color: #64748b;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 13px;\n  transition: background 0.18s, color 0.18s;\n  flex-shrink: 0;\n}\n\n.close-button:hover {\n  background: #e2e8f0;\n  color: #0f172a;\n}\n\n/* --- Body --- */\n.modal-body {\n  padding: 20px 24px;\n}\n\n.hire-modal-body {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  padding: 20px 24px;\n}\n\n/* --- Info Sections --- */\n.hire-info-section {\n  border-radius: 12px;\n  padding: 18px 20px;\n}\n\n/* Pricing section — soft amber tint */\n.hire-info-section:first-child {\n  background: #fffbeb;\n  border: 1px solid #fde68a;\n}\n\n/* Contact section — soft blue tint */\n.hire-info-section:last-child {\n  background: #f0f9ff;\n  border: 1px solid #bae6fd;\n}\n\n.hire-info-section h3 {\n  margin: 0 0 10px 0;\n  font-size: 0.8rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  display: flex;\n  align-items: center;\n  gap: 7px;\n}\n\n/* Heading color per section */\n.hire-info-section:first-child h3 {\n  color: #b45309;\n}\n\n.hire-info-section:last-child h3 {\n  color: #0369a1;\n}\n\n.hire-info-section p {\n  margin: 0 0 4px 0;\n  font-size: 0.875rem;\n  color: #475569;\n  line-height: 1.65;\n}\n\n.hire-info-section strong {\n  color: #0f172a;\n  font-weight: 650;\n}\n\n/* --- Contact Card --- */\n.contact-details-card {\n  margin-top: 14px;\n  background: #ffffff;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  padding: 8px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03);\n}\n\n.contact-link {\n  text-decoration: none;\n  display: block;\n  border-radius: 8px;\n  transition: all 0.2s ease;\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n}\n\n.contact-link:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);\n}\n\n.contact-link.call-link:hover {\n  background: #f0f9ff;\n  border-color: #bae6fd;\n}\n\n.contact-link.whatsapp-link:hover {\n  background: #f0fdf4;\n  border-color: #bbf7d0;\n}\n\n.contact-row {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  padding: 12px 16px;\n}\n\n.contact-icon-wrapper {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n  flex-shrink: 0;\n}\n\n.call-link .contact-icon-wrapper {\n  background: #e0f2fe;\n  color: #0284c7;\n}\n\n.call-link:hover .contact-icon-wrapper {\n  background: #0284c7;\n  color: #ffffff;\n}\n\n.whatsapp-link .contact-icon-wrapper {\n  background: #dcfce7;\n  color: #22c55e;\n}\n\n.whatsapp-link:hover .contact-icon-wrapper {\n  background: #22c55e;\n  color: #ffffff;\n}\n\n.contact-text-group {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  text-align: left;\n}\n\n.contact-label {\n  font-size: 0.72rem;\n  font-weight: 600;\n  color: #64748b;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.contact-number {\n  font-size: 0.95rem;\n  font-weight: 600;\n  color: #0f172a;\n}\n\n/* --- Footer --- */\n.modal-footer {\n  display: flex;\n  justify-content: flex-end;\n  padding: 14px 24px 20px;\n  border-top: 1px solid #f1f5f9;\n}\n\n.btn-secondary {\n  padding: 9px 24px;\n  background: #f1f5f9;\n  color: #475569;\n  border: none;\n  border-radius: 9px;\n  font-size: 0.875rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.18s, color 0.18s;\n}\n\n.btn-secondary:hover {\n  background: #e2e8f0;\n  color: #0f172a;\n}\n\n/* --- Animation --- */\n@keyframes modalSlideIn {\n  from {\n    opacity: 0;\n    transform: translateY(20px) scale(0.96);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n/* ==========================================================================\n   Responsive\n   ========================================================================== */\n\n@media (max-width: 768px) {\n  .hire-person-banner {\n    margin: 0;\n    padding: 6px 10px !important;\n    width: 100%;\n    box-sizing: border-box;\n    gap: 8px !important;\n    border-radius: 8px !important;\n  }\n\n  .hire-person-heading {\n    font-size: 0.75rem !important;\n    white-space: normal;\n    font-weight: 700 !important;\n  }\n\n  .hire-person-subheading {\n    font-size: 0.62rem !important;\n    white-space: normal;\n    font-weight: 500 !important;\n  }\n\n  .hire-person-icon {\n    width: 24px !important;\n    height: 24px !important;\n    font-size: 0.7rem !important;\n  }\n\n  .modal-content,\n  .hire-modal-content {\n    border-radius: 14px;\n    max-width: 90% !important;\n    max-height: 85vh !important;\n    display: flex !important;\n    flex-direction: column !important;\n    overflow: hidden !important;\n    margin: auto !important;\n  }\n\n  .modal-header {\n    padding: 12px 16px !important;\n  }\n\n  .modal-header h2 {\n    font-size: 0.92rem !important;\n  }\n\n  .close-button {\n    width: 28px !important;\n    height: 28px !important;\n    font-size: 11px !important;\n  }\n\n  .hire-modal-body {\n    padding: 12px 16px !important;\n    overflow-y: auto !important;\n    display: flex !important;\n    flex-direction: column !important;\n    gap: 12px !important;\n  }\n\n  .modal-footer {\n    padding-left: 16px;\n    padding-right: 16px;\n  }\n\n  .hire-info-section {\n    padding: 12px 14px !important;\n  }\n\n  .hire-info-section h3 {\n    font-size: 0.72rem !important;\n    margin-bottom: 6px !important;\n  }\n\n  .hire-info-section p {\n    font-size: 0.8rem !important;\n    line-height: 1.5 !important;\n  }\n\n  .contact-details-card {\n    margin-top: 8px !important;\n    gap: 6px !important;\n    padding: 6px !important;\n  }\n\n  .contact-row {\n    padding: 8px 12px !important;\n    gap: 10px !important;\n  }\n\n  .contact-icon-wrapper {\n    width: 30px !important;\n    height: 30px !important;\n  }\n\n  .contact-icon-wrapper svg {\n    width: 14px !important;\n    height: 14px !important;\n  }\n\n  .contact-number {\n    font-size: 13.5px !important;\n  }\n\n  .wallet-action-right {\n    align-items: stretch !important;\n    width: 100%;\n  }\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.dashboard-container {\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n  background: var(--gray-50);\n  margin: 0;\n  padding: 0;\n}\n\n/* Modern color scheme and variables */\n:root {\n  --primary: #3b82f6;\n  --primary-light: #93c5fd;\n  --primary-dark: #1e40af;\n  --secondary: #8b5cf6;\n  --accent: #ec4899;\n  --gray-50: #f9fafb;\n  --gray-100: #f3f4f6;\n  --gray-200: #e5e7eb;\n  --gray-300: #d1d5db;\n  --gray-700: #374151;\n  --gray-800: #1f2937;\n  --gray-900: #0f172a;\n  --success: #10b981;\n  --warning: #f59e0b;\n  --danger: #ef4444;\n}\n\n.dashboard-header {\n  background: linear-gradient(135deg, #0047AB 0%, #003680 100%) !important;\n}\n\n/* Minimal Dashboard Styles */\n.premium-dashboard-header {\n  background: white;\n  border-radius: 12px;\n  padding: 1.5rem;\n  margin-bottom: 1.5rem;\n  color: var(--gray-800);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n  border: 1px solid var(--gray-200);\n}\n\n.premium-stats-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n  flex-wrap: nowrap;\n  position: relative;\n  z-index: 1;\n}\n\n.premium-stat-card {\n  background: var(--gray-50);\n  border-radius: 8px;\n  padding: 0.75rem;\n  border: 1px solid var(--gray-200);\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  transition: all 0.2s ease;\n  flex: 1;\n  min-width: 200px;\n}\n\n.premium-stat-card:hover {\n  background: white;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n}\n\n.stat-icon-wrapper {\n  width: 32px;\n  height: 32px;\n  border-radius: 6px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.9rem;\n  flex-shrink: 0;\n  background: var(--gray-200);\n  color: var(--gray-600);\n}\n\n.stat-content {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.stat-content h4 {\n  font-size: 0.75rem;\n  font-weight: 500;\n  color: var(--gray-600);\n  margin: 0;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.stat-content p {\n  font-size: 1.2rem;\n  font-weight: 600;\n  margin: 0;\n  color: var(--gray-900);\n  white-space: nowrap;\n}\n\n.wallet-amount {\n  color: var(--primary);\n}\n\n.premium-add-money-btn {\n  background: var(--primary);\n  color: white;\n  border: none;\n  padding: 0.25rem 0.5rem;\n  border-radius: 4px;\n  font-size: 0.7rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.3rem;\n  margin-top: 0.5rem;\n}\n\n.premium-add-money-btn:hover {\n  background: var(--primary-dark);\n}\n\n/* Premium Rate Management */\n.premium-rate-management {\n  margin-bottom: 2.5rem;\n}\n\n.rate-management-header {\n  margin-bottom: 1.5rem;\n  display: flex;\n  justify-content: start;\n  gap: 10px;\n}\n\n.rate-management-header h3 {\n  font-size: 2.5rem;\n  font-weight: 700;\n  color: var(--gray-800);\n  margin: 0 0 0.5rem 0;\n}\n\n.rate-management-header p {\n  color: var(--gray-600);\n  font-size: 1.2rem;\n  margin-top: 10px;\n\n  text-align: center;\n}\n\n.premium-rate-cards {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 0.75rem;\n}\n\n.premium-rate-card {\n  background: white;\n  border-radius: 10px;\n  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.05);\n  border: 1px solid var(--gray-200);\n  overflow: hidden;\n  transition: all 0.3s ease;\n  min-height: auto;\n}\n\n.premium-rate-card:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.06);\n}\n\n.rate-card-header {\n  padding: 0.4rem 0.5rem;\n  background: var(--gray-50);\n  border-bottom: 1px solid var(--gray-200);\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n  width: 100%;\n}\n\n.rate-card-icon {\n  width: 20px;\n  height: 20px;\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.6rem;\n  color: white;\n  flex-shrink: 0;\n  background: var(--primary);\n}\n\n.bulk-icon {\n  background: #10b981;\n}\n\n.type-icon {\n  background: var(--gray-600);\n}\n\n\n.rate-card-title {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex: 1;\n  width: 100%;\n}\n\n.heading-card-dashboard {\n  flex: 1;\n  font-size: 2rem;\n  font-weight: 600;\n  color: var(--gray-800);\n  margin: 0;\n}\n\n.rate-card-title button {\n  flex-shrink: 0;\n  margin-left: auto;\n}\n\n.rate-card-title p {\n  font-size: 0.8rem;\n  color: var(--gray-600);\n  margin: 0;\n}\n\n.rate-card-content {\n  padding: 0.5rem;\n  display: flex;\n  flex-direction: column;\n  /* Changed to column */\n  gap: 0.5rem;\n  flex-grow: 1;\n  /* Allow content to grow */\n}\n\n.rate-loading {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  color: var(--gray-600);\n  font-size: 0.9rem;\n  padding: 1rem;\n}\n\n.rate-edit-form {\n  display: flex;\n  flex-direction: row;\n  gap: 5px;\n  width: 100%;\n  height: 100%;\n  /* border: solid 2px green; */\n  align-items: center;\n}\n\n.rate-input-group {\n  display: flex;\n  align-items: center;\n  flex-direction: row;\n  gap: 0.5rem;\n  flex-wrap: nowrap;\n}\n\n.rate-input-group label {\n  font-weight: 600;\n  color: black;\n  font-size: 0.9rem;\n  min-width: 30px;\n  white-space: nowrap;\n}\n\n.premium-rate-input {\n  /* flex: 1; */\n  padding: 0.6rem 1rem;\n  border: 2px solid var(--gray-300);\n  border-radius: 8px;\n  font-size: 1rem;\n  transition: all 0.3s ease;\n  min-width: 0;\n  /* height: 50px; */\n  /* border: solid 2px red; */\n}\n\n.premium-rate-input:focus {\n  outline: none;\n  border-color: var(--primary);\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n.rate-edit-actions {\n  display: flex;\n  gap: 0.5rem;\n  justify-content: center;\n  /* align-items: center; */\n  /* border: solid 2px green; */\n  height: 40px;\n  width: 40%;\n  /* margin-top: 1.5rem; */\n}\n\n.premium-btn {\n  padding: 0.3rem 0.6rem;\n  border-radius: 4px;\n  font-weight: 500;\n  font-size: 0.75rem;\n  border: none;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.2rem;\n  text-decoration: none;\n  min-width: auto;\n  width: auto;\n}\n\n.premium-btn-primary {\n  background: var(--primary);\n  color: white;\n}\n\n.premium-btn-primary:hover {\n  background: var(--primary-dark);\n}\n\n.premium-btn-success {\n  background: var(--success);\n  color: white;\n}\n\n.premium-btn-success:hover {\n  background: #059669;\n}\n\n.premium-btn-secondary {\n  background: #2563eb;\n  color: white;\n}\n\n.premium-btn-secondary:hover {\n  background: #1d4ed8;\n}\n\n.premium-btn-accent {\n  background: var(--secondary);\n  color: white;\n}\n\n.premium-btn-accent:hover {\n  background: #7c3aed;\n}\n\n.premium-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: none;\n}\n\n.rate-display-form {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 1rem;\n  width: 100%;\n  height: 100%;\n  /* border: solid 2px red; */\n}\n\n.rate-display-form-dashboard {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  /* font-size: 50px; */\n  gap: 1rem;\n  width: 100%;\n  height: 100%;\n  padding: 0.75rem;\n  background: linear-gradient(135deg, #f8f9ff 0%, #ffffff 100%);\n  border-radius: 8px;\n  border: 1px solid var(--gray-200);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n  transition: all 0.3s ease;\n}\n\n.rate-display-form-dashboard:hover {\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\n  transform: translateY(-1px);\n}\n\n.current-milk-rate-display-dashboard {\n  text-align: center;\n  padding: 0.75rem 1rem;\n  background: var(--gray-50);\n  border-radius: 6px;\n  border: 1px solid var(--gray-200);\n  flex: 1;\n  min-width: 120px;\n  height: 50px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  transition: all 0.3s ease;\n}\n\n.rate-value {\n  display: block;\n  font-size: 1.2rem;\n  font-weight: 600;\n  color: var(--primary);\n  margin-bottom: 0.1rem;\n}\n\n.rate-label {\n  font-size: 0.8rem;\n  color: var(--gray-600);\n  font-weight: 500;\n}\n\n.bulk-rate-features,\n.rate-settings-features {\n  margin-bottom: 0.75rem;\n  flex-grow: 1;\n  /* Allow features to take up space */\n}\n\n.feature-item {\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n  margin-bottom: 0.3rem;\n  font-size: 0.8rem;\n  color: var(--gray-700);\n}\n\n/* New user highlight styles */\n.new-user-highlight {\n  color: #dc3545 !important;\n  font-weight: 600 !important;\n}\n\n.new-user-message {\n  color: #dc3545 !important;\n  font-weight: 600 !important;\n  font-style: italic;\n  animation: pulse 2s infinite;\n}\n\n@keyframes pulse {\n  0% {\n    opacity: 1;\n  }\n\n  50% {\n    opacity: 0.7;\n  }\n\n  100% {\n    opacity: 1;\n  }\n}\n\n.feature-check {\n  color: var(--success);\n  font-size: 0.5rem;\n  flex-shrink: 0;\n}\n\n.feature-warning {\n  color: #dc3545 !important;\n  font-size: 0.5rem;\n  flex-shrink: 0;\n  animation: pulse 2s infinite;\n}\n\n.bulk-action-btn-rate,\n.bulk-action-btn-milk-rate {\n  width: auto;\n  /* max-width: 150px; */\n  justify-content: center;\n  padding: 0.4rem 0.7rem;\n  /* background-color: #047857; */\n  font-size: 1rem;\n  font-weight: 500;\n  margin: 10px auto;\n  display: flex;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  align-items: center;\n  gap: 0.3rem;\n  height: fit-content;\n}\n\n.bulk-action-btn-rate {\n  background-color: #0056b3;\n}\n\n.bulk-action-btn-milk-rate {\n  background-color: #28a745;\n}\n\n/* Base styles for content buttons - 70% width and centered */\n.rate-card-content .bulk-action-btn-rate,\n.rate-card-content .bulk-action-btn-milk-rate {\n  width: 70%;\n  margin: 0 auto;\n  justify-content: center;\n  display: flex;\n}\n\n/* Hide content buttons on screens above 768px */\n@media (min-width: 769px) {\n\n  .rate-card-content .bulk-action-btn-rate,\n  .rate-card-content .bulk-action-btn-milk-rate {\n    display: none;\n  }\n}\n\n/* Header button styling */\n.rate-card-title .bulk-action-btn-rate,\n.rate-card-title .bulk-action-btn-milk-rate {\n  padding: 0.3rem 0.6rem;\n  font-size: 0.7rem;\n  border-radius: 4px;\n  border: none;\n  color: white;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  gap: 0.2rem;\n  white-space: nowrap;\n}\n\n.rate-card-title .bulk-action-btn-rate:hover,\n.rate-card-title .bulk-action-btn-milk-rate:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);\n}\n\n.bulk-action-btn-rate svg {\n  font-size: 0.9em;\n  margin-right: 0.2rem;\n}\n\n.bulk-action-btn-rate:hover {\n  background: #059669;\n  transform: translateY(-1px);\n}\n\n/* Rate Content Wrapper - 50-50 Layout */\n.rate-content-wrapper {\n  display: flex;\n  gap: 1rem;\n  align-items: stretch;\n}\n\n.rate-display-section {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n}\n\n.rate-type-section {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n}\n\n.current-balance-section {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.75rem;\n  flex-wrap: wrap;\n  padding: 0.75rem 1rem;\n  background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%);\n  border-radius: 10px;\n  border: 1px solid #bae6fd;\n}\n\n.wallet-balance-display {\n  padding: 1rem 1.5rem;\n  background: #ffffff;\n}\n\n.balance-label-payment {\n  font-size: 15px;\n  font-weight: 600;\n  color: #0369a1;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.balance-amount {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: #0284c7;\n  min-width: 100px;\n  text-align: center;\n}\n\n.refresh-balance-btn-payment {\n  background: linear-gradient(135deg, #0284c7 0%, #0369a1 100%);\n  border: none;\n  border-radius: 8px;\n  padding: 0.6rem;\n  color: white;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n  box-shadow: 0 2px 8px rgba(2, 132, 199, 0.25);\n}\n\n.refresh-balance-btn-payment:hover:not(:disabled) {\n  background: linear-gradient(135deg, #0369a1 0%, #075985 100%);\n  transform: scale(1.05);\n  box-shadow: 0 4px 12px rgba(2, 132, 199, 0.35);\n}\n\n.refresh-balance-btn-payment:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.new-balance-section {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.75rem;\n  margin-top: 0.75rem;\n  padding-top: 0.75rem;\n  border-top: 2px dashed #86efac;\n  animation: slideDown 0.3s ease-out;\n}\n\n.new-balance-label-payment {\n  font-size: 15px;\n  font-weight: 600;\n  color: #15803d;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.new-balance-amount {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: #16a34a;\n  min-width: 100px;\n  text-align: center;\n}\n\n/* Mobile responsive for wallet balance display */\n@media (max-width: 768px) {\n  .wallet-balance-display {\n    padding: 0.875rem 1rem;\n  }\n\n  .current-balance-section {\n    padding: 0.6rem 0.8rem;\n    gap: 0.5rem;\n    flex-wrap: nowrap;\n  }\n\n  .balance-amount,\n  .new-balance-amount {\n    font-size: 1.1rem;\n    min-width: auto;\n  }\n\n  .balance-label-payment,\n  .new-balance-label-payment {\n    font-size: 12px !important;\n  }\n\n  .refresh-balance-btn-payment {\n    padding: 0.4rem;\n    font-size: 0.8rem;\n  }\n\n  .new-balance-section {\n    margin-top: 0.5rem;\n    padding-top: 0.5rem;\n    flex-wrap: nowrap;\n  }\n}\n\n/* rate settings modal - exact match to image */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.6);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1001;\n  padding: 16px;\n}\n\n.modal-container {\n  background: white;\n  width: 100%;\n  max-width: 350px;\n  border-radius: 16px;\n  overflow: hidden;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);\n}\n\n/* Increase modal width on desktop screens */\n@media (min-width: 769px) {\n  .modal-container {\n    max-width: 500px;\n  }\n}\n\n/* Header */\n.rate-settings-modal-header {\n  padding: 16px 20px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 1px solid #f0f0f0;\n}\n\n.rate-settings-modal-header h2 {\n  font-size: 18px;\n  font-weight: 600;\n  color: #1a1a1a;\n  margin: 0;\n}\n\n.rate-settings-modal-close-btn {\n  background: none;\n  border: none;\n  font-size: 20px;\n  color: #666;\n  cursor: pointer;\n  padding: 4px;\n  border-radius: 4px;\n}\n\n.rate-settings-modal-close-btn:hover {\n  background: #f5f5f5;\n}\n\n/* Body */\n.rate-settings-modal-body {\n  padding: 16px 20px;\n}\n\n.rate-settings-modal-section {\n  margin-bottom: 16px;\n}\n\n.rate-settings-modal-section:last-child {\n  margin-bottom: 0;\n}\n\n.rate-settings-modal-heading {\n  font-size: 16px;\n  font-weight: 600;\n  color: #333;\n  margin-bottom: 8px;\n}\n\n/* Milk Rate Card - Blue container */\n.rate-settings-modal-input-group-dashboard {\n  background: #f8f9fa;\n  border: none;\n  border-radius: 12px;\n  padding: 16px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.rate-settings-modal-label {\n  font-size: 14px;\n  color: #666;\n  font-weight: 500;\n}\n\n.rate-settings-modal-input {\n  border: solid 1px #003680;\n  border-radius: 5px;\n  background: transparent;\n  font-size: 23px;\n  font-weight: 700;\n  color: #0047AB;\n  width: 90px;\n  text-align: center;\n\n  /* outline: none; */\n}\n\n.rate-settings-modal-input:disabled {\n  color: #0047AB;\n  opacity: 1;\n}\n\n/* Dropdown */\n.rate-settings-modal-dropdown {\n  width: 100%;\n  padding: 14px 16px;\n  border: 1px solid #e0e0e0;\n  border-radius: 12px;\n  font-size: 16px;\n  appearance: none;\n  background-color: white;\n  color: #333;\n  font-weight: 500;\n  background-image: url(\"data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23333' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6,9 12,15 18,9'%3e%3c/polyline%3e%3c/svg%3e\");\n  background-repeat: no-repeat;\n  background-position: right 12px center;\n  background-size: 16px;\n  padding-right: 40px;\n}\n\n/* Option Buttons - Grid layout */\n.rate-settings-modal-row {\n  display: flex;\n  gap: 16px;\n  margin-bottom: 16px;\n}\n\n.rate-settings-modal-col {\n  flex: 1;\n}\n\n.rate-settings-modal-options {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n}\n\n.rate-settings-modal-option-btn {\n  padding: 12px 16px;\n  border: 1px solid #e0e0e0;\n  background: white;\n  border-radius: 8px;\n  font-weight: 600;\n  color: #666;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  font-size: 14px;\n}\n\n.rate-settings-modal-option-btn.active {\n  background-color: #0047AB;\n  border-color: #0047AB;\n  color: white;\n}\n\n.rate-settings-modal-option-btn:hover:not(.active) {\n  background: #f8f9fa;\n  border-color: #adb5bd;\n}\n\n/* Footer Buttons */\n.rate-settings-modal-footer {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px;\n  padding: 16px 20px;\n  border-top: 1px solid #f0f0f0;\n}\n\n.rate-settings-modal-cancel-btn {\n  padding: 14px 20px;\n  background: white;\n  border: 1px solid #0047AB;\n  border-radius: 12px;\n  font-weight: 600;\n  color: #0047AB;\n  font-size: 16px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.rate-settings-modal-cancel-btn:hover {\n  background: #f8f9fa;\n}\n\n.rate-settings-modal-save-btn {\n  padding: 14px 20px;\n  background-color: #0047AB;\n  border: none;\n  border-radius: 12px;\n  color: white;\n  font-weight: 600;\n  font-size: 16px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.rate-settings-modal-save-btn:hover:not(:disabled) {\n  background: #003680;\n}\n\n.rate-settings-modal-save-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* Edit/Save buttons for milk rate */\n.balance-label-payment {\n  font-size: 15px;\n  font-weight: 500;\n  color: #0c4a6e;\n}\n\n.balance-amount {\n  font-size: 1.25rem;\n  font-weight: 700;\n  color: #0284c7;\n}\n\n.refresh-balance-btn-payment {\n  background: #0284c7;\n  border: none;\n  border-radius: 6px;\n  padding: 0.5rem;\n  color: white;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n  margin-left: 0.5rem;\n}\n\n.refresh-balance-btn-payment:hover:not(:disabled) {\n  background: #0369a1;\n  transform: scale(1.05);\n}\n\n.refresh-balance-btn-payment:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.new-balance-label-payment {\n  font-size: 15px;\n  font-weight: 500;\n  color: #15803d;\n}\n\n.rate-settings-modal-btn {\n  background-color: #0047AB;\n  color: white;\n  border: none;\n  border-radius: 8px;\n  padding: 10px 16px;\n  font-size: 12px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.rate-settings-modal-btn:hover:not(:disabled) {\n  background-color: #003680;\n}\n\n.rate-settings-modal-btn-secondary {\n  background-color: #6c757d;\n  color: white;\n  border: none;\n  border-radius: 8px;\n  padding: 8px 10px;\n  font-size: 12px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.rate-settings-modal-btn-secondary:hover {\n  background-color: #5a6268;\n}\n\n.rate-settings-modal-flex-gap {\n  display: flex;\n  gap: 8px;\n}\n\n.rate-settings-modal-icon-margin {\n  margin-right: 2px;\n}\n\n.edit-field {\n  /* border: solid 2px red; */\n  margin-bottom: 10px;\n}\n\n/* Confirmation Modal Styles */\n.confirmation-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.6);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 9999;\n  padding: 16px;\n}\n\n.confirmation-modal-container {\n  background: white;\n  width: 100%;\n  max-width: 350px;\n  border-radius: 16px;\n  overflow: hidden;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);\n}\n\n.confirmation-modal-header {\n  padding: 16px 20px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 1px solid #f0f0f0;\n}\n\n.confirmation-modal-header h3 {\n  font-size: 16px;\n  font-weight: 600;\n  color: #1a1a1a;\n  margin: 0;\n}\n\n.confirmation-modal-close-btn {\n  background: none;\n  border: none;\n  font-size: 18px;\n  color: #666;\n  cursor: pointer;\n  padding: 4px;\n  border-radius: 4px;\n}\n\n.confirmation-modal-close-btn:hover {\n  background: #f5f5f5;\n}\n\n.confirmation-modal-body {\n  padding: 16px 20px;\n  text-align: center;\n}\n\n.confirmation-modal-message {\n  font-size: 14px;\n  color: #333;\n  margin-bottom: 12px;\n  font-weight: 500;\n}\n\n.confirmation-modal-value-display {\n  background: #0047AB;\n  color: white;\n  padding: 8px 16px;\n  border-radius: 20px;\n  font-size: 14px;\n  font-weight: 600;\n  display: inline-block;\n  margin-bottom: 12px;\n}\n\n.confirmation-modal-description {\n  font-size: 12px;\n  color: #666;\n  margin: 0;\n}\n\n.confirmation-modal-footer {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n  padding: 16px 20px;\n  border-top: 1px solid #f0f0f0;\n}\n\n.confirmation-modal-cancel-btn {\n  padding: 10px 16px;\n  background: white;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  font-weight: 500;\n  color: #666;\n  font-size: 14px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.confirmation-modal-cancel-btn:hover {\n  background: #f8f9fa;\n}\n\n.confirmation-modal-confirm-btn {\n  padding: 10px 16px;\n  background-color: #0047AB;\n  border: none;\n  border-radius: 8px;\n  color: white;\n  font-weight: 500;\n  font-size: 14px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.confirmation-modal-confirm-btn:hover {\n  background-color: #003680;\n}\n\n\n/* Mobile Responsive Styles for Rate Content */\n@media (max-width: 768px) {\n  .rate-content-wrapper {\n    flex-direction: column;\n    gap: 1rem;\n  }\n\n  .rate-display-section,\n  .rate-type-section {\n    flex: none;\n    width: 100%;\n  }\n\n  .modal-container {\n    width: 95%;\n    max-width: 320px;\n    border-radius: 12px;\n  }\n\n  .rate-settings-modal-header {\n    padding: 16px 20px;\n  }\n\n  .rate-settings-modal-header h2 {\n    font-size: 16px;\n  }\n\n  .rate-settings-modal-close-btn {\n    font-size: 18px;\n  }\n\n  .rate-settings-modal-body {\n    padding: 16px 20px;\n  }\n\n  .rate-settings-modal-section {\n    margin-bottom: 20px;\n  }\n\n  .rate-settings-modal-heading {\n    font-size: 14px;\n    margin-bottom: 10px;\n  }\n\n  .rate-settings-modal-input-group {\n    padding: 12px;\n  }\n\n  .rate-settings-modal-label {\n    font-size: 12px;\n  }\n\n  .rate-settings-modal-input {\n    font-size: 20px;\n    width: 70px;\n  }\n\n  .rate-settings-modal-dropdown {\n    padding: 10px 12px;\n    font-size: 14px;\n    padding-right: 35px;\n  }\n\n  .rate-settings-modal-row {\n    gap: 12px;\n    margin-bottom: 20px;\n  }\n\n  .rate-settings-modal-options {\n    gap: 8px;\n  }\n\n  .rate-settings-modal-option-btn {\n    padding: 10px 12px;\n    font-size: 12px;\n  }\n\n  .rate-settings-modal-footer {\n    padding: 16px 20px;\n    gap: 12px;\n  }\n\n  .rate-settings-modal-cancel-btn,\n  .rate-settings-modal-save-btn {\n    padding: 12px 16px;\n    font-size: 14px;\n  }\n\n  .rate-settings-modal-btn,\n  .rate-settings-modal-btn-secondary {\n    padding: 6px 10px;\n    font-size: 12px;\n  }\n\n  .rate-settings-modal-flex-gap {\n    gap: 6px;\n  }\n\n  .rate-settings-modal-icon-margin {\n    margin-right: 2px;\n  }\n\n  /* Mobile styles for rate display form dashboard */\n  .rate-display-form-dashboard {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 0.5rem;\n    padding: 0.5rem;\n    height: auto;\n    min-height: auto;\n  }\n\n  .current-milk-rate-display-dashboard {\n    width: 100%;\n    height: 45px;\n    min-width: auto;\n    padding: 0.5rem;\n  }\n\n  .rate-value {\n    font-size: 1rem;\n    font-weight: 600;\n  }\n\n  .edit-rate-button-dashboard {\n    width: auto;\n    max-width: 250px;\n    justify-content: center;\n    padding: 0.5rem 0.75rem;\n    font-size: 0.75rem;\n    height: auto;\n    min-height: 40px;\n    white-space: nowrap;\n    margin: auto;\n  }\n}\n\n/* Rate Type Control - Updated for 50-50 layout */\n.preview-table-bulk {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 13px;\n  border: 1px solid #e0e0e0;\n}\n\n.preview-table-bulk th,\n.preview-table-bulk td {\n  border: 1px solid #e0e0e0;\n  padding: 8px 12px;\n  text-align: center;\n}\n\n.preview-table-bulk th {\n  background-color: #f5f5f5;\n  font-weight: 600;\n}\n\n.rate-type-control-compact {\n  display: flex;\n  flex-direction: column;\n  gap: 0rem;\n  /* padding: 1revm; */\n  /* background: linear-gradient(135deg, #f8f9ff 0%, #ffffff 100%); */\n  border-radius: 8px;\n  /* box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05); */\n  border: none;\n  height: 100%;\n}\n\n.rate-type-row {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n}\n\n.rate-type-label {\n  font-size: 1.2rem;\n  font-weight: 600;\n  color: var(--gray-700);\n  margin: auto;\n  white-space: nowrap;\n  background: linear-gradient(135deg, var(--primary-light) 0%, var(--primary) 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.premium-select-rate-type {\n  border: 1px solid var(--gray-300);\n  padding: 0.5rem 0.75rem;\n  border-radius: 6px;\n  font-size: 0.7rem;\n  background: white;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  outline: none;\n  min-width: 120px;\n  width: 50%;\n  height: auto;\n  appearance: none;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'%3E%3Cpath fill='%23374151' d='M0 2l4 4 4-4z'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: right 0.5rem center;\n  padding-right: 2rem;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.premium-select-rate-type:hover {\n  border-color: var(--primary);\n  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.1);\n  transform: translateY(-1px);\n}\n\n.premium-select-rate-type:focus {\n  border-color: var(--primary);\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.15);\n}\n\n.premium-select-rate-type:disabled {\n  background-color: var(--gray-100);\n  color: var(--gray-500);\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n/* Mobile responsive styling for rate type dropdown */\n@media (max-width: 768px) {\n  .premium-select-rate-type {\n    padding: 0.4rem 0.6rem;\n    font-size: 12px;\n    min-width: 100px;\n    width: 60%;\n    border-radius: 4px;\n    background-position: right 0.4rem center;\n    padding-right: 1.5rem;\n  }\n\n  .premium-select-rate-type:hover {\n    box-shadow: 0 0 0 1px rgba(59, 130, 246, 0.1);\n    transform: translateY(-0.5px);\n  }\n\n  .premium-select-rate-type:focus {\n    box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.15);\n  }\n\n  .premium-select-rate-type option {\n    font-size: 0.6rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .premium-select-rate-type {\n    padding: 0.3rem 0.5rem;\n    font-size: 12px;\n    min-width: 80px;\n    margin: auto;\n    width: 70%;\n    border-radius: 3px;\n    background-position: right 0.3rem center;\n    padding-right: 1.2rem;\n  }\n\n  .premium-select-rate-type:hover {\n    transform: none;\n  }\n\n  .premium-select-rate-type:focus {\n    box-shadow: 0 0 0 1px rgba(59, 130, 246, 0.15);\n  }\n\n  .premium-select-rate-type option {\n    font-size: 1rem;\n  }\n\n  /* Mobile styling for Current Milk Rate card */\n  .premium-rate-card {\n    padding: 0.5rem;\n  }\n\n  .rate-card-header {\n    flex-direction: row;\n    padding: 0.4rem;\n    gap: 0.4rem;\n  }\n\n  .rate-card-icon {\n    width: 20px;\n    height: 20px;\n    font-size: 0.6rem;\n  }\n\n  .heading-card-dashboard {\n    font-size: 2rem;\n    margin-bottom: 0.05rem;\n    font-weight: 600;\n    text-align: left;\n  }\n\n  .rate-card-title p {\n    font-size: 0.5rem;\n  }\n\n  .rate-card-content {\n    padding: 0.5rem;\n    gap: 0rem;\n  }\n\n  .current-rate-display {\n    padding: 0.4rem;\n    min-width: 70px;\n  }\n\n  .rate-value {\n    font-size: 0.9rem;\n    font-weight: 600;\n  }\n\n  .rate-label {\n    font-size: 0.6rem;\n  }\n\n  .edit-rate-button {\n    padding: 0.2rem 0.4rem;\n    font-size: 0.55rem;\n    gap: 0.15rem;\n  }\n\n\n  .rate-type-row {\n    gap: 0.4rem;\n  }\n\n  .rate-type-label {\n    font-size: 1rem;\n  }\n\n  .save-rate-button {\n    padding: 0.2rem 0.4rem;\n    font-size: 0.55rem;\n    max-width: 60px;\n    border-radius: 3px;\n  }\n}\n\n.premium-select-rate-type option {\n  padding: 0.25rem 0.5rem;\n  font-size: 0.65rem;\n  background: white;\n  color: var(--gray-700);\n}\n\n.premium-select-rate-type.compact {\n  padding: 0.2rem 0.4rem;\n  font-size: 0.6rem;\n  min-width: 80px;\n  height: 24px;\n  background-position: right 0.2rem center;\n  padding-right: 1rem;\n}\n\n.premium-select-rate-type.compact:hover {\n  box-shadow: 0 0 0 1px rgba(59, 130, 246, 0.1);\n}\n\n.premium-select-rate-type.compact:focus {\n  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.15);\n}\n\n.premium-select-rate-type.compact option {\n  font-size: 0.6rem;\n}\n\n.premium-select.compact {\n  padding: 0.4rem 0.6rem;\n  font-size: 0.875rem;\n  border-radius: 4px;\n  flex: 1;\n  min-width: 120px;\n}\n\n.rate-type-saving-indicator {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  color: #10b981;\n  font-size: 0.75rem;\n  margin-left: 8px;\n  padding: 3px 6px;\n  background-color: rgba(16, 185, 129, 0.1);\n  border-radius: 4px;\n  animation: pulse 1.5s ease-in-out infinite;\n}\n\n@keyframes pulse {\n\n  0%,\n  100% {\n    opacity: 1;\n  }\n\n  50% {\n    opacity: 0.6;\n  }\n}\n\n.save-rate-button {\n  background: linear-gradient(135deg, #10b981 0%, #059669 100%);\n  border: none;\n  color: white;\n  padding: 0.35rem 0.75rem;\n  border-radius: 6px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.3rem;\n  white-space: nowrap;\n  min-width: auto;\n  width: auto;\n  max-width: 120px;\n  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.25);\n}\n\n.save-rate-button:hover:not(:disabled) {\n  background: linear-gradient(135deg, #059669 0%, #047857 100%);\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(16, 185, 129, 0.35);\n}\n\n.save-rate-button:disabled {\n  background: linear-gradient(135deg, #e5e7eb 0%, #d1d5db 100%);\n  color: #9ca3af;\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.premium-select.compact {\n  padding: 0.25rem 0.5rem;\n  font-size: 0.65rem;\n  min-width: 90px;\n  border-radius: 4px;\n  border: 1px solid var(--gray-300);\n  background: white;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  outline: none;\n  height: 28px;\n  appearance: none;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'%3E%3Cpath fill='%23374151' d='M0 2l4 4 4-4z'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: right 0.4rem center;\n  padding-right: 1.2rem;\n}\n\n.premium-select.compact:hover {\n  border-color: var(--primary);\n  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.1);\n}\n\n.premium-select.compact:focus {\n  border-color: var(--primary);\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.15);\n}\n\n.premium-select.compact option {\n  padding: 0.25rem 0.5rem;\n  font-size: 0.65rem;\n  background: white;\n  color: var(--gray-700);\n}\n\n/* Mobile responsive dropdown */\n@media (max-width: 768px) {\n  .premium-select.compact {\n    padding: 0.15rem 0.3rem;\n    font-size: 0.55rem;\n    min-width: 70px;\n    height: 24px;\n    background-position: right 0.2rem center;\n    padding-right: 1rem;\n  }\n\n  .premium-select.compact:hover {\n    box-shadow: 0 0 0 1px rgba(59, 130, 246, 0.1);\n  }\n\n  .premium-select.compact:focus {\n    box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.15);\n  }\n\n  .premium-select.compact option {\n    font-size: 0.55rem;\n  }\n\n  /* Mobile styling for Bulk Rate Update card */\n  .premium-rate-card {\n    padding: 0.5rem;\n  }\n\n  .rate-card-header {\n    padding: 0.4rem;\n    gap: 0.4rem;\n    flex-direction: row;\n  }\n\n  .rate-card-icon {\n    width: 20px;\n    height: 20px;\n    font-size: 0.6rem;\n  }\n\n  .heading-card-dashboard {\n    font-size: 1rem;\n    margin-bottom: 0.05rem;\n  }\n\n  .rate-card-title p {\n    font-size: 0.5rem;\n  }\n\n  .rate-card-content {\n    padding: 0.5rem;\n    gap: 0rem;\n    /* border: solid 2px red; */\n  }\n\n  .bulk-rate-features {\n    margin-bottom: 0.5rem;\n  }\n\n  .feature-item {\n    font-size: 0.6rem;\n    margin-bottom: 0.3rem;\n    gap: 0.3rem;\n  }\n\n  .feature-check {\n    font-size: 0.5rem;\n  }\n\n  .bulk-action-btn-rate {\n    /* padding: 0.3rem 0.6rem; */\n    font-size: 0.6rem;\n    min-height: 28px;\n    border-radius: 3px;\n    width: 90%;\n    /* border: solid 2px red; */\n  }\n\n  .bulk-action-btn-rate svg {\n    font-size: 0.8em;\n  }\n}\n\n.premium-btn.compact {\n  padding: 0.4rem 0.8rem;\n  font-size: 0.75rem;\n  min-height: auto;\n  height: auto;\n}\n\n.premium-select {\n  padding: 0.6rem 1rem;\n  border: 2px solid var(--gray-300);\n  border-radius: 8px;\n  font-size: 0.9rem;\n  background: white;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.premium-select:focus {\n  outline: none;\n  border-color: var(--primary);\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n/* Premium Action Sections */\n.premium-action-sections {\n  margin-bottom: 2rem;\n}\n\n.premium-action-sections .section-header {\n  margin-bottom: 1.5rem;\n}\n\n.premium-action-sections .section-header h3 {\n  font-size: 2.5rem;\n  font-weight: 700;\n  color: var(--gray-800);\n  margin: 0 0 0.5rem 0;\n}\n\n.premium-action-sections .section-header p {\n  color: var(--gray-600);\n  font-size: 1.2rem;\n  margin: 0;\n}\n\n.premium-action-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 1rem;\n}\n\n.premium-action-card {\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.06);\n  border: 1px solid var(--gray-200);\n  overflow: hidden;\n  transition: all 0.3s ease;\n}\n\n.premium-action-card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.08);\n}\n\n.premium-action-card.disabled-card {\n  opacity: 0.6;\n  pointer-events: none;\n}\n\n.action-card-header {\n  padding: 1rem;\n  background: var(--gray-50);\n  border-bottom: 1px solid var(--gray-200);\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.action-card-icon {\n  width: 36px;\n  height: 36px;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1rem;\n  color: white;\n  flex-shrink: 0;\n}\n\n.standard-icon {\n  background: var(--primary);\n}\n\n.prorata-icon {\n  background: var(--primary);\n}\n\n.reports-icon {\n  background: red;\n}\n\n.action-card-title h4 {\n  font-size: 1.2rem;\n  font-weight: 600;\n  color: var(--gray-800);\n  margin: 0 0 0.2rem 0;\n}\n\n.action-card-title p {\n  font-size: 0.9rem;\n  color: var(--gray-600);\n  margin: 0;\n}\n\n.action-card-content {\n  padding: 1rem;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  /* border: solid 2px red; */\n  gap: 0.75rem;\n}\n\n.premium-action-btn {\n  padding: 1rem 0.8rem;\n  border-radius: 8px;\n  font-weight: 500;\n  font-size: 0.9rem;\n  border: none;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n  text-decoration: none;\n  justify-content: center;\n  /* border: solid 2px green; */\n}\n\n.premi.bulk-action-btn {\n  padding: 0.6rem 1rem;\n  border-radius: 8px;\n  font-weight: 500;\n  font-size: 0.85rem;\n  border: none;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n  text-decoration: none;\n  justify-content: center;\n}\n\n.primary-btn {\n  background: #28a745;\n  color: white;\n}\n\n.primary-btn:hover {\n  background: #218838;\n}\n\n.secondary-btn {\n  background: linear-gradient(135deg, #0047AB 0%, #003680 100%);\n  color: white;\n  border: 1px solid #003680;\n}\n\n.secondary-btn:hover {\n  background: linear-gradient(135deg, #003680 0%, #002850 100%);\n}\n\n.premium-action-btn.disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: none;\n}\n\n.disabled-badge {\n  font-size: 0.75rem;\n  color: var(--warning);\n  font-weight: 600;\n  background-color: rgba(245, 158, 11, 0.1);\n  padding: 0.25rem 0.5rem;\n  border-radius: 4px;\n  border: 1px solid rgba(245, 158, 11, 0.3);\n  display: inline-block;\n  margin-top: 0.5rem;\n}\n\n/* Responsive Design for Premium Dashboard */\n@media (max-width: 1024px) {\n  .premium-dashboard-header {\n    padding: 2rem;\n  }\n\n  .premium-header-title h2 {\n    font-size: 1.8rem;\n  }\n\n  .premium-stats-row {\n    grid-template-columns: 1fr;\n    gap: 1rem;\n  }\n\n  .premium-rate-cards {\n    grid-template-columns: 1fr;\n  }\n\n  .premium-action-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 768px) {\n  .premium-dashboard-header {\n    padding: 1.5rem;\n    margin-bottom: 1.5rem;\n  }\n\n  .premium-header-title h2 {\n    font-size: 1.5rem;\n  }\n\n  .premium-header-title p {\n    font-size: 1rem;\n  }\n\n  .premium-stat-card {\n    padding: 1rem;\n  }\n\n  .stat-icon-wrapper {\n    width: 40px;\n    height: 40px;\n    font-size: 1.1rem;\n  }\n\n  .stat-content p {\n    font-size: 1.1rem;\n  }\n\n  .rate-management-header h3 {\n    font-size: 1.5rem;\n  }\n\n  .premium-action-sections .section-header h3 {\n    font-size: 1.5rem;\n  }\n\n  .rate-card-header,\n  .action-card-header {\n    padding: 1rem;\n  }\n\n  .rate-card-content,\n  .action-card-content {\n    padding: 1rem;\n  }\n\n  .rate-card-icon,\n  .action-card-icon {\n    width: 40px;\n    height: 40px;\n    font-size: 1rem;\n  }\n\n  .heading-card-dashboard,\n  .action-card-title h4 {\n    font-size: 1rem;\n  }\n\n  .rate-value {\n    font-size: 1.5rem;\n  }\n\n  .premium-btn {\n    padding: 0.5rem 1rem;\n    font-size: 0.8rem;\n  }\n\n  .premium-action-btn {\n    padding: 0.6rem 1rem;\n    font-size: 0.8rem;\n  }\n\n  .action-card-content {\n    flex-direction: column;\n    gap: 0.5rem;\n  }\n\n  /* Responsive rate cards for tablets */\n  .premium-rate-cards {\n    grid-template-columns: 1fr;\n    gap: 1rem;\n  }\n\n  .rate-card-header {\n    padding: 0.6rem 0.8rem;\n    gap: 0.6rem;\n  }\n\n  .rate-card-icon {\n    width: 22px;\n    height: 22px;\n    font-size: 0.65rem;\n  }\n\n  .heading-card-dashboard {\n    font-size: 1rem;\n  }\n\n  .rate-card-content {\n    padding: 0.8rem;\n    gap: 0.6rem;\n  }\n\n  .feature-item {\n    font-size: 0.85rem;\n    gap: 0.5rem;\n    margin-bottom: 0.4rem;\n  }\n\n  .feature-check {\n    font-size: 0.55rem;\n  }\n\n  .rate-card-title .bulk-action-btn-rate,\n  .rate-card-title .bulk-action-btn-milk-rate {\n    padding: 0.4rem 0.7rem;\n    font-size: 0.75rem;\n    gap: 0.25rem;\n  }\n\n  /* Hide content buttons on tablet */\n  .rate-card-content .bulk-action-btn-rate,\n  .rate-card-content .bulk-action-btn-milk-rate {\n    display: none;\n  }\n}\n\n@media (max-width: 480px) {\n  .premium-dashboard-header {\n    padding: 0.75rem;\n    margin-bottom: 1rem;\n  }\n\n  .premium-header-title h2 {\n    font-size: 1.3rem;\n  }\n\n  .premium-stats-row {\n    flex-direction: column;\n    gap: 0.75rem;\n  }\n\n  .owner-wallet-row {\n    flex-direction: column;\n    align-items: flex-start;\n    /* gap: 0.5rem; */\n  }\n\n  .owner-info {\n    width: 100%;\n  }\n\n  .wallet-info {\n    width: 100%;\n    /* justify-content: space-between; */\n  }\n\n  .stat-icon-wrapper {\n    width: 40px;\n    height: 40px;\n    border-radius: 8px;\n    font-size: 1rem;\n    background: var(--primary);\n    color: white;\n  }\n\n  .dairy-icon {\n    background: #0056b3;\n  }\n\n  .wallet-icon {\n    background: #10b981;\n  }\n\n  .stat-content {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 0.25rem;\n    text-align: left;\n    flex: 1;\n  }\n\n  .stat-content h4 {\n    font-size: 0.65rem;\n    font-weight: 600;\n    color: var(--gray-600);\n    margin-bottom: 0.1rem;\n  }\n\n  .stat-content p {\n    font-size: 0.85rem;\n    font-weight: 700;\n    color: var(--gray-900);\n    margin: 0;\n  }\n\n  .wallet-amount {\n    color: #10b981;\n    font-size: 0.9rem;\n    font-weight: 700;\n  }\n\n  .premium-add-money-btn {\n    margin-top: 0.25rem;\n    padding: 0.2rem 0.5rem;\n    font-size: 0.6rem;\n    border-radius: 4px;\n    background: #10b981;\n    color: white;\n    border: none;\n    font-weight: 600;\n    box-shadow: 0 2px 4px rgba(16, 185, 129, 0.2);\n  }\n\n  .premium-add-money-btn:hover {\n    background: #059669;\n    transform: translateY(-1px);\n    box-shadow: 0 4px 8px rgba(64, 73, 70, 0.3);\n  }\n\n  .rate-edit-actions {\n    flex-direction: column;\n  }\n\n  .rate-input-group {\n    flex-direction: row;\n    align-items: center;\n    gap: 0.5rem;\n    /* border: solid 2px red; */\n  }\n\n  .action-card-content {\n    flex-direction: column;\n    gap: 0.5rem;\n  }\n\n  .premium-action-btn {\n    padding: 0.8rem 0.6rem;\n    font-size: 0.8rem;\n  }\n\n  /* Responsive rate cards for mobile */\n  .premium-rate-cards {\n    grid-template-columns: 1fr !important;\n    gap: 0.6rem !important;\n  }\n\n  .premium-rate-card {\n    border-radius: 8px !important;\n    border: 1px solid rgba(0, 0, 0, 0.08) !important;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.02) !important;\n  }\n\n  .rate-card-header {\n    padding: 6px 10px !important;\n    gap: 6px !important;\n    background: #fafafa !important;\n    border-bottom: 1px solid #f0f0f0 !important;\n  }\n\n  .rate-card-icon {\n    width: 20px !important;\n    height: 20px !important;\n    font-size: 0.65rem !important;\n    border-radius: 4px !important;\n  }\n\n  .heading-card-dashboard {\n    font-size: 0.8rem !important;\n    font-weight: 700 !important;\n    color: #1f2937 !important;\n  }\n\n  .current-rate-box-dashboard {\n    padding: 2px 6px !important;\n    margin-top: 0px !important;\n    border-radius: 6px !important;\n    margin-right: 0px !important;\n  }\n\n  .current-rate-box-dashboard .rate-symbol,\n  .current-rate-box-dashboard .rate-amount {\n    font-size: 11px !important;\n  }\n\n  .rate-card-content {\n    padding: 8px 10px !important;\n    display: flex !important;\n    flex-direction: column !important;\n    gap: 8px !important;\n  }\n\n  .feature-item {\n    font-size: 0.72rem !important;\n    gap: 6px !important;\n    margin-bottom: 4px !important;\n    color: #4b5563 !important;\n    display: flex !important;\n    align-items: center !important;\n  }\n\n  .feature-check {\n    font-size: 0.6rem !important;\n    color: #10b981 !important;\n  }\n\n  /* Hide buttons in header on mobile */\n  .rate-card-title .bulk-action-btn-rate,\n  .rate-card-title .bulk-action-btn-milk-rate {\n    display: none !important;\n  }\n\n  /* Show buttons at bottom of content on mobile as full-width */\n  .rate-card-content .bulk-action-btn-rate,\n  .rate-card-content .bulk-action-btn-milk-rate {\n    display: flex !important;\n    padding: 7px 12px !important;\n    font-size: 0.78rem !important;\n    font-weight: 600 !important;\n    gap: 6px !important;\n    width: 100% !important;\n    margin: 2px 0 0 0 !important;\n    border-radius: 6px !important;\n    justify-content: center !important;\n    box-sizing: border-box !important;\n  }\n\n  /* \n  .bulk-action-btn {\n    padding: 0.6rem 1rem;\n    font-size: 0.9rem;\n  } */\n\n  /* Mobile styling for Current Milk Rate card */\n  .premium-rate-card {\n    padding: 0.75rem;\n  }\n\n  .rate-card-header {\n    padding: 0.5rem;\n    gap: 0.5rem;\n    flex-direction: row;\n  }\n\n  .rate-card-icon {\n    width: 24px;\n    height: 24px;\n    font-size: 0.7rem;\n  }\n\n  .heading-card-dashboard {\n    font-size: 1.5rem;\n    margin-bottom: 0.1rem;\n    font-weight: 600;\n  }\n\n  .rate-card-title p {\n    font-size: 0.6rem;\n  }\n\n  .rate-card-content {\n    padding: 0.75rem;\n    gap: 0.5rem;\n    /* border: solid 2px red; */\n  }\n\n  .current-rate-display {\n    padding: 0.4rem;\n    min-width: 70px;\n  }\n\n  .rate-value {\n    font-size: 0.9rem;\n    font-weight: 600;\n  }\n\n  .rate-label {\n    font-size: 0.6rem;\n  }\n\n  .edit-rate-button {\n    padding: 0.3rem 0.6rem;\n    font-size: 0.65rem;\n    gap: 0.2rem;\n  }\n\n  .rate-type-row {\n    gap: 0.4rem;\n  }\n\n  .premium-select.compact {\n    padding: 0.3rem 0.5rem;\n    font-size: 0.7rem;\n    min-width: 100px;\n  }\n\n  .save-rate-button {\n    padding: 0.3rem 0.6rem;\n    font-size: 0.65rem;\n    max-width: 80px;\n  }\n\n  .premium-rate-input {\n    padding: 0.25rem 0.4rem;\n    font-size: 0.7rem;\n    border-radius: 4px;\n  }\n\n  .rate-edit-actions {\n    gap: 0.3rem;\n    margin-top: 0.3rem;\n  }\n\n  .premium-btn {\n    padding: 0.2rem 0.4rem;\n    font-size: 0.55rem;\n    border-radius: 3px;\n  }\n\n  .edit-rate-button {\n    padding: 0.2rem 0.4rem;\n    font-size: 0.55rem;\n    gap: 0.15rem;\n  }\n\n  .premium-select-rate.compact {\n    padding: 0.2rem 0.4rem;\n    font-size: 0.6rem;\n    min-width: 80px;\n    border-radius: 3px;\n  }\n\n  .save-rate-button {\n    padding: 0.2rem 0.4rem;\n    font-size: 0.55rem;\n    max-width: 60px;\n    border-radius: 3px;\n  }\n}\n\n/* Header */\n.dashboard-header {\n  background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);\n\n  padding: 0;\n  margin: 0;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border-bottom: none;\n  box-shadow: 0 8px 32px rgba(37, 99, 235, 0.2);\n  gap: 1rem;\n  height: 70px;\n  position: relative;\n  /* Establishes a stacking context */\n  z-index: 999;\n  width: 100vw;\n  left: 50%;\n  transform: translateX(-50%);\n}\n\n/* Desktop Header Layout */\n.desktop-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  height: 100%;\n}\n\n/* Mobile Header Layout */\n.mobile-header {\n  display: none;\n  flex-direction: column;\n  width: 100%;\n  height: auto;\n\n\n}\n\n.mobile-header-top {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  padding: 0.5rem 1rem 0.5rem;\n  min-height: 55px;\n  position: relative;\n  gap: 0.5rem;\n  margin-top: 0;\n}\n\n.mobile-header-title {\n  position: absolute;\n  /* left: 50%; */\n  /* transform: translateX(-50%); */\n  font-size: 1.2rem;\n  font-weight: 600;\n  color: white;\n  margin: 0;\n  white-space: nowrap;\n  text-align: left;\n  z-index: 1;\n}\n\n.mobile-header-bottom {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0.5rem;\n  min-height: 40px;\n\n}\n\n.header-center {\n  flex: 1;\n  text-align: center;\n  padding: 0;\n  margin: 0;\n}\n\n.dashboard-header h1 {\n  font-size: 2rem;\n  color: white;\n  margin: 0;\n  padding: 0;\n  font-weight: 700;\n}\n\n.logo-container {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(255, 255, 255, 0.2);\n  width: 50px;\n  height: 50px;\n  border-radius: 10px;\n  flex-shrink: 0;\n  box-shadow: none;\n  transition: all 0.3s ease;\n  margin: 0;\n  padding: 0;\n  margin-left: 1.5rem;\n}\n\n.logo-container-mobile {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(255, 255, 255, 0.2);\n  width: 44px;\n  height: 44px;\n  border-radius: 10px;\n  flex-shrink: 0;\n  box-shadow: none;\n  transition: all 0.3s ease;\n  margin: 0;\n  padding: 0;\n}\n\n.logo-container:hover {\n  transform: scale(1.08);\n  background: rgba(255, 255, 255, 0.3);\n}\n\n.logo {\n  position: relative;\n  top: 0;\n  width: 40px;\n  object-fit: contain;\n  background: transparent;\n  margin: 0;\n  padding: 0;\n}\n\n.user-info {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  flex-shrink: 0;\n  margin: 0;\n  padding: 0;\n  margin-right: 1rem;\n  overflow: visible;\n}\n\n.header-actions {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  margin: 0;\n  padding: 0;\n  overflow: visible;\n}\n\n.home-btn {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  color: white;\n  text-decoration: none;\n  padding: 0.5rem 1rem;\n  border-radius: 8px;\n  background: rgba(255, 255, 255, 0.1);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  transition: all 0.3s ease;\n  font-size: 0.9rem;\n  font-weight: 500;\n}\n\n.home-btn:hover {\n  background: rgba(255, 255, 255, 0.2);\n  transform: translateY(-2px);\n}\n\n.home-btn-mobile {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  text-decoration: none;\n  padding: 0.5rem;\n  border-radius: 8px;\n  background: rgba(255, 255, 255, 0.1);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  transition: all 0.3s ease;\n  font-size: 1rem;\n}\n\n.home-btn-mobile:hover {\n  background: rgba(255, 255, 255, 0.2);\n}\n\n.user-details {\n  display: flex;\n  flex-direction: row;\n  gap: 0.8rem;\n  align-items: center;\n  background: rgba(255, 255, 255, 0.15);\n  padding: 0.5rem 1rem;\n  border-radius: 8px;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  margin: 0;\n  backdrop-filter: blur(10px);\n}\n\n.user-name-phone {\n  display: flex;\n  align-items: center;\n  gap: 0.6rem;\n}\n\n.user-icon,\n.phone-icon {\n  color: white;\n  font-size: 0.9rem;\n}\n\n.user-name {\n  color: white;\n  font-weight: 600;\n  font-size: 0.95rem;\n}\n\n.user-phone {\n  display: flex;\n  align-items: center;\n  gap: 0.6rem;\n  font-size: 0.8rem;\n  color: rgba(255, 255, 255, 0.9);\n  font-weight: 400;\n}\n\n.logout-button {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.5rem 1rem;\n  border: 1px solid rgba(255, 255, 255, 0.3);\n  border-radius: 6px;\n  background-color: rgba(255, 255, 255, 0.15);\n  color: white;\n  transition: all 0.3s ease;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 0.85rem;\n  box-shadow: none;\n  margin: 0;\n  backdrop-filter: blur(10px);\n}\n\n\n.logout-button:active {\n  transform: translateY(0);\n  box-shadow: 0 2px 6px rgba(239, 68, 68, 0.15);\n}\n\n/* Profile Dropdown Styles */\n.profile-dropdown {\n  position: relative;\n  width: fit-content;\n  /* padding: 10px; */\n  z-index: 99999;\n  /* border: green solid 2px; */\n}\n\n.profile-button-dashboard {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.5rem 1rem;\n  border: 1px solid rgba(255, 255, 255, 0.3);\n  border-radius: 6px;\n  background-color: rgba(255, 255, 255, 0.15);\n  color: white;\n  transition: all 0.3s ease;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 0.85rem;\n  box-shadow: none;\n  margin: 0;\n  backdrop-filter: blur(10px);\n}\n\n.profile-button-dashboard:hover {\n  background-color: rgba(255, 255, 255, 0.25);\n  border-color: rgba(255, 255, 255, 0.4);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n}\n\n.profile-icon-dashboard {\n  font-size: 1.2rem;\n  color: white;\n  /* border: solid 2px red; */\n}\n\n.profile-chevron {\n  font-size: 0.7rem;\n  color: rgba(255, 255, 255, 0.9);\n  transition: transform 0.3s ease;\n}\n\n.profile-chevron.open {\n  transform: rotate(180deg);\n}\n\n.profile-menu {\n  position: absolute;\n  top: calc(100% + 0.5rem);\n  right: 0;\n  background: white;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);\n  min-width: 250px;\n  max-width: 300px;\n  z-index: 99999;\n  overflow: visible;\n  transform: translateX(0);\n  opacity: 1;\n  visibility: visible;\n}\n\n/* Prevent dropdown from going off-screen on smaller viewports */\n@media (max-width: 768px) {\n  .profile-menu {\n    right: -1rem;\n    min-width: 200px;\n    max-width: 250px;\n  }\n}\n\n@media (max-width: 480px) {\n  .profile-menu {\n    right: -2rem;\n    min-width: 180px;\n    max-width: 220px;\n  }\n}\n\n.profile-info {\n  padding: 1rem;\n  border-bottom: 1px solid #f0f0f0;\n}\n\n.profile-header-dashborad {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  margin-bottom: 0.75rem;\n}\n\n.profile-avatar {\n  font-size: 2rem;\n  color: var(--primary);\n  flex-shrink: 0;\n}\n\n.profile-details {\n  flex: 1;\n}\n\n.profile-name {\n  font-size: 0.95rem;\n  font-weight: 600;\n  color: #333;\n  margin-bottom: 0.2rem;\n}\n\n.profile-role {\n  font-size: 0.8rem;\n  color: #666;\n}\n\n.profile-contact,\n.profile-dairy {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-size: 0.85rem;\n  color: #555;\n  margin-bottom: 0.5rem;\n}\n\n/* Dairy logo edit button inside the profile dropdown */\n.profile-logo-edit-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  background: #f1f5f9;\n  border: 1px solid #e2e8f0;\n  color: #0d47a1;\n  padding: 3px 10px;\n  border-radius: 50px;\n  font-size: 11px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  margin-left: auto;\n  flex-shrink: 0;\n}\n\n.profile-logo-edit-btn:hover {\n  background: #e2e8f0;\n  border-color: #cbd5e1;\n}\n\n.profile-logo-thumb {\n  width: 18px;\n  height: 18px;\n  object-fit: contain;\n  border-radius: 3px;\n  background: #ffffff;\n}\n\n/* Logo preview row in the profile dropdown */\n.profile-logo-preview-row {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 0.5rem;\n}\n\n.profile-logo-preview-img {\n  max-width: 120px;\n  max-height: 60px;\n  object-fit: contain;\n  border-radius: 8px;\n  background: #f8fafc;\n  padding: 4px;\n  border: 1px solid #e2e8f0;\n}\n\n.contact-icon,\n.dairy-icon {\n  font-size: 0.8rem;\n  color: #888;\n  width: 16px;\n}\n\n.profile-actions {\n  padding: 0.5rem;\n}\n\n.profile-logout-btn {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  width: 100%;\n  padding: 0.6rem 0.8rem;\n  border: none;\n  border-radius: 6px;\n  background: #f5f5f5;\n  color: #d32f2f;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 0.85rem;\n  /* transition: all 0.3s ease; */\n}\n\n.profile-logout-btn:hover {\n  background: #ffebee;\n  color: #c62828;\n}\n\n.logout-icon {\n  font-size: 0.9rem;\n}\n\n/* Mobile Menu Toggle */\n.mobile-menu-toggle {\n  display: none;\n  background: none;\n  border: none;\n  color: white;\n  font-size: 1.5rem;\n  cursor: pointer;\n  padding: 0.5rem;\n  border-radius: 6px;\n  transition: all 0.3s ease;\n}\n\n.mobile-menu-toggle:hover {\n  background: rgba(255, 255, 255, 0.1);\n}\n\n.mobile-menu-overlay {\n  display: none;\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  z-index: 1051;\n  /* Must be higher than header (1050) */\n  opacity: 0;\n  transition: opacity 0.3s ease;\n}\n\n.mobile-menu-overlay.active {\n  display: block;\n  opacity: 1;\n}\n\n.mobile-menu {\n  position: fixed;\n  top: 0;\n  right: -100%;\n  width: 280px;\n  height: 100%;\n  background: white;\n  box-shadow: -4px 0 12px rgba(0, 0, 0, 0.1);\n  z-index: 1052;\n  /* Must be higher than overlay and header */\n  transition: right 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);\n  overflow-y: auto;\n}\n\n.mobile-menu.active {\n  right: 0;\n}\n\n.mobile-menu-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 1.5rem;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.mobile-menu-close {\n  background: none;\n  border: none;\n  color: #374151;\n  font-size: 1.5rem;\n  cursor: pointer;\n  padding: 0.5rem;\n  border-radius: 6px;\n  transition: all 0.3s ease;\n}\n\n.mobile-menu-close:hover {\n  background: #f3f4f6;\n}\n\n.mobile-menu-content {\n  padding: 1.5rem;\n}\n\n.mobile-user-info {\n  background: #f9fafb;\n  padding: 1rem;\n  border-radius: 8px;\n  margin-bottom: 1.5rem;\n  border: 1px solid #e5e7eb;\n}\n\n.mobile-user-name {\n  color: #374151;\n  font-weight: 600;\n  font-size: 1rem;\n  margin-bottom: 0.5rem;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.mobile-user-name .user-icon {\n  color: #374151;\n  font-size: 0.9rem;\n}\n\n.mobile-user-phone {\n  color: #6b7280;\n  font-size: 0.9rem;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.mobile-user-phone .phone-icon {\n  color: #6b7280;\n  font-size: 0.9rem;\n}\n\n.mobile-m.premium-stats-row {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n/* Desktop layout - wallet in top right corner */\n@media (min-width: 769px) {\n  .premium-stats-row {\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: flex-start;\n  }\n\n  .owner-info-vertical {\n    display: flex;\n    flex-direction: column;\n    gap: 0.5rem;\n    width: 100%;\n  }\n\n  .owner-wallet-row {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n  }\n\n  .owner-info {\n    flex-shrink: 0;\n  }\n\n  .wallet-info {\n    flex-shrink: 0;\n    margin-left: auto;\n  }\n\n  .phone-info {\n    width: 100%;\n    margin-top: 0.5rem;\n  }\n}\n\n.mobile-language-switcher {\n  margin-bottom: 1rem;\n}\n\n/* Mobile language switcher specific styling */\n.mobile-language-switcher .language-switcher {\n  width: 100%;\n}\n\n.mobile-language-switcher .lang-btn {\n  width: 100%;\n  justify-content: center;\n  padding: 0.75rem 1rem;\n  background: #f9fafb;\n  color: #374151;\n  border: 1px solid #e5e7eb;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-size: 0.9rem;\n  font-weight: 500;\n}\n\n.mobile-language-switcher .lang-btn .lang-icon {\n  color: #6b7280;\n  font-size: 0.9rem;\n}\n\n.mobile-language-switcher .lang-btn .lang-text {\n  color: #374151;\n  font-size: 0.9rem;\n}\n\n.mobile-language-switcher .lang-btn .lang-chevron {\n  color: #6b7280;\n  font-size: 0.8rem;\n}\n\n.mobile-language-switcher .lang-btn:hover {\n  background: #f3f4f6;\n  border-color: #d1d5db;\n}\n\n.mobile-language-switcher .language-dropdown {\n  position: absolute;\n  top: 100%;\n  left: 50%;\n  transform: translateX(-50%);\n  right: auto;\n  margin-top: 0.5rem;\n  width: 200px;\n  max-width: 90vw;\n}\n\n.mobile-logout-btn {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.75rem 1rem;\n  border: none;\n  border-radius: 6px;\n  background-color: #ef4444;\n  color: white;\n  transition: all 0.3s ease;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 0.9rem;\n  text-decoration: none;\n  justify-content: center;\n}\n\n.mobile-logout-btn:hover {\n  background-color: #dc2626;\n  transform: translateY(-1px);\n}\n\n.mobile-home-link {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.75rem 1rem;\n  border-radius: 6px;\n  background-color: #3b82f6;\n  color: white;\n  transition: all 0.3s ease;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 0.9rem;\n  text-decoration: none;\n  justify-content: center;\n  margin-bottom: 0.5rem;\n}\n\n.mobile-home-link:hover {\n  background-color: #2563eb;\n  transform: translateY(-1px);\n}\n\n/* Tablet Responsive Styles */\n@media (max-width: 1024px) {\n  .dashboard-header {\n    padding: 0;\n    height: 60px;\n  }\n\n  .logo-container {\n    width: 40px;\n    height: 40px;\n    margin-left: 1rem;\n  }\n\n  .logo {\n    width: 32px;\n  }\n\n  .dashboard-header h1 {\n    font-size: 1.3rem;\n  }\n\n  .user-details {\n    padding: 0.4rem 0.8rem;\n    gap: 0.6rem;\n  }\n\n  .user-name {\n    font-size: 0.85rem;\n  }\n\n  .user-phone {\n    font-size: 0.75rem;\n  }\n\n  .logout-button {\n    padding: 0.4rem 0.8rem;\n    font-size: 0.8rem;\n  }\n}\n\n/* Mobile Responsive Styles */\n@media (max-width: 768px) {\n  .dashboard-header {\n    height: auto;\n    padding: 0;\n    position: relative;\n    flex-direction: column;\n  }\n\n  .desktop-header {\n    display: none;\n  }\n\n  .mobile-header {\n    display: flex;\n  }\n\n  .mobile-header-top {\n    padding: 0.5rem 1rem;\n    height: 50px;\n    display: flex;\n    justify-content: none;\n    align-items: center;\n    margin-top: 0;\n  }\n\n  .mobile-header-title {\n    font-size: 1rem;\n    font-weight: 600;\n    color: white;\n    margin-left: 0;\n    white-space: nowrap;\n    text-align: left;\n    align-items: flex-start;\n    /* position: absolute; */\n    left: 50%;\n    transform: translateX(-50%);\n  }\n\n  .mobile-header-actions {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n  }\n\n  .mobile-header-actions .profile-button-dashboard {\n    padding: 0.4rem 0.8rem;\n    font-size: 0.8rem;\n  }\n\n  .mobile-header-actions .profile-icon-dashboard {\n    font-size: 1rem;\n  }\n\n  .mobile-header-bottom {\n    padding: 0.5rem;\n    min-height: 40px;\n  }\n\n  .mobile-header-bottom h1 {\n    font-size: 1.1rem;\n    font-weight: 600;\n    color: white;\n    margin: 0;\n    text-align: center;\n  }\n\n  .logo-container-mobile {\n    width: 36px;\n    height: 36px;\n    margin: 0;\n  }\n\n  .logo {\n    width: 28px;\n  }\n\n  .mobile-menu-toggle {\n    display: block;\n    font-size: 1.2rem;\n    padding: 0.5rem;\n    background: none;\n    border: none;\n    color: white;\n    cursor: pointer;\n    border-radius: 6px;\n    transition: all 0.3s ease;\n  }\n\n  .mobile-menu-toggle:hover {\n    background: rgba(255, 255, 255, 0.1);\n  }\n\n  .user-info {\n    display: none;\n  }\n\n  .header-actions {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n  }\n}\n\n/* Small Mobile Responsive Styles */\n@media (max-width: 480px) {\n  .mobile-header-top {\n\n    padding: 0.4rem 0.75rem;\n    height: 45px;\n    margin-top: 0;\n  }\n\n  .mobile-header-title {\n    font-size: 0.95rem;\n    font-weight: 600;\n    color: white;\n    margin: 0;\n    white-space: nowrap;\n    text-align: center;\n    position: absolute;\n    left: 50%;\n    transform: translateX(-50%);\n  }\n\n  .mobile-header-bottom {\n    padding: 0.4rem;\n    min-height: 35px;\n  }\n\n  .mobile-header-bottom h1 {\n    font-size: 0.95rem;\n    font-weight: 600;\n  }\n\n  .logo-container-mobile {\n    width: 32px;\n    height: 32px;\n  }\n\n  .logo {\n    width: 20px;\n  }\n\n  .mobile-menu-toggle {\n    font-size: 1.1rem;\n    padding: 0.4rem;\n  }\n}\n\n/* Extra Small Mobile Responsive Styles */\n@media (max-width: 360px) {\n  .mobile-header-top {\n    padding: 0.3rem 0.5rem;\n    height: 40px;\n    margin-top: 0;\n  }\n\n  .mobile-header-bottom {\n    padding: 0.3rem;\n    min-height: 30px;\n  }\n\n  .mobile-header-bottom h1 {\n    font-size: 0.85rem;\n    font-weight: 600;\n  }\n\n  .logo-container-mobile {\n    width: 28px;\n    height: 28px;\n  }\n\n  .logo {\n    width: 25px;\n  }\n\n  .mobile-menu-toggle {\n    font-size: 1rem;\n    padding: 0.3rem;\n  }\n\n  .mobile-menu {\n    width: 240px;\n  }\n}\n\n/* Main Content */\n.dashboard-content {\n  flex: 1;\n  max-width: 1280px;\n  margin: 0 auto;\n  padding: 2rem;\n  width: 100%;\n}\n\n/* Responsive adjustments for dashboard content */\n@media (max-width: 768px) {\n  .dashboard-content {\n    padding: 1rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .dashboard-content {\n    padding: 0.75rem;\n  }\n}\n\n@media (max-width: 360px) {\n  .dashboard-content {\n    padding: 0.5rem;\n  }\n}\n\n/* Welcome Section */\n.welcome-section {\n  background-color: white;\n  border-radius: 8px;\n  padding: 1.5rem;\n  margin-bottom: 2rem;\n  border: 1px solid var(--gray-200);\n}\n\n.welcome-section h2 {\n  color: var(--gray-800);\n  margin-bottom: 0.5rem;\n}\n\n/* Dashboard Sections */\n.dashboard-sections {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 2rem;\n}\n\n.dashboard-section {\n  background: white;\n  border-radius: 16px;\n  padding: 2rem;\n  border: 1px solid var(--gray-200);\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.06);\n  transition: all 0.3s ease;\n}\n\n.dashboard-section:hover {\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);\n  transform: translateY(-2px);\n}\n\n.section-header {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  margin-bottom: 2rem;\n  padding-bottom: 1rem;\n  border-bottom: 2px solid var(--gray-100);\n}\n\n.section-icon {\n  color: var(--primary);\n  font-size: 1.75rem;\n  background: linear-gradient(135deg, var(--primary-light) 0%, var(--primary) 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.section-header h3 {\n  color: var(--gray-800);\n  font-size: 1.35rem;\n  font-weight: 700;\n  letter-spacing: -0.01em;\n}\n\n/* Action Cards */\n.actions-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 1.5rem;\n}\n\n.action-card {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 2rem 1.5rem;\n  border-radius: 12px;\n  background: linear-gradient(135deg, var(--gray-50) 0%, white 100%);\n  border: 1px solid var(--gray-200);\n  text-decoration: none;\n  color: var(--gray-800);\n  transition: all 0.3s ease;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);\n  cursor: pointer;\n}\n\n.action-card:hover {\n  background: linear-gradient(135deg, white 0%, var(--gray-50) 100%);\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);\n  transform: translateY(-4px);\n  border-color: var(--primary-light);\n}\n\n.action-card.primary {\n  background: linear-gradient(135deg, var(--primary) 0%, var(--primary-dark) 100%);\n  color: white;\n  border: none;\n  box-shadow: 0 4px 16px rgba(59, 130, 246, 0.3);\n}\n\n.action-card.primary:hover {\n  background: linear-gradient(135deg, var(--primary-dark) 0%, #1e3a8a 100%);\n  box-shadow: 0 8px 24px rgba(59, 130, 246, 0.4);\n  transform: translateY(-4px);\n}\n\n.action-card.raw {\n  background: linear-gradient(135deg, var(--secondary) 0%, #7c3aed 100%);\n  color: white;\n  border: none;\n  box-shadow: 0 4px 16px rgba(139, 92, 246, 0.3);\n}\n\n.action-card.raw:hover {\n  background: linear-gradient(135deg, #7c3aed 0%, #6d28d9 100%);\n  box-shadow: 0 8px 24px rgba(139, 92, 246, 0.4);\n  transform: translateY(-4px);\n}\n\n/* View Collections button - More visible subtle style */\n.action-card.view-collections-button {\n  background-color: var(--gray-100);\n  border: 2px solid #7cbef4fa;\n  color: #495057;\n  transition: all 0.2s ease;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n}\n\n.action-card.view-collections-button:hover {\n  background-color: #e9ecef;\n  border-color: #7cbef4fa;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n/* ProRata View Collections button - More visible subtle style */\n.action-card.prorata-view-collections-button {\n  background-color: var(--gray-100);\n  border: 2px solid #7cbef4fa;\n  color: #495057;\n  transition: all 0.2s ease;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n}\n\n.action-card.prorata-view-collections-button:hover {\n  background-color: #e9ecef;\n  border-color: #7cbef4fa;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n/* Disabled state for KG/Liters rate types */\n.dashboard-section.disabled-section {\n  opacity: 0.6;\n  position: relative;\n}\n\n.action-card.disabled {\n  opacity: 0.5;\n  cursor: not-allowed !important;\n  pointer-events: none;\n}\n\n.action-card.disabled:hover {\n  background-color: var(--gray-50);\n  transform: none;\n}\n\n.disabled-badge {\n  font-size: 0.75rem;\n  color: var(--warning);\n  font-weight: 600;\n  margin-left: auto;\n  background-color: rgba(245, 158, 11, 0.1);\n  padding: 0.25rem 0.5rem;\n  border-radius: 4px;\n  border: 1px solid rgba(245, 158, 11, 0.3);\n}\n\n.action-icon {\n  font-size: 1.5rem;\n  margin-bottom: 0.75rem;\n}\n\n/* Messages */\n.success-message {\n  background-color: var(--success);\n  color: white;\n  padding: 0.75rem 1rem;\n  border-radius: 6px;\n  margin-bottom: 1rem;\n}\n\n.low-balance-alert {\n  background-color: var(--danger);\n  color: white;\n  padding: 0.75rem 1rem;\n  border-radius: 6px;\n  margin-bottom: 1rem;\n}\n\n/* Responsive Design */\n@media (max-width: 1024px) {\n  .dashboard-content {\n    padding: 1.5rem;\n  }\n}\n\n@media (max-width: 768px) {\n  .dashboard-content {\n    padding: 1rem;\n  }\n\n  .dashboard-sections {\n    grid-template-columns: 1fr;\n    gap: 1rem;\n  }\n\n  .dashboard-section {\n    padding: 1rem;\n  }\n\n  .section-header {\n    margin-bottom: 1rem;\n  }\n\n  .section-header h3 {\n    font-size: 1rem;\n  }\n\n  .section-icon {\n    font-size: 1.1rem;\n  }\n\n  .actions-grid {\n    grid-template-columns: 1fr;\n    gap: 0.5rem;\n  }\n\n  .action-card {\n    padding: 0.75rem 1rem;\n    width: 100%;\n    min-height: auto;\n  }\n\n  .action-card span {\n    font-size: 0.9rem;\n  }\n\n  .action-icon {\n    font-size: 1.1rem;\n    margin-bottom: 0.35rem;\n  }\n\n  .dashboard-header {\n    padding: 0;\n    flex-direction: column;\n    gap: 1rem;\n    text-align: center;\n    height: auto;\n    min-height: 80px;\n  }\n\n  .header-center {\n    order: 2;\n  }\n\n  .dashboard-header h1 {\n    font-size: 1.15rem;\n  }\n\n  .logo-container {\n    width: 50px;\n    height: 50px;\n    order: 1;\n  }\n\n  .logo {\n    width: 42px;\n  }\n\n  .user-info {\n    flex-direction: column;\n    gap: 0.75rem;\n    order: 3;\n    width: 100%;\n  }\n\n  .user-details {\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: flex-start;\n    width: 100%;\n    gap: 0.5rem;\n    padding: 0.6rem 0.75rem;\n  }\n\n  .user-name-phone {\n    font-size: 0.85rem;\n    gap: 0.4rem;\n  }\n\n  .user-phone {\n    font-size: 0.85rem;\n    gap: 0.4rem;\n  }\n\n  .user-icon,\n  .phone-icon {\n    font-size: 0.85rem;\n  }\n\n  .user-name {\n    font-size: 0.9rem;\n  }\n\n  .header-actions {\n    flex-direction: row;\n    gap: 0.5rem;\n    align-items: center;\n    flex-shrink: 0;\n    justify-content: center;\n    width: 100%;\n  }\n\n  .logout-button {\n    padding: 0.5rem 0.8rem;\n    font-size: 0.8rem;\n    width: auto;\n    justify-content: center;\n    flex-shrink: 0;\n  }\n\n  .welcome-section {\n    padding: 1rem;\n    margin-bottom: 1rem;\n  }\n\n  .welcome-section h2 {\n    font-size: 1.1rem;\n  }\n\n  .welcome-section p {\n    font-size: 0.9rem;\n  }\n\n  /* Responsive Combined Info Container */\n  .combined-info-container-dashboard {\n    grid-template-columns: 1fr;\n    gap: 1rem;\n    margin-bottom: 1.5rem;\n  }\n\n  .dairy-info-container-dashboard,\n  .rate-info-container {\n    padding: 1rem;\n    border-radius: 8px;\n  }\n\n  .dairy-info-content {\n    gap: 0.75rem;\n  }\n\n  .info-item {\n    /* padding: 0.6rem; */\n    flex-wrap: wrap;\n  }\n\n  .info-icon {\n    font-size: 1rem;\n  }\n\n  .info-label {\n    font-size: 0.85rem;\n  }\n\n  .info-value {\n    font-size: 0.9rem;\n  }\n\n  .add-money-btn {\n    font-size: 0.8rem;\n    padding: 0.4rem 0.8rem;\n    margin-left: 0;\n    margin-top: 8px;\n    width: 90%;\n    max-width: none;\n  }\n\n  .rate-info-container {\n    padding: 1rem;\n    margin-bottom: 1rem;\n  }\n\n  .rate-info-content {\n    flex-direction: column;\n    gap: 0.75rem;\n  }\n\n  .rate-section,\n  .rate-type-section {\n    padding: 0.6rem;\n    min-height: auto;\n  }\n\n  .rate-display p,\n  .rate-type-display p {\n    font-size: 0.85rem;\n  }\n\n  .rate-edit-container {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .rate-edit,\n  .rate-type-control {\n    flex-direction: column;\n    align-items: stretch;\n    min-width: 100%;\n  }\n\n  .rate-input {\n    width: 100%;\n    padding: 0.4rem;\n    font-size: 0.9rem;\n  }\n\n  .rate-edit-container .bulk-rate-button {\n    /* width: 100%; */\n    justify-content: center;\n    padding: 0.4rem 0.6rem;\n    font-size: 0.8rem;\n  }\n}\n\n/* Combined Info Cards Container */\n.combined-info-container-dashboard {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 0.5rem;\n  margin-bottom: 1rem;\n}\n\n/* Tablet devices - medium screens */\n@media (min-width: 769px) and (max-width: 1024px) {\n  .combined-info-container-dashboard {\n    grid-template-columns: 1fr 1fr;\n    gap: 0.8rem;\n  }\n\n  .dairy-info-container-dashboard,\n  .rate-info-container {\n    padding: 0.8rem;\n  }\n\n  .dairy-info-content {\n    gap: 0.2rem;\n    justify-content: space-between;\n    align-items: center;\n    flex-direction: row;\n  }\n\n  .info-item {\n    padding: 0.25rem 0.35rem;\n    gap: 0.15rem;\n    /* flex: 1; */\n    min-width: 45%;\n    justify-content: flex-start;\n    align-items: center;\n  }\n\n  .info-icon {\n    font-size: 0.7rem;\n  }\n\n  .info-label {\n    font-size: 0.65rem;\n  }\n\n  .info-value {\n    font-size: 0.7rem;\n    text-align: left;\n  }\n\n  .add-money-btn {\n    padding: 0.08rem 0.18rem;\n    font-size: 0.48rem;\n    margin-left: 0.09rem;\n  }\n\n  .rate-buttons {\n    gap: 0.28rem;\n    justify-content: center;\n    align-items: center;\n  }\n\n  .edit-rate-button-dashboard,\n  .bulk-rate-button {\n    padding: 0.32rem 0.55rem;\n    font-size: 0.66rem;\n    min-height: 30px;\n    display: inline-flex;\n    align-items: center;\n    gap: 0.2rem;\n    white-space: nowrap;\n  }\n\n  .bulk-rate-button {\n    padding: 0.42rem 0.65rem;\n    font-size: 0.71rem;\n  }\n}\n\n@media (width: 768px) {\n  .combined-info-container-dashboard {\n    display: flex;\n    flex-direction: row;\n    gap: 0.8rem;\n  }\n\n  .dairy-info-container-dashboard,\n  .rate-info-container {\n    padding: 0.8rem;\n    width: 50%;\n  }\n\n  .dairy-info-content {\n    display: flex;\n    flex-direction: row;\n    gap: 0.8rem;\n  }\n\n  .info-item {\n    padding: 0.25rem 0.35rem;\n    gap: 0.15rem;\n    justify-content: flex-start;\n    align-items: center;\n    margin-bottom: 20px;\n  }\n\n  .info-icon {\n    font-size: 0.7rem;\n  }\n\n  .info-label {\n    font-size: 0.65rem;\n  }\n\n  .info-value {\n    font-size: 0.7rem;\n    text-align: left;\n  }\n\n  .add-money-btn {\n    padding: 0.08rem 0.18rem;\n    font-size: 0.48rem;\n    margin-left: 0.09rem;\n  }\n\n\n  .rate-buttons {\n    gap: 0.28rem;\n    justify-content: center;\n    align-items: center;\n  }\n\n  .edit-rate-button-dashboard,\n  .bulk-rate-button {\n    padding: 0.32rem 0.55rem;\n    font-size: 0.66rem;\n    min-height: 30px;\n    display: inline-flex;\n    align-items: center;\n    gap: 0.2rem;\n    white-space: nowrap;\n  }\n\n  .bulk-rate-button {\n    padding: 0.42rem 0.65rem;\n    font-size: 0.71rem;\n  }\n\n  .combined-info-container-dashboard {\n    grid-template-columns: 1fr 1fr;\n    gap: 0.6rem;\n  }\n\n  .dairy-info-container-dashboard,\n  .rate-info-container {\n    padding: 0.7rem;\n  }\n\n  .dairy-info-content {\n    gap: 0.15rem;\n  }\n\n  .info-item {\n    padding: 0.2rem 0.3rem;\n    gap: 0.12rem;\n  }\n\n  .info-icon {\n    font-size: 0.68rem;\n  }\n\n  .info-label {\n    font-size: 0.63rem;\n  }\n\n  .info-value {\n    font-size: 0.68rem;\n  }\n\n  .add-money-btn {\n    padding: 0.07rem 0.14rem;\n    font-size: 0.47rem;\n    margin-left: 0.085rem;\n  }\n\n  .dashboard-sections {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 1rem;\n  }\n\n  .actions-grid {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 0.75rem;\n  }\n\n  .action-card {\n    padding: 1rem 0.75rem;\n    min-height: 80px;\n  }\n\n  /* Show owner info in dairy card at 768px */\n  .owner-info-768 {\n    display: flex !important;\n  }\n\n  /* Show owner info in header at 768px */\n  .user-details {\n    display: flex !important;\n  }\n\n  .user-info {\n    gap: 0.5rem;\n  }\n}\n\n/* Large tablets and small desktops */\n@media (min-width: 1025px) and (max-width: 1366px) {\n  .combined-info-container-dashboard {\n    grid-template-columns: 1fr 1fr;\n    gap: 0.6rem;\n  }\n\n  .dairy-info-container-dashboard,\n  .rate-info-container {\n    padding: 0.7rem;\n  }\n\n  .dairy-info-content {\n    gap: 0.15rem;\n  }\n\n  .info-item {\n    padding: 0.2rem 0.3rem;\n    gap: 0.12rem;\n  }\n\n  .info-icon {\n    font-size: 0.68rem;\n  }\n\n  .info-label {\n    font-size: 0.63rem;\n  }\n\n  .info-value {\n    font-size: 0.68rem;\n  }\n\n  .add-money-btn {\n    padding: 0.07rem 0.14rem;\n    font-size: 0.47rem;\n    margin-left: 0.085rem;\n  }\n}\n\n/* Mobile responsive - stack cards vertically */\n@media (max-width: 768px) {\n  .combined-info-container-dashboard {\n    grid-template-columns: 1fr;\n    gap: 1rem;\n  }\n\n  .dairy-info-container-dashboard,\n  .rate-info-container {\n    max-width: 100%;\n    padding: 0.5rem;\n  }\n\n  .dairy-info-content {\n    gap: 0rem !important;\n    flex-direction: row !important;\n    justify-content: center !important;\n    align-items: center !important;\n    flex-wrap: wrap !important;\n  }\n\n  .info-item {\n    padding: 0.15rem 0.2rem !important;\n    gap: 0.1rem !important;\n    flex: none !important;\n    min-width: auto !important;\n    justify-content: center !important;\n    align-items: center !important;\n  }\n\n  .info-icon {\n    font-size: 0.8rem;\n    flex-shrink: 0;\n    width: 18px;\n  }\n\n  .info-label {\n    font-size: 0.75rem;\n    font-weight: 600;\n    flex-shrink: 0;\n    white-space: nowrap;\n    margin-right: 0.3rem;\n  }\n\n  .info-value {\n    font-size: 0.75rem !important;\n    font-weight: 500 !important;\n    flex: 1 !important;\n    text-align: left !important;\n    white-space: nowrap !important;\n  }\n\n  .add-money-btn {\n    padding: 0.06rem 0.12rem;\n    font-size: 0.45rem;\n    font-weight: 600;\n    flex-shrink: 0;\n    margin-left: 0.08rem;\n    min-width: auto;\n    width: auto;\n  }\n\n  .rate-info-content {\n    gap: 0.5rem;\n  }\n\n  .rate-section,\n  .rate-type-section {\n    padding: 0.6rem;\n  }\n\n  .rate-display p {\n    font-size: 0.85rem;\n    font-weight: 500;\n  }\n\n  .rate-buttons {\n    flex-direction: row;\n    gap: 0.25rem;\n    width: 100%;\n    justify-content: center;\n    align-items: center;\n    flex-wrap: wrap;\n  }\n\n  .edit-rate-button-dashboard,\n  .bulk-rate-button {\n    flex: none;\n    justify-content: center;\n    padding: 0.3rem 0.5rem;\n    font-size: 0.65rem;\n    font-weight: 600;\n    min-height: 28px;\n    border-radius: 5px;\n    transition: all 0.2s ease;\n    min-width: auto;\n    width: auto;\n    display: inline-flex;\n    align-items: center;\n    gap: 0.2rem;\n    white-space: nowrap;\n  }\n\n  .edit-rate-button-dashboard {\n    background-color: white;\n    border: 1px solid var(--primary);\n    color: var(--primary);\n    padding: 0.25rem 0.45rem;\n    font-size: 0.62rem;\n  }\n\n  .edit-rate-button-dashboard:hover {\n    background-color: var(--primary);\n    color: black;\n    transform: translateY(-1px);\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  }\n\n  .bulk-rate-button {\n    padding: 0.35rem 0.6rem;\n    font-size: 0.68rem;\n    background: linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%);\n    color: white;\n    border: none;\n    border-radius: 5px;\n    box-shadow: 0 2px 6px rgba(79, 70, 229, 0.2);\n    animation: bulkButtonPulse 2s infinite;\n  }\n\n  .bulk-rate-button:hover {\n    background: linear-gradient(135deg, #4338ca 0%, #6d28d9 100%);\n    transform: translateY(-2px);\n    box-shadow: 0 4px 12px rgba(79, 70, 229, 0.3);\n  }\n\n  @keyframes bulkButtonPulse {\n    0% {\n      box-shadow: 0 2px 6px rgba(79, 70, 229, 0.2);\n    }\n\n    50% {\n      box-shadow: 0 2px 10px rgba(79, 70, 229, 0.4);\n    }\n\n    100% {\n      box-shadow: 0 2px 6px rgba(79, 70, 229, 0.2);\n    }\n  }\n\n  /* Very small screens responsive design */\n  @media (max-width: 380px) {\n    .rate-buttons {\n      flex-direction: column;\n      gap: 0.4rem;\n      align-items: center;\n    }\n\n    .edit-rate-button-dashboard,\n    .bulk-rate-button {\n      width: auto;\n      padding: 0.35rem 0.6rem;\n      font-size: 0.68rem;\n      min-height: 32px;\n      max-width: 180px;\n      display: inline-flex;\n      align-items: center;\n      gap: 0.2rem;\n      white-space: nowrap;\n    }\n\n    .bulk-rate-button {\n      font-size: 0.73rem;\n      padding: 0.45rem 0.75rem;\n      max-width: 200px;\n    }\n  }\n\n  .rate-type-control {\n    flex-direction: column;\n    gap: 0.6rem;\n    align-items: stretch;\n  }\n\n  .rate-type-left {\n    width: 100%;\n    justify-content: space-between;\n  }\n\n  /* \n  .rate-type-label {\n    font-size: 0.85rem;\n    font-weight: 600;\n  } */\n\n  .rate-type-select {\n    flex: 1;\n    min-width: auto;\n    max-width: 150px;\n    padding: 0.4rem 0.6rem;\n    font-size: 0.85rem;\n  }\n\n  .rate-type-controls {\n    width: 100%;\n    justify-content: center;\n  }\n\n  .submit-rate-type-button {\n    width: auto;\n    max-width: 150px;\n    justify-content: center;\n    padding: 0.5rem 0.8rem;\n    font-size: 0.8rem;\n    font-weight: 600;\n  }\n\n  .rate-edit-container {\n    gap: 0.6rem;\n  }\n\n  .rate-edit {\n    gap: 0.5rem;\n  }\n\n  .rate-edit label {\n    font-size: 0.85rem;\n    font-weight: 600;\n  }\n\n  .rate-input {\n    padding: 0.4rem 0.6rem;\n    font-size: 0.85rem;\n    min-width: 80px;\n  }\n}\n\n/* Dairy Info Container */\n.dairy-info-container-dashboard {\n  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);\n  border-radius: 12px;\n  padding: 1.5rem;\n  border: 1px solid var(--gray-200);\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.06);\n  transition: all 0.3s ease;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.dairy-info-container-dashboard:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);\n}\n\n.dairy-info-content {\n  display: flex;\n  flex-direction: column;\n  gap: 0.8rem;\n  width: 100%;\n  justify-content: center;\n  align-items: center;\n}\n\n.info-item {\n  display: flex;\n  align-items: center;\n  gap: 0.8rem;\n  padding: 1rem 1.2rem;\n  background: linear-gradient(135deg, var(--gray-50) 0%, white 100%);\n  border-radius: 8px;\n  border: 1px solid var(--gray-200);\n  transition: all 0.3s ease;\n  justify-content: center;\n  width: 100%;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);\n}\n\n.info-item:hover {\n  background: linear-gradient(135deg, white 0%, var(--gray-50) 100%);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\n  transform: translateY(-1px);\n}\n\n.info-icon {\n  color: var(--primary);\n  font-size: 1.2rem;\n  flex-shrink: 0;\n}\n\n.info-label {\n  font-weight: 600;\n  color: var(--gray-700);\n  font-size: 0.75rem;\n  flex-shrink: 0;\n  text-align: left;\n}\n\n.info-value {\n  color: var(--gray-800);\n  font-weight: 500;\n  font-size: 0.8rem;\n  flex: 1;\n  text-align: left;\n}\n\n.add-money-btn {\n  background-color: var(--success);\n  color: white;\n  border: none;\n  padding: 0.2rem 0.6rem;\n  border-radius: 3px;\n  font-size: 0.7rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n.add-money-btn:hover {\n  background-color: #16a34a;\n}\n\n/* Hide owner info by default, show only at 768px */\n.owner-info-768 {\n  display: none;\n}\n\n.rate-info-container {\n  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);\n  border-radius: 12px;\n  padding: 1.5rem;\n  border: 1px solid var(--gray-200);\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.06);\n  transition: all 0.3s ease;\n}\n\n.rate-info-container:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);\n}\n\n.rate-info-content {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  align-items: stretch;\n}\n\n.rate-section {\n  flex: 1;\n  background: linear-gradient(135deg, var(--gray-50) 0%, white 100%);\n  border: 1px solid var(--gray-200);\n  border-radius: 8px;\n  padding: 1rem;\n  min-height: auto;\n  display: flex;\n  align-items: center;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);\n  transition: all 0.3s ease;\n}\n\n.rate-section:hover {\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\n}\n\n.rate-display,\n.rate-type-display {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 0.5rem;\n  width: 100%;\n}\n\n.rate-buttons {\n  display: flex;\n  gap: 0.3rem;\n  align-items: center;\n}\n\n.rate-display p,\n.rate-type-display p {\n  font-size: 0.75rem;\n  margin: 0;\n}\n\n.rate-edit-container {\n  display: flex;\n  flex-direction: column;\n  gap: 0.3rem;\n  width: 100%;\n}\n\n.rate-edit {\n  display: flex;\n  align-items: center;\n  gap: 0.3rem;\n  flex-wrap: wrap;\n}\n\n.rate-edit label {\n  font-size: 0.75rem;\n  font-weight: 500;\n  color: var(--gray-700);\n  white-space: nowrap;\n}\n\n.rate-input {\n  padding: 0.2rem 0.4rem;\n  font-size: 0.75rem;\n  border: 1px solid var(--gray-300);\n  border-radius: 3px;\n  min-width: 70px;\n}\n\n.rate-type-control {\n  display: flex;\n  align-items: center;\n  gap: 0.3rem;\n  width: 100%;\n  flex-wrap: wrap;\n  justify-content: space-between;\n}\n\n.rate-type-label {\n  font-size: 1rem;\n  font-weight: 600;\n  color: var(--gray-700);\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  white-space: nowrap;\n}\n\n.rate-type-icon {\n  font-size: 0.8rem;\n  color: var(--primary);\n  opacity: 0.8;\n}\n\n.rate-type-left {\n  display: flex;\n  align-items: center;\n  gap: 0.3rem;\n}\n\n.rate-type-select {\n  padding: 0.2rem 0.4rem;\n  font-size: 0.75rem;\n  border: 1px solid var(--gray-300);\n  border-radius: 3px;\n  min-width: 90px;\n}\n\n.rate-type-controls {\n  display: flex;\n  align-items: center;\n  gap: 0.3rem;\n}\n\n.edit-rate-button-dashboard,\n.bulk-rate-button,\n.save-rate-button,\n.submit-rate-type-button {\n  padding: 0.35rem 0.75rem;\n  font-size: 0.75rem;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.3rem;\n  text-decoration: none;\n  min-width: auto;\n  width: auto;\n}\n\n.edit-rate-button-dashboard {\n  background-color: var(--primary);\n  border: 2px solid var(--primary);\n  color: white;\n  padding: 0.5rem 1rem;\n  font-size: 0.75rem;\n  font-weight: 600;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.3rem;\n  white-space: nowrap;\n  box-shadow: 0 2px 8px rgba(59, 130, 246, 0.1);\n  height: fit-content;\n  min-width: auto;\n}\n\n.edit-rate-button-dashboard:hover {\n  background-color: var(--primary-dark);\n  color: white;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.2);\n}\n\n.edit-rate-button-dashboard:active {\n  transform: translateY(0);\n  box-shadow: 0 2px 4px rgba(59, 130, 246, 0.1);\n}\n\n.save-rate-button-dashboard {\n  background: linear-gradient(135deg, #10b981 0%, #059669 100%);\n  border: none;\n  color: white;\n  padding: 0.15rem 0.4rem;\n  border-radius: 4px;\n  font-size: 0.90rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.2rem;\n  white-space: nowrap;\n  min-width: auto;\n  width: 50%;\n  box-shadow: 0 1px 4px rgba(16, 185, 129, 0.2);\n}\n\n.save-rate-button-dashboard:hover:not(:disabled) {\n  background: linear-gradient(135deg, #059669 0%, #047857 100%);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);\n}\n\n.save-rate-button-dashboard:disabled {\n  background: linear-gradient(135deg, #e5e7eb 0%, #d1d5db 100%);\n  color: #9ca3af;\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.cancel-rate-button-dashboard {\n  padding: 0.15rem 0.4rem;\n  background: linear-gradient(135deg, #ffffff 0%, #f8f9ff 100%);\n  border: 1px solid #e5e7eb;\n  color: #6b7280;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-weight: 600;\n  font-size: 0.90rem;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.2rem;\n  white-space: nowrap;\n  width: 50%;\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);\n}\n\n.cancel-rate-button-dashboard:hover:not(:disabled) {\n  background: linear-gradient(135deg, #f3f4f6 0%, #e5e7eb 100%);\n  border-color: #d1d5db;\n  color: #374151;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n}\n\n.cancel-rate-button-dashboard:disabled {\n  background: #f9fafb;\n  border-color: #e5e7eb;\n  color: #9ca3af;\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\n}\n\n.bulk-rate-button {\n  background: linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%);\n  color: white;\n  border: none;\n  padding: 0.6rem 1.2rem;\n  font-size: 0.85rem;\n  font-weight: 700;\n  border-radius: 8px;\n  box-shadow: 0 4px 12px rgba(79, 70, 229, 0.3);\n  animation: bulkButtonPulse 2s infinite;\n}\n\n.bulk-rate-button:hover {\n  background: linear-gradient(135deg, #4338ca 0%, #6d28d9 100%);\n  transform: translateY(-3px);\n  box-shadow: 0 6px 16px rgba(79, 70, 229, 0.4);\n}\n\n@keyframes bulkButtonPulse {\n  0% {\n    box-shadow: 0 2px 6px rgba(79, 70, 229, 0.2);\n  }\n\n  50% {\n    box-shadow: 0 2px 10px rgba(79, 70, 229, 0.4);\n  }\n\n  100% {\n    box-shadow: 0 2px 6px rgba(79, 70, 229, 0.2);\n  }\n}\n\n.save-rate-button,\n.submit-rate-type-button {\n  background: linear-gradient(135deg, var(--success) 0%, #059669 100%);\n  border: none;\n  color: white;\n  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);\n}\n\n.save-rate-button:hover,\n.submit-rate-type-button:hover {\n  background: linear-gradient(135deg, #059669 0%, #047857 100%);\n  transform: translateY(-2px);\n  box-shadow: 0 6px 16px rgba(16, 185, 129, 0.4);\n}\n\n.save-rate-button:disabled,\n.submit-rate-type-button:disabled {\n  background: var(--gray-200);\n  color: var(--gray-500);\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: none;\n}\n\n.add-money-btn {\n  background: linear-gradient(135deg, var(--success) 0%, #059669 100%);\n  color: white;\n  border: none;\n  padding: 0.5rem 1rem;\n  border-radius: 6px;\n  font-size: 0.8rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  white-space: nowrap;\n  flex-shrink: 0;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.3rem;\n  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);\n}\n\n.add-money-btn:hover {\n  background: linear-gradient(135deg, #059669 0%, #047857 100%);\n  transform: translateY(-2px);\n  box-shadow: 0 6px 16px rgba(16, 185, 129, 0.4);\n}\n\n.submit-rate-type-button:not(:disabled) {\n  background-color: var(--success);\n  border: 1px solid var(--success);\n  animation: pulse 2s infinite;\n}\n\n@keyframes pulse {\n  0% {\n    box-shadow: 0 0 0 0 rgba(34, 197, 94, 0.4);\n  }\n\n  70% {\n    box-shadow: 0 0 0 6px rgba(34, 197, 94, 0);\n  }\n\n  100% {\n    box-shadow: 0 0 0 0 rgba(34, 197, 94, 0);\n  }\n}\n\n.rate-info-container {\n  padding: 2rem;\n  margin-bottom: 1rem;\n  /* border: solid 2px red; */\n}\n\n@media (max-width: 768px) {\n  .rate-info-container {\n    padding: 1rem;\n    margin-bottom: 1rem;\n    /* border: solid 2px red; */\n  }\n\n  .rate-info-content {\n    flex-direction: column;\n    gap: 0.75rem;\n  }\n\n  .rate-section,\n  .rate-type-section {\n    padding: 0.6rem;\n    min-height: auto;\n  }\n\n  .rate-display p,\n  .rate-type-display p {\n    font-size: 0.85rem;\n  }\n\n  .rate-edit-container {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .rate-edit,\n  .rate-type-control {\n    flex-direction: column;\n    align-items: stretch;\n    min-width: 100%;\n  }\n\n  .rate-input {\n    width: 100%;\n    padding: 0.4rem;\n    font-size: 0.9rem;\n  }\n\n  .rate-edit-container .bulk-rate-button {\n    width: 100%;\n    justify-content: center;\n    padding: 0.4rem 0.6rem;\n    font-size: 0.8rem;\n  }\n\n  .rate-type-select {\n    width: 100%;\n    padding: 0.35rem 0.6rem;\n    font-size: 0.85rem;\n  }\n\n  .submit-rate-type-button {\n    width: auto;\n    max-width: 150px;\n    justify-content: center;\n    padding: 0.35rem 0.6rem;\n    font-size: 0.8rem;\n  }\n\n  .rate-display,\n  .rate-type-display {\n    flex-direction: column;\n    text-align: center;\n    gap: 0.5rem;\n  }\n\n  .rate-buttons-group {\n    flex-direction: column;\n    width: 100%;\n    gap: 0.5rem;\n  }\n\n  .edit-rate-button-dashboard,\n  .bulk-rate-button,\n  .save-rate-button {\n    width: auto;\n    max-width: 150px;\n    justify-content: center;\n    padding: 0.4rem 0.6rem;\n    font-size: 0.8rem;\n    white-space: nowrap;\n  }\n\n  .save-rate-button-dashboard,\n  .cancel-rate-button-dashboard {\n    width: auto;\n    font-size: 0.8rem;\n  }\n}\n\n/* Footer */\n.dashboard-footer {\n  text-align: center;\n  padding: 2rem;\n  margin-top: auto;\n  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);\n  border-top: 1px solid var(--gray-200);\n  box-shadow: 0 -4px 16px rgba(0, 0, 0, 0.04);\n}\n\n.dashboard-footer p {\n  margin: 0;\n  color: var(--gray-700);\n  font-size: 0.9rem;\n  font-weight: 500;\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .dashboard-footer {\n    padding: 1rem;\n  }\n\n  /* Make preview table more compact on tablets/phones */\n  .preview-table {\n    min-width: 800px;\n    font-size: 12px;\n  }\n\n  .preview-table th,\n  .preview-table td {\n    padding: 6px 8px;\n  }\n}\n\n.razorpay-section {\n  background: white;\n  border-radius: 8px;\n  padding: 1.5rem 2rem 1.25rem 2rem;\n  border: 1px solid var(--gray-200);\n  margin-top: 2rem;\n  margin-bottom: 2rem;\n  width: 100%;\n  max-width: 100%;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  gap: 0.7rem;\n}\n\n.dashboard-centered-card {\n  margin: 0 auto 2.5rem auto;\n  max-width: 540px;\n  background: #fff;\n  border-radius: 12px;\n  box-shadow: 0 2px 14px 0 rgba(41, 67, 161, 0.08);\n  border: 1px solid var(--gray-200);\n  padding: 2rem 2.2rem 1.7rem 2.2rem;\n  display: flex;\n  flex-direction: column;\n  gap: 1.1rem;\n  z-index: 1;\n}\n\n.razorpay-section-label {\n  display: flex;\n  align-items: center;\n  gap: 0.95rem;\n  font-size: 1.22rem;\n  font-weight: 700;\n  color: var(--gray-800);\n  margin-bottom: 4px;\n  letter-spacing: 0.01em;\n}\n\n.razorpay-icon-bg {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--primary);\n  color: #fff;\n  border-radius: 50%;\n  font-size: 1.31rem;\n  width: 2.4rem;\n  height: 2.4rem;\n}\n\n.add-funds-desc {\n  color: var(--gray-700);\n  margin-bottom: 0.2rem;\n  font-size: 1rem;\n  opacity: 0.8;\n}\n\n.add-funds-form-row {\n  display: flex;\n  gap: 1.33rem;\n  align-items: flex-end;\n  margin-top: 4px;\n}\n\n.add-funds-input {\n  width: 180px;\n  padding: 0.9rem 1.1rem;\n  font-size: 1.17rem;\n  border-radius: 7px;\n  background: var(--gray-100);\n  border: 1.5px solid var(--gray-200);\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 10, 0.05);\n  outline: none;\n  transition: border 0.19s, box-shadow 0.19s;\n}\n\n.add-funds-input.input-error {\n  border-color: var(--danger);\n}\n\n.add-funds-input:focus {\n  border-color: var(--primary);\n  background: #fff;\n  box-shadow: 0 0 0 2px var(--primary-light);\n}\n\n.add-funds-button {\n  padding: 0.9rem 2.2rem;\n  font-size: 1.17rem;\n  border-radius: 7px;\n  font-weight: 600;\n  box-shadow: 0 1.5px 4.5px 0 rgba(41, 67, 161, 0.10);\n}\n\n.add-funds-feedback-error {\n  color: var(--danger);\n  font-size: 14.5px;\n  margin-top: 5px;\n  animation: fadeIn 0.2s ease-in;\n}\n\n.add-funds-feedback-success {\n  color: var(--success);\n  font-size: 15px;\n  margin-top: 7px;\n  animation: fadeIn 0.2s ease-in;\n}\n\n@keyframes fadeIn {\n  0% {\n    opacity: 0;\n    transform: translateY(5px);\n  }\n\n  100% {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@media (max-width: 768px) {\n  .dashboard-centered-card {\n    padding: 1rem;\n    margin-bottom: 1.5rem;\n  }\n\n  .razorpay-section {\n    padding: 1rem;\n    margin-top: 1rem;\n    margin-bottom: 1rem;\n    gap: 0.6rem;\n  }\n\n  .razorpay-section-label {\n    font-size: 1rem;\n    gap: 0.7rem;\n    margin-bottom: 2px;\n  }\n\n  .razorpay-icon-bg {\n    width: 2rem;\n    height: 2rem;\n    font-size: 1.1rem;\n  }\n\n  .add-funds-desc {\n    font-size: 0.85rem;\n    margin-bottom: 0.15rem;\n  }\n\n  .add-funds-form-row {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 0.75rem;\n    margin-top: 3px;\n  }\n\n  .add-funds-input,\n  .add-funds-button {\n    width: 100%;\n    font-size: 0.95rem;\n    min-width: 0;\n    padding: 0.75rem 0.9rem;\n  }\n\n  .add-funds-feedback-error,\n  .add-funds-feedback-success {\n    font-size: 0.8rem;\n    margin-top: 4px;\n  }\n}\n\n/* Action button styling for Change Milk Rate */\n.action-button {\n  cursor: pointer;\n  border: none;\n  font-family: inherit;\n  font-size: inherit;\n  border: 1px solid var(--gray-200);\n}\n\n/* Modal Styles - REMOVED CONFLICTING OVERLAY */\n\n.modal-content {\n  background-color: white;\n  border-radius: 8px;\n  padding: 0;\n  max-width: 90vw;\n  max-height: 95vh;\n  overflow-y: auto;\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);\n\n  display: flex;\n  flex-direction: column;\n}\n\n.date-filter-modal {\n  width: 500px;\n}\n\n.preview-modal {\n  width: 95%;\n  max-width: 1400px;\n  max-height: 95vh;\n  display: flex;\n  flex-direction: column;\n}\n\n.preview-modal .modal-body {\n  flex: 1;\n  overflow-y: auto;\n  padding: 1rem;\n  min-height: 0;\n}\n\n.preview-modal .modal-header {\n  flex-shrink: 0;\n}\n\n.preview-modal .modal-footer {\n  flex-shrink: 0;\n  border-top: 1px solid var(--gray-200);\n  background-color: white;\n  position: sticky;\n  bottom: 0;\n}\n\n\n.modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1.5rem;\n  border-bottom: 1px solid var(--gray-200);\n}\n\n.modal-header h2 {\n  margin: 0;\n  color: var(--gray-800);\n  font-size: 1.25rem;\n}\n\n.modal-close-button,\n.close-modal-button {\n  background: none;\n  border: none;\n  font-size: 1.25rem;\n  color: var(--gray-700);\n  cursor: pointer;\n  padding: 0.5rem;\n  border-radius: 4px;\n  transition: background-color 0.2s;\n}\n\n.modal-close-button:hover,\n.close-modal-button:hover {\n  background-color: var(--gray-100);\n}\n\n.date-filter-container {\n  padding: 1.5rem;\n}\n\n.date-input-group {\n  margin-bottom: 1rem;\n}\n\n.date-input-group label {\n  display: block;\n  margin-bottom: 0.5rem;\n  font-weight: 500;\n  color: var(--gray-700);\n}\n\n.date-input {\n  width: 100%;\n  padding: 0.75rem;\n  border: 1px solid var(--gray-200);\n  border-radius: 4px;\n  font-size: 1rem;\n}\n\n.date-filter-actions {\n  display: flex;\n  gap: 1rem;\n  justify-content: flex-end;\n  margin-top: 1.5rem;\n}\n\n.date-filter-button {\n  padding: 0.75rem 1.5rem;\n  border-radius: 4px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.date-filter-button.secondary {\n  background-color: white;\n  border: 1px solid var(--gray-200);\n  color: var(--gray-700);\n}\n\n.date-filter-button.secondary:hover {\n  background-color: var(--gray-50);\n}\n\n.date-filter-button.primary {\n  background-color: var(--primary);\n  border: none;\n  color: white;\n}\n\n.date-filter-button.primary:hover {\n  background-color: var(--primary-dark);\n}\n\n.modal-body {\n  padding: 1.5rem;\n  flex: 1;\n  overflow-y: auto;\n  min-height: 0;\n}\n\n.modal-footer {\n  display: flex;\n  gap: 1rem;\n  justify-content: flex-end;\n  padding: 1.5rem;\n  border-top: 1px solid var(--gray-200);\n}\n\n.cancel-button {\n  padding: 0.35rem 0.75rem;\n  background: linear-gradient(135deg, #ffffff 0%, #f8f9ff 100%);\n  border: 2px solid #e5e7eb;\n  color: #6b7280;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-weight: 600;\n  font-size: 0.75rem;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n}\n\n.cancel-button:hover {\n  background: linear-gradient(135deg, #f3f4f6 0%, #e5e7eb 100%);\n  border-color: #d1d5db;\n  color: #374151;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n}\n\n.confirm-button {\n  padding: 0.75rem 1.5rem;\n  background-color: var(--primary);\n  border: none;\n  color: white;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: all 0.2s;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.confirm-button:hover {\n  background-color: var(--primary-dark);\n}\n\n.confirm-button:disabled {\n  background-color: var(--gray-200);\n  cursor: not-allowed;\n}\n\n/* Collections Display Styles */\n.collections-display-section {\n  background-color: white;\n  border-radius: 8px;\n  padding: 1.5rem;\n  margin-bottom: 2rem;\n  border: 1px solid var(--gray-200);\n}\n\n.collections-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1rem;\n}\n\n.collections-header h3 {\n  margin: 0;\n  color: var(--gray-800);\n}\n\n.close-collections-button {\n  background: none;\n  border: none;\n  font-size: 1.25rem;\n  color: var(--gray-700);\n  cursor: pointer;\n  padding: 0.5rem;\n  border-radius: 4px;\n  transition: background-color 0.2s;\n}\n\n.close-collections-button:hover {\n  background-color: var(--gray-100);\n}\n\n.collections-table-container {\n  overflow-x: auto;\n}\n\n.collections-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.875rem;\n}\n\n.collections-table th,\n.collections-table td {\n  padding: 0.75rem;\n  text-align: left;\n  border-bottom: 1px solid var(--gray-200);\n}\n\n.collections-table th {\n  background-color: var(--gray-50);\n  font-weight: 600;\n  color: var(--gray-700);\n}\n\n.collections-table tbody tr:hover {\n  background-color: var(--gray-50);\n}\n\n.customer-name-cell {\n  min-width: 200px;\n}\n\n/* Preview table styles */\n.preview-table-container {\n  overflow-x: auto;\n  margin: 1rem 0;\n}\n\n.preview-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 13px;\n  min-width: 1000px;\n  /* keep columns readable; allow horizontal scroll when needed */\n}\n\n.preview-table th {\n  padding: 8px 10px;\n  text-align: left;\n  background-color: #f5f5f5;\n  font-weight: 600;\n  color: #444;\n  border-bottom: 1px solid #e0e0e0;\n}\n\n.preview-table td {\n  padding: 8px 10px;\n  text-align: left;\n  border-bottom: 1px solid #e0e0e0;\n  white-space: nowrap;\n}\n\n.preview-table tbody tr:hover {\n  background-color: #f9f9f9;\n}\n\n.error-message {\n  color: var(--danger);\n  background-color: #fef2f2;\n  border: 1px solid #fecaca;\n  padding: 0.75rem;\n  border-radius: 4px;\n  margin: 1rem 0;\n}\n\n.edit-form-error {\n  color: var(--danger);\n  background-color: #fef2f2;\n  border: 1px solid #fecaca;\n  padding: 0.75rem;\n  border-radius: 4px;\n  margin-bottom: 15px;\n  font-weight: bold;\n}\n\n/* Responsive styles for modals */\n@media (max-width: 768px) {\n  /* Removed conflicting modal-overlay styles */\n\n  .modal-content {\n    margin: 0;\n    width: 95%;\n    max-width: 320px;\n    border-radius: 8px;\n  }\n\n  /* Mobile modal z-index fixes */\n  .modal-overlay {\n    z-index: 1001 !important;\n  }\n\n  .confirmation-modal-overlay {\n    z-index: 9999 !important;\n  }\n}\n\n/* Extra small mobile screens */\n@media (max-width: 480px) {\n\n  /* Extra small mobile modal z-index fixes */\n  .modal-overlay {\n    z-index: 1001 !important;\n  }\n\n  .confirmation-modal-overlay {\n    z-index: 9999 !important;\n  }\n}\n\n/* Universal modal z-index fix for all screen sizes */\n@media all {\n  .modal-overlay {\n    z-index: 1001 !important;\n  }\n\n  .confirmation-modal-overlay {\n    z-index: 9999 !important;\n  }\n}\n\n.collections-table {\n  font-size: 0.7rem;\n  min-width: 800px;\n  /* Ensure horizontal scroll for better readability */\n}\n\n.collections-table th,\n.collections-table td {\n  padding: 0.4rem 0.3rem;\n  white-space: nowrap;\n}\n\n.collections-table th {\n  font-size: 0.65rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.025em;\n}\n\n.date-filter-form {\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.date-filter-form .form-group {\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.date-filter-form .form-group label {\n  font-weight: 600;\n  font-size: 0.9rem;\n  color: var(--gray-700);\n}\n\n.date-filter-form input {\n  padding: 0.75rem;\n  font-size: 1rem;\n  border-radius: 6px;\n  border: 1px solid var(--gray-300);\n}\n\n.modal-footer {\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.modal-footer button {\n  width: 100%;\n  padding: 0.875rem;\n  font-size: 1rem;\n  font-weight: 600;\n}\n\n.milk-rate-input {\n  width: 100%;\n  max-width: 120px;\n  font-size: 1rem;\n  padding: 0.75rem;\n  text-align: center;\n  font-weight: 600;\n}\n\n.rate-settings {\n  margin: 0.5rem 0;\n  padding: 0.75rem;\n  background-color: var(--gray-50);\n  border-radius: 8px;\n  border: 1px solid var(--gray-200);\n}\n\n.rate-input-group {\n  flex-direction: row;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.rate-input-group label {\n  font-size: 1rem;\n  font-weight: 600;\n  color: var(--gray-800);\n}\n\n\n/* Collection Summary Styles */\n.preview-summary {\n  margin-top: 1rem;\n  border: 1px solid var(--gray-200);\n  border-radius: 6px;\n  overflow: hidden;\n  flex-shrink: 0;\n}\n\n/* Preview table container improvements */\n.preview-table-container {\n  overflow-x: auto;\n  margin: 1rem 0;\n  max-height: 80vh;\n  /* taller scrollable area so more rows are visible on desktop */\n  overflow-y: auto;\n  border: 1px solid var(--gray-200);\n  border-radius: 4px;\n  width: 100%;\n}\n\n/* Milk rate input styling */\n.milk-rate-input {\n  padding: 8px 12px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  width: 100px;\n  font-size: 1rem;\n}\n\n/* Preview header styling */\n.preview-header {\n  margin-bottom: 1rem;\n}\n\n.preview-header h3 {\n  margin-bottom: 8px;\n  color: var(--gray-800);\n}\n\n.collections-count {\n  margin-left: 10px;\n  font-size: 0.9em;\n  color: #666;\n}\n\n.rate-settings {\n  margin-top: 8px;\n  margin-bottom: 8px;\n}\n\n/* Compact the Milk Rate card inside the preview header */\n.preview-header .rate-settings {\n  margin: 6px 0;\n  padding: 6px 10px;\n}\n\n.preview-header .rate-input-group {\n  gap: 8px;\n  /* border: solid 2px red; */\n}\n\n.milk-rate-input {\n  padding: 6px 10px;\n  height: 34px;\n}\n\n.rate-input-group {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  /* border: solid 2px red; */\n}\n\n.rate-input-group label {\n  font-weight: bold;\n  color: var(--gray-700);\n  /* border: solid 2px red; */\n}\n\n.summary-card {\n  transition: all 0.2s ease;\n}\n\n.summary-card:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n/* Responsive styles for summary cards */\n@media (max-width: 768px) {\n  .preview-summary {\n    margin: 1rem 0;\n  }\n\n  .preview-summary [style*=\"grid-template-columns: repeat(4, 1fr)\"] {\n    grid-template-columns: repeat(2, 1fr) !important;\n    gap: 6px !important;\n  }\n\n  .summary-card {\n    padding: 6px 8px !important;\n  }\n\n  .summary-card div:first-child {\n    font-size: 10px !important;\n  }\n\n  .summary-card div:last-child {\n    font-size: 12px !important;\n  }\n\n  .rate-input {\n    padding: 6px 10px;\n    height: 34px;\n    margin: auto;\n    /* font-size: 25px; */\n  }\n\n  #rate-input-milk {\n    font-size: 15px;\n  }\n}\n\n/* Wallet Transaction History Styles */\n.transaction-history-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1rem;\n  padding-bottom: 0.5rem;\n  border-bottom: 1px solid var(--gray-200);\n}\n\n.transaction-history-header h3 {\n  margin: 0;\n  color: var(--gray-800);\n  font-size: 1.25rem;\n  display: flex;\n  align-items: center;\n}\n\n.toggle-transactions-button {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-size: 0.9rem;\n}\n\n.transaction-history-content {\n  margin-top: 1rem;\n}\n\n.transactions-table-container {\n  overflow-x: auto;\n  border-radius: 8px;\n  border: 1px solid var(--gray-200);\n}\n\n.transaction-type {\n  padding: 0.25rem 0.5rem;\n  border-radius: 4px;\n  font-size: 0.8rem;\n  font-weight: 500;\n  text-transform: uppercase;\n}\n\n.transaction-type.credit {\n  background-color: #dcfce7;\n  color: #166534;\n}\n\n.transaction-type.debit {\n  background-color: #fef2f2;\n  color: #991b1b;\n}\n\n.transaction-status {\n  padding: 0.25rem 0.5rem;\n  border-radius: 4px;\n  font-size: 0.8rem;\n  font-weight: 500;\n  text-transform: uppercase;\n}\n\n.transaction-status.success {\n  background-color: #dcfce7;\n  color: #166534;\n}\n\n.transaction-status.pending {\n  background-color: #fef3c7;\n  color: #92400e;\n}\n\n.transaction-status.failed {\n  background-color: #fef2f2;\n  color: #991b1b;\n}\n\n.credit-amount {\n  color: var(--success);\n  font-weight: 600;\n}\n\n.debit-amount {\n  color: var(--danger);\n  font-weight: 600;\n}\n\n.no-transactions {\n  text-align: center;\n  padding: 2rem;\n  color: var(--gray-700);\n}\n\n.no-transactions p {\n  margin: 0;\n  font-style: italic;\n}\n\n/* Payment Link Display Styles */\n.payment-link-container {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n  margin-top: 1rem;\n  padding: 1rem;\n  background-color: #f0f9ff;\n  border: 1px solid #0ea5e9;\n  border-radius: 8px;\n}\n\n.payment-link-header {\n  color: #0369a1;\n  font-size: 0.9rem;\n  margin-bottom: 0.25rem;\n  text-align: center;\n}\n\n.payment-link-button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0.75rem 1.5rem;\n  background-color: #0ea5e9;\n  color: white;\n  text-decoration: none;\n  border-radius: 6px;\n  font-weight: 600;\n  font-size: 1rem;\n  transition: all 0.2s ease;\n  border: none;\n  cursor: pointer;\n}\n\n.payment-link-button:hover {\n  background-color: #0284c7;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(14, 165, 233, 0.3);\n  color: white;\n  text-decoration: none;\n}\n\n.refresh-balance-button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0.5rem 1rem;\n  background-color: var(--success);\n  color: white;\n  border: none;\n  border-radius: 6px;\n  font-weight: 500;\n  font-size: 0.9rem;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.refresh-balance-button:hover {\n  background-color: #16a34a;\n  transform: translateY(-1px);\n  box-shadow: 0 2px 8px rgba(34, 197, 94, 0.3);\n}\n\n/* Responsive styles for payment link container */\n@media (max-width: 768px) {\n  .payment-link-container {\n    padding: 0.75rem;\n    gap: 0.75rem;\n    margin-top: 0.75rem;\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .payment-link-button {\n    padding: 0.625rem 1rem;\n    font-size: 0.9rem;\n    width: 100%;\n    text-align: center;\n  }\n\n  .payment-link-header {\n    font-size: 0.85rem;\n    text-align: center;\n  }\n}\n\n@media (max-width: 480px) {\n  .payment-link-container {\n    padding: 0.5rem;\n    gap: 0.5rem;\n    margin-top: 0.5rem;\n  }\n\n  .payment-link-button {\n    padding: 0.5rem 0.75rem;\n    font-size: 0.85rem;\n  }\n\n  .payment-link-button:hover {\n    transform: none;\n    /* Disable hover transform on mobile */\n  }\n\n  .payment-link-header {\n    font-size: 0.8rem;\n  }\n\n  /* Additional mobile improvements for milk rate modals - Removed conflicting modal-overlay */\n\n  .modal-content {\n    border-radius: 6px;\n  }\n\n  .date-filter-modal {\n    max-height: 90vh;\n  }\n\n  .preview-modal {\n    height: 98vh;\n    max-height: 98vh;\n  }\n\n  /* Further compact table for small phones */\n  .preview-table {\n    min-width: 680px;\n    font-size: 11px;\n  }\n\n  .preview-table th,\n  .preview-table td {\n    padding: 5px 6px;\n  }\n\n  .preview-modal .modal-header {\n    padding: 0.4rem;\n  }\n\n  .preview-modal .modal-header h2 {\n    font-size: 0.95rem;\n  }\n\n  .preview-modal .modal-body {\n    padding: 0.25rem;\n  }\n\n  .preview-modal .modal-footer {\n    padding: 0.4rem;\n  }\n\n  .collections-table {\n    font-size: 0.65rem;\n    min-width: 700px;\n  }\n\n  .collections-table th,\n  .collections-table td {\n    padding: 0.3rem 0.2rem;\n  }\n\n  .collections-table th {\n    font-size: 0.6rem;\n  }\n\n  .modal-footer button {\n    padding: 0.6rem;\n    font-size: 0.9rem;\n  }\n\n  .milk-rate-input {\n    max-width: 100px;\n    font-size: 0.9rem;\n    padding: 0.625rem;\n  }\n\n  .rate-settings {\n    margin: 0.5rem 0;\n    padding: 0.5rem;\n  }\n\n  .rate-input-group {\n    gap: 0.5rem;\n  }\n\n  .rate-input-group label {\n    font-size: 0.9rem;\n  }\n\n  .date-filter-form input {\n    padding: 0.625rem;\n    font-size: 0.9rem;\n  }\n}\n\n/* Add Money Button in Dairy Info Card */\n.add-money-btn {\n  margin-left: 12px;\n  padding: 6px 14px;\n  background-color: #1a73e8;\n  color: white;\n  border: none;\n  border-radius: 5px;\n  font-size: 0.8rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 2px 4px rgba(26, 115, 232, 0.2);\n  white-space: nowrap;\n  flex-shrink: 0;\n  text-align: center;\n  max-width: 110px;\n}\n\n.add-money-btn:hover {\n  background-color: #1557b0;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 8px rgba(26, 115, 232, 0.3);\n}\n\n.add-money-btn:active {\n  transform: translateY(0);\n}\n\n/* Modal Overlay - Perfect Centering */\n.modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 9999;\n  padding: 0;\n  overflow: hidden;\n  min-height: 100vh;\n  width: 100vw;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n\n  to {\n    opacity: 1;\n  }\n}\n\n/* Modal Content */\n.modal-content {\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);\n  border: 1px solid #e5e7eb;\n  max-width: 500px;\n  width: 90%;\n  max-height: 90vh;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  animation: slideUp 0.3s ease-out;\n}\n\n/* Ensure wider layout for the milk rate preview modal card */\n.modal-content.preview-modal {\n  width: 95%;\n  max-width: 1400px;\n  max-height: 95vh;\n}\n\n@keyframes slideUp {\n  from {\n    opacity: 0;\n    transform: translateY(30px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.add-money-modal {\n  max-width: 450px;\n  background: white;\n  border-radius: 16px;\n  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);\n  overflow: hidden;\n  width: 95%;\n}\n\n/* Offers Modal */\n.offers-modal {\n  max-width: 400px;\n  background: white;\n  border-radius: 16px;\n  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);\n  overflow: hidden;\n  width: 95%;\n}\n\n.offers-modal-header {\n  padding: 1.5rem;\n  border-bottom: 1px solid #f3f4f6;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  background: white;\n}\n\n.offers-modal-title-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  flex: 1;\n}\n\n.offers-modal-icon-wrapper {\n  width: 48px;\n  height: 48px;\n  background: linear-gradient(135deg, #ff6b35, #f7931e);\n  border-radius: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 0.75rem;\n}\n\n.offers-modal-icon {\n  color: white;\n  font-size: 1.5rem;\n}\n\n.offers-modal-header h3 {\n  margin: 0;\n  font-size: 1.25rem;\n  color: #111827;\n  font-weight: 700;\n}\n\n.offers-modal-subtitle {\n  margin: 0.25rem 0 0 0;\n  font-size: 0.875rem;\n  color: #6b7280;\n  font-weight: 500;\n}\n\n.offers-modal-close-btn {\n  background: none;\n  border: none;\n  font-size: 1.5rem;\n  color: #6b7280;\n  cursor: pointer;\n  padding: 0.25rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 4px;\n  transition: all 0.2s;\n}\n\n.offers-modal-close-btn:hover {\n  background-color: #f3f4f6;\n  color: #1f2937;\n}\n\n.offers-modal-body {\n  padding: 1.5rem;\n  background-color: #ffffff;\n}\n\n.offers-list {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.offer-item {\n  position: relative;\n  padding: 1.25rem;\n  border: 2px solid #e5e7eb;\n  border-radius: 16px;\n  transition: all 0.2s;\n}\n\n.offer-item.starter-bonus {\n  background-color: #f8fafc;\n  border-color: #3b82f6;\n}\n\n.offer-item.premium-bonus {\n  background-color: #fef3c7;\n  border-color: #f59e0b;\n}\n\n.offer-item:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n}\n\n.best-value-tag {\n  position: absolute;\n  top: -8px;\n  right: 12px;\n  background: linear-gradient(135deg, #dc2626, #ef4444);\n  color: white;\n  font-size: 0.75rem;\n  font-weight: 700;\n  padding: 0.25rem 0.75rem;\n  border-radius: 12px;\n  box-shadow: 0 2px 4px rgba(220, 38, 38, 0.3);\n}\n\n.offer-header {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  margin-bottom: 1rem;\n}\n\n.offer-badge {\n  background: linear-gradient(135deg, #10b981, #059669);\n  color: white;\n  font-size: 0.875rem;\n  font-weight: 600;\n  padding: 0.375rem 0.75rem;\n  border-radius: 20px;\n  display: flex;\n  align-items: center;\n  gap: 0.375rem;\n  box-shadow: 0 2px 4px rgba(16, 185, 129, 0.3);\n}\n\n.offer-header h4 {\n  margin: 0;\n  font-size: 1.125rem;\n  font-weight: 700;\n  color: #111827;\n}\n\n.offer-details p {\n  margin: 0 0 0.5rem 0;\n  font-size: 0.875rem;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.offer-details p:last-child {\n  margin-bottom: 0;\n}\n\n.offer-range {\n  color: #374151;\n  font-weight: 600;\n}\n\n.offer-bonus {\n  color: #059669;\n  font-weight: 600;\n}\n\n.offer-example {\n  color: #6b7280;\n  font-size: 0.8rem;\n  font-style: italic;\n}\n\n/* Modal Header */\n.modal-header {\n  padding: 1.5rem;\n  border-bottom: 1px solid #f3f4f6;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  background: white;\n}\n\n.modal-header h3 {\n  margin: 0;\n  font-size: 1.25rem;\n  color: #111827;\n  font-weight: 700;\n}\n\n.modal-header-actions {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.offers-btn {\n  background: #ff7e00;\n  border: 1px solid #ff7e00;\n  border-radius: 8px;\n  padding: 0.5rem 1rem;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  color: #ffffff;\n  font-size: 0.875rem;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.offers-btn:hover {\n  background-color: #e67200;\n  border-color: #e67200;\n}\n\n.modal-close-btn {\n  background: none;\n  border: none;\n  font-size: 1.5rem;\n  color: #6b7280;\n  cursor: pointer;\n  padding: 0.25rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 4px;\n  transition: all 0.2s;\n}\n\n.modal-close-btn:hover {\n  background-color: #f3f4f6;\n  color: #1f2937;\n}\n\n/* Modal Body */\n.modal-body {\n  padding: 1.5rem;\n  background-color: #ffffff;\n  display: flex;\n  flex-direction: column;\n  overflow-y: auto;\n  flex: 1;\n}\n\n.modal-body-money {\n  padding: 1rem 1.5rem;\n  background-color: #ffffff;\n  display: flex;\n  flex-direction: column;\n}\n\n.add-funds-desc {\n  color: #6b7280;\n  font-size: 0.95rem;\n  margin-bottom: 1.5rem;\n}\n\n.add-funds-form {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  width: 100%;\n}\n\n.info-message {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.5rem;\n  padding: 0.75rem 1rem;\n  background-color: #f0f9ff;\n  border-radius: 8px;\n  color: #0c4a6e;\n  font-size: 0.875rem;\n  font-weight: 500;\n  margin-bottom: 0.5rem;\n  width: 100%;\n  line-height: 1.4;\n}\n\n.info-icon {\n  color: #0284c7;\n  font-size: 1rem;\n  flex-shrink: 0;\n  margin-top: 2px;\n}\n\n.refresh-link {\n  color: #0284c7;\n  text-decoration: underline;\n  cursor: pointer;\n  font-weight: 600;\n  border: none;\n  background: none;\n  padding: 0;\n}\n\n.refresh-link:hover {\n  color: #0369a1;\n}\n\n.amount-input-container {\n  position: relative;\n  display: flex;\n  align-items: center;\n  margin: 1rem 0;\n  width: 100%;\n  max-width: 300px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.currency-symbol {\n  position: absolute;\n  left: 1rem;\n  font-size: 1.5rem;\n  color: #6b7280;\n  font-weight: 500;\n  z-index: 1;\n}\n\n.amount-input {\n  padding-left: 3rem !important;\n  font-size: 2rem !important;\n  font-weight: 600 !important;\n  height: 4rem !important;\n  border: 2px solid #e5e7eb !important;\n  border-radius: 12px !important;\n  background: white !important;\n}\n\n.amount-input:focus {\n  border-color: #667eea !important;\n  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1) !important;\n}\n\n.form-label {\n  font-weight: 600;\n  color: #374151;\n  font-size: 0.95rem;\n  margin-bottom: 0.5rem;\n  display: block;\n}\n\n.form-input {\n  width: 100%;\n  padding: 0.75rem;\n  border: 2px solid #e5e7eb;\n  border-radius: 8px;\n  font-size: 1rem;\n  transition: all 0.3s;\n  outline: none;\n}\n\n.form-input:focus {\n  border-color: #1a73e8;\n  box-shadow: 0 0 0 3px rgba(26, 115, 232, 0.1);\n}\n\n.form-input.input-error {\n  border-color: #ef4444;\n}\n\n/* Bonus Message */\n.bonus-message {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.75rem 1rem;\n  background-color: #d1fae5;\n  border: 1px solid #a7f3d0;\n  border-radius: 8px;\n  color: #065f46;\n  font-size: 0.875rem;\n  font-weight: 500;\n  margin-top: 0.75rem;\n  animation: slideDown 0.3s ease-out;\n}\n\n.bonus-message-new {\n  /* display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  padding: 0.5rem 1rem;\n  background-color: #dcfce7;\n  border: 1px solid #bbf7d0;\n  border-radius: 20px;\n  color: #166534;\n  font-size: 0.875rem;\n  font-weight: 500;\n  margin: 1rem auto 0;\n  animation: slideDown 0.3s ease-out; */\n  width: 100%;\n  color: #166534;\n\n  /* border: solid 2px red; */\n}\n\n@keyframes slideDown {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.bonus-icon {\n  font-size: 1.25rem;\n}\n\n/* Quick Recharge Section */\n.quick-recharge-section {\n  padding: 1.5rem;\n  background-color: #ffffff;\n  border-top: 1px solid #f3f4f6;\n}\n\n.quick-recharge-buttons {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 0.75rem;\n}\n\n.quick-amount-btn {\n  width: 100%;\n  padding: 0.875rem 0.5rem;\n  background-color: white;\n  color: #374151;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  font-size: 0.875rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  white-space: nowrap;\n}\n\n.quick-amount-btn:hover:not(:disabled) {\n  background-color: #f9fafb;\n  border-color: #d1d5db;\n}\n\n.quick-amount-btn:active:not(:disabled) {\n  transform: scale(0.98);\n}\n\n.quick-amount-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.quick-amount-highlight {\n  background-color: #10b981;\n  color: white;\n  border-color: #10b981;\n}\n\n.quick-amount-highlight:hover:not(:disabled) {\n  background-color: #059669;\n  border-color: #059669;\n}\n\n.quick-amount-selected {\n  background-color: #10b981;\n  color: white;\n  border-color: #10b981;\n}\n\n.quick-amount-selected:hover:not(:disabled) {\n  background-color: #059669;\n  border-color: #059669;\n}\n\n.feedback-error {\n  color: #ef4444;\n  font-size: 0.875rem;\n  margin-top: 0.5rem;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.feedback-success {\n  color: #22c55e;\n  font-size: 0.875rem;\n  margin-top: 0.5rem;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.payment-link-container {\n  margin-top: 1rem;\n  padding: 1rem;\n  background-color: #f0f7ff;\n  border-radius: 8px;\n  border: 1px solid #bfdbfe;\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.payment-link-header {\n  color: #1e40af;\n  font-size: 0.95rem;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n.payment-link-button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0.75rem 1.5rem;\n  background-color: #1a73e8;\n  color: white;\n  text-decoration: none;\n  border-radius: 8px;\n  font-weight: 600;\n  transition: all 0.3s;\n  flex: 1;\n}\n\n.payment-link-button:hover {\n  background-color: #1557b0;\n  transform: translateY(-1px);\n}\n\n\n/* Modal Footer */\n.modal-footer {\n  padding: 1.5rem;\n  border-top: 1px solid #f3f4f6;\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n  background-color: #ffffff;\n}\n\n.modal-btn {\n  padding: 1rem;\n  border-radius: 12px;\n  font-weight: 600;\n  font-size: 1rem;\n  cursor: pointer;\n  transition: all 0.3s;\n  border: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n}\n\n.modal-btn-primary {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  border: none;\n  padding: 1rem;\n  border-radius: 12px;\n  font-weight: 600;\n  font-size: 1rem;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.25);\n}\n\n.modal-btn-primary:hover:not(:disabled) {\n  background: linear-gradient(135deg, #5a67d8 0%, #6b46c1 100%);\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.35);\n}\n\n.modal-btn-primary:disabled {\n  background: linear-gradient(135deg, #e5e7eb 0%, #d1d5db 100%);\n  color: #9ca3af;\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.coupon-btn {\n  background: white !important;\n  color: #667eea !important;\n  border: 1px solid #667eea !important;\n  font-size: 0.875rem !important;\n  padding: 0.875rem 1rem !important;\n  border-radius: 12px !important;\n  box-shadow: none !important;\n}\n\n.coupon-btn:hover:not(:disabled) {\n  background: #f8faff !important;\n  border-color: #5a67d8 !important;\n  color: #5a67d8 !important;\n  transform: none !important;\n  box-shadow: none !important;\n}\n\n.modal-btn-secondary {\n  background: linear-gradient(135deg, #ffffff 0%, #f8f9ff 100%);\n  color: #6b7280;\n  border: 2px solid #e5e7eb;\n  padding: 0.75rem 1.5rem;\n  border-radius: 8px;\n  font-weight: 600;\n  font-size: 0.8rem;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n}\n\n.modal-btn-secondary:hover:not(:disabled) {\n  background: linear-gradient(135deg, #f3f4f6 0%, #e5e7eb 100%);\n  border-color: #d1d5db;\n  color: #374151;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n}\n\n.modal-btn-secondary:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* Responsive Modal */\n@media (max-width: 768px) {\n  .modal-content {\n    width: 95%;\n    max-height: 95vh;\n  }\n\n  .modal-header {\n    padding: 1rem;\n  }\n\n  .modal-body {\n    padding: 1rem;\n  }\n\n  .modal-footer {\n    padding: 0.75rem 1rem;\n    flex-direction: column-reverse;\n  }\n\n  .modal-btn {\n    width: 100%;\n  }\n\n  .add-money-btn {\n    font-size: 0.85rem;\n    padding: 8px 16px;\n    margin-left: 8px;\n    margin-top: 0;\n    min-width: 110px;\n  }\n\n  /* Quick recharge 2x2 grid on mobile */\n  .quick-recharge-buttons {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .quick-amount-btn {\n    font-size: 0.95rem;\n    padding: 0.625rem 0.75rem;\n  }\n\n  .info-message {\n    font-size: 10px !important;\n  }\n\n  .bonus-message-new {\n    font-size: 10px;\n  }\n}\n\n/* Mobile Responsive Styles for Add Money Modal */\n@media (max-width: 768px) {\n  .modal-overlay .add-money-modal {\n    margin: 10px;\n    max-height: 90vh;\n    overflow-y: auto;\n  }\n\n  .add-money-modal .modal-header {\n    padding: 12px 16px;\n  }\n\n  .add-money-modal .modal-header h3 {\n    font-size: 16px;\n  }\n\n  .add-money-modal .modal-header-actions {\n    gap: 8px;\n  }\n\n  .add-money-modal .offers-btn {\n    padding: 6px 10px;\n    font-size: 12px;\n  }\n\n  .add-money-modal .modal-close-btn {\n    width: 28px;\n    height: 28px;\n    font-size: 12px;\n  }\n\n  .wallet-balance-display {\n    padding: 8px 16px;\n    margin: 8px 0;\n  }\n\n  .current-balance-section {\n    gap: 8px;\n  }\n\n  .balance-label-payment {\n    font-size: 12px;\n  }\n\n  .balance-amount {\n    font-size: 14px;\n  }\n\n  .refresh-balance-btn-payment {\n    width: 24px;\n    height: 24px;\n    font-size: 10px;\n  }\n\n  .payment-feedback {\n    margin: 6px 16px;\n    padding: 8px 12px;\n    font-size: 12px;\n  }\n\n  .feedback-error {\n    margin: 6px 16px;\n    padding: 8px 12px;\n    font-size: 12px;\n  }\n\n  .modal-body-money {\n    padding: 8px 16px;\n  }\n\n  .add-funds-form {\n    gap: 12px;\n  }\n\n  .info-message {\n    padding: 8px 12px;\n    font-size: 11px !important;\n  }\n\n  .info-icon {\n    font-size: 12px;\n    margin-right: 6px;\n  }\n\n  .refresh-link {\n    font-size: 11px;\n  }\n\n  .amount-input-container {\n    margin: 8px 0;\n  }\n\n  .currency-symbol {\n    font-size: 16px;\n  }\n\n  .amount-input {\n    font-size: 16px;\n    padding: 8px 12px;\n  }\n\n  .bonus-message-new {\n    padding: 8px 12px;\n    margin: 8px 0;\n    font-size: 11px;\n  }\n\n  .bonus-icon {\n    font-size: 14px;\n    margin-right: 6px;\n  }\n\n  .quick-recharge-section {\n    padding: 8px 16px;\n    margin: 8px 0;\n  }\n\n  .quick-recharge-buttons {\n    gap: 8px;\n  }\n\n  .quick-amount-btn {\n    padding: 8px 12px;\n    font-size: 12px;\n    min-height: 36px;\n  }\n\n  .modal-footer {\n    padding: 12px 16px;\n    gap: 8px;\n  }\n\n  .modal-btn {\n    padding: 10px 16px;\n    font-size: 14px;\n    min-height: 40px;\n  }\n\n  .trouble-section {\n    margin-top: 8px;\n    padding-top: 8px;\n    flex-direction: column;\n    gap: 8px;\n    text-align: center;\n  }\n\n  .trouble-text {\n    font-size: 12px;\n  }\n\n  .contact-us-btn {\n    padding: 8px 16px;\n    font-size: 12px;\n    min-height: 36px;\n  }\n}\n\n/* Extra small screens - further optimization */\n@media (max-width: 480px) {\n  .modal-overlay .add-money-modal {\n    margin: 5px;\n    max-height: 95vh;\n  }\n\n  .add-money-modal .modal-header {\n    padding: 10px 12px;\n  }\n\n  .add-money-modal .modal-header h3 {\n    font-size: 14px;\n  }\n\n  .wallet-balance-display {\n    padding: 6px 12px;\n    margin: 6px 0;\n  }\n\n  .modal-body-money {\n    padding: 6px 12px;\n  }\n\n  .quick-recharge-section {\n    padding: 6px 12px;\n  }\n\n  .modal-footer {\n    padding: 10px 12px;\n  }\n\n  .quick-recharge-buttons {\n    gap: 6px;\n  }\n\n  .quick-amount-btn {\n    padding: 6px 8px;\n    font-size: 11px;\n    min-height: 32px;\n  }\n\n  .modal-btn {\n    padding: 8px 12px;\n    font-size: 13px;\n    min-height: 36px;\n  }\n}\n\n@media (max-width: 480px) {\n  .add-money-btn {\n    font-size: 0.8rem;\n    padding: 7px 14px;\n    margin-left: 6px;\n    min-width: 100px;\n  }\n}\n\n/* Extra small screens - optimize layout */\n@media (max-width: 480px) {\n  .combined-info-container-dashboard {\n    gap: 0.75rem;\n    margin-bottom: 1rem;\n  }\n\n  .dairy-info-container-dashboard,\n  .rate-info-container {\n    padding: 0.75rem;\n  }\n\n  .info-item {\n    padding: 0.5rem;\n    flex-direction: row;\n    align-items: flex-start;\n    /* gap: 0.5rem; */\n  }\n\n  .info-label {\n    font-size: 0.8rem;\n  }\n\n  .info-value {\n    font-size: 0.85rem;\n    width: 100%;\n  }\n\n  .add-money-btn {\n    width: 100%;\n    margin-top: 0.5rem;\n    font-size: 0.75rem;\n    padding: 0.4rem 0.6rem;\n  }\n\n  .rate-info-content {\n    gap: 0.5rem;\n  }\n\n  .rate-section,\n  .rate-type-section {\n    padding: 0.5rem;\n  }\n\n  .rate-display p,\n  .rate-type-display p {\n    font-size: 0.8rem;\n  }\n\n  .rate-input {\n    font-size: 0.85rem;\n    padding: 0.35rem;\n  }\n\n  .edit-rate-button-dashboard,\n  .bulk-rate-button,\n  .save-rate-button,\n  .submit-rate-type-button {\n    font-size: 0.75rem;\n    padding: 0.35rem 0.6rem;\n  }\n\n  .dashboard-header {\n    padding: 0;\n    min-height: 70px;\n  }\n\n  .logo-container {\n    width: 45px;\n    height: 45px;\n  }\n\n  .logo {\n    width: 38px;\n  }\n\n  .dashboard-header h1 {\n    font-size: 1rem;\n  }\n\n  .user-details {\n    padding: 0.5rem 0.6rem;\n  }\n\n  .user-name-phone,\n  .user-phone {\n    font-size: 0.8rem;\n  }\n\n  .user-name {\n    font-size: 0.85rem;\n  }\n}\n\n/* Very small screens - wrap button to new line */\n@media (max-width: 380px) {\n  .info-item {\n    flex-wrap: wrap;\n  }\n\n  .add-money-btn {\n    margin-left: 0;\n    margin-top: 8px;\n    width: 90%;\n    max-width: none;\n    font-size: 0.875rem;\n    font-weight: 600;\n  }\n}\n\n/* Bulk Rate Selector Modal - Perfect Mobile Centering */\n.bulk-rate-selector-modal {\n  width: 90vw;\n  max-width: 360px;\n  margin: auto;\n  background: linear-gradient(135deg, #fef3c7 0%, #fde68a 50%, #fef3c7 100%);\n  border-radius: 20px;\n  backdrop-filter: blur(20px);\n  position: relative;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  transform: none;\n  left: auto;\n  right: auto;\n  top: auto;\n  bottom: auto;\n  max-height: 90vh;\n}\n\n.bulk-rate-selector-modal::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 2px;\n  background: #0056b3;\n  opacity: 0.8;\n}\n\n.bulk-rate-selector-modal .bulk-modal-header {\n  padding: 28px 32px;\n  border-bottom: 1px solid rgba(245, 158, 11, 0.08);\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background: #0056b3;\n  border-radius: 18px 18px 0 0;\n  position: relative;\n  color: white;\n}\n\n.bulk-rate-selector-modal .bulk-modal-header::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: linear-gradient(135deg, rgba(255, 255, 255, 0.15) 0%, rgba(255, 255, 255, 0.05) 100%);\n  border-radius: 18px 18px 0 0;\n}\n\n.bulk-rate-selector-modal .bulk-modal-header .bulk-header-text {\n  margin: 0;\n  font-size: 22px;\n  font-weight: 800;\n  color: white;\n  letter-spacing: -0.6px;\n  position: relative;\n  z-index: 1;\n  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.bulk-rate-selector-modal .close-modal-button {\n  background: rgba(255, 255, 255, 0.25);\n  border: 2px solid rgba(255, 255, 255, 0.4);\n  font-size: 18px;\n  cursor: pointer;\n  color: white;\n  padding: 0;\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);\n  border-radius: 50%;\n  position: relative;\n  z-index: 1;\n  backdrop-filter: blur(10px);\n}\n\n.bulk-rate-selector-modal .close-modal-button:hover {\n  background: rgba(255, 255, 255, 0.35);\n  transform: scale(1.1);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n}\n\n.bulk-rate-selector-modal .modal-body {\n  padding: 32px;\n  background: linear-gradient(135deg, #fffbeb 0%, #ffffff 50%, #fffbeb 100%);\n  position: relative;\n}\n\n.collection-type-options {\n  display: flex;\n  flex-direction: row;\n  gap: 16px;\n  padding: 0 8px;\n}\n\n.collection-type-btn {\n  flex: 1;\n  padding: 24px 16px;\n  border: 2px solid rgba(102, 126, 234, 0.15);\n  border-radius: 16px;\n  background: linear-gradient(135deg, #ffffff 0%, #f8f9ff 100%);\n  cursor: pointer;\n  font-size: 16px;\n  font-weight: 700;\n  color: #2d3748;\n  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);\n  position: relative;\n  min-height: 80px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  white-space: normal;\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n  overflow: hidden;\n  box-shadow: 0 8px 25px rgba(102, 126, 234, 0.08),\n    inset 0 1px 0 rgba(255, 255, 255, 0.8);\n}\n\n.collection-type-btn::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(90deg, transparent, rgba(102, 126, 234, 0.1), transparent);\n  transition: left 0.4s ease;\n}\n\n.collection-type-btn:hover {\n  border-color: #667eea;\n  /* background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); */\n  background: #0056b3;\n  color: white;\n  transform: translateY(-3px);\n  box-shadow: 0 12px 24px rgba(102, 126, 234, 0.25);\n}\n\n.collection-type-btn:hover::before {\n  left: 100%;\n}\n\n.collection-type-btn:active {\n  transform: translateY(-1px);\n  box-shadow: 0 8px 16px rgba(102, 126, 234, 0.3);\n}\n\n@keyframes slideUp {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* ========================================\n   COMPREHENSIVE RESPONSIVE DESIGN\n   ======================================== */\n\n/* Extra Small Devices (320px - 480px) */\n@media (max-width: 480px) {\n  .dashboard-container {\n    padding: 0 0.5rem 0.5rem;\n  }\n\n  .dashboard-header {\n    flex-direction: column;\n    gap: 1rem;\n    padding: 0;\n  }\n\n  .header-center {\n    order: -1;\n    text-align: center;\n  }\n\n  .user-info {\n    flex-direction: column;\n    align-items: center;\n    gap: 0.5rem;\n  }\n\n  .premium-rate-cards {\n    grid-template-columns: 1fr;\n    gap: 1rem;\n  }\n\n  .premium-rate-cards .bulk-rate-card {\n    order: -1;\n  }\n\n  .premium-rate-card {\n    padding: 1.25rem;\n    border-radius: 12px;\n    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);\n    min-height: 180px;\n    display: flex;\n    flex-direction: column;\n  }\n\n  .rate-card-header {\n    flex-direction: row;\n    text-align: center;\n    gap: 0.75rem;\n    padding-bottom: 1rem;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.08);\n  }\n\n  .rate-card-content {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    gap: 1rem;\n  }\n\n  .rate-display-form {\n    flex-direction: column;\n    gap: 1rem;\n    align-items: stretch;\n  }\n\n  .current-rate-display {\n    padding: 1rem;\n    background: linear-gradient(135deg, #f8f9ff 0%, #ffffff 100%);\n    border-radius: 8px;\n    text-align: center;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n  }\n\n  .rate-value {\n    font-size: 1.4rem;\n    font-weight: 700;\n    color: var(--primary);\n  }\n\n  .rate-label {\n    font-size: 0.8rem;\n    color: var(--gray-600);\n    margin-top: 0.25rem;\n  }\n\n  .edit-rate-button-dashboard {\n    width: auto;\n    max-width: 120px;\n    padding: 0.75rem 1rem;\n    font-size: 0.85rem;\n    border-radius: 8px;\n    margin-top: 0.5rem;\n    white-space: nowrap;\n  }\n\n  .rate-type-row {\n    flex-direction: column;\n    gap: 0rem;\n    align-items: stretch;\n  }\n\n  .rate-type-label {\n    text-align: center;\n    font-weight: 600;\n    color: var(--gray-700);\n    margin-bottom: 0.5rem;\n  }\n\n  .premium-select.compact {\n    width: 100%;\n    padding: 0.75rem;\n    font-size: 0.9rem;\n    border-radius: 8px;\n    border: 2px solid var(--gray-300);\n  }\n\n  .save-rate-button {\n    width: 100%;\n    max-width: none;\n    padding: 0.75rem 1rem;\n    font-size: 0.85rem;\n    border-radius: 8px;\n    margin-top: 0.5rem;\n  }\n\n  .bulk-action-btn-rate {\n    width: 100%;\n    /* padding: 0.75rem 1rem; */\n    font-size: 0.9rem;\n    border-radius: 8px;\n    margin-top: -0.7rem;\n  }\n\n  .bulk-rate-features {\n    margin-bottom: 1rem;\n  }\n\n  .bulk-rate-features li {\n    padding: 0.5rem 0;\n    font-size: 0.85rem;\n  }\n\n  .bulk-rate-selector-modal {\n    width: 95%;\n    margin: 1rem;\n    border-radius: 16px;\n  }\n\n  .bulk-rate-selector-modal .modal-header {\n    padding: 1.5rem;\n    border-radius: 16px 16px 0 0;\n  }\n\n  .bulk-rate-selector-modal .modal-header h2 {\n    font-size: 1.2rem;\n    font-weight: 700;\n  }\n\n  .bulk-rate-selector-modal .modal-body {\n    padding: 1.5rem;\n  }\n\n  .collection-type-options {\n    flex-direction: column;\n    gap: 1rem;\n  }\n\n  .collection-type-btn {\n    padding: 1.25rem 0.75rem;\n    font-size: 0.9rem;\n    border-radius: 12px;\n    min-height: 70px;\n    line-height: 1.2;\n  }\n\n  .modal-btn-primary,\n  .modal-btn-secondary,\n  .cancel-button {\n    width: 100%;\n    margin-bottom: 0.5rem;\n    padding: 0.75rem 1rem;\n    font-size: 0.85rem;\n    border-radius: 8px;\n  }\n\n  .modal-footer {\n    flex-direction: column;\n    gap: 0.5rem;\n  }\n}\n\n/* Small Mobile Devices (480px and below) */\n@media (max-width: 480px) {\n  .rate-display-form-dashboard {\n    padding: 0.4rem;\n    gap: 0.4rem;\n  }\n\n  .current-milk-rate-display-dashboard {\n    height: 40px;\n    padding: 0.4rem;\n  }\n\n  .rate-value {\n    font-size: 0.9rem;\n    font-weight: 600;\n  }\n\n  .edit-rate-button-dashboard {\n    padding: 0.4rem 0.6rem;\n    font-size: 0.7rem;\n    min-height: 36px;\n  }\n}\n\n/* Large Devices (769px - 1024px) - Fix card layout and visibility */\n@media (min-width: 769px) and (max-width: 1024px) {\n  .premium-rate-cards {\n    grid-template-columns: 1fr;\n    gap: 1.5rem;\n  }\n\n  .premium-rate-card {\n    min-height: 180px;\n    padding: 1.5rem;\n  }\n\n  .rate-card-content {\n    flex-direction: column;\n    gap: 1rem;\n  }\n\n  .rate-content-wrapper {\n    flex-direction: column;\n    gap: 1rem;\n  }\n\n  .rate-display-section,\n  .rate-type-section {\n    width: 100%;\n  }\n\n  .current-milk-rate-display-dashboard {\n    min-width: 200px;\n    padding: 1rem;\n  }\n\n  .edit-rate-button-dashboard {\n    max-width: 200px;\n    padding: 0.6rem 1rem;\n    font-size: 0.8rem;\n  }\n}\n\n/* Large Devices (1024px - 1440px) - Fix card layout and visibility */\n@media (min-width: 1024px) and (max-width: 1440px) {\n  .premium-rate-cards {\n    grid-template-columns: repeat(2, 1fr) !important;\n    gap: 1.5rem;\n    display: grid !important;\n  }\n\n  .premium-rate-card {\n    min-height: 180px;\n    padding: 1.5rem;\n  }\n\n  /* Desktop rate card optimizations */\n  .rate-card-header {\n    padding: 0.5rem 0.8rem;\n    gap: 0.5rem;\n  }\n\n  .rate-card-icon {\n    width: 22px;\n    height: 22px;\n    font-size: 0.65rem;\n  }\n\n  .heading-card-dashboard {\n    font-size: 1rem;\n  }\n\n  .rate-card-content {\n    padding: 0.8rem;\n    gap: 0.6rem;\n  }\n\n  .feature-item {\n    font-size: 0.9rem;\n    gap: 0.5rem;\n    margin-bottom: 0.4rem;\n  }\n\n  .feature-check {\n    font-size: 0.6rem;\n  }\n\n  .rate-card-title .bulk-action-btn-rate,\n  .rate-card-title .bulk-action-btn-milk-rate {\n    padding: 0.4rem 0.8rem;\n    font-size: 0.75rem;\n    gap: 0.25rem;\n  }\n\n  /* Hide content buttons on desktop */\n  .rate-card-content .bulk-action-btn-rate,\n  .rate-card-content .bulk-action-btn-milk-rate {\n    display: none;\n  }\n\n  .rate-card-content {\n    flex-direction: column;\n    gap: 1rem;\n  }\n\n  .rate-content-wrapper {\n    flex-direction: column;\n    gap: 1rem;\n  }\n\n  .rate-display-section,\n  .rate-type-section {\n    width: 100%;\n  }\n\n  .current-milk-rate-display-dashboard {\n    min-width: 200px;\n    padding: 1rem;\n  }\n\n  .edit-rate-button-dashboard {\n    max-width: 200px;\n    padding: 0.6rem 1rem;\n    font-size: 0.8rem;\n  }\n}\n\n/* Specific fix for exactly 768px - force single column layout */\n@media (max-width: 768px) {\n  .premium-rate-cards {\n    grid-template-columns: 1fr !important;\n    gap: 1rem !important;\n    display: grid !important;\n  }\n\n  .bulk-action-btn-rate {\n    width: auto;\n    max-width: 120px;\n    font-size: 0.8rem;\n    padding: 6px 10px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  .bulk-action-btn-milk-rate {\n    width: auto;\n    max-width: 140px;\n    font-size: 0.8rem;\n    padding: 6px 10px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  .current-rate-display {\n    padding: 0.6rem;\n    margin-bottom: 0.4rem;\n  }\n\n  .current-rate-label {\n    font-size: 0.6rem;\n    margin-bottom: 0.2rem;\n  }\n\n  .current-rate-value {\n    font-size: 1rem;\n  }\n}\n\n/* Medium Small Devices (425px - 768px) - Full Width Layout */\n@media (min-width: 425px) and (max-width: 768px) {\n  .premium-rate-cards {\n    grid-template-columns: 1fr;\n    gap: 1rem;\n  }\n\n  .premium-rate-card {\n    min-height: 160px;\n  }\n\n  .rate-card-content {\n    flex-direction: column;\n    gap: 0.75rem;\n  }\n}\n\n/* Small Devices (481px - 768px) */\n@media (min-width: 481px) and (max-width: 768px) {\n  .dashboard-header {\n    padding: 0;\n  }\n\n  .premium-rate-cards {\n    grid-template-columns: 1fr;\n    gap: 1.25rem;\n  }\n\n  .premium-rate-cards .bulk-rate-card {\n    order: -1;\n  }\n\n  .rate-type-row {\n    flex-wrap: wrap;\n    gap: 0.75rem;\n  }\n\n  .premium-select.compact {\n    flex: 1;\n    min-width: 150px;\n  }\n\n  .bulk-rate-selector-modal {\n    width: 90%;\n  }\n\n  .collection-type-options {\n    gap: 1.25rem;\n  }\n}\n\n/* Medium Devices (769px - 1024px) - Tablets */\n@media (min-width: 769px) and (max-width: 1024px) {\n  .dashboard-header {\n    padding: 0;\n  }\n\n  .premium-rate-cards {\n    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n    gap: 1.5rem;\n  }\n\n  .rate-management-header {\n    flex-direction: column;\n    text-align: center;\n    gap: 0.5rem;\n  }\n\n  .bulk-rate-selector-modal {\n    max-width: 600px;\n  }\n\n  .collection-type-options {\n    gap: 1.5rem;\n  }\n}\n\n/* Large Devices (1025px - 1440px) - Desktops */\n@media (min-width: 1025px) and (max-width: 1440px) {\n  .premium-rate-cards {\n    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n    gap: 1.75rem;\n  }\n\n  .bulk-rate-selector-modal {\n    max-width: 580px;\n  }\n}\n\n/* Extra Large Devices (1441px+) - Large Desktops */\n@media (min-width: 1441px) {\n  .dashboard-container {\n    max-width: 1400px;\n    margin: 0 auto;\n  }\n\n  .premium-rate-cards {\n    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n    gap: 2rem;\n  }\n\n  /* Extra large screen optimizations */\n  .rate-card-header {\n    padding: 0.6rem 1rem;\n    gap: 0.6rem;\n  }\n\n  .rate-card-icon {\n    width: 24px;\n    height: 24px;\n    font-size: 0.7rem;\n  }\n\n  .heading-card-dashboard {\n    font-size: 1.1rem;\n  }\n\n  .rate-card-content {\n    padding: 1rem;\n    gap: 0.7rem;\n  }\n\n  .feature-item {\n    font-size: 0.95rem;\n    gap: 0.6rem;\n    margin-bottom: 0.5rem;\n  }\n\n  .feature-check {\n    font-size: 0.65rem;\n  }\n\n  .rate-card-title .bulk-action-btn-rate,\n  .rate-card-title .bulk-action-btn-milk-rate {\n    padding: 0.5rem 0.9rem;\n    font-size: 0.8rem;\n    gap: 0.3rem;\n  }\n\n  /* Hide content buttons on extra large screens */\n  .rate-card-content .bulk-action-btn-rate,\n  .rate-card-content .bulk-action-btn-milk-rate {\n    display: none;\n  }\n\n  .bulk-rate-selector-modal {\n    max-width: 620px;\n  }\n\n  .premium-rate-card {\n    min-height: 200px;\n  }\n}\n\n/* High DPI / Retina Displays */\n@media (-webkit-min-device-pixel-ratio: 2),\n(min-resolution: 192dpi) {\n  .bulk-rate-selector-modal::before {\n    height: 1px;\n  }\n\n  .premium-rate-card {\n    border-width: 0.5px;\n  }\n}\n\n/* Landscape Orientation for Mobile */\n@media (max-width: 768px) and (orientation: landscape) {\n  .dashboard-header {\n    flex-direction: row;\n    padding: 0;\n  }\n\n  .premium-rate-cards {\n    grid-template-columns: 1fr;\n    gap: 1rem;\n  }\n\n  .premium-rate-cards .bulk-rate-card {\n    order: -1;\n  }\n\n  .bulk-rate-selector-modal .modal-header {\n    padding: 1rem 1.5rem;\n  }\n\n  .bulk-rate-selector-modal .bulk-modal-header {\n    padding: 1rem 1.5rem;\n  }\n\n  .bulk-rate-selector-modal .bulk-modal-header .bulk-header-text {\n    font-size: 1.2rem;\n    font-weight: 700;\n  }\n\n  .bulk-rate-selector-modal .modal-body {\n    padding: 1.5rem;\n  }\n}\n\n/* Dark Mode Support (if needed in future) */\n@media (prefers-color-scheme: dark) {\n\n  /* Placeholder for dark mode styles */\n  .bulk-rate-selector-modal {\n    background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 50%, #1a1a1a 100%);\n  }\n}\n\n/* Language Switcher Styling for Dashboard Header */\n.dashboard-header .lang-btn {\n  background: rgba(255, 255, 255, 0.15);\n  border: 1px solid rgba(255, 255, 255, 0.3);\n  color: white;\n  padding: 8px 12px;\n  border-radius: 6px;\n  font-size: 13px;\n  font-weight: 500;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  cursor: pointer;\n}\n\n.dashboard-header .lang-btn:hover {\n  background: rgba(255, 255, 255, 0.3);\n  border-color: rgba(255, 255, 255, 0.4);\n}\n\n.dashboard-header .lang-icon {\n  color: white;\n}\n\n.dashboard-header .lang-text {\n  color: white;\n}\n\n.dashboard-header .lang-chevron {\n  color: rgba(255, 255, 255, 0.9);\n}\n\n.dashboard-header .lang-menu {\n  background: white;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  min-width: 150px;\n}\n\n.dashboard-header .lang-item {\n  color: #333;\n  padding: 10px 12px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  font-size: 13px;\n}\n\n.dashboard-header .lang-item:hover {\n  background-color: #f5f5f5;\n}\n\n.dashboard-header .lang-item.active {\n  background-color: #e3f2fd;\n  color: #2563eb;\n  font-weight: 600;\n}\n\n/* Reduced Motion Support */\n@media (prefers-reduced-motion: reduce) {\n\n  .bulk-rate-selector-modal,\n  .collection-type-btn,\n  .save-rate-button,\n  .cancel-button,\n  .modal-btn-primary,\n  .modal-btn-secondary {\n    animation: none;\n    transition: none;\n  }\n\n  .collection-type-btn:hover,\n  .save-rate-button:hover,\n  .cancel-button:hover,\n  .modal-btn-primary:hover,\n  .modal-btn-secondary:hover {\n    transform: none;\n  }\n}\n\n/* ============================================\n   COMPREHENSIVE RESPONSIVE DESIGN\n   ============================================ */\n\n/* Single Clean Mobile Rule */\n@media (max-width: 768px) {\n  .bulk-rate-selector-modal {\n    max-width: 92vw;\n  }\n\n  /* Chrome Mobile Specific Fix */\n  .modal-overlay {\n    -webkit-overflow-scrolling: touch;\n  }\n\n  .bulk-rate-selector-modal {\n    -webkit-transform: none;\n    transform: none;\n  }\n}\n\n/* Extra Small Devices (320px - 480px) - Small Phones */\n@media (max-width: 480px) {\n  .dashboard-container {\n    padding: 0 0.5rem 0.5rem;\n  }\n\n  .dashboard-header {\n    height: auto;\n    min-height: 60px;\n    padding: 0;\n  }\n\n  .desktop-header {\n    display: none;\n  }\n\n  .mobile-header {\n    display: block;\n  }\n\n  .mobile-header-top {\n    padding: 0.5rem;\n    margin-top: 0;\n  }\n\n  .mobile-header-bottom h1 {\n    font-size: 1.1rem;\n    margin: 0.5rem 0;\n  }\n\n  .premium-dashboard-header {\n    padding: 1rem;\n    margin-bottom: 1rem;\n  }\n\n  .premium-stats-row {\n    flex-direction: column;\n    gap: 0.75rem;\n  }\n\n  .owner-wallet-row {\n    flex-direction: column;\n    align-items: flex-start;\n    /* gap: 0.5rem; */\n  }\n\n  .owner-info {\n    width: 100%;\n  }\n\n  .wallet-info {\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-start;\n    width: 100%;\n    /* justify-content: space-between; */\n  }\n\n  .premium-stat-card {\n    flex-direction: row;\n    padding: 0.75rem;\n    min-width: 100%;\n    border-radius: 8px;\n  }\n\n  .stat-icon-wrapper {\n    width: 32px;\n    height: 32px;\n    font-size: 0.8rem;\n  }\n\n  .stat-content {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 0.25rem;\n  }\n\n  .stat-content h4 {\n    font-size: 0.6rem;\n  }\n\n  .stat-content p {\n    font-size: 0.8rem;\n  }\n\n  .premium-add-money-btn {\n    padding: 0.15rem 0.4rem;\n    font-size: 0.55rem;\n  }\n\n  .rate-management-header h3 {\n    font-size: 1.2rem;\n  }\n\n  .premium-rate-cards {\n    grid-template-columns: 1fr;\n    gap: 0.75rem;\n  }\n\n  .premium-rate-card {\n    padding: 0.75rem;\n  }\n\n  .rate-card-header {\n    padding: 0.5rem;\n    gap: 0.5rem;\n    flex-direction: row;\n  }\n\n  .rate-card-icon {\n    width: 20px;\n    height: 20px;\n    font-size: 0.6rem;\n  }\n\n  .heading-card-dashboard {\n    font-size: 1.5rem;\n  }\n\n  .rate-card-title p {\n    font-size: 0.5rem;\n  }\n\n  .rate-card-content {\n    padding: 0.75rem;\n    gap: 0.5rem;\n    flex-direction: column;\n  }\n\n  .rate-content-wrapper {\n    flex-direction: column;\n    gap: 0.75rem;\n  }\n\n  .current-milk-rate-display-dashboard {\n    padding: 0.5rem;\n    min-width: auto;\n    height: 45px;\n  }\n\n  .rate-value {\n    font-size: 0.9rem;\n  }\n\n  .rate-label {\n    font-size: 0.6rem;\n  }\n\n  .premium-rate-input {\n    padding: 0.4rem 0.6rem;\n    font-size: 0.8rem;\n  }\n\n  .rate-edit-actions {\n    flex-direction: column;\n    gap: 0.5rem;\n    height: auto;\n    width: 100%;\n  }\n\n  .premium-btn {\n    padding: 0.3rem 0.6rem;\n    font-size: 0.6rem;\n    width: 100%;\n  }\n\n  .premium-action-grid {\n    grid-template-columns: 1fr;\n    gap: 0.75rem;\n  }\n\n  .premium-action-card {\n    border-radius: 8px;\n  }\n\n  .action-card-header {\n    padding: 0.75rem;\n    gap: 0.5rem;\n  }\n\n  .action-card-icon {\n    width: 28px;\n    height: 28px;\n    font-size: 0.8rem;\n  }\n\n  .action-card-title h4 {\n    font-size: 1rem;\n  }\n\n  .action-card-title p {\n    font-size: 0.7rem;\n  }\n\n  .action-card-content {\n    padding: 0.75rem;\n    gap: 0.5rem;\n  }\n\n  .premium-action-btn {\n    padding: 0.8rem 1rem;\n    font-size: 0.8rem;\n  }\n\n  .bulk-rate-selector-modal {\n    width: 95%;\n    margin: 0.5rem;\n    border-radius: 12px;\n  }\n\n  .bulk-rate-selector-modal .bulk-modal-header {\n    padding: 1rem;\n  }\n\n  .bulk-rate-selector-modal .bulk-modal-header .bulk-header-text {\n    font-size: 1.1rem;\n    font-weight: 700;\n  }\n\n  .bulk-rate-selector-modal .modal-body {\n    padding: 1rem;\n  }\n\n  .collection-type-options {\n    flex-direction: column;\n    gap: 0.75rem;\n    padding: 0;\n  }\n\n  .collection-type-btn {\n    padding: 1rem 0.75rem;\n    font-size: 0.8rem;\n    min-height: 60px;\n    border-radius: 8px;\n  }\n\n  /* .premium-select-rate-type {\ncms\n   粗体\n   aja\n    width: 100 Reich\n   obot\n    premium-select-rate-typeides\n    bs\n   elve\n    Early\n   lain\n    sled\n    0.6rem;\n    font-size: 0.7rem;\n  } */\n\n  .save-rate-button {\n    padding: 0.3rem 0.6rem;\n    font-size: 0.6rem;\n    width: 100%;\n  }\n\n  .mobile-menu-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: rgba(0, 0, 0, 0.5);\n    z-index: 999;\n  }\n\n  .mobile-menu {\n    position: fixed;\n    top: 0;\n    right: -100%;\n    width: 80%;\n    max-width: 300px;\n    height: 100%;\n    background: white;\n    box-shadow: -2px 0 10px rgba(0, 0, 0, 0.1);\n    transition: right 0.3s ease;\n    z-index: 1000;\n    overflow-y: auto;\n  }\n\n  .mobile-menu.active {\n    right: 0;\n  }\n\n  .mobile-menu-header {\n    padding: 1rem;\n    border-bottom: 1px solid #e5e7eb;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n\n  .mobile-menu-close {\n    background: none;\n    border: none;\n    font-size: 1.5rem;\n    cursor: pointer;\n    color: #6b7280;\n  }\n\n  .mobile-menu-content {\n    padding: 1rem;\n  }\n\n  .mobile-menu-section {\n    margin-bottom: 2rem;\n  }\n\n  .mobile-menu-section h3 {\n    font-size: 0.9rem;\n    color: #6b7280;\n    margin-bottom: 0.5rem;\n    text-transform: uppercase;\n  }\n\n  .mobile-menu-link {\n    display: block;\n    padding: 0.75rem;\n    color: #374151;\n    text-decoration: none;\n    border-radius: 6px;\n    transition: background 0.2s ease;\n  }\n\n  .mobile-menu-link:hover {\n    background: #f3f4f6;\n  }\n}\n\n/* Small Devices (481px - 768px) - Large Phones and Small Tablets */\n@media (min-width: 481px) and (max-width: 768px) {\n  .dashboard-container {\n    padding: 0 1rem 1rem;\n  }\n\n  .premium-dashboard-header {\n    padding: 1.5rem;\n  }\n\n  .premium-stats-row {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 1rem;\n  }\n\n  .premium-stat-card {\n    flex-direction: column;\n    text-align: center;\n    padding: 1rem;\n  }\n\n  .stat-icon-wrapper {\n    width: 40px;\n    height: 40px;\n    font-size: 1rem;\n  }\n\n  .stat-content {\n    flex-direction: column;\n    align-items: center;\n    gap: 0.5rem;\n  }\n\n  .stat-content h4 {\n    font-size: 0.7rem;\n  }\n\n  .stat-content p {\n    font-size: 1rem;\n  }\n\n  .premium-rate-cards {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 1rem;\n  }\n\n  .rate-card-content {\n    flex-direction: column;\n    gap: 1rem;\n  }\n\n  .premium-action-grid {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 1rem;\n  }\n\n  .bulk-rate-selector-modal {\n    width: 90%;\n    max-width: 500px;\n  }\n\n  .bulk-rate-selector-modal .bulk-modal-header {\n    padding: 1.5rem;\n  }\n\n  .bulk-rate-selector-modal .bulk-modal-header .bulk-header-text {\n    font-size: 1.3rem;\n    font-weight: 750;\n  }\n\n  .collection-type-options {\n    gap: 1rem;\n  }\n\n  .collection-type-btn {\n    padding: 1.25rem 1rem;\n    font-size: 0.9rem;\n    min-height: 70px;\n  }\n}\n\n/* Medium Devices (769px - 1024px) - Tablets */\n@media (min-width: 769px) and (max-width: 1024px) {\n  .dashboard-container {\n    padding: 0 1.5rem 1.5rem;\n    max-width: 100%;\n  }\n\n  .premium-dashboard-header {\n    padding: 2rem;\n  }\n\n  .premium-stats-row {\n    grid-template-columns: repeat(3, 1fr);\n    gap: 1.25rem;\n  }\n\n  .premium-stat-card {\n    padding: 1.25rem;\n  }\n\n  .stat-icon-wrapper {\n    width: 44px;\n    height: 44px;\n    font-size: 1.1rem;\n  }\n\n  .stat-content h4 {\n    font-size: 0.8rem;\n  }\n\n  .stat-content p {\n    font-size: 1.1rem;\n  }\n\n  .premium-rate-cards {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 1.25rem;\n  }\n\n  .premium-rate-card {\n    min-height: 140px;\n  }\n\n  .rate-card-header {\n    padding: 1rem;\n  }\n\n  .rate-card-icon {\n    width: 32px;\n    height: 32px;\n    font-size: 0.9rem;\n  }\n\n  .heading-card-dashboard {\n    font-size: 1.5rem;\n  }\n\n  .rate-card-title p {\n    font-size: 0.7rem;\n  }\n\n  .rate-card-content {\n    padding: 1.25rem;\n  }\n\n  .premium-action-grid {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 1.25rem;\n  }\n\n  .premium-action-card {\n    min-height: 160px;\n  }\n\n  .action-card-header {\n    padding: 1.25rem;\n  }\n\n  .action-card-icon {\n    width: 40px;\n    height: 40px;\n    font-size: 1.1rem;\n  }\n\n  .action-card-title h4 {\n    font-size: 1.1rem;\n  }\n\n  .action-card-title p {\n    font-size: 0.7rem;\n  }\n\n  .action-card-content {\n    padding: 1.25rem;\n  }\n\n  .premium-action-btn {\n    padding: 1rem 1.25rem;\n    font-size: 0.9rem;\n  }\n\n  .bulk-rate-selector-modal {\n    max-width: 550px;\n  }\n\n  .bulk-rate-selector-modal .bulk-modal-header {\n    padding: 2rem;\n  }\n\n  .bulk-rate-selector-modal .bulk-modal-header .bulk-header-text {\n    font-size: 1.5rem;\n    font-weight: 800;\n  }\n\n  .collection-type-btn {\n    padding: 1.5rem 1.25rem;\n    font-size: 1rem;\n    min-height: 75px;\n  }\n\n  .premium-rate-input {\n    padding: 0.5rem 0.75rem;\n    font-size: 0.9rem;\n  }\n\n  .premium-btn {\n    padding: 0.4rem 0.8rem;\n    font-size: 0.7rem;\n  }\n\n  .premium-select-rate-type {\n    padding: 0.5rem 0.75rem;\n    font-size: 0.8rem;\n  }\n}\n\n/* Large Devices (1025px - 1440px) - Large Tablets and Small Desktops */\n@media (min-width: 1025px) and (max-width: 1440px) {\n  .dashboard-container {\n    padding: 0 2rem 2rem;\n    max-width: 1400px;\n    margin: 0 auto;\n  }\n\n  .premium-stats-row {\n    grid-template-columns: repeat(4, 1fr);\n    gap: 1.5rem;\n  }\n\n  .premium-rate-cards {\n    grid-template-columns: repeat(3, 1fr);\n    gap: 1.5rem;\n  }\n\n  .premium-action-grid {\n    grid-template-columns: repeat(3, 1fr);\n    gap: 1.5rem;\n  }\n\n  .bulk-rate-selector-modal {\n    max-width: 600px;\n  }\n}\n\n/* Body scroll lock for modal */\nbody.modal-open {\n  overflow: hidden;\n  position: fixed;\n  width: 100%;\n}\n\n/* Removed GPU hacks - they cause layout bugs on Chrome mobile */\n\n/* Landscape Orientation Adjustments */\n@media (max-width: 768px) and (orientation: landscape) {\n  .mobile-header-bottom h1 {\n    font-size: 1rem;\n    margin: 0.25rem 0;\n  }\n\n  .premium-stats-row {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 0.5rem;\n  }\n\n  .premium-stat-card {\n    padding: 0.5rem;\n  }\n\n  .stat-icon-wrapper {\n    width: 28px;\n    height: 28px;\n    font-size: 0.7rem;\n  }\n\n  .stat-content h4 {\n    font-size: 0.55rem;\n  }\n\n  .stat-content p {\n    font-size: 0.75rem;\n  }\n\n  .premium-rate-cards {\n    grid-template-columns: repeat(3, 1fr);\n    gap: 0.5rem;\n  }\n\n  .rate-card-header {\n    padding: 0.4rem;\n  }\n\n  .rate-card-icon {\n    width: 24px;\n    height: 24px;\n    font-size: 0.6rem;\n  }\n\n\n  .rate-card-title p {\n    font-size: 0.45rem;\n  }\n\n  .rate-card-content {\n    padding: 0.5rem;\n  }\n\n  .premium-action-grid {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 0.5rem;\n  }\n\n  .action-card-header {\n    padding: 0.5rem;\n  }\n\n  .action-card-icon {\n    width: 32px;\n    height: 32px;\n    font-size: 0.8rem;\n  }\n\n  .action-card-title h4 {\n    font-size: 1rem;\n  }\n\n  .action-card-title p {\n    font-size: 0.7rem;\n  }\n\n  .action-card-content {\n    padding: 0.5rem;\n  }\n\n  .premium-action-btn {\n    padding: 0.6rem 0.8rem;\n    font-size: 0.75rem;\n  }\n}\n\n/* High DPI/Retina Display Optimizations */\n@media (-webkit-min-device-pixel-ratio: 2),\n(min-resolution: 192dpi) {\n\n  .stat-icon-wrapper,\n  .rate-card-icon,\n  .action-card-icon {\n    border-width: 0.5px;\n  }\n\n  .premium-btn,\n  .premium-action-btn {\n    border-width: 0.5px;\n  }\n}\n\n\n/* Success/Error Notification */\n.notification-toast {\n  position: fixed;\n  top: 20px;\n  right: 20px;\n  background-color: #10b981;\n  color: #fff;\n  padding: 1rem 1.5rem;\n  border-radius: 8px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  z-index: 9999;\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  font-size: 0.95rem;\n  font-weight: 500;\n  animation: slideIn 0.3s ease-out;\n  max-width: 400px;\n}\n\n.notification-toast.error {\n  background-color: #dc2626;\n}\n\n@keyframes slideIn {\n  from {\n    transform: translateX(100%);\n    opacity: 0;\n  }\n\n  to {\n    transform: translateX(0);\n    opacity: 1;\n  }\n}\n\n/* Footer Logo */\n.footer-logo {\n  width: 170px;\n}\n\n/* Premium Dashboard Header Styles */\n.owner-info-vertical {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n\n.owner-wallet-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  /* gap: 1rem; */\n  flex-wrap: wrap;\n}\n\n/* Mobile reordering: owner name first, then phone, then wallet */\n@media (max-width: 480px) {\n  .owner-info-vertical {\n    display: flex;\n    flex-direction: column;\n  }\n\n  .owner-wallet-row {\n    display: flex !important;\n    flex-direction: column !important;\n    gap: 12px !important;\n  }\n\n  .owner-info-left:not(.long-name) {\n    display: flex !important;\n    flex-direction: row !important;\n    flex-wrap: nowrap !important;\n    align-items: center !important;\n    gap: 8px !important;\n    order: -2 !important;\n    width: 100% !important;\n  }\n\n  .owner-info-left.long-name {\n    display: flex !important;\n    flex-direction: column !important;\n    align-items: flex-start !important;\n    gap: 6px !important;\n    order: -2 !important;\n    width: 100% !important;\n  }\n\n  .wallet-action-right {\n    display: flex !important;\n    flex-direction: column !important;\n    align-items: stretch !important;\n    width: 100% !important;\n    order: -1 !important;\n    gap: 10px !important;\n  }\n\n  .owner-info-left:not(.long-name) .owner-info {\n    margin-bottom: 0 !important;\n    display: flex !important;\n    align-items: center !important;\n    gap: 0.5rem !important;\n    flex: 1 1 0% !important;\n    min-width: 0 !important;\n  }\n\n  .owner-info-left:not(.long-name) .phone-info {\n    margin-bottom: 0 !important;\n    display: flex !important;\n    align-items: center !important;\n    gap: 0.5rem !important;\n    flex: 1 1 0% !important;\n    min-width: 0 !important;\n  }\n\n  .owner-info-left.long-name .owner-info,\n  .owner-info-left.long-name .phone-info {\n    margin-bottom: 0 !important;\n    display: flex !important;\n    align-items: center !important;\n    gap: 0.5rem !important;\n    width: 100% !important;\n  }\n\n  .owner-info span,\n  .phone-info span {\n    font-size: 0.9rem !important;\n    white-space: nowrap !important;\n    overflow: hidden !important;\n    text-overflow: ellipsis !important;\n  }\n\n  .owner-info-left.long-name span {\n    max-width: 100% !important;\n  }\n\n  .wallet-info {\n    order: 0;\n    /* Wallet third */\n    width: 100%;\n    flex-wrap: nowrap;\n    align-items: center;\n    justify-content: flex-start;\n    gap: 0.4rem;\n    padding: 0.5rem 0;\n  }\n\n  .hire-person-banner {\n    order: 1;\n    /* Hire button last */\n    width: 100% !important;\n    margin: 0 !important;\n    box-sizing: border-box;\n  }\n\n  .wallet-info .icon-wallet {\n    font-size: 1rem;\n  }\n\n  .wallet-info .wallet-recharge-link {\n    font-size: 0.8rem;\n    font-weight: 600;\n    color: #3b82f6;\n    text-decoration: underline;\n    white-space: nowrap;\n    margin-left: 0;\n    padding-left: 0;\n  }\n\n  .wallet-info span:last-child {\n    font-size: 0.9rem;\n    font-weight: 700;\n    color: #1f2937;\n  }\n\n  .heading-card-dashboard {\n    font-size: 1rem !important;\n    font-weight: 600;\n    text-align: left;\n  }\n}\n\n.premium-add-money-btn {\n  margin-left: 0;\n  margin-top: 0.35rem;\n}\n\n.owner-info {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  flex-shrink: 0;\n}\n\n.phone-info {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  flex-shrink: 0;\n}\n\n.wallet-info {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  flex-shrink: 0;\n}\n\n.wallet-recharge-link {\n  cursor: pointer;\n  transition: text-decoration 0.3s ease;\n}\n\n.wallet-recharge-link:hover {\n  text-decoration: underline;\n  color: #3b82f6;\n}\n\n.owner-info span,\n.phone-info span,\n.wallet-info span {\n  font-size: 1.1rem;\n  font-weight: 500;\n}\n\n/* Icon Color Styles */\n.icon-user {\n  color: #3b82f6;\n}\n\n.icon-phone {\n  color: #10b981;\n}\n\n.icon-wallet {\n  color: #6366f1;\n}\n\n/* Button Margin Styles */\n.btn-margin-left {\n  margin-left: 0.5rem;\n}\n\n/* FontAwesome Icon Spacing */\n.icon-margin-right-10 {\n  margin-right: 10px;\n}\n\n.icon-margin-right-6 {\n  margin-right: 6px;\n}\n\n.icon-margin-right-8 {\n  margin-right: 8px;\n}\n\n.icon-margin-right-5 {\n  margin-right: 5px;\n}\n\n.icon-margin-right-0-5rem {\n  margin-right: 0.5rem;\n}\n\n/* Flex Container Styles */\n.flex-gap-0-5rem {\n  display: flex;\n  gap: 0.5rem;\n}\n\n/* Error Message Styles */\n.error-message-red {\n  color: red;\n  margin: 10px 0;\n}\n\n.edit-form-error {\n  margin-bottom: 15px;\n  color: red;\n  font-weight: bold;\n}\n\n/* Modal Body Styles */\n.modal-body-flex {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  overflow: auto;\n  padding: 20px;\n  padding-bottom: 20px;\n}\n\n/* Preview Header Styles */\n.preview-header-blue {\n  background-color: #e3f2fd;\n  padding: 5px 8px;\n  border-radius: 3px;\n  margin-bottom: 8px;\n  border-left: 2px solid #1976d2;\n  flex-shrink: 0;\n}\n\n/* Close Button Styles */\n.close-btn-16px {\n  font-size: 16px;\n}\n\n/* Rate Chart Modal Styles */\n.rate-chart-modal {\n  background-color: white;\n  border-radius: 8px;\n  max-width: 600px;\n  width: 90%;\n  max-height: 80vh;\n  overflow: auto;\n  position: relative;\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);\n}\n\n.rate-chart-header {\n  padding: 16px 20px;\n  border-bottom: 1px solid #e0e0e0;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background-color: #f8f9fa;\n  border-radius: 8px 8px 0 0;\n}\n\n.rate-chart-header h3 {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 600;\n  color: #333;\n}\n\n.modal-close-btn-ratechart {\n  background: none;\n  border: none;\n  font-size: 20px;\n  cursor: pointer;\n  color: #666;\n  padding: 4px;\n  border-radius: 4px;\n  transition: all 0.2s;\n}\n\n.modal-close-btn-ratechart:hover {\n  background-color: #f0f0f0;\n  color: #333;\n}\n\n.rate-chart-body {\n  padding: 20px;\n  max-height: 60vh;\n  overflow-y: auto;\n}\n\n.rate-chart-section {\n  margin-bottom: 24px;\n}\n\n.rate-chart-section:last-child {\n  margin-bottom: 0;\n}\n\n.rate-chart-section h4 {\n  margin: 0 0 8px 0;\n  font-size: 16px;\n  font-weight: 600;\n  color: #333;\n}\n\n.rate-description {\n  margin: 0 0 16px 0;\n  font-size: 14px;\n  color: #666;\n  line-height: 1.4;\n}\n\n.rate-row {\n  display: flex;\n  gap: 12px;\n  margin-bottom: 12px;\n  align-items: flex-end;\n}\n\n.rate-input-group {\n  flex: 1;\n}\n\n.rate-input-group label {\n  display: block;\n  font-size: 12px;\n  color: #666;\n  margin-bottom: 4px;\n  font-weight: 500;\n}\n\n.rate-input {\n  width: 100%;\n  padding: 8px 12px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 14px;\n  transition: border-color 0.2s;\n}\n\n.rate-input:focus {\n  outline: none;\n  border-color: #007bff;\n  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);\n}\n\n.rate-input-with-icon {\n  display: flex;\n  align-items: center;\n}\n\n.rate-icon {\n  margin-right: 8px;\n  font-size: 14px;\n  color: #666;\n  font-weight: 600;\n  min-width: 16px;\n}\n\n.delete-rate-btn {\n  padding: 8px;\n  border: 1px solid #dc3545;\n  background-color: #dc3545;\n  color: white;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 12px;\n  transition: all 0.2s;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.delete-rate-btn:hover {\n  background-color: #c82333;\n  border-color: #c82333;\n}\n\n.add-step-btn {\n  padding: 8px 16px;\n  border: 1px solid #007bff;\n  background-color: #007bff;\n  color: white;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  transition: all 0.2s;\n}\n\n.add-step-btn:hover {\n  background-color: #0056b3;\n  border-color: #0056b3;\n}\n\n.rate-chart-footer {\n  padding: 16px 20px;\n  border-top: 1px solid #e0e0e0;\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  background-color: #f8f9fa;\n  border-radius: 0 0 8px 8px;\n}\n\n.modal-btn {\n  padding: 8px 16px;\n  border: 1px solid transparent;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  transition: all 0.2s;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.modal-btn-secondary {\n  background-color: #6c757d;\n  color: white;\n  border-color: #6c757d;\n}\n\n.modal-btn-secondary:hover {\n  background-color: #5a6268;\n  border-color: #5a6268;\n}\n\n.modal-btn-primary {\n  background-color: #007bff;\n  color: white;\n  border-color: #007bff;\n}\n\n.modal-btn-primary:hover {\n  background-color: #0056b3;\n  border-color: #0056b3;\n}\n\n.modal-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n/* Mobile Responsive Styles for Rate Chart Modal */\n@media (max-width: 768px) {\n  .rate-chart-modal {\n    width: 95%;\n    max-height: 90vh;\n    margin: 10px;\n  }\n\n  .rate-chart-header {\n    padding: 12px 16px;\n  }\n\n  .rate-chart-header h3 {\n    font-size: 16px;\n  }\n\n  .modal-close-btn-ratechart {\n    font-size: 18px;\n    padding: 6px;\n  }\n\n  .rate-chart-body {\n    padding: 16px;\n    max-height: 65vh;\n  }\n\n  .rate-chart-section {\n    margin-bottom: 20px;\n  }\n\n  .rate-chart-section h4 {\n    font-size: 15px;\n    margin-bottom: 6px;\n  }\n\n  .rate-description {\n    font-size: 13px;\n    margin-bottom: 12px;\n  }\n\n  .rate-row {\n    flex-direction: column;\n    gap: 8px;\n    align-items: stretch;\n  }\n\n  .rate-input-group {\n    width: 100%;\n  }\n\n  .rate-input {\n    padding: 10px 12px;\n    font-size: 16px;\n    /* Prevents zoom on iOS */\n  }\n\n  .rate-input-with-icon {\n    align-items: center;\n  }\n\n  .rate-icon {\n    margin-right: 10px;\n    font-size: 16px;\n  }\n\n  .delete-rate-btn {\n    position: absolute;\n    right: 8px;\n    top: 8px;\n    padding: 6px;\n    font-size: 11px;\n  }\n\n  .add-step-btn {\n    padding: 10px 16px;\n    font-size: 15px;\n    justify-content: center;\n  }\n\n  .rate-chart-footer {\n    padding: 12px 16px;\n    flex-direction: column;\n    gap: 8px;\n  }\n\n  .modal-btn {\n    width: 100%;\n    padding: 12px 16px;\n    font-size: 15px;\n    justify-content: center;\n  }\n}\n\n@media (max-width: 480px) {\n  .rate-chart-modal {\n    width: 98%;\n    margin: 5px;\n    max-height: 95vh;\n  }\n\n  .rate-chart-header {\n    padding: 10px 12px;\n  }\n\n  .rate-chart-header h3 {\n    font-size: 15px;\n  }\n\n  .rate-chart-body {\n    padding: 12px;\n    max-height: 70vh;\n  }\n\n  .rate-chart-section {\n    margin-bottom: 16px;\n  }\n\n  .rate-chart-section h4 {\n    font-size: 14px;\n  }\n\n  .rate-description {\n    font-size: 12px;\n    margin-bottom: 10px;\n  }\n\n  .rate-input {\n    padding: 8px 10px;\n    font-size: 16px;\n  }\n\n  .rate-icon {\n    margin-right: 8px;\n    font-size: 14px;\n  }\n\n  .add-step-btn {\n    padding: 8px 12px;\n    font-size: 14px;\n  }\n\n  .rate-chart-footer {\n    padding: 10px 12px;\n  }\n\n  .modal-btn {\n    padding: 10px 12px;\n    font-size: 14px;\n  }\n}\n\n/* Bulk Edit Modal Buttons Mobile Responsive */\n@media (max-width: 768px) {\n\n  .modal-footer .cancel-button,\n  .modal-footer .confirm-button {\n    width: 100% !important;\n    padding: 12px 16px !important;\n    font-size: 15px !important;\n    min-height: 48px;\n    margin-bottom: 8px;\n  }\n\n  .modal-footer {\n    flex-direction: column !important;\n    gap: 8px !important;\n    padding: 16px !important;\n    flex-wrap: wrap !important;\n  }\n}\n\n@media (max-width: 480px) {\n\n  .modal-footer .cancel-button,\n  .modal-footer .confirm-button {\n    padding: 10px 12px !important;\n    font-size: 14px !important;\n    min-height: 44px;\n    margin-bottom: 6px;\n  }\n\n  .modal-footer {\n    padding: 12px !important;\n    gap: 6px !important;\n  }\n}\n\n/* Payment Feedback Message Styles */\n.payment-feedback {\n  padding: 12px 16px;\n  margin: 10px 0;\n  border-radius: 8px;\n  font-weight: 500;\n  text-align: center;\n  animation: slideInFromTop 0.3s ease-out;\n}\n\n.payment-feedback.success {\n  background-color: #e8f5e8;\n  color: #2e7d32;\n  border: 1px solid #4caf50;\n}\n\n.payment-feedback.error {\n  background-color: #ffebee;\n  color: #c62828;\n  border: 1px solid #f44336;\n}\n\n@keyframes slideInFromTop {\n  from {\n    transform: translateY(-20px);\n    opacity: 0;\n  }\n\n  to {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n\n/* Current Rate Box Styles */\n.current-rate-box-dashboard {\n  display: inline-flex;\n  align-items: center;\n  border: 1px solid #000;\n  border-radius: 8px;\n  padding: 4px 12px;\n  margin-top: 0px;\n  margin-right: 10px;\n  transition: all 0.3s ease;\n}\n\n.current-rate-box-dashboard:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(76, 175, 80, 0.3);\n}\n\n.rate-symbol {\n  font-size: 18px;\n  font-weight: bold;\n  color: #2e7d32;\n  margin-right: 4px;\n}\n\n.rate-amount {\n  font-size: 18px;\n  font-weight: bold;\n  color: #2e7d32;\n  font-family: 'Courier New', monospace;\n}\n\n@media (max-width: 768px) {\n  .current-rate-box-dashboard {\n    padding: 4px 8px;\n    margin-top: 6px;\n  }\n\n  .rate-symbol,\n  .rate-amount {\n    font-size: 16px;\n  }\n}\n\n/* Mobile Language Switcher Styles */\n@media (max-width: 768px) {\n  .mobile-header-top {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    gap: 8px !important;\n  }\n\n  .logo-container-mobile {\n    flex-shrink: 0;\n  }\n\n  .mobile-header-title {\n    text-align: left !important;\n    justify-self: flex-start !important;\n    flex: 1;\n    position: static;\n    transform: none;\n    left: auto;\n    margin-left: 0;\n    margin-right: 0;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    max-width: 200px;\n  }\n\n  .mobile-header-actions {\n    flex-shrink: 0;\n  }\n\n  .mobile-header-actions .language-switcher {\n    transform: scale(0.75);\n    margin-left: 15px;\n    margin-right: 3px;\n  }\n\n  .mobile-header-actions .language-switcher .language-switcher-button {\n    padding: 4px 8px;\n    font-size: 11px;\n    min-width: 60px;\n  }\n\n  .mobile-header-actions .language-switcher .language-dropdown {\n    top: 30px;\n    right: 0;\n  }\n\n  .mobile-header-actions .language-switcher .language-dropdown .language-option {\n    padding: 6px 10px;\n    font-size: 11px;\n  }\n}\n\n/* Support Modal Styles */\n.trouble-section {\n  display: flex;\n  /* flex-direction: column; */\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  margin-top: 12px;\n  padding-top: 12px;\n  border-top: 1px solid #eee;\n}\n\n.trouble-text {\n  color: #000;\n  font-size: 14px;\n}\n\n.contact-us-btn {\n  background: linear-gradient(135deg, #1e3a8a, #1e40af);\n  color: white;\n  border: none;\n  padding: 10px 18px;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  box-shadow: 0 2px 8px rgba(30, 58, 138, 0.2);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.contact-us-btn:hover {\n  background: linear-gradient(135deg, #1e40af, #1d4ed8);\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(30, 58, 138, 0.4);\n  border-color: rgba(255, 255, 255, 0.2);\n}\n\n.contact-us-btn:active {\n  transform: translateY(0);\n  box-shadow: 0 2px 8px rgba(30, 58, 138, 0.2);\n}\n\n.support-modal {\n  background: white;\n  border-radius: 12px;\n  max-width: 450px;\n  width: 90%;\n  max-height: 80vh;\n  overflow-y: auto;\n  position: relative;\n  animation: modalSlideIn 0.3s ease-out;\n}\n\n.support-modal-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 20px 24px;\n  border-bottom: 1px solid #eee;\n  background: linear-gradient(135deg, #4a90e2, #357abd);\n  border-radius: 12px 12px 0 0;\n}\n\n.support-modal-header h3 {\n  margin: 0;\n  color: white;\n  font-size: 18px;\n  font-weight: 600;\n}\n\n.support-modal-header .modal-close-btn {\n  background: rgba(255, 255, 255, 0.2);\n  border: none;\n  color: white;\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: background 0.3s ease;\n}\n\n.support-modal-header .modal-close-btn:hover {\n  background: rgba(255, 255, 255, 0.3);\n}\n\n.support-modal-body {\n  padding: 16px;\n}\n\n.support-options {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  margin-bottom: 16px;\n}\n\n.support-option {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  padding: 12px;\n  border-radius: 8px;\n  text-decoration: none;\n  border: 2px solid #f0f0f0;\n  transition: all 0.3s ease;\n}\n\n.support-option:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n}\n\n.whatsapp-support:hover {\n  border-color: #25d366;\n  background: rgba(37, 211, 102, 0.05);\n}\n\n.call-support:hover {\n  border-color: #4a90e2;\n  background: rgba(74, 144, 226, 0.05);\n}\n\n.support-option-icon {\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 18px;\n  color: white;\n}\n\n.whatsapp-support .support-option-icon {\n  background: #25d366;\n}\n\n.call-support .support-option-icon {\n  background: #4a90e2;\n}\n\n.support-option-content h4 {\n  margin: 0 0 4px 0;\n  font-size: 16px;\n  font-weight: 600;\n  color: #333;\n}\n\n.support-option-content p {\n  margin: 0 0 8px 0;\n  font-size: 14px;\n  color: #666;\n}\n\n.support-number {\n  font-size: 14px;\n  font-weight: 600;\n  color: #333;\n}\n\n.support-website {\n  text-align: center;\n  padding: 16px;\n  background: #f8f9fa;\n  border-radius: 8px;\n}\n\n.support-website p {\n  margin: 0 0 8px 0;\n  font-size: 14px;\n  color: #666;\n}\n\n.website-link {\n  color: #4a90e2;\n  text-decoration: none;\n  font-weight: 600;\n  font-size: 16px;\n  transition: color 0.3s ease;\n}\n\n.website-link:hover {\n  color: #357abd;\n  text-decoration: underline;\n}\n\n.refresh-link {\n  color: #4a90e2;\n  text-decoration: none;\n  font-weight: 600;\n  font-size: 12px;\n  padding: 4px 8px;\n  border: 1px solid #4a90e2;\n  border-radius: 4px;\n  background: rgba(74, 144, 226, 0.05);\n  transition: all 0.3s ease;\n  cursor: pointer;\n  display: inline-block;\n}\n\n.refresh-link:hover {\n  color: #357abd;\n  background: rgba(74, 144, 226, 0.1);\n  border-color: #357abd;\n  transform: translateY(-1px);\n}\n\n@keyframes modalSlideIn {\n  from {\n    opacity: 0;\n    transform: scale(0.9) translateY(-20px);\n  }\n\n  to {\n    opacity: 1;\n    transform: scale(1) translateY(0);\n  }\n}\n\n/* Mobile Responsive Styles for Support Modal */\n@media (max-width: 768px) {\n  .support-modal {\n    width: 95%;\n    max-height: 85vh;\n  }\n\n  .support-modal-header {\n    padding: 16px 20px;\n  }\n\n  .support-modal-header h3 {\n    font-size: 16px;\n  }\n\n  .support-modal-body {\n    padding: 20px;\n  }\n\n  .support-option {\n    padding: 12px;\n    gap: 12px;\n  }\n\n  .support-option-icon {\n    width: 40px;\n    height: 40px;\n    font-size: 16px;\n  }\n\n  .support-option-content h4 {\n    font-size: 14px;\n  }\n\n  .support-option-content p {\n    font-size: 12px;\n  }\n\n  .support-number {\n    font-size: 12px;\n  }\n\n  .trouble-section {\n    flex-direction: column;\n    gap: 12px;\n    text-align: center;\n  }\n\n  .contact-us-btn {\n    width: 100%;\n    max-width: 200px;\n  }\n}\n\n/* Offers Modal Support Section */\n.offers-support-section {\n  margin-top: 16px;\n  padding: 12px;\n  background: #f8f9fa;\n  border-radius: 8px;\n  text-align: center;\n  border-top: 2px solid #4a90e2;\n}\n\n.offers-support-text {\n  display: block;\n  margin-bottom: 12px;\n  color: #666;\n  font-size: 13px;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.offers-contact-btn {\n  background: linear-gradient(135deg, #4a90e2, #357abd);\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.offers-contact-btn:hover {\n  background: linear-gradient(135deg, #357abd, #2968a3);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(74, 144, 226, 0.3);\n}\n\n/* Rate Settings Modal Support Section */\n.rate-settings-support-section {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 12px 0;\n  border-top: 1px solid #eee;\n  margin-top: 12px;\n}\n\n.rate-settings-support-text {\n  color: #666;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.rate-settings-contact-btn {\n  background: linear-gradient(135deg, #4a90e2, #357abd);\n  color: white;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 6px;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.rate-settings-contact-btn:hover {\n  background: linear-gradient(135deg, #357abd, #2968a3);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(74, 144, 226, 0.3);\n}\n\n/* Mobile Responsive Styles for Support Sections */\n@media (max-width: 768px) {\n  .offers-support-section {\n    margin-top: 16px;\n    padding: 12px;\n  }\n\n  .offers-support-text {\n    font-size: 13px;\n    margin-bottom: 10px;\n  }\n\n  .offers-contact-btn {\n    padding: 8px 16px;\n    font-size: 13px;\n  }\n\n  .rate-settings-support-section {\n    flex-direction: column;\n    gap: 8px;\n    text-align: center;\n  }\n\n  .rate-settings-contact-btn {\n    width: 100%;\n    max-width: 200px;\n    justify-content: center;\n  }\n}\n\n.prorata-report-btn-wrapper {\n  position: relative;\n  display: inline-block;\n}\n\n@media (max-width: 768px) {\n  .prorata-report-btn-wrapper {\n    width: 100% !important;\n    display: flex !important;\n    flex-direction: column !important;\n  }\n  .prorata-report-btn-wrapper .pro-rata-report-generator {\n    width: 100% !important;\n  }\n  .prorata-report-btn-wrapper button {\n    width: 100% !important;\n  }\n}\n\n/* Rate Settings Modal Row styling for Rate Type & Animal Type side-by-side */\n.rate-settings-modal-row-dashboard {\n  display: flex;\n  gap: 16px;\n  margin-bottom: 15px;\n}\n\n@media (max-width: 480px) {\n  .rate-settings-modal-row-dashboard {\n    flex-direction: row !important;\n    gap: 8px !important;\n    margin-bottom: 10px !important;\n  }\n  .rate-settings-modal-row-dashboard .rate-settings-modal-section-dashboard {\n    flex: 1 1 0 !important;\n    min-width: 0 !important;\n  }\n}\n\n/* Bulk Edit Stats Panel Mobile Alignment */\n@media (max-width: 768px) {\n  .bulk-edit-stats-panel {\n    display: grid !important;\n    grid-template-columns: repeat(2, 1fr) !important;\n    gap: 12px 0 !important;\n    padding: 10px 8px !important;\n    width: 100% !important;\n    box-sizing: border-box !important;\n  }\n\n  .bulk-edit-stats-divider {\n    display: none !important;\n  }\n\n  .bulk-edit-stats-item {\n    width: 100% !important;\n    min-width: 0 !important;\n    flex: none !important;\n    box-sizing: border-box !important;\n  }\n\n  .bulk-edit-stats-item:nth-child(4n+1) {\n    border-right: 1px solid #dee2e6 !important;\n  }\n\n  /* Rate Settings Modal Mobile Buttons styling */\n  .rate-settings-modal-option-btn {\n    padding: 8px 12px !important;\n    font-size: 13px !important;\n    border-radius: 6px !important;\n  }\n\n  .rate-settings-modal-cancel-btn,\n  .rate-settings-modal-save-btn {\n    padding: 10px 14px !important;\n    font-size: 14px !important;\n    border-radius: 8px !important;\n  }\n\n  .rate-settings-modal-btn {\n    padding: 8px 12px !important;\n    font-size: 11px !important;\n    border-radius: 6px !important;\n  }\n\n  .rate-settings-modal-footer {\n    gap: 8px !important;\n    padding: 10px 12px !important;\n  }\n\n  .rate-settings-modal-body {\n    padding: 12px 16px !important;\n  }\n\n  .rate-settings-modal-section,\n  .rate-settings-modal-col {\n    margin-bottom: 12px !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
